/**
 * Generated by orval v7.1.1 🍺
 * Do not edit manually.
 * Hosting UAPI
 * Hosting UAPI is an API to expose Hosting, Addons, and Site functionality to a customer-facing Front End such as (Account Manager).
 * OpenAPI spec version: 0.1.0-unknown
 */
import { useInfiniteQuery, useMutation, useQuery } from '@tanstack/react-query';
import type {
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';

import type {
  AccessLogs200,
  AccessLogsParams,
  AccountAddonList200,
  AccountAddonListParams,
  AccountEventList200,
  AccountEventListParams,
  AccountFeatures200,
  AccountFeaturesParams,
  AccountHostingList200,
  AccountHostingListParams,
  AccountHostingListV2Params,
  AccountHostingListV2200,
  AccountPublicKey200,
  AccountPublicKey404,
  AccountPublicKeyCreate200,
  AccountPublicKeyCreate409,
  AccountPublicKeyCreateBody,
  AccountPublicKeyDelete200,
  AccountPublicKeyDelete404,
  AccountPublicKeys200,
  AccountPublicKeyToggle200,
  AccountPublicKeyToggle409,
  AccountPublicKeyToggleBody,
  AccountPurchaseHosting200,
  AccountPurchaseHosting400,
  AccountPurchaseHosting401,
  AccountPurchaseHosting403,
  AccountPurchaseHosting404,
  AccountPurchaseHosting502,
  AccountPurchaseHostingBody,
  AccountPurchaseOrder200,
  AccountPurchaseOrder400,
  AccountPurchaseOrder401,
  AccountPurchaseOrder403,
  AccountPurchaseOrder404,
  AccountPurchaseProducts200,
  AccountPurchaseProducts400,
  AccountPurchaseProducts401,
  AccountPurchaseProducts403,
  AccountPurchaseProducts502,
  ActivityLog200,
  ActivityLogParams,
  AddCron200,
  AddCron400,
  AddCronBody,
  AddHostingRedirects200,
  AddHostingRedirectsBody,
  AddIndex200,
  AddIndexBody,
  AddonsCloudflare200,
  AddonsCloudflareExternalNsCheck200,
  AddonsCloudflareExternalNsCheckParams,
  AddonsInfo200,
  AddonsJetpackValidate200,
  AddonsLlmBalance200,
  AddonsLlmKeys200,
  AddonsLlmKeysCreate200,
  AddonsLlmKeysCreateBody,
  AddonsLlmKeysDelete200,
  AddonsLlmKeysDeleteBody,
  AddonsLlmKeysParams,
  AddonsSitelockSso200,
  AddonsSitelockSsoV2Params,
  AddonsSitelockSsoV2200,
  AddonsSpamexpertsDomainAssign200,
  AddonsSpamexpertsDomainAssignBody,
  AddonsSpamexpertsSso200,
  AddonsSync200,
  AddonsWorkflows200,
  AddonsWorkflowsParams,
  AddPrivacy200,
  AddPrivacyBody,
  AddSiteIpaddress200,
  AddSiteIpaddressBody,
  AllUserMonarxDetails200,
  Announcements200,
  BackupCreateOndemandV1Body,
  BackupCreateOndemandV1200,
  BackupCreateOndemandV1400,
  BackupCreateOndemandV1403,
  BackupCreateOndemandV1404,
  BackupCreateOndemandV1409,
  BackupCreateV2Body,
  BackupCreateV3Body,
  BackupCreateV2200,
  BackupCreateV3200,
  BackupCustomDeleteV1Body,
  BackupCustomDeleteV1200,
  BackupCustomDeleteV1400,
  BackupCustomDeleteV1403,
  BackupCustomDeleteV1404,
  BackupCustomDeleteV1409,
  BackupDownloadV2Body,
  BackupDownloadV2200,
  BackupDownloadV2400,
  BackupDownloadV2403,
  BackupDownloadV2404,
  BackupDownloadV2409,
  BackupInitiate200,
  BackupInitiateBody,
  BackupList200,
  BackupListParams,
  BackupListV3Params,
  BackupListV2200,
  BackupListV3200,
  BackupMeta200,
  BackupMetaParams,
  BackupPrefSetStatus200,
  BackupPrefSetStatusBody,
  BackupRestoreV2Body,
  BackupRestoreV3Body,
  BackupRestoreV2200,
  BackupRestoreV3200,
  BackupRestoreV3400,
  BackupRestoreV3403,
  BackupRestoreV3404,
  BackupRestoreV3409,
  BackupSettings200,
  BackupSettingsCreate200,
  BackupSettingsCreateBody,
  BackupSettingsUpdate200,
  BackupSettingsUpdateBody,
  BackupsJetpackBackup200,
  BackupStatus200,
  BackupStatusParams,
  BackupStatusV2Params,
  BackupStatusV3Params,
  BackupStatusV2200,
  BackupStatusV3200,
  BackupStatusV3400,
  BackupUsage200,
  BullhornAnnouncements200,
  CodeguardBackupCreate200,
  CodeguardBackupCreateBody,
  CodeguardBackupDownload200,
  CodeguardBackupDownloadBody,
  CodeguardBackupList200,
  CodeguardBackupListParams,
  CodeguardBackupRestore200,
  CodeguardBackupRestoreBody,
  CodeguardDatabaseBackupCreate200,
  CodeguardDatabaseBackupCreateBody,
  CodeguardDatabaseBackupList200,
  CodeguardDatabaseBackupListParams,
  CodeguardDatabaseBackupRestore200,
  CodeguardDatabaseBackupRestoreBody,
  CodeguardDatabaseList200,
  CodeguardLoginLink200,
  CodeguardPlanInfo200,
  CodeguardWebsiteBackupCreate200,
  CodeguardWebsiteBackupCreateBody,
  CodeguardWebsiteBackupList200,
  CodeguardWebsiteBackupListParams,
  CodeguardWebsiteBackupRestore200,
  CodeguardWebsiteBackupRestoreBody,
  CodeguardWebsiteList200,
  CreatePhpInfo200,
  Cron200,
  CronBody,
  CronLastRun200,
  CronLastRunParams,
  Db200,
  DbAdd200,
  DbAddBody,
  DbBody,
  DbCheckDatabase200,
  DbCheckDatabaseBody,
  DbListV2200,
  DbMultipleUserDatabase200,
  DbMultipleUserDatabaseBody,
  DbUsage200,
  DbUserAdd200,
  DbUserAddBody,
  DbUserDelete200,
  DbUserDeleteBody,
  DbUserList200,
  DbUserPasswordSet200,
  DbUserPasswordSetBody,
  DbUserPrivsGet200,
  DbUserPrivsGetParams,
  DbUserPrivsSet200,
  DbUserPrivsSetBody,
  DbUserRename200,
  DbUserRenameBody,
  DirectoryPrivacy200,
  DirectoryPrivacyParams,
  DomainCertInstall200,
  DomainCertInstallBody,
  DomainCerts200,
  DomainCertUninstall200,
  DomainCertUpdate200,
  DomainCertUpdateBody,
  DomainDnseditor200,
  DomainDnseditorAdd200,
  DomainDnseditorAddBody,
  DomainDnseditorBody,
  DomainDnseditorEdit200,
  DomainDnseditorEditBody,
  DomainDnseditorList200,
  DomainDnsExport200,
  DomainDnsExportParams,
  DomainDnsImport200,
  DomainDnsImportBody,
  DomainDnsImportParams,
  DomainDnszoneReset200,
  DomainEmailDeliverability200,
  DomainHealth200,
  DomainHealthParams,
  DomainInfo200,
  DomainResourceRecords200,
  DomainResourceRecords400,
  DomainResourceRecords401,
  DomainResourceRecords502,
  DomainResourceRecordsParams,
  Domains200,
  DomainsEntriLastSuccess200,
  DomainsEntriLastSuccessBody,
  DomainsParams,
  DomainsSetEntriUsed200,
  DomainsUnsetEntriUsed200,
  DomainUnassign200,
  DomainZoneeditorUrl200,
  EditPrivacy200,
  EditPrivacyBody,
  EmailSso200,
  EmailSso400,
  EmailSso512,
  EmailSsoParams,
  EntriJwt200,
  ErrorPagesAdd200,
  ErrorPagesAddBody,
  ErrorPagesDelete200,
  ErrorPagesDeleteBody,
  ErrorPagesFetch200,
  ErrorPagesFetchParams,
  HostingAccount200,
  HostingAddons200,
  HostingAddonsParams,
  HostingAdvancedConsole200,
  HostingAdvancedConsoleParams,
  HostingAdvancedDns200,
  HostingAdvancedDnsParams,
  HostingAdvancedDnsUpdate200,
  HostingAdvancedDnsUpdateBody,
  HostingAdvancedDomainServices200,
  HostingAdvancedDomainServicesBody,
  HostingAdvancedDomainServicesCheck200,
  HostingAdvancedImages200,
  HostingAdvancedImagesParams,
  HostingAdvancedPassword200,
  HostingAdvancedPasswordBody,
  HostingAdvancedServer200,
  HostingAdvancedServerHealthcheck200,
  HostingAdvancedServerStatus200,
  HostingAdvancedServerStatusBody,
  HostingAdvancedServerV2200,
  HostingAdvancedSsoWhm200,
  HostingAdvancedSystemConsole200,
  HostingApplicationConfigResponse,
  HostingApplicationDeleteParams,
  HostingApplicationDeleteResponse,
  HostingApplicationDeploymentDetailResponse,
  HostingApplicationDeploymentHistoryResponse,
  HostingApplicationDeploymentLogsGetParams,
  HostingApplicationDeploymentLogsResponse,
  HostingApplicationHostnamesRequest,
  HostingApplicationHostnamesResponse,
  HostingApplicationListResponse,
  HostingApplicationOverviewResponse,
  HostingBackups200,
  HostingCapabilities200,
  HostingConfigMutationResponse,
  HostingConfigSetVariableRequest,
  HostingDbAuthorizedHosts200,
  HostingDbAuthorizedHostsAdd200,
  HostingDbAuthorizedHostsAddBody,
  HostingDbAuthorizedHostsDelete200,
  HostingDbAuthorizedHostsDeleteBody,
  HostingDbAuthorizedHostsUpdate200,
  HostingDbAuthorizedHostsUpdateBody,
  HostingDomainAssign200,
  HostingDomainAssignBody,
  HostingDomainAvailability200,
  HostingDomainAvailabilityParams,
  HostingDomainsLink200,
  HostingDomainsLinkBody,
  HostingDomainsUnassign200,
  HostingDomainsUnassignBody,
  HostingDomainsUnassignV2Body,
  HostingDomainsUnassignV2200,
  HostingDomainsV2Params,
  HostingDomainsV2200,
  HostingEcommerceInfo200,
  HostingEmailAdd200,
  HostingEmailAdd400,
  HostingEmailAdd403,
  HostingEmailAdd409,
  HostingEmailAdd512,
  HostingEmailAddBody,
  HostingEmailAutoresponderCreate200,
  HostingEmailAutoresponderCreate400,
  HostingEmailAutoresponderCreateBody,
  HostingEmailAutoresponderDelete200,
  HostingEmailAutoresponderDelete400,
  HostingEmailAutoresponderDelete404,
  HostingEmailAutoresponderDeleteParams,
  HostingEmailAutoresponderInfo200,
  HostingEmailAutoresponderInfo404,
  HostingEmailAutoresponderInfoParams,
  HostingEmailAutoresponderList200,
  HostingEmailAutoresponderListParams,
  HostingEmailAutoresponderUpdate200,
  HostingEmailAutoresponderUpdate400,
  HostingEmailAutoresponderUpdateBody,
  HostingEmailDelete200,
  HostingEmailDeleteParams,
  HostingEmailDomainRouting200,
  HostingEmailDomainRoutingParams,
  HostingEmailDomainRoutingSet200,
  HostingEmailDomainRoutingSetBody,
  HostingEmailFiltersAdd200,
  HostingEmailFiltersAddBody,
  HostingEmailFiltersDelete200,
  HostingEmailFiltersDelete400,
  HostingEmailFiltersDelete404,
  HostingEmailFiltersDeleteParams,
  HostingEmailFiltersList200,
  HostingEmailFiltersListParams,
  HostingEmailFiltersUpdate200,
  HostingEmailFiltersUpdateBody,
  HostingEmailFolderList200,
  HostingEmailFolderList404,
  HostingEmailForwardDelete200,
  HostingEmailForwardDeleteParams,
  HostingEmailForwarderAdd200,
  HostingEmailForwarderAdd400,
  HostingEmailForwarderAdd403,
  HostingEmailForwarderAdd409,
  HostingEmailForwarderAdd512,
  HostingEmailForwarderAddBody,
  HostingEmailForwardersList200,
  HostingEmailForwardersListParams,
  HostingEmailKeysAdd200,
  HostingEmailKeysAddBody,
  HostingEmailKeysList200,
  HostingEmailList200,
  HostingEmailSettings200,
  HostingEmailSettings403,
  HostingEmailSettings404,
  HostingEmailSettings512,
  HostingEmailSettingsBody,
  HostingEmailSetupInfo200,
  HostingEmailSetupInfo404,
  HostingEmailSpamCustomSettings200,
  HostingEmailSpamCustomSettingsUpdate200,
  HostingEmailSpamCustomSettingsUpdateBody,
  HostingEmailSpamEmpty200,
  HostingEmailSpamSettings200,
  HostingEmailSpamSettingsUpdate200,
  HostingEmailSpamSettingsUpdateBody,
  HostingEmailTestSend200,
  HostingEmailTestSend403,
  HostingEmailTestSend404,
  HostingEmailTestSend512,
  HostingEmailTestSendBody,
  HostingEmailUpdate200,
  HostingEmailUpdate400,
  HostingEmailUpdate403,
  HostingEmailUpdate512,
  HostingEmailUpdateBody,
  HostingErrorResponse,
  HostingFixownership200,
  HostingFtp200,
  HostingFtpAdd200,
  HostingFtpAddBody,
  HostingFtpBody,
  HostingFtpList200,
  HostingFtpUpdate200,
  HostingFtpUpdateBody,
  HostingInfo200,
  HostingInfoDiskUsage200,
  HostingLead200,
  HostingLead400,
  HostingLeadParams,
  HostingLicenseInfo200,
  HostingLicenseInfoParams,
  HostingMigrationInfo200,
  HostingMigrationInfoParams,
  HostingMigrations200,
  HostingMigrationsBody,
  HostingMigrationsEvent200,
  HostingMigrationsEventBody,
  HostingMigrationSiteScanStatus200,
  HostingMigrationSiteScanStatusParams,
  HostingMigrationStatus200,
  HostingMonarxAddonsList200,
  HostingMonarxAddonsListParams,
  HostingNameservers200,
  HostingNameserversV2200,
  HostingOnboardingData200,
  HostingOnboardingDataUpdate200,
  HostingOnboardingDataUpdateBody,
  HostingPasswordUpdate200,
  HostingPasswordUpdateBody,
  HostingRedeployRequest,
  HostingRedeployResponse,
  HostingRedirect200,
  HostingRedirectBody,
  HostingRedirects200Item,
  HostingRedirectsV2200Item,
  HostingRepo200,
  HostingRepoBody,
  HostingRepoList200Item,
  HostingRepoLog200,
  HostingRepoLogParams,
  HostingRepoSync200,
  HostingRepoSyncBody,
  HostingResellerSsoWhm200,
  HostingRollbackRequest,
  HostingRollbackResponse,
  HostingSendEmailSetupInfo200,
  HostingSendEmailSetupInfo404,
  HostingSendEmailSetupInfoBody,
  HostingServerHits200,
  HostingServerHitsParams,
  HostingShellInfo200,
  HostingShellToggle200,
  HostingShellToggleBody,
  HostingSiteAdd200,
  HostingSiteAddBody,
  HostingSiteAddV2Body,
  HostingSiteAddV3Body,
  HostingSiteAddV2200,
  HostingSiteAddV3200,
  HostingSitesV2Params,
  HostingSitesV2200,
  HostingSpamexpertsEligibleDomains200,
  HostingSshInfo200,
  HostingVisitors200,
  HostingVisitorsParams,
  HostingVpsSshKeySync200,
  HostingVpsSshKeySync404,
  HostingVpsSshKeySync500,
  HotlinkconfigAdd200,
  HotlinkconfigAddBody,
  HotlinkconfigDelete200,
  HotlinkconfigDeleteBody,
  HotlinkconfigDetails200,
  HotlinkconfigDetailsParams,
  Index200,
  IndexBody,
  JetpackBackupStatus200,
  ListCrons200,
  ListFilesV2Params,
  ListFilesV2200,
  ListIndex200,
  ListIndexParams,
  MonarxAddonReportUrl200,
  MonarxAddonReportUrlParams,
  MonarxAddonSealGeneration200,
  MonarxAddonSealGenerationParams,
  OnboardingExploreAiAllAccessClickRequest,
  OnboardingGetStepsResponse,
  OnboardingSignInAiDashboardClickRequest,
  OnboardingSurveyRequest,
  OnboardingSurveyResponse,
  PasswordGenerate200,
  PasswordScore200,
  PasswordScoreParams,
  PhpErrors200,
  PhpErrorsParams,
  Privacy200,
  PrivacyBody,
  PrivacyUser200,
  PrivacyUserBody,
  ProductLicenseDetails200,
  ProductLicenseDetailsParams,
  PublicImages200,
  PublicImagesParams,
  PublicImagesV2Params,
  PublicImagesV2200,
  PublicRegions200,
  RepairDatabase200,
  RepairDatabaseBody,
  ResetSite200,
  ResetSiteBody,
  Site200,
  SiteAddonCloudflare200,
  SiteAddonCloudflare400,
  SiteAddonWpsolution200,
  SiteAddonWpsolution400,
  SiteAddonWpsolutionBody,
  SiteBody,
  SiteInfoResponseModelV2,
  SiteIpaddress200,
  SiteIpaddressBody,
  SiteIpaddressList200Item,
  SiteMalwareStatus200,
  SiteMalwareStatusV2200,
  SitePendingDomainDelete200,
  SitePluginInstall200,
  SitePluginInstallBody,
  SitePluginInstaller200,
  SitePluginInstallerBody,
  SitePlugins200,
  SitePluginsAutoupdate200,
  SitePluginsAutoupdateBody,
  SitePluginsParams,
  SitePluginsToggle200,
  SitePluginsToggleBody,
  SitePluginsUpdate200,
  SitePluginsUpdateBody,
  SitePluginUpdate200,
  SitePluginUpdateBody,
  SiteQualityMetrics200,
  SiteQualityMetricsParams,
  SitesAccessLogs200,
  SitesAccessLogsDownloadParams,
  SitesAccessLogsParams,
  SitesAtomicMetrics200,
  SitesAtomicMetricsParams,
  SitesAutoupdatesResponse,
  SitesAutoupdatesUpdateBody,
  SitesBackups200,
  SitesBackupsCodeguard200,
  SitesBackupsDetails200,
  SitesBackupsXcitium200,
  SitesBatch200,
  SitesBatchBody,
  SitesDatabaseInfo200,
  SitesDatabasePasswordsync200,
  SitesDns200,
  SitesDnsParams,
  SitesDomain200,
  SitesDomainParams,
  SitesDomainsCreate200,
  SitesDomainsCreateBody,
  SitesDomainsV2Params,
  SitesDomainsV2200,
  SitesDomainUrl200,
  SitesDomainUrlBody,
  SitesErrorLogs200,
  SitesErrorLogsDownloadParams,
  SitesErrorLogsParams,
  SitesHasBackups200,
  SitesInfo200,
  SitesJetpackPurchase200,
  SitesListV3Params,
  SitesListV2200,
  SitesListV3200,
  SitesMetricDimensions200,
  SitesMetricDimensionsParams,
  SitesMetricsDimensionAveraged200,
  SitesMetricsDimensionAveragedParams,
  SitesOnboardingSteps200,
  SitesPerformanceCachepurge200,
  SitesPerformanceCachepurgeBody,
  SitesPerformanceEdgecache200,
  SitesPerformanceEdgecacheBody,
  SitesPerformanceEnduranceCacheLevel200,
  SitesPerformanceEnduranceCacheLevelBody,
  SitesPerformanceEnduranceCacheLevelStatus200,
  SitesPerformanceEndurancePageCache200,
  SitesPerformanceRedisPurge200,
  SitesPerformanceRedisPurgeBody,
  SitesPerformanceRedisStatus200,
  SitesPerformanceRedisToggle200,
  SitesPerformanceRedisToggleBody,
  SitesPerformanceRedisUninstall200,
  SitesPerformanceScans200,
  SitesPerformanceScansAdd200,
  SitesPerformanceScansAddBody,
  SitesPerformanceScansList200,
  SitesPerformanceScansListParams,
  SitesSecurityBundle200,
  SitesSecurityCheckCore200,
  SitesSecurityHttpsEnableDisableSsl200,
  SitesSecurityHttpsEnableDisableSslBody,
  SitesSecurityHttpsRedirectionStatus200,
  SitesSecurityResetCoreFiles200,
  SitesSecuritySitelock200,
  SitesSecuritySitelockParams,
  SitesSecuritySitelockV2Params,
  SitesSecuritySitelockV2200,
  SitesSecuritySslAcme200,
  SitesSecuritySslStatus200,
  SitesSecuritySslStatusParams,
  SitesSettingsComingSoon200,
  SitesSettingsComingSoonToggle200,
  SitesSettingsComingSoonToggleBody,
  SitesSettingsDebug200,
  SitesSettingsDebugToggle200,
  SitesSettingsDebugToggleBody,
  SitesSettingsPhpVersionInheritance200,
  SitesSettingsPhpVersionInheritanceParams,
  SitesSettingsPhpVersions200,
  SitesSettingsPhpVersionUpdate200,
  SitesSettingsPhpVersionUpdateBody,
  SitesSshUserCreate200,
  SitesSshUserCreateBody,
  SitesSshUserDelete200,
  SitesSshUserDeleteBody,
  SitesSshUserList200,
  SitesSshUserListV2200,
  SitesSshUserUpdate200,
  SitesSshUserUpdateBody,
  SitesSsl200,
  SitesSso200,
  SitesSsoParams,
  SiteStatus200,
  SitesVersion200,
  SiteThemeInstall200,
  SiteThemeInstallBody,
  SiteUpdate200,
  SiteUpdate400,
  SiteUpdateBody,
  SiteUsers200,
  SiteUsersV2Params,
  SiteUsersV2200,
  SiteWpGenerate200,
  SiteWpGenerateBody,
  SshKey200,
  SshKeyBody,
  SshKeyFetch200,
  SshKeyFetchParams,
  SshKeyGenerate200,
  SshKeyGenerateBody,
  SshKeyImport200,
  SshKeyImportBody,
  SshKeyImportV2Body,
  SshKeyImportV3Body,
  SshKeyImportV2200,
  SshKeyImportV3200,
  SshKeyList200,
  SshKeyListV4Params,
  SshKeyListV2200,
  SshKeyListV3200,
  SshKeyListV4200,
  SshKeyV2Body,
  SshKeyV2200,
  Sso200,
  SsoParams,
  StagingSitePromote200,
  StagingSitePromote409,
  StagingSitePromoteBody,
  UpdateCron200,
  UpdateCronBody,
  UpdateDomainResourceRecords200,
  UpdateDomainResourceRecords400,
  UpdateDomainResourceRecords401,
  UpdateDomainResourceRecords502,
  UpdateDomainResourceRecordsBody,
  UserBillingAccounts200,
  UserBillingAccounts401,
  UserBillingAccounts502,
  UserDomains200,
  UserHosting200,
  UserHostingOverview200,
  UserHostingOverviewParams,
  UserHostingParams,
  UserOnboarding200,
  UserPhoneSmsConsent200,
  UserPhoneSmsConsent400,
  UserPhoneSmsConsentParams,
  UserPhoneSmsConsentUpdate200,
  UserPhoneSmsConsentUpdate400,
  UserPhoneSmsConsentUpdateBody,
  UserProducts200,
  UserProducts401,
  UserProducts502,
  UserProservices200,
  UserServers200,
  UserServersParams,
  UserSitesAi200,
  UserSitesAi400,
  UserSitesAiParams,
  UserSpamexperts200,
  WaldaiSso200,
  WaldaiSso404,
  WaldaiSso502,
  WebzaiSso200,
  WeeblySso200,
  XcitiumBackupCreate200,
  XcitiumBackupCreateBody,
  XcitiumBackupDownload200,
  XcitiumBackupDownloadBody,
  XcitiumBackupList200,
  XcitiumBackupListParams,
  XcitiumBackupRestore200,
  XcitiumBackupRestoreBody,
  XcitiumPlanInfo200,
  XcitiumSso200,
} from './index.schemas';

/**
 * Returns a list of events across a tenant
 * @summary Event list for all accounts under a tenant
 */
export const accountEventList = (
  params?: AccountEventListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountEventList200>> => {
  return axios.get(`/v1/account/events`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccountEventListQueryKey = (
  params?: AccountEventListParams,
) => {
  return [`/v1/account/events`, ...(params ? [params] : [])] as const;
};

export const getAccountEventListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountEventList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountEventListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountEventList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccountEventListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountEventList>>
  > = ({ signal }) => accountEventList(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountEventList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountEventListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountEventList>>
>;
export type AccountEventListQueryError = AxiosError<unknown>;

export function useAccountEventList<
  TData = Awaited<ReturnType<typeof accountEventList>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | AccountEventListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountEventList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEventList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountEventList<
  TData = Awaited<ReturnType<typeof accountEventList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountEventListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountEventList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountEventList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountEventList<
  TData = Awaited<ReturnType<typeof accountEventList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountEventListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountEventList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Event list for all accounts under a tenant
 */

export function useAccountEventList<
  TData = Awaited<ReturnType<typeof accountEventList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountEventListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountEventList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountEventListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * DEPRECATED - Returns a list of feature information such as addon, features, sites, du, fs, db
 * @deprecated
 * @summary Return the array of product_inst_ids for the supplied account_ids
 */
export const accountFeatures = (
  params?: AccountFeaturesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountFeatures200>> => {
  return axios.get(`/v1/account/features`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccountFeaturesQueryKey = (params?: AccountFeaturesParams) => {
  return [`/v1/account/features`, ...(params ? [params] : [])] as const;
};

export const getAccountFeaturesQueryOptions = <
  TData = Awaited<ReturnType<typeof accountFeatures>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountFeaturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountFeatures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAccountFeaturesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accountFeatures>>> = ({
    signal,
  }) => accountFeatures(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountFeatures>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountFeaturesQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountFeatures>>
>;
export type AccountFeaturesQueryError = AxiosError<unknown>;

export function useAccountFeatures<
  TData = Awaited<ReturnType<typeof accountFeatures>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | AccountFeaturesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountFeatures>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFeatures>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountFeatures<
  TData = Awaited<ReturnType<typeof accountFeatures>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountFeaturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountFeatures>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountFeatures>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountFeatures<
  TData = Awaited<ReturnType<typeof accountFeatures>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountFeaturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountFeatures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Return the array of product_inst_ids for the supplied account_ids
 */

export function useAccountFeatures<
  TData = Awaited<ReturnType<typeof accountFeatures>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountFeaturesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountFeatures>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountFeaturesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a hosting account list
 * @summary Hosting account list for a customer
 */
export const accountHostingList = (
  params?: AccountHostingListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountHostingList200>> => {
  return axios.get(`/v1/account/hosting`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccountHostingListQueryKey = (
  params?: AccountHostingListParams,
) => {
  return [`/v1/account/hosting`, ...(params ? [params] : [])] as const;
};

export const getAccountHostingListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountHostingList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccountHostingListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountHostingList>>
  > = ({ signal }) => accountHostingList(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountHostingList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountHostingListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountHostingList>>
>;
export type AccountHostingListQueryError = AxiosError<unknown>;

export function useAccountHostingList<
  TData = Awaited<ReturnType<typeof accountHostingList>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | AccountHostingListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountHostingList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountHostingList<
  TData = Awaited<ReturnType<typeof accountHostingList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountHostingList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountHostingList<
  TData = Awaited<ReturnType<typeof accountHostingList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Hosting account list for a customer
 */

export function useAccountHostingList<
  TData = Awaited<ReturnType<typeof accountHostingList>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountHostingListQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the account public key list
 * @summary Account public key list
 */
export const accountPublicKeys = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPublicKeys200>> => {
  return axios.get(`/v1/account/public-keys`, options);
};

export const getAccountPublicKeysQueryKey = () => {
  return [`/v1/account/public-keys`] as const;
};

export const getAccountPublicKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof accountPublicKeys>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof accountPublicKeys>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAccountPublicKeysQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountPublicKeys>>
  > = ({ signal }) => accountPublicKeys({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountPublicKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountPublicKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountPublicKeys>>
>;
export type AccountPublicKeysQueryError = AxiosError<unknown>;

export function useAccountPublicKeys<
  TData = Awaited<ReturnType<typeof accountPublicKeys>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof accountPublicKeys>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountPublicKeys>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPublicKeys<
  TData = Awaited<ReturnType<typeof accountPublicKeys>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof accountPublicKeys>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof accountPublicKeys>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPublicKeys<
  TData = Awaited<ReturnType<typeof accountPublicKeys>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof accountPublicKeys>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Account public key list
 */

export function useAccountPublicKeys<
  TData = Awaited<ReturnType<typeof accountPublicKeys>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof accountPublicKeys>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountPublicKeysQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create an account public key
 * @summary Account public key creation
 */
export const accountPublicKeyCreate = (
  accountPublicKeyCreateBody: AccountPublicKeyCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPublicKeyCreate200>> => {
  return axios.post(
    `/v1/account/public-keys`,
    accountPublicKeyCreateBody,
    options,
  );
};

export const getAccountPublicKeyCreateMutationOptions = <
  TError = AxiosError<AccountPublicKeyCreate409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyCreate>>,
    TError,
    { data: AccountPublicKeyCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPublicKeyCreate>>,
  TError,
  { data: AccountPublicKeyCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPublicKeyCreate>>,
    { data: AccountPublicKeyCreateBody }
  > = (props) => {
    const { data } = props ?? {};

    return accountPublicKeyCreate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountPublicKeyCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPublicKeyCreate>>
>;
export type AccountPublicKeyCreateMutationBody = AccountPublicKeyCreateBody;
export type AccountPublicKeyCreateMutationError =
  AxiosError<AccountPublicKeyCreate409>;

/**
 * @summary Account public key creation
 */
export const useAccountPublicKeyCreate = <
  TError = AxiosError<AccountPublicKeyCreate409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyCreate>>,
    TError,
    { data: AccountPublicKeyCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPublicKeyCreate>>,
  TError,
  { data: AccountPublicKeyCreateBody },
  TContext
> => {
  const mutationOptions = getAccountPublicKeyCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns an account public key
 * @summary Account public key info
 */
export const accountPublicKey = (
  publicKeyId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPublicKey200>> => {
  return axios.get(`/v1/account/public-keys/${publicKeyId}`, options);
};

export const getAccountPublicKeyQueryKey = (publicKeyId: number) => {
  return [`/v1/account/public-keys/${publicKeyId}`] as const;
};

export const getAccountPublicKeyQueryOptions = <
  TData = Awaited<ReturnType<typeof accountPublicKey>>,
  TError = AxiosError<AccountPublicKey404>,
>(
  publicKeyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPublicKey>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccountPublicKeyQueryKey(publicKeyId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountPublicKey>>
  > = ({ signal }) =>
    accountPublicKey(publicKeyId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!publicKeyId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accountPublicKey>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountPublicKeyQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountPublicKey>>
>;
export type AccountPublicKeyQueryError = AxiosError<AccountPublicKey404>;

export function useAccountPublicKey<
  TData = Awaited<ReturnType<typeof accountPublicKey>>,
  TError = AxiosError<AccountPublicKey404>,
>(
  publicKeyId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPublicKey>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPublicKey>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPublicKey<
  TData = Awaited<ReturnType<typeof accountPublicKey>>,
  TError = AxiosError<AccountPublicKey404>,
>(
  publicKeyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPublicKey>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPublicKey>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPublicKey<
  TData = Awaited<ReturnType<typeof accountPublicKey>>,
  TError = AxiosError<AccountPublicKey404>,
>(
  publicKeyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPublicKey>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Account public key info
 */

export function useAccountPublicKey<
  TData = Awaited<ReturnType<typeof accountPublicKey>>,
  TError = AxiosError<AccountPublicKey404>,
>(
  publicKeyId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPublicKey>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountPublicKeyQueryOptions(publicKeyId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enable or disable a pubkey on an account.
 * @summary Account public key toggle
 */
export const accountPublicKeyToggle = (
  publicKeyId: number,
  accountPublicKeyToggleBody: AccountPublicKeyToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPublicKeyToggle200>> => {
  return axios.post(
    `/v1/account/public-keys/${publicKeyId}`,
    accountPublicKeyToggleBody,
    options,
  );
};

export const getAccountPublicKeyToggleMutationOptions = <
  TError = AxiosError<AccountPublicKeyToggle409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyToggle>>,
    TError,
    { publicKeyId: number; data: AccountPublicKeyToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPublicKeyToggle>>,
  TError,
  { publicKeyId: number; data: AccountPublicKeyToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPublicKeyToggle>>,
    { publicKeyId: number; data: AccountPublicKeyToggleBody }
  > = (props) => {
    const { publicKeyId, data } = props ?? {};

    return accountPublicKeyToggle(publicKeyId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountPublicKeyToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPublicKeyToggle>>
>;
export type AccountPublicKeyToggleMutationBody = AccountPublicKeyToggleBody;
export type AccountPublicKeyToggleMutationError =
  AxiosError<AccountPublicKeyToggle409>;

/**
 * @summary Account public key toggle
 */
export const useAccountPublicKeyToggle = <
  TError = AxiosError<AccountPublicKeyToggle409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyToggle>>,
    TError,
    { publicKeyId: number; data: AccountPublicKeyToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPublicKeyToggle>>,
  TError,
  { publicKeyId: number; data: AccountPublicKeyToggleBody },
  TContext
> => {
  const mutationOptions = getAccountPublicKeyToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete an account public key
 * @summary Account public key deletion
 */
export const accountPublicKeyDelete = (
  publicKeyId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPublicKeyDelete200>> => {
  return axios.delete(`/v1/account/public-keys/${publicKeyId}`, options);
};

export const getAccountPublicKeyDeleteMutationOptions = <
  TError = AxiosError<AccountPublicKeyDelete404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyDelete>>,
    TError,
    { publicKeyId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPublicKeyDelete>>,
  TError,
  { publicKeyId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPublicKeyDelete>>,
    { publicKeyId: number }
  > = (props) => {
    const { publicKeyId } = props ?? {};

    return accountPublicKeyDelete(publicKeyId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountPublicKeyDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPublicKeyDelete>>
>;

export type AccountPublicKeyDeleteMutationError =
  AxiosError<AccountPublicKeyDelete404>;

/**
 * @summary Account public key deletion
 */
export const useAccountPublicKeyDelete = <
  TError = AxiosError<AccountPublicKeyDelete404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPublicKeyDelete>>,
    TError,
    { publicKeyId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPublicKeyDelete>>,
  TError,
  { publicKeyId: number },
  TContext
> => {
  const mutationOptions = getAccountPublicKeyDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a tenant (billing account) addon list
 * @summary List of addons under a tenant
 */
export const accountAddonList = (
  accountId: string,
  params?: AccountAddonListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountAddonList200>> => {
  return axios.get(`/v1/account/${accountId}/addons`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccountAddonListQueryKey = (
  accountId: string,
  params?: AccountAddonListParams,
) => {
  return [
    `/v1/account/${accountId}/addons`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAccountAddonListQueryOptions = <
  TData = Awaited<ReturnType<typeof accountAddonList>>,
  TError = AxiosError<unknown>,
>(
  accountId: string,
  params?: AccountAddonListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountAddonList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccountAddonListQueryKey(accountId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountAddonList>>
  > = ({ signal }) =>
    accountAddonList(accountId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!accountId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accountAddonList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountAddonListQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountAddonList>>
>;
export type AccountAddonListQueryError = AxiosError<unknown>;

export function useAccountAddonList<
  TData = Awaited<ReturnType<typeof accountAddonList>>,
  TError = AxiosError<unknown>,
>(
  accountId: string,
  params: undefined | AccountAddonListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountAddonList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountAddonList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountAddonList<
  TData = Awaited<ReturnType<typeof accountAddonList>>,
  TError = AxiosError<unknown>,
>(
  accountId: string,
  params?: AccountAddonListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountAddonList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountAddonList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountAddonList<
  TData = Awaited<ReturnType<typeof accountAddonList>>,
  TError = AxiosError<unknown>,
>(
  accountId: string,
  params?: AccountAddonListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountAddonList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List of addons under a tenant
 */

export function useAccountAddonList<
  TData = Awaited<ReturnType<typeof accountAddonList>>,
  TError = AxiosError<unknown>,
>(
  accountId: string,
  params?: AccountAddonListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountAddonList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountAddonListQueryOptions(
    accountId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a combined backup list with website commit ids and corresponding database commits
 * @summary backup list
 */
export const codeguardBackupList = (
  addonId: number,
  params: CodeguardBackupListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardBackupList200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/backups`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCodeguardBackupListQueryKey = (
  addonId: number,
  params: CodeguardBackupListParams,
) => {
  return [
    `/v1/addons/codeguard/${addonId}/backups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCodeguardBackupListQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: CodeguardBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCodeguardBackupListQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardBackupList>>
  > = ({ signal }) =>
    codeguardBackupList(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardBackupList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardBackupListQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardBackupList>>
>;
export type CodeguardBackupListQueryError = AxiosError<unknown>;

export function useCodeguardBackupList<
  TData = Awaited<ReturnType<typeof codeguardBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: CodeguardBackupListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardBackupList<
  TData = Awaited<ReturnType<typeof codeguardBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: CodeguardBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardBackupList<
  TData = Awaited<ReturnType<typeof codeguardBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: CodeguardBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary backup list
 */

export function useCodeguardBackupList<
  TData = Awaited<ReturnType<typeof codeguardBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: CodeguardBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardBackupListQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates the website backup
 * @summary backup create
 */
export const codeguardBackupCreate = (
  addonId: number,
  codeguardBackupCreateBody: CodeguardBackupCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardBackupCreate200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/backups`,
    codeguardBackupCreateBody,
    options,
  );
};

export const getCodeguardBackupCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardBackupCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardBackupCreate>>,
    { addonId: number; data: CodeguardBackupCreateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardBackupCreate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardBackupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardBackupCreate>>
>;
export type CodeguardBackupCreateMutationBody = CodeguardBackupCreateBody;
export type CodeguardBackupCreateMutationError = AxiosError<unknown>;

/**
 * @summary backup create
 */
export const useCodeguardBackupCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardBackupCreateBody },
  TContext
> => {
  const mutationOptions = getCodeguardBackupCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Queues the backup download.
 * @summary backup download
 */
export const codeguardBackupDownload = (
  addonId: number,
  codeguardBackupDownloadBody: CodeguardBackupDownloadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardBackupDownload200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/backups/download`,
    codeguardBackupDownloadBody,
    options,
  );
};

export const getCodeguardBackupDownloadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupDownload>>,
    TError,
    { addonId: number; data: CodeguardBackupDownloadBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardBackupDownload>>,
  TError,
  { addonId: number; data: CodeguardBackupDownloadBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardBackupDownload>>,
    { addonId: number; data: CodeguardBackupDownloadBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardBackupDownload(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardBackupDownloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardBackupDownload>>
>;
export type CodeguardBackupDownloadMutationBody = CodeguardBackupDownloadBody;
export type CodeguardBackupDownloadMutationError = AxiosError<unknown>;

/**
 * @summary backup download
 */
export const useCodeguardBackupDownload = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupDownload>>,
    TError,
    { addonId: number; data: CodeguardBackupDownloadBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardBackupDownload>>,
  TError,
  { addonId: number; data: CodeguardBackupDownloadBody },
  TContext
> => {
  const mutationOptions = getCodeguardBackupDownloadMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Restores a website and database backup
 * @summary backups restore
 */
export const codeguardBackupRestore = (
  addonId: number,
  codeguardBackupRestoreBody: CodeguardBackupRestoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardBackupRestore200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/backups/restore`,
    codeguardBackupRestoreBody,
    options,
  );
};

export const getCodeguardBackupRestoreMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardBackupRestoreBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardBackupRestore>>,
    { addonId: number; data: CodeguardBackupRestoreBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardBackupRestore(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardBackupRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardBackupRestore>>
>;
export type CodeguardBackupRestoreMutationBody = CodeguardBackupRestoreBody;
export type CodeguardBackupRestoreMutationError = AxiosError<unknown>;

/**
 * @summary backups restore
 */
export const useCodeguardBackupRestore = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardBackupRestoreBody },
  TContext
> => {
  const mutationOptions = getCodeguardBackupRestoreMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns all database records CodeGuard maintains for this user's account.
 * @deprecated
 * @summary database list
 */
export const codeguardDatabaseList = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardDatabaseList200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/databases`, options);
};

export const getCodeguardDatabaseListQueryKey = (addonId: number) => {
  return [`/v1/addons/codeguard/${addonId}/databases`] as const;
};

export const getCodeguardDatabaseListQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardDatabaseList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCodeguardDatabaseListQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardDatabaseList>>
  > = ({ signal }) =>
    codeguardDatabaseList(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardDatabaseList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardDatabaseListQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardDatabaseList>>
>;
export type CodeguardDatabaseListQueryError = AxiosError<unknown>;

export function useCodeguardDatabaseList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardDatabaseList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardDatabaseList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardDatabaseList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardDatabaseList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary database list
 */

export function useCodeguardDatabaseList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardDatabaseListQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all database backup records CodeGuard maintains for this user's account.
 * @deprecated
 * @summary database backup list
 */
export const codeguardDatabaseBackupList = (
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardDatabaseBackupList200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/databases/backups`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCodeguardDatabaseBackupListQueryKey = (
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
) => {
  return [
    `/v1/addons/codeguard/${addonId}/databases/backups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCodeguardDatabaseBackupListQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCodeguardDatabaseBackupListQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardDatabaseBackupList>>
  > = ({ signal }) =>
    codeguardDatabaseBackupList(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardDatabaseBackupListQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardDatabaseBackupList>>
>;
export type CodeguardDatabaseBackupListQueryError = AxiosError<unknown>;

export function useCodeguardDatabaseBackupList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: undefined | CodeguardDatabaseBackupListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardDatabaseBackupList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardDatabaseBackupList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary database backup list
 */

export function useCodeguardDatabaseBackupList<
  TData = Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardDatabaseBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardDatabaseBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardDatabaseBackupListQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Queue the creation of a database backup.
 * @deprecated
 * @summary database backup create
 */
export const codeguardDatabaseBackupCreate = (
  addonId: number,
  codeguardDatabaseBackupCreateBody: CodeguardDatabaseBackupCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardDatabaseBackupCreate200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/databases/backups`,
    codeguardDatabaseBackupCreateBody,
    options,
  );
};

export const getCodeguardDatabaseBackupCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardDatabaseBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardDatabaseBackupCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>,
    { addonId: number; data: CodeguardDatabaseBackupCreateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardDatabaseBackupCreate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardDatabaseBackupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>
>;
export type CodeguardDatabaseBackupCreateMutationBody =
  CodeguardDatabaseBackupCreateBody;
export type CodeguardDatabaseBackupCreateMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary database backup create
 */
export const useCodeguardDatabaseBackupCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardDatabaseBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardDatabaseBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardDatabaseBackupCreateBody },
  TContext
> => {
  const mutationOptions =
    getCodeguardDatabaseBackupCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Restores a database backup
 * @deprecated
 * @summary  database backup restore
 */
export const codeguardDatabaseBackupRestore = (
  addonId: number,
  codeguardDatabaseBackupRestoreBody: CodeguardDatabaseBackupRestoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardDatabaseBackupRestore200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/databases/backups/restore`,
    codeguardDatabaseBackupRestoreBody,
    options,
  );
};

export const getCodeguardDatabaseBackupRestoreMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardDatabaseBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardDatabaseBackupRestoreBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>,
    { addonId: number; data: CodeguardDatabaseBackupRestoreBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardDatabaseBackupRestore(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardDatabaseBackupRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>
>;
export type CodeguardDatabaseBackupRestoreMutationBody =
  CodeguardDatabaseBackupRestoreBody;
export type CodeguardDatabaseBackupRestoreMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary  database backup restore
 */
export const useCodeguardDatabaseBackupRestore = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardDatabaseBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardDatabaseBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardDatabaseBackupRestoreBody },
  TContext
> => {
  const mutationOptions =
    getCodeguardDatabaseBackupRestoreMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns an oauth login URL that can be used to access CodeGuard dashboard for a user.
 * @summary login link
 */
export const codeguardLoginLink = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardLoginLink200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/login`, options);
};

export const getCodeguardLoginLinkQueryKey = (addonId: number) => {
  return [`/v1/addons/codeguard/${addonId}/login`] as const;
};

export const getCodeguardLoginLinkQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardLoginLink>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardLoginLink>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCodeguardLoginLinkQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardLoginLink>>
  > = ({ signal }) => codeguardLoginLink(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardLoginLink>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardLoginLinkQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardLoginLink>>
>;
export type CodeguardLoginLinkQueryError = AxiosError<unknown>;

export function useCodeguardLoginLink<
  TData = Awaited<ReturnType<typeof codeguardLoginLink>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardLoginLink>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardLoginLink>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardLoginLink<
  TData = Awaited<ReturnType<typeof codeguardLoginLink>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardLoginLink>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardLoginLink>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardLoginLink<
  TData = Awaited<ReturnType<typeof codeguardLoginLink>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardLoginLink>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary login link
 */

export function useCodeguardLoginLink<
  TData = Awaited<ReturnType<typeof codeguardLoginLink>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardLoginLink>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardLoginLinkQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the subscribed plan and usage info
 * @summary plan info
 */
export const codeguardPlanInfo = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardPlanInfo200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/plan`, options);
};

export const getCodeguardPlanInfoQueryKey = (addonId: number) => {
  return [`/v1/addons/codeguard/${addonId}/plan`] as const;
};

export const getCodeguardPlanInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCodeguardPlanInfoQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardPlanInfo>>
  > = ({ signal }) => codeguardPlanInfo(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardPlanInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardPlanInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardPlanInfo>>
>;
export type CodeguardPlanInfoQueryError = AxiosError<unknown>;

export function useCodeguardPlanInfo<
  TData = Awaited<ReturnType<typeof codeguardPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardPlanInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardPlanInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardPlanInfo<
  TData = Awaited<ReturnType<typeof codeguardPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardPlanInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardPlanInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardPlanInfo<
  TData = Awaited<ReturnType<typeof codeguardPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary plan info
 */

export function useCodeguardPlanInfo<
  TData = Awaited<ReturnType<typeof codeguardPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardPlanInfoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all website records CodeGuard maintains for this user's account.
 * @deprecated
 * @summary website list
 */
export const codeguardWebsiteList = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardWebsiteList200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/websites`, options);
};

export const getCodeguardWebsiteListQueryKey = (addonId: number) => {
  return [`/v1/addons/codeguard/${addonId}/websites`] as const;
};

export const getCodeguardWebsiteListQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardWebsiteList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCodeguardWebsiteListQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardWebsiteList>>
  > = ({ signal }) =>
    codeguardWebsiteList(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardWebsiteList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardWebsiteListQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardWebsiteList>>
>;
export type CodeguardWebsiteListQueryError = AxiosError<unknown>;

export function useCodeguardWebsiteList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardWebsiteList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardWebsiteList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardWebsiteList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardWebsiteList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary website list
 */

export function useCodeguardWebsiteList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardWebsiteListQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all website backup records CodeGuard maintains for this user's account.
 * @deprecated
 * @summary  website backup list
 */
export const codeguardWebsiteBackupList = (
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardWebsiteBackupList200>> => {
  return axios.get(`/v1/addons/codeguard/${addonId}/websites/backups`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCodeguardWebsiteBackupListQueryKey = (
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
) => {
  return [
    `/v1/addons/codeguard/${addonId}/websites/backups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCodeguardWebsiteBackupListQueryOptions = <
  TData = Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCodeguardWebsiteBackupListQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof codeguardWebsiteBackupList>>
  > = ({ signal }) =>
    codeguardWebsiteBackupList(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CodeguardWebsiteBackupListQueryResult = NonNullable<
  Awaited<ReturnType<typeof codeguardWebsiteBackupList>>
>;
export type CodeguardWebsiteBackupListQueryError = AxiosError<unknown>;

export function useCodeguardWebsiteBackupList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: undefined | CodeguardWebsiteBackupListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardWebsiteBackupList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCodeguardWebsiteBackupList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary  website backup list
 */

export function useCodeguardWebsiteBackupList<
  TData = Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: CodeguardWebsiteBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof codeguardWebsiteBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCodeguardWebsiteBackupListQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Initiate the creation of a new backup for a given website
 * @deprecated
 * @summary website backup create
 */
export const codeguardWebsiteBackupCreate = (
  addonId: number,
  codeguardWebsiteBackupCreateBody: CodeguardWebsiteBackupCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardWebsiteBackupCreate200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/websites/backups`,
    codeguardWebsiteBackupCreateBody,
    options,
  );
};

export const getCodeguardWebsiteBackupCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardWebsiteBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardWebsiteBackupCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>,
    { addonId: number; data: CodeguardWebsiteBackupCreateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardWebsiteBackupCreate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardWebsiteBackupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>
>;
export type CodeguardWebsiteBackupCreateMutationBody =
  CodeguardWebsiteBackupCreateBody;
export type CodeguardWebsiteBackupCreateMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary website backup create
 */
export const useCodeguardWebsiteBackupCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>,
    TError,
    { addonId: number; data: CodeguardWebsiteBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardWebsiteBackupCreate>>,
  TError,
  { addonId: number; data: CodeguardWebsiteBackupCreateBody },
  TContext
> => {
  const mutationOptions =
    getCodeguardWebsiteBackupCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Restores a website backup
 * @deprecated
 * @summary  website backup restore
 */
export const codeguardWebsiteBackupRestore = (
  addonId: number,
  codeguardWebsiteBackupRestoreBody: CodeguardWebsiteBackupRestoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CodeguardWebsiteBackupRestore200>> => {
  return axios.post(
    `/v1/addons/codeguard/${addonId}/websites/backups/restore`,
    codeguardWebsiteBackupRestoreBody,
    options,
  );
};

export const getCodeguardWebsiteBackupRestoreMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardWebsiteBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardWebsiteBackupRestoreBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>,
    { addonId: number; data: CodeguardWebsiteBackupRestoreBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return codeguardWebsiteBackupRestore(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CodeguardWebsiteBackupRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>
>;
export type CodeguardWebsiteBackupRestoreMutationBody =
  CodeguardWebsiteBackupRestoreBody;
export type CodeguardWebsiteBackupRestoreMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary  website backup restore
 */
export const useCodeguardWebsiteBackupRestore = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>,
    TError,
    { addonId: number; data: CodeguardWebsiteBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof codeguardWebsiteBackupRestore>>,
  TError,
  { addonId: number; data: CodeguardWebsiteBackupRestoreBody },
  TContext
> => {
  const mutationOptions =
    getCodeguardWebsiteBackupRestoreMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns an oauth login URL that can be used to access Sitelock dashboard for a user.
 * @summary sso
 */
export const addonsSitelockSso = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsSitelockSso200>> => {
  return axios.get(`/v1/addons/sitelock/${addonId}/sso`, options);
};

export const getAddonsSitelockSsoQueryKey = (addonId: number) => {
  return [`/v1/addons/sitelock/${addonId}/sso`] as const;
};

export const getAddonsSitelockSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsSitelockSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsSitelockSsoQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addonsSitelockSso>>
  > = ({ signal }) => addonsSitelockSso(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsSitelockSso>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsSitelockSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsSitelockSso>>
>;
export type AddonsSitelockSsoQueryError = AxiosError<unknown>;

export function useAddonsSitelockSso<
  TData = Awaited<ReturnType<typeof addonsSitelockSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSso>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSitelockSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSitelockSso<
  TData = Awaited<ReturnType<typeof addonsSitelockSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSso>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSitelockSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSitelockSso<
  TData = Awaited<ReturnType<typeof addonsSitelockSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sso
 */

export function useAddonsSitelockSso<
  TData = Awaited<ReturnType<typeof addonsSitelockSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsSitelockSsoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a combined backup list with website commit ids and corresponding database commits
 * @summary backup list
 */
export const xcitiumBackupList = (
  addonId: string,
  params: XcitiumBackupListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumBackupList200>> => {
  return axios.get(`/v1/addons/xcitium/${addonId}/backups`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getXcitiumBackupListQueryKey = (
  addonId: string,
  params: XcitiumBackupListParams,
) => {
  return [
    `/v1/addons/xcitium/${addonId}/backups`,
    ...(params ? [params] : []),
  ] as const;
};

export const getXcitiumBackupListQueryOptions = <
  TData = Awaited<ReturnType<typeof xcitiumBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: XcitiumBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getXcitiumBackupListQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof xcitiumBackupList>>
  > = ({ signal }) =>
    xcitiumBackupList(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof xcitiumBackupList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type XcitiumBackupListQueryResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumBackupList>>
>;
export type XcitiumBackupListQueryError = AxiosError<unknown>;

export function useXcitiumBackupList<
  TData = Awaited<ReturnType<typeof xcitiumBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: XcitiumBackupListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumBackupList<
  TData = Awaited<ReturnType<typeof xcitiumBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: XcitiumBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumBackupList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumBackupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumBackupList<
  TData = Awaited<ReturnType<typeof xcitiumBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: XcitiumBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary backup list
 */

export function useXcitiumBackupList<
  TData = Awaited<ReturnType<typeof xcitiumBackupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: XcitiumBackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumBackupList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getXcitiumBackupListQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates the website backup
 * @summary backup create
 */
export const xcitiumBackupCreate = (
  addonId: number,
  xcitiumBackupCreateBody: XcitiumBackupCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumBackupCreate200>> => {
  return axios.post(
    `/v1/addons/xcitium/${addonId}/backups`,
    xcitiumBackupCreateBody,
    options,
  );
};

export const getXcitiumBackupCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupCreate>>,
    TError,
    { addonId: number; data: XcitiumBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof xcitiumBackupCreate>>,
  TError,
  { addonId: number; data: XcitiumBackupCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof xcitiumBackupCreate>>,
    { addonId: number; data: XcitiumBackupCreateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return xcitiumBackupCreate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type XcitiumBackupCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumBackupCreate>>
>;
export type XcitiumBackupCreateMutationBody = XcitiumBackupCreateBody;
export type XcitiumBackupCreateMutationError = AxiosError<unknown>;

/**
 * @summary backup create
 */
export const useXcitiumBackupCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupCreate>>,
    TError,
    { addonId: number; data: XcitiumBackupCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof xcitiumBackupCreate>>,
  TError,
  { addonId: number; data: XcitiumBackupCreateBody },
  TContext
> => {
  const mutationOptions = getXcitiumBackupCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Queues the backup download.
 * @summary backup download
 */
export const xcitiumBackupDownload = (
  addonId: number,
  xcitiumBackupDownloadBody: XcitiumBackupDownloadBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumBackupDownload200>> => {
  return axios.post(
    `/v1/addons/xcitium/${addonId}/backups/download`,
    xcitiumBackupDownloadBody,
    options,
  );
};

export const getXcitiumBackupDownloadMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupDownload>>,
    TError,
    { addonId: number; data: XcitiumBackupDownloadBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof xcitiumBackupDownload>>,
  TError,
  { addonId: number; data: XcitiumBackupDownloadBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof xcitiumBackupDownload>>,
    { addonId: number; data: XcitiumBackupDownloadBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return xcitiumBackupDownload(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type XcitiumBackupDownloadMutationResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumBackupDownload>>
>;
export type XcitiumBackupDownloadMutationBody = XcitiumBackupDownloadBody;
export type XcitiumBackupDownloadMutationError = AxiosError<unknown>;

/**
 * @summary backup download
 */
export const useXcitiumBackupDownload = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupDownload>>,
    TError,
    { addonId: number; data: XcitiumBackupDownloadBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof xcitiumBackupDownload>>,
  TError,
  { addonId: number; data: XcitiumBackupDownloadBody },
  TContext
> => {
  const mutationOptions = getXcitiumBackupDownloadMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Restores a website and database backup
 * @summary backups restore
 */
export const xcitiumBackupRestore = (
  addonId: number,
  xcitiumBackupRestoreBody: XcitiumBackupRestoreBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumBackupRestore200>> => {
  return axios.post(
    `/v1/addons/xcitium/${addonId}/backups/restore`,
    xcitiumBackupRestoreBody,
    options,
  );
};

export const getXcitiumBackupRestoreMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupRestore>>,
    TError,
    { addonId: number; data: XcitiumBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof xcitiumBackupRestore>>,
  TError,
  { addonId: number; data: XcitiumBackupRestoreBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof xcitiumBackupRestore>>,
    { addonId: number; data: XcitiumBackupRestoreBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return xcitiumBackupRestore(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type XcitiumBackupRestoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumBackupRestore>>
>;
export type XcitiumBackupRestoreMutationBody = XcitiumBackupRestoreBody;
export type XcitiumBackupRestoreMutationError = AxiosError<unknown>;

/**
 * @summary backups restore
 */
export const useXcitiumBackupRestore = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof xcitiumBackupRestore>>,
    TError,
    { addonId: number; data: XcitiumBackupRestoreBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof xcitiumBackupRestore>>,
  TError,
  { addonId: number; data: XcitiumBackupRestoreBody },
  TContext
> => {
  const mutationOptions = getXcitiumBackupRestoreMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the subscribed plan and usage info
 * @summary plan info
 */
export const xcitiumPlanInfo = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumPlanInfo200>> => {
  return axios.get(`/v1/addons/xcitium/${addonId}/plan`, options);
};

export const getXcitiumPlanInfoQueryKey = (addonId: string) => {
  return [`/v1/addons/xcitium/${addonId}/plan`] as const;
};

export const getXcitiumPlanInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof xcitiumPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getXcitiumPlanInfoQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof xcitiumPlanInfo>>> = ({
    signal,
  }) => xcitiumPlanInfo(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof xcitiumPlanInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type XcitiumPlanInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumPlanInfo>>
>;
export type XcitiumPlanInfoQueryError = AxiosError<unknown>;

export function useXcitiumPlanInfo<
  TData = Awaited<ReturnType<typeof xcitiumPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumPlanInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumPlanInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumPlanInfo<
  TData = Awaited<ReturnType<typeof xcitiumPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumPlanInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumPlanInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumPlanInfo<
  TData = Awaited<ReturnType<typeof xcitiumPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary plan info
 */

export function useXcitiumPlanInfo<
  TData = Awaited<ReturnType<typeof xcitiumPlanInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof xcitiumPlanInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getXcitiumPlanInfoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an SSO URL that can be used to access the user's Xcitium dashboard.
 * @summary Xcitium SSO link
 */
export const xcitiumSso = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<XcitiumSso200>> => {
  return axios.get(`/v1/addons/xcitium/${addonId}/sso`, options);
};

export const getXcitiumSsoQueryKey = (addonId: string) => {
  return [`/v1/addons/xcitium/${addonId}/sso`] as const;
};

export const getXcitiumSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof xcitiumSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof xcitiumSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getXcitiumSsoQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof xcitiumSso>>> = ({
    signal,
  }) => xcitiumSso(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof xcitiumSso>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type XcitiumSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof xcitiumSso>>
>;
export type XcitiumSsoQueryError = AxiosError<unknown>;

export function useXcitiumSso<
  TData = Awaited<ReturnType<typeof xcitiumSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof xcitiumSso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumSso<
  TData = Awaited<ReturnType<typeof xcitiumSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof xcitiumSso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof xcitiumSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useXcitiumSso<
  TData = Awaited<ReturnType<typeof xcitiumSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof xcitiumSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Xcitium SSO link
 */

export function useXcitiumSso<
  TData = Awaited<ReturnType<typeof xcitiumSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof xcitiumSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getXcitiumSsoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup initiate
 * @summary Backup initiate
 */
export const backupInitiate = (
  addonId: string,
  backupInitiateBody: BackupInitiateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupInitiate200>> => {
  return axios.post(
    `/v1/addons/${addonId}/backup`,
    backupInitiateBody,
    options,
  );
};

export const getBackupInitiateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupInitiate>>,
    TError,
    { addonId: string; data: BackupInitiateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupInitiate>>,
  TError,
  { addonId: string; data: BackupInitiateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupInitiate>>,
    { addonId: string; data: BackupInitiateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupInitiate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupInitiateMutationResult = NonNullable<
  Awaited<ReturnType<typeof backupInitiate>>
>;
export type BackupInitiateMutationBody = BackupInitiateBody;
export type BackupInitiateMutationError = AxiosError<unknown>;

/**
 * @summary Backup initiate
 */
export const useBackupInitiate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupInitiate>>,
    TError,
    { addonId: string; data: BackupInitiateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupInitiate>>,
  TError,
  { addonId: string; data: BackupInitiateBody },
  TContext
> => {
  const mutationOptions = getBackupInitiateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Backup status
 * @summary Backup status
 */
export const backupStatus = (
  addonId: string,
  params: BackupStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupStatus200>> => {
  return axios.get(`/v1/addons/${addonId}/backup`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupStatusQueryKey = (
  addonId: string,
  params: BackupStatusParams,
) => {
  return [`/v1/addons/${addonId}/backup`, ...(params ? [params] : [])] as const;
};

export const getBackupStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof backupStatus>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupStatusQueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupStatus>>> = ({
    signal,
  }) => backupStatus(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof backupStatus>>
>;
export type BackupStatusQueryError = AxiosError<unknown>;

export function useBackupStatus<
  TData = Awaited<ReturnType<typeof backupStatus>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatus<
  TData = Awaited<ReturnType<typeof backupStatus>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatus<
  TData = Awaited<ReturnType<typeof backupStatus>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup status
 */

export function useBackupStatus<
  TData = Awaited<ReturnType<typeof backupStatus>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupStatusQueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated, use backup_list_v2 instead - Returns backup list
 * @deprecated
 * @summary Backup list
 */
export const backupList = (
  addonId: string,
  params: BackupListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupList200>> => {
  return axios.get(`/v1/addons/${addonId}/backup/list`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupListQueryKey = (
  addonId: string,
  params: BackupListParams,
) => {
  return [
    `/v1/addons/${addonId}/backup/list`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBackupListQueryOptions = <
  TData = Awaited<ReturnType<typeof backupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupListQueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupList>>> = ({
    signal,
  }) => backupList(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupListQueryResult = NonNullable<
  Awaited<ReturnType<typeof backupList>>
>;
export type BackupListQueryError = AxiosError<unknown>;

export function useBackupList<
  TData = Awaited<ReturnType<typeof backupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupList<
  TData = Awaited<ReturnType<typeof backupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupList<
  TData = Awaited<ReturnType<typeof backupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Backup list
 */

export function useBackupList<
  TData = Awaited<ReturnType<typeof backupList>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: BackupListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupListQueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup meta
 * @summary Backup meta
 */
export const backupMeta = (
  addonId: number,
  params?: BackupMetaParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupMeta200>> => {
  return axios.get(`/v1/addons/${addonId}/backup/meta`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupMetaQueryKey = (
  addonId: number,
  params?: BackupMetaParams,
) => {
  return [
    `/v1/addons/${addonId}/backup/meta`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBackupMetaQueryOptions = <
  TData = Awaited<ReturnType<typeof backupMeta>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: BackupMetaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupMeta>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupMetaQueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupMeta>>> = ({
    signal,
  }) => backupMeta(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupMeta>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupMetaQueryResult = NonNullable<
  Awaited<ReturnType<typeof backupMeta>>
>;
export type BackupMetaQueryError = AxiosError<unknown>;

export function useBackupMeta<
  TData = Awaited<ReturnType<typeof backupMeta>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: undefined | BackupMetaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupMeta>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupMeta>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupMeta<
  TData = Awaited<ReturnType<typeof backupMeta>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: BackupMetaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupMeta>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupMeta>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupMeta<
  TData = Awaited<ReturnType<typeof backupMeta>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: BackupMetaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupMeta>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup meta
 */

export function useBackupMeta<
  TData = Awaited<ReturnType<typeof backupMeta>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: BackupMetaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupMeta>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupMetaQueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup create on demand
 * @summary Backup create on demand
 */
export const backupCreateOndemandV1 = (
  addonId: number,
  siteId: number,
  backupCreateOndemandV1Body: BackupCreateOndemandV1Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupCreateOndemandV1200>> => {
  return axios.post(
    `/v1/addons/${addonId}/backup/sites/${siteId}/create`,
    backupCreateOndemandV1Body,
    options,
  );
};

export const getBackupCreateOndemandV1MutationOptions = <
  TError = AxiosError<
    | BackupCreateOndemandV1400
    | BackupCreateOndemandV1403
    | BackupCreateOndemandV1404
    | BackupCreateOndemandV1409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateOndemandV1>>,
    TError,
    { addonId: number; siteId: number; data: BackupCreateOndemandV1Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupCreateOndemandV1>>,
  TError,
  { addonId: number; siteId: number; data: BackupCreateOndemandV1Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupCreateOndemandV1>>,
    { addonId: number; siteId: number; data: BackupCreateOndemandV1Body }
  > = (props) => {
    const { addonId, siteId, data } = props ?? {};

    return backupCreateOndemandV1(addonId, siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupCreateOndemandV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupCreateOndemandV1>>
>;
export type BackupCreateOndemandV1MutationBody = BackupCreateOndemandV1Body;
export type BackupCreateOndemandV1MutationError = AxiosError<
  | BackupCreateOndemandV1400
  | BackupCreateOndemandV1403
  | BackupCreateOndemandV1404
  | BackupCreateOndemandV1409
>;

/**
 * @summary Backup create on demand
 */
export const useBackupCreateOndemandV1 = <
  TError = AxiosError<
    | BackupCreateOndemandV1400
    | BackupCreateOndemandV1403
    | BackupCreateOndemandV1404
    | BackupCreateOndemandV1409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateOndemandV1>>,
    TError,
    { addonId: number; siteId: number; data: BackupCreateOndemandV1Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupCreateOndemandV1>>,
  TError,
  { addonId: number; siteId: number; data: BackupCreateOndemandV1Body },
  TContext
> => {
  const mutationOptions = getBackupCreateOndemandV1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete custom backup
 * @summary Delete custom backup
 */
export const backupCustomDeleteV1 = (
  addonId: number,
  siteId: number,
  backupCustomDeleteV1Body: BackupCustomDeleteV1Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupCustomDeleteV1200>> => {
  return axios.post(
    `/v1/addons/${addonId}/backup/sites/${siteId}/delete`,
    backupCustomDeleteV1Body,
    options,
  );
};

export const getBackupCustomDeleteV1MutationOptions = <
  TError = AxiosError<
    | BackupCustomDeleteV1400
    | BackupCustomDeleteV1403
    | BackupCustomDeleteV1404
    | BackupCustomDeleteV1409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCustomDeleteV1>>,
    TError,
    { addonId: number; siteId: number; data: BackupCustomDeleteV1Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupCustomDeleteV1>>,
  TError,
  { addonId: number; siteId: number; data: BackupCustomDeleteV1Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupCustomDeleteV1>>,
    { addonId: number; siteId: number; data: BackupCustomDeleteV1Body }
  > = (props) => {
    const { addonId, siteId, data } = props ?? {};

    return backupCustomDeleteV1(addonId, siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupCustomDeleteV1MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupCustomDeleteV1>>
>;
export type BackupCustomDeleteV1MutationBody = BackupCustomDeleteV1Body;
export type BackupCustomDeleteV1MutationError = AxiosError<
  | BackupCustomDeleteV1400
  | BackupCustomDeleteV1403
  | BackupCustomDeleteV1404
  | BackupCustomDeleteV1409
>;

/**
 * @summary Delete custom backup
 */
export const useBackupCustomDeleteV1 = <
  TError = AxiosError<
    | BackupCustomDeleteV1400
    | BackupCustomDeleteV1403
    | BackupCustomDeleteV1404
    | BackupCustomDeleteV1409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCustomDeleteV1>>,
    TError,
    { addonId: number; siteId: number; data: BackupCustomDeleteV1Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupCustomDeleteV1>>,
  TError,
  { addonId: number; siteId: number; data: BackupCustomDeleteV1Body },
  TContext
> => {
  const mutationOptions = getBackupCustomDeleteV1MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * HAL get_site_backup_pref: schedule, retention, and status for a site.
 * @summary Get site backup preference
 */
export const backupSettings = (
  addonId: number,
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupSettings200>> => {
  return axios.get(
    `/v1/addons/${addonId}/backup/sites/${siteId}/settings`,
    options,
  );
};

export const getBackupSettingsQueryKey = (addonId: number, siteId: number) => {
  return [`/v1/addons/${addonId}/backup/sites/${siteId}/settings`] as const;
};

export const getBackupSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof backupSettings>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupSettings>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupSettingsQueryKey(addonId, siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupSettings>>> = ({
    signal,
  }) => backupSettings(addonId, siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(addonId && siteId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof backupSettings>>
>;
export type BackupSettingsQueryError = AxiosError<unknown>;

export function useBackupSettings<
  TData = Awaited<ReturnType<typeof backupSettings>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupSettings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupSettings<
  TData = Awaited<ReturnType<typeof backupSettings>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupSettings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupSettings<
  TData = Awaited<ReturnType<typeof backupSettings>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupSettings>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get site backup preference
 */

export function useBackupSettings<
  TData = Awaited<ReturnType<typeof backupSettings>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupSettings>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupSettingsQueryOptions(addonId, siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * HAL backup_pref_create
 * @summary Create site backup preference
 */
export const backupSettingsCreate = (
  addonId: number,
  siteId: number,
  backupSettingsCreateBody: BackupSettingsCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupSettingsCreate200>> => {
  return axios.post(
    `/v1/addons/${addonId}/backup/sites/${siteId}/settings`,
    backupSettingsCreateBody,
    options,
  );
};

export const getBackupSettingsCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupSettingsCreate>>,
    TError,
    { addonId: number; siteId: number; data: BackupSettingsCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupSettingsCreate>>,
  TError,
  { addonId: number; siteId: number; data: BackupSettingsCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupSettingsCreate>>,
    { addonId: number; siteId: number; data: BackupSettingsCreateBody }
  > = (props) => {
    const { addonId, siteId, data } = props ?? {};

    return backupSettingsCreate(addonId, siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupSettingsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof backupSettingsCreate>>
>;
export type BackupSettingsCreateMutationBody = BackupSettingsCreateBody;
export type BackupSettingsCreateMutationError = AxiosError<unknown>;

/**
 * @summary Create site backup preference
 */
export const useBackupSettingsCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupSettingsCreate>>,
    TError,
    { addonId: number; siteId: number; data: BackupSettingsCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupSettingsCreate>>,
  TError,
  { addonId: number; siteId: number; data: BackupSettingsCreateBody },
  TContext
> => {
  const mutationOptions = getBackupSettingsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * HAL backup_pref_update
 * @summary Update site backup preference
 */
export const backupSettingsUpdate = (
  addonId: number,
  siteId: number,
  backupSettingsUpdateBody: BackupSettingsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupSettingsUpdate200>> => {
  return axios.put(
    `/v1/addons/${addonId}/backup/sites/${siteId}/settings`,
    backupSettingsUpdateBody,
    options,
  );
};

export const getBackupSettingsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupSettingsUpdate>>,
    TError,
    { addonId: number; siteId: number; data: BackupSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupSettingsUpdate>>,
  TError,
  { addonId: number; siteId: number; data: BackupSettingsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupSettingsUpdate>>,
    { addonId: number; siteId: number; data: BackupSettingsUpdateBody }
  > = (props) => {
    const { addonId, siteId, data } = props ?? {};

    return backupSettingsUpdate(addonId, siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupSettingsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof backupSettingsUpdate>>
>;
export type BackupSettingsUpdateMutationBody = BackupSettingsUpdateBody;
export type BackupSettingsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Update site backup preference
 */
export const useBackupSettingsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupSettingsUpdate>>,
    TError,
    { addonId: number; siteId: number; data: BackupSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupSettingsUpdate>>,
  TError,
  { addonId: number; siteId: number; data: BackupSettingsUpdateBody },
  TContext
> => {
  const mutationOptions = getBackupSettingsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * HAL backup_pref_set_status — toggles scheduled backup (enable/disable); response status is active or paused.
 * @summary Enable or disable site backup preference
 */
export const backupPrefSetStatus = (
  addonId: number,
  siteId: number,
  backupPrefSetStatusBody: BackupPrefSetStatusBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupPrefSetStatus200>> => {
  return axios.put(
    `/v1/addons/${addonId}/backup/sites/${siteId}/settings/status`,
    backupPrefSetStatusBody,
    options,
  );
};

export const getBackupPrefSetStatusMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupPrefSetStatus>>,
    TError,
    { addonId: number; siteId: number; data: BackupPrefSetStatusBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupPrefSetStatus>>,
  TError,
  { addonId: number; siteId: number; data: BackupPrefSetStatusBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupPrefSetStatus>>,
    { addonId: number; siteId: number; data: BackupPrefSetStatusBody }
  > = (props) => {
    const { addonId, siteId, data } = props ?? {};

    return backupPrefSetStatus(addonId, siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupPrefSetStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof backupPrefSetStatus>>
>;
export type BackupPrefSetStatusMutationBody = BackupPrefSetStatusBody;
export type BackupPrefSetStatusMutationError = AxiosError<unknown>;

/**
 * @summary Enable or disable site backup preference
 */
export const useBackupPrefSetStatus = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupPrefSetStatus>>,
    TError,
    { addonId: number; siteId: number; data: BackupPrefSetStatusBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupPrefSetStatus>>,
  TError,
  { addonId: number; siteId: number; data: BackupPrefSetStatusBody },
  TContext
> => {
  const mutationOptions = getBackupPrefSetStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * HAL backup_usage_stat: allowed, used, and available backup storage in bytes for the addon.
 * @summary Backup storage usage
 */
export const backupUsage = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupUsage200>> => {
  return axios.get(`/v1/addons/${addonId}/backup/usage`, options);
};

export const getBackupUsageQueryKey = (addonId: number) => {
  return [`/v1/addons/${addonId}/backup/usage`] as const;
};

export const getBackupUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof backupUsage>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackupUsageQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupUsage>>> = ({
    signal,
  }) => backupUsage(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof backupUsage>>
>;
export type BackupUsageQueryError = AxiosError<unknown>;

export function useBackupUsage<
  TData = Awaited<ReturnType<typeof backupUsage>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupUsage<
  TData = Awaited<ReturnType<typeof backupUsage>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupUsage<
  TData = Awaited<ReturnType<typeof backupUsage>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup storage usage
 */

export function useBackupUsage<
  TData = Awaited<ReturnType<typeof backupUsage>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupUsageQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Decom and delete cloudflare basic addon
 * @summary Uninstall cloudflare basic addon
 */
export const addonsCloudflare = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsCloudflare200>> => {
  return axios.delete(`/v1/addons/${addonId}/cloudflare`, options);
};

export const getAddonsCloudflareMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsCloudflare>>,
    TError,
    { addonId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addonsCloudflare>>,
  TError,
  { addonId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addonsCloudflare>>,
    { addonId: number }
  > = (props) => {
    const { addonId } = props ?? {};

    return addonsCloudflare(addonId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddonsCloudflareMutationResult = NonNullable<
  Awaited<ReturnType<typeof addonsCloudflare>>
>;

export type AddonsCloudflareMutationError = AxiosError<unknown>;

/**
 * @summary Uninstall cloudflare basic addon
 */
export const useAddonsCloudflare = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsCloudflare>>,
    TError,
    { addonId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addonsCloudflare>>,
  TError,
  { addonId: number },
  TContext
> => {
  const mutationOptions = getAddonsCloudflareMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get cloudflare basic addon nameservers
 * @summary Get cloudflare basic addon nameservers
 */
export const addonsCloudflareExternalNsCheck = (
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsCloudflareExternalNsCheck200>> => {
  return axios.get(`/v1/addons/${addonId}/cloudflare/external-ns-check`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAddonsCloudflareExternalNsCheckQueryKey = (
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
) => {
  return [
    `/v1/addons/${addonId}/cloudflare/external-ns-check`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAddonsCloudflareExternalNsCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAddonsCloudflareExternalNsCheckQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>
  > = ({ signal }) =>
    addonsCloudflareExternalNsCheck(addonId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsCloudflareExternalNsCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>
>;
export type AddonsCloudflareExternalNsCheckQueryError = AxiosError<unknown>;

export function useAddonsCloudflareExternalNsCheck<
  TData = Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: undefined | AddonsCloudflareExternalNsCheckParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsCloudflareExternalNsCheck<
  TData = Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsCloudflareExternalNsCheck<
  TData = Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get cloudflare basic addon nameservers
 */

export function useAddonsCloudflareExternalNsCheck<
  TData = Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsCloudflareExternalNsCheckParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsCloudflareExternalNsCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsCloudflareExternalNsCheckQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns addon information
 * @summary info
 */
export const addonsInfo = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsInfo200>> => {
  return axios.get(`/v1/addons/${addonId}/info`, options);
};

export const getAddonsInfoQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/info`] as const;
};

export const getAddonsInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddonsInfoQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addonsInfo>>> = ({
    signal,
  }) => addonsInfo(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsInfo>>
>;
export type AddonsInfoQueryError = AxiosError<unknown>;

export function useAddonsInfo<
  TData = Awaited<ReturnType<typeof addonsInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsInfo<
  TData = Awaited<ReturnType<typeof addonsInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsInfo<
  TData = Awaited<ReturnType<typeof addonsInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary info
 */

export function useAddonsInfo<
  TData = Awaited<ReturnType<typeof addonsInfo>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsInfoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Runs the validate_addon_state jetpack addon action to update is_connected which we return back to the client
 * @summary sso
 */
export const addonsJetpackValidate = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsJetpackValidate200>> => {
  return axios.post(
    `/v1/addons/${addonId}/jetpack/validate`,
    undefined,
    options,
  );
};

export const getAddonsJetpackValidateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsJetpackValidate>>,
    TError,
    { addonId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addonsJetpackValidate>>,
  TError,
  { addonId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addonsJetpackValidate>>,
    { addonId: string }
  > = (props) => {
    const { addonId } = props ?? {};

    return addonsJetpackValidate(addonId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddonsJetpackValidateMutationResult = NonNullable<
  Awaited<ReturnType<typeof addonsJetpackValidate>>
>;

export type AddonsJetpackValidateMutationError = AxiosError<unknown>;

/**
 * @summary sso
 */
export const useAddonsJetpackValidate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsJetpackValidate>>,
    TError,
    { addonId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addonsJetpackValidate>>,
  TError,
  { addonId: string },
  TContext
> => {
  const mutationOptions = getAddonsJetpackValidateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the credits balance of an llm addon
 * @summary Get the credits balance of llm addon
 */
export const addonsLlmBalance = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsLlmBalance200>> => {
  return axios.get(`/v1/addons/${addonId}/llm/balance`, options);
};

export const getAddonsLlmBalanceQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/llm/balance`] as const;
};

export const getAddonsLlmBalanceQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsLlmBalance>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsLlmBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsLlmBalanceQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addonsLlmBalance>>
  > = ({ signal }) => addonsLlmBalance(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsLlmBalance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsLlmBalanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsLlmBalance>>
>;
export type AddonsLlmBalanceQueryError = AxiosError<unknown>;

export function useAddonsLlmBalance<
  TData = Awaited<ReturnType<typeof addonsLlmBalance>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsLlmBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsLlmBalance>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsLlmBalance<
  TData = Awaited<ReturnType<typeof addonsLlmBalance>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsLlmBalance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsLlmBalance>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsLlmBalance<
  TData = Awaited<ReturnType<typeof addonsLlmBalance>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsLlmBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get the credits balance of llm addon
 */

export function useAddonsLlmBalance<
  TData = Awaited<ReturnType<typeof addonsLlmBalance>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsLlmBalance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsLlmBalanceQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of llm keys
 * @summary List of keys for an llm addon
 */
export const addonsLlmKeys = (
  addonId: string,
  params?: AddonsLlmKeysParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsLlmKeys200>> => {
  return axios.get(`/v1/addons/${addonId}/llm/keys`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAddonsLlmKeysQueryKey = (
  addonId: string,
  params?: AddonsLlmKeysParams,
) => {
  return [
    `/v1/addons/${addonId}/llm/keys`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAddonsLlmKeysQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsLlmKeys>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsLlmKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsLlmKeys>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsLlmKeysQueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addonsLlmKeys>>> = ({
    signal,
  }) => addonsLlmKeys(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsLlmKeys>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsLlmKeysQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsLlmKeys>>
>;
export type AddonsLlmKeysQueryError = AxiosError<unknown>;

export function useAddonsLlmKeys<
  TData = Awaited<ReturnType<typeof addonsLlmKeys>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: undefined | AddonsLlmKeysParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsLlmKeys>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsLlmKeys>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsLlmKeys<
  TData = Awaited<ReturnType<typeof addonsLlmKeys>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsLlmKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsLlmKeys>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsLlmKeys>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsLlmKeys<
  TData = Awaited<ReturnType<typeof addonsLlmKeys>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsLlmKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsLlmKeys>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List of keys for an llm addon
 */

export function useAddonsLlmKeys<
  TData = Awaited<ReturnType<typeof addonsLlmKeys>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsLlmKeysParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsLlmKeys>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsLlmKeysQueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add an llm key
 * @summary Add a key to an llm addon
 */
export const addonsLlmKeysCreate = (
  addonId: string,
  addonsLlmKeysCreateBody: AddonsLlmKeysCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsLlmKeysCreate200>> => {
  return axios.post(
    `/v1/addons/${addonId}/llm/keys`,
    addonsLlmKeysCreateBody,
    options,
  );
};

export const getAddonsLlmKeysCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsLlmKeysCreate>>,
    TError,
    { addonId: string; data: AddonsLlmKeysCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addonsLlmKeysCreate>>,
  TError,
  { addonId: string; data: AddonsLlmKeysCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addonsLlmKeysCreate>>,
    { addonId: string; data: AddonsLlmKeysCreateBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return addonsLlmKeysCreate(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddonsLlmKeysCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof addonsLlmKeysCreate>>
>;
export type AddonsLlmKeysCreateMutationBody = AddonsLlmKeysCreateBody;
export type AddonsLlmKeysCreateMutationError = AxiosError<unknown>;

/**
 * @summary Add a key to an llm addon
 */
export const useAddonsLlmKeysCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsLlmKeysCreate>>,
    TError,
    { addonId: string; data: AddonsLlmKeysCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addonsLlmKeysCreate>>,
  TError,
  { addonId: string; data: AddonsLlmKeysCreateBody },
  TContext
> => {
  const mutationOptions = getAddonsLlmKeysCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete an llm key
 * @summary Delete a key from an llm addon
 */
export const addonsLlmKeysDelete = (
  addonId: string,
  addonsLlmKeysDeleteBody: AddonsLlmKeysDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsLlmKeysDelete200>> => {
  return axios.delete(`/v1/addons/${addonId}/llm/keys`, {
    data: addonsLlmKeysDeleteBody,
    ...options,
  });
};

export const getAddonsLlmKeysDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsLlmKeysDelete>>,
    TError,
    { addonId: string; data: AddonsLlmKeysDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addonsLlmKeysDelete>>,
  TError,
  { addonId: string; data: AddonsLlmKeysDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addonsLlmKeysDelete>>,
    { addonId: string; data: AddonsLlmKeysDeleteBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return addonsLlmKeysDelete(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddonsLlmKeysDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof addonsLlmKeysDelete>>
>;
export type AddonsLlmKeysDeleteMutationBody = AddonsLlmKeysDeleteBody;
export type AddonsLlmKeysDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Delete a key from an llm addon
 */
export const useAddonsLlmKeysDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsLlmKeysDelete>>,
    TError,
    { addonId: string; data: AddonsLlmKeysDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addonsLlmKeysDelete>>,
  TError,
  { addonId: string; data: AddonsLlmKeysDeleteBody },
  TContext
> => {
  const mutationOptions = getAddonsLlmKeysDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Generates the Monarx seal HTML snippet and registration ID for the specified domain.
 * @summary Monarx seal generation
 */
export const monarxAddonSealGeneration = (
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MonarxAddonSealGeneration200>> => {
  return axios.get(`/v1/addons/${addonId}/monarx/generate_seal`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getMonarxAddonSealGenerationQueryKey = (
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
) => {
  return [
    `/v1/addons/${addonId}/monarx/generate_seal`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMonarxAddonSealGenerationQueryOptions = <
  TData = Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getMonarxAddonSealGenerationQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof monarxAddonSealGeneration>>
  > = ({ signal }) =>
    monarxAddonSealGeneration(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MonarxAddonSealGenerationQueryResult = NonNullable<
  Awaited<ReturnType<typeof monarxAddonSealGeneration>>
>;
export type MonarxAddonSealGenerationQueryError = AxiosError<void>;

export function useMonarxAddonSealGeneration<
  TData = Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params: undefined | MonarxAddonSealGenerationParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useMonarxAddonSealGeneration<
  TData = Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useMonarxAddonSealGeneration<
  TData = Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Monarx seal generation
 */

export function useMonarxAddonSealGeneration<
  TData = Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonSealGenerationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonSealGeneration>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMonarxAddonSealGenerationQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns tokenized Monarx plugin report URL for iframe usage
 * @summary Monarx report URL
 */
export const monarxAddonReportUrl = (
  addonId: number,
  params?: MonarxAddonReportUrlParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<MonarxAddonReportUrl200>> => {
  return axios.get(`/v1/addons/${addonId}/monarx/report_url`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getMonarxAddonReportUrlQueryKey = (
  addonId: number,
  params?: MonarxAddonReportUrlParams,
) => {
  return [
    `/v1/addons/${addonId}/monarx/report_url`,
    ...(params ? [params] : []),
  ] as const;
};

export const getMonarxAddonReportUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof monarxAddonReportUrl>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonReportUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonReportUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getMonarxAddonReportUrlQueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof monarxAddonReportUrl>>
  > = ({ signal }) =>
    monarxAddonReportUrl(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof monarxAddonReportUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type MonarxAddonReportUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof monarxAddonReportUrl>>
>;
export type MonarxAddonReportUrlQueryError = AxiosError<void>;

export function useMonarxAddonReportUrl<
  TData = Awaited<ReturnType<typeof monarxAddonReportUrl>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params: undefined | MonarxAddonReportUrlParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonReportUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof monarxAddonReportUrl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useMonarxAddonReportUrl<
  TData = Awaited<ReturnType<typeof monarxAddonReportUrl>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonReportUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonReportUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof monarxAddonReportUrl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useMonarxAddonReportUrl<
  TData = Awaited<ReturnType<typeof monarxAddonReportUrl>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonReportUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonReportUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Monarx report URL
 */

export function useMonarxAddonReportUrl<
  TData = Awaited<ReturnType<typeof monarxAddonReportUrl>>,
  TError = AxiosError<void>,
>(
  addonId: number,
  params?: MonarxAddonReportUrlParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof monarxAddonReportUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getMonarxAddonReportUrlQueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Assigns a domain to SpamExperts
 * @summary SpamExperts domain assign
 */
export const addonsSpamexpertsDomainAssign = (
  addonId: string,
  addonsSpamexpertsDomainAssignBody: AddonsSpamexpertsDomainAssignBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsSpamexpertsDomainAssign200>> => {
  return axios.post(
    `/v1/addons/${addonId}/spamexperts/domain/assign`,
    addonsSpamexpertsDomainAssignBody,
    options,
  );
};

export const getAddonsSpamexpertsDomainAssignMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>,
    TError,
    { addonId: string; data: AddonsSpamexpertsDomainAssignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>,
  TError,
  { addonId: string; data: AddonsSpamexpertsDomainAssignBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>,
    { addonId: string; data: AddonsSpamexpertsDomainAssignBody }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return addonsSpamexpertsDomainAssign(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddonsSpamexpertsDomainAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>
>;
export type AddonsSpamexpertsDomainAssignMutationBody =
  AddonsSpamexpertsDomainAssignBody;
export type AddonsSpamexpertsDomainAssignMutationError = AxiosError<unknown>;

/**
 * @summary SpamExperts domain assign
 */
export const useAddonsSpamexpertsDomainAssign = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>,
    TError,
    { addonId: string; data: AddonsSpamexpertsDomainAssignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addonsSpamexpertsDomainAssign>>,
  TError,
  { addonId: string; data: AddonsSpamexpertsDomainAssignBody },
  TContext
> => {
  const mutationOptions =
    getAddonsSpamexpertsDomainAssignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns spamexperts sso url
 * @summary info
 */
export const addonsSpamexpertsSso = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsSpamexpertsSso200>> => {
  return axios.get(`/v1/addons/${addonId}/spamexperts/sso`, options);
};

export const getAddonsSpamexpertsSsoQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/spamexperts/sso`] as const;
};

export const getAddonsSpamexpertsSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsSpamexpertsSsoQueryKey(addonId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addonsSpamexpertsSso>>
  > = ({ signal }) =>
    addonsSpamexpertsSso(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsSpamexpertsSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsSpamexpertsSso>>
>;
export type AddonsSpamexpertsSsoQueryError = AxiosError<unknown>;

export function useAddonsSpamexpertsSso<
  TData = Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSpamexpertsSso<
  TData = Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSpamexpertsSso<
  TData = Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary info
 */

export function useAddonsSpamexpertsSso<
  TData = Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSpamexpertsSso>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsSpamexpertsSsoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns addon sync data
 * @summary sync
 */
export const addonsSync = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsSync200>> => {
  return axios.get(`/v1/addons/${addonId}/sync`, options);
};

export const getAddonsSyncQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/sync`] as const;
};

export const getAddonsSyncQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsSync>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsSync>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAddonsSyncQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addonsSync>>> = ({
    signal,
  }) => addonsSync(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsSync>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsSyncQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsSync>>
>;
export type AddonsSyncQueryError = AxiosError<unknown>;

export function useAddonsSync<
  TData = Awaited<ReturnType<typeof addonsSync>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsSync>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSync>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSync<
  TData = Awaited<ReturnType<typeof addonsSync>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsSync>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSync>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSync<
  TData = Awaited<ReturnType<typeof addonsSync>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsSync>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sync
 */

export function useAddonsSync<
  TData = Awaited<ReturnType<typeof addonsSync>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof addonsSync>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsSyncQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns WebZai SSO URL
 * @summary webzai sso
 */
export const webzaiSso = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WebzaiSso200>> => {
  return axios.get(`/v1/addons/${addonId}/webzai/sso`, options);
};

export const getWebzaiSsoQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/webzai/sso`] as const;
};

export const getWebzaiSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof webzaiSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWebzaiSsoQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof webzaiSso>>> = ({
    signal,
  }) => webzaiSso(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type WebzaiSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof webzaiSso>>
>;
export type WebzaiSsoQueryError = AxiosError<unknown>;

export function useWebzaiSso<
  TData = Awaited<ReturnType<typeof webzaiSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof webzaiSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWebzaiSso<
  TData = Awaited<ReturnType<typeof webzaiSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof webzaiSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWebzaiSso<
  TData = Awaited<ReturnType<typeof webzaiSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary webzai sso
 */

export function useWebzaiSso<
  TData = Awaited<ReturnType<typeof webzaiSso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof webzaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWebzaiSsoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns Weebly SSO URL
 * @summary weebly sso
 */
export const weeblySso = (
  addonId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WeeblySso200>> => {
  return axios.get(`/v1/addons/${addonId}/weebly/sso`, options);
};

export const getWeeblySsoQueryKey = (addonId: string) => {
  return [`/v1/addons/${addonId}/weebly/sso`] as const;
};

export const getWeeblySsoQueryOptions = <
  TData = Awaited<ReturnType<typeof weeblySso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWeeblySsoQueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof weeblySso>>> = ({
    signal,
  }) => weeblySso(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type WeeblySsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof weeblySso>>
>;
export type WeeblySsoQueryError = AxiosError<unknown>;

export function useWeeblySso<
  TData = Awaited<ReturnType<typeof weeblySso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeblySso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWeeblySso<
  TData = Awaited<ReturnType<typeof weeblySso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof weeblySso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWeeblySso<
  TData = Awaited<ReturnType<typeof weeblySso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary weebly sso
 */

export function useWeeblySso<
  TData = Awaited<ReturnType<typeof weeblySso>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof weeblySso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWeeblySsoQueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of workflows for the addon
 * @summary addon workflow list
 */
export const addonsWorkflows = (
  addonId: string,
  params?: AddonsWorkflowsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsWorkflows200>> => {
  return axios.get(`/v1/addons/${addonId}/workflows`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAddonsWorkflowsQueryKey = (
  addonId: string,
  params?: AddonsWorkflowsParams,
) => {
  return [
    `/v1/addons/${addonId}/workflows`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAddonsWorkflowsQueryOptions = <
  TData = Awaited<ReturnType<typeof addonsWorkflows>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsWorkflowsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsWorkflows>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsWorkflowsQueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof addonsWorkflows>>> = ({
    signal,
  }) => addonsWorkflows(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsWorkflows>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsWorkflowsQueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsWorkflows>>
>;
export type AddonsWorkflowsQueryError = AxiosError<unknown>;

export function useAddonsWorkflows<
  TData = Awaited<ReturnType<typeof addonsWorkflows>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params: undefined | AddonsWorkflowsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsWorkflows>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsWorkflows>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsWorkflows<
  TData = Awaited<ReturnType<typeof addonsWorkflows>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsWorkflowsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsWorkflows>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsWorkflows>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsWorkflows<
  TData = Awaited<ReturnType<typeof addonsWorkflows>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsWorkflowsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsWorkflows>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary addon workflow list
 */

export function useAddonsWorkflows<
  TData = Awaited<ReturnType<typeof addonsWorkflows>>,
  TError = AxiosError<unknown>,
>(
  addonId: string,
  params?: AddonsWorkflowsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsWorkflows>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsWorkflowsQueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reads global announcements JSON from the configured OCI PAR URL and returns a list. Returns an empty announcements array when the feature is disabled. Requires bearer JWT.
 * @summary Announcements
 */
export const announcements = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Announcements200>> => {
  return axios.get(`/v1/announcements`, options);
};

export const getAnnouncementsQueryKey = () => {
  return [`/v1/announcements`] as const;
};

export const getAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof announcements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAnnouncementsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof announcements>>> = ({
    signal,
  }) => announcements({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof announcements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof announcements>>
>;
export type AnnouncementsQueryError = AxiosError<unknown>;

export function useAnnouncements<
  TData = Awaited<ReturnType<typeof announcements>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof announcements>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAnnouncements<
  TData = Awaited<ReturnType<typeof announcements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof announcements>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAnnouncements<
  TData = Awaited<ReturnType<typeof announcements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Announcements
 */

export function useAnnouncements<
  TData = Awaited<ReturnType<typeof announcements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof announcements>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAnnouncementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Reads bullhorn announcements JSON from the configured OCI PAR URL and returns a list. Returns an empty bullhornAnnouncements array when the feature is disabled. Requires bearer JWT.
 * @summary Bullhorn announcements
 */
export const bullhornAnnouncements = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BullhornAnnouncements200>> => {
  return axios.get(`/v1/announcements/bullhorn`, options);
};

export const getBullhornAnnouncementsQueryKey = () => {
  return [`/v1/announcements/bullhorn`] as const;
};

export const getBullhornAnnouncementsQueryOptions = <
  TData = Awaited<ReturnType<typeof bullhornAnnouncements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof bullhornAnnouncements>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBullhornAnnouncementsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof bullhornAnnouncements>>
  > = ({ signal }) => bullhornAnnouncements({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof bullhornAnnouncements>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BullhornAnnouncementsQueryResult = NonNullable<
  Awaited<ReturnType<typeof bullhornAnnouncements>>
>;
export type BullhornAnnouncementsQueryError = AxiosError<unknown>;

export function useBullhornAnnouncements<
  TData = Awaited<ReturnType<typeof bullhornAnnouncements>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof bullhornAnnouncements>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof bullhornAnnouncements>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBullhornAnnouncements<
  TData = Awaited<ReturnType<typeof bullhornAnnouncements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof bullhornAnnouncements>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof bullhornAnnouncements>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBullhornAnnouncements<
  TData = Awaited<ReturnType<typeof bullhornAnnouncements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof bullhornAnnouncements>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Bullhorn announcements
 */

export function useBullhornAnnouncements<
  TData = Awaited<ReturnType<typeof bullhornAnnouncements>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof bullhornAnnouncements>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBullhornAnnouncementsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get domain info
 * @summary domain info
 */
export const domainInfo = (
  domainId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainInfo200>> => {
  return axios.get(`/v1/domains/${domainId}`, options);
};

export const getDomainInfoQueryKey = (domainId: number) => {
  return [`/v1/domains/${domainId}`] as const;
};

export const getDomainInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof domainInfo>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDomainInfoQueryKey(domainId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domainInfo>>> = ({
    signal,
  }) => domainInfo(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainInfo>>
>;
export type DomainInfoQueryError = AxiosError<unknown>;

export function useDomainInfo<
  TData = Awaited<ReturnType<typeof domainInfo>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainInfo<
  TData = Awaited<ReturnType<typeof domainInfo>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainInfo<
  TData = Awaited<ReturnType<typeof domainInfo>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain info
 */

export function useDomainInfo<
  TData = Awaited<ReturnType<typeof domainInfo>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainInfoQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the certificates for a given domain name or id
 * @summary domain cert list
 */
export const domainCerts = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainCerts200>> => {
  return axios.get(`/v1/domains/${domainId}/certs`, options);
};

export const getDomainCertsQueryKey = (domainId: string) => {
  return [`/v1/domains/${domainId}/certs`] as const;
};

export const getDomainCertsQueryOptions = <
  TData = Awaited<ReturnType<typeof domainCerts>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainCerts>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDomainCertsQueryKey(domainId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domainCerts>>> = ({
    signal,
  }) => domainCerts(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainCerts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainCertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainCerts>>
>;
export type DomainCertsQueryError = AxiosError<unknown>;

export function useDomainCerts<
  TData = Awaited<ReturnType<typeof domainCerts>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainCerts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainCerts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainCerts<
  TData = Awaited<ReturnType<typeof domainCerts>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainCerts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainCerts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainCerts<
  TData = Awaited<ReturnType<typeof domainCerts>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainCerts>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain cert list
 */

export function useDomainCerts<
  TData = Awaited<ReturnType<typeof domainCerts>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainCerts>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainCertsQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Install and enable a certificate for a given domain
 * @summary domain cert install
 */
export const domainCertInstall = (
  domainId: string,
  domainCertInstallBody: DomainCertInstallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainCertInstall200>> => {
  return axios.post(
    `/v1/domains/${domainId}/certs`,
    domainCertInstallBody,
    options,
  );
};

export const getDomainCertInstallMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertInstall>>,
    TError,
    { domainId: string; data: DomainCertInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainCertInstall>>,
  TError,
  { domainId: string; data: DomainCertInstallBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainCertInstall>>,
    { domainId: string; data: DomainCertInstallBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainCertInstall(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainCertInstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainCertInstall>>
>;
export type DomainCertInstallMutationBody = DomainCertInstallBody;
export type DomainCertInstallMutationError = AxiosError<unknown>;

/**
 * @summary domain cert install
 */
export const useDomainCertInstall = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertInstall>>,
    TError,
    { domainId: string; data: DomainCertInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainCertInstall>>,
  TError,
  { domainId: string; data: DomainCertInstallBody },
  TContext
> => {
  const mutationOptions = getDomainCertInstallMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Install a certificate for a given domain name or id
 * @summary domain certs
 */
export const domainCertUpdate = (
  domainId: string,
  domainCertUpdateBody: DomainCertUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainCertUpdate200>> => {
  return axios.put(
    `/v1/domains/${domainId}/certs`,
    domainCertUpdateBody,
    options,
  );
};

export const getDomainCertUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertUpdate>>,
    TError,
    { domainId: string; data: DomainCertUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainCertUpdate>>,
  TError,
  { domainId: string; data: DomainCertUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainCertUpdate>>,
    { domainId: string; data: DomainCertUpdateBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainCertUpdate(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainCertUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainCertUpdate>>
>;
export type DomainCertUpdateMutationBody = DomainCertUpdateBody;
export type DomainCertUpdateMutationError = AxiosError<unknown>;

/**
 * @summary domain certs
 */
export const useDomainCertUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertUpdate>>,
    TError,
    { domainId: string; data: DomainCertUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainCertUpdate>>,
  TError,
  { domainId: string; data: DomainCertUpdateBody },
  TContext
> => {
  const mutationOptions = getDomainCertUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Uninstall a certificate for a given domain name or id
 * @summary domain cert uninstall
 */
export const domainCertUninstall = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainCertUninstall200>> => {
  return axios.delete(`/v1/domains/${domainId}/certs`, options);
};

export const getDomainCertUninstallMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertUninstall>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainCertUninstall>>,
  TError,
  { domainId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainCertUninstall>>,
    { domainId: string }
  > = (props) => {
    const { domainId } = props ?? {};

    return domainCertUninstall(domainId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainCertUninstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainCertUninstall>>
>;

export type DomainCertUninstallMutationError = AxiosError<unknown>;

/**
 * @summary domain cert uninstall
 */
export const useDomainCertUninstall = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainCertUninstall>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainCertUninstall>>,
  TError,
  { domainId: string },
  TContext
> => {
  const mutationOptions = getDomainCertUninstallMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deleting dns records to the specified domain
 * @summary delete zone record
 */
export const domainDnseditor = (
  domainId: string,
  domainDnseditorBody: DomainDnseditorBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnseditor200>> => {
  return axios.delete(`/v1/domains/${domainId}/dns-editor`, {
    data: domainDnseditorBody,
    ...options,
  });
};

export const getDomainDnseditorMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditor>>,
    TError,
    { domainId: string; data: DomainDnseditorBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainDnseditor>>,
  TError,
  { domainId: string; data: DomainDnseditorBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainDnseditor>>,
    { domainId: string; data: DomainDnseditorBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainDnseditor(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainDnseditorMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainDnseditor>>
>;
export type DomainDnseditorMutationBody = DomainDnseditorBody;
export type DomainDnseditorMutationError = AxiosError<unknown>;

/**
 * @summary delete zone record
 */
export const useDomainDnseditor = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditor>>,
    TError,
    { domainId: string; data: DomainDnseditorBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainDnseditor>>,
  TError,
  { domainId: string; data: DomainDnseditorBody },
  TContext
> => {
  const mutationOptions = getDomainDnseditorMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns all the types of DNS records that are managable to that domain or id
 * @summary Manage your nameservers and advanced DNS records.
 */
export const domainDnseditorList = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnseditorList200>> => {
  return axios.get(`/v1/domains/${domainId}/dns-editor`, options);
};

export const getDomainDnseditorListQueryKey = (domainId: string) => {
  return [`/v1/domains/${domainId}/dns-editor`] as const;
};

export const getDomainDnseditorListQueryOptions = <
  TData = Awaited<ReturnType<typeof domainDnseditorList>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnseditorList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainDnseditorListQueryKey(domainId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof domainDnseditorList>>
  > = ({ signal }) =>
    domainDnseditorList(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainDnseditorList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainDnseditorListQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainDnseditorList>>
>;
export type DomainDnseditorListQueryError = AxiosError<unknown>;

export function useDomainDnseditorList<
  TData = Awaited<ReturnType<typeof domainDnseditorList>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnseditorList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnseditorList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnseditorList<
  TData = Awaited<ReturnType<typeof domainDnseditorList>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnseditorList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnseditorList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnseditorList<
  TData = Awaited<ReturnType<typeof domainDnseditorList>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnseditorList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Manage your nameservers and advanced DNS records.
 */

export function useDomainDnseditorList<
  TData = Awaited<ReturnType<typeof domainDnseditorList>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnseditorList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainDnseditorListQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adding dns records to the specified domain
 * @summary add dns zone record
 */
export const domainDnseditorAdd = (
  domainId: string,
  domainDnseditorAddBody: DomainDnseditorAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnseditorAdd200>> => {
  return axios.post(
    `/v1/domains/${domainId}/dns-editor`,
    domainDnseditorAddBody,
    options,
  );
};

export const getDomainDnseditorAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditorAdd>>,
    TError,
    { domainId: string; data: DomainDnseditorAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainDnseditorAdd>>,
  TError,
  { domainId: string; data: DomainDnseditorAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainDnseditorAdd>>,
    { domainId: string; data: DomainDnseditorAddBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainDnseditorAdd(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainDnseditorAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainDnseditorAdd>>
>;
export type DomainDnseditorAddMutationBody = DomainDnseditorAddBody;
export type DomainDnseditorAddMutationError = AxiosError<unknown>;

/**
 * @summary add dns zone record
 */
export const useDomainDnseditorAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditorAdd>>,
    TError,
    { domainId: string; data: DomainDnseditorAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainDnseditorAdd>>,
  TError,
  { domainId: string; data: DomainDnseditorAddBody },
  TContext
> => {
  const mutationOptions = getDomainDnseditorAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Editing dns records to the specified domain
 * @summary edit dns zone record
 */
export const domainDnseditorEdit = (
  domainId: string,
  domainDnseditorEditBody: DomainDnseditorEditBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnseditorEdit200>> => {
  return axios.put(
    `/v1/domains/${domainId}/dns-editor`,
    domainDnseditorEditBody,
    options,
  );
};

export const getDomainDnseditorEditMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditorEdit>>,
    TError,
    { domainId: string; data: DomainDnseditorEditBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainDnseditorEdit>>,
  TError,
  { domainId: string; data: DomainDnseditorEditBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainDnseditorEdit>>,
    { domainId: string; data: DomainDnseditorEditBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainDnseditorEdit(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainDnseditorEditMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainDnseditorEdit>>
>;
export type DomainDnseditorEditMutationBody = DomainDnseditorEditBody;
export type DomainDnseditorEditMutationError = AxiosError<unknown>;

/**
 * @summary edit dns zone record
 */
export const useDomainDnseditorEdit = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnseditorEdit>>,
    TError,
    { domainId: string; data: DomainDnseditorEditBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainDnseditorEdit>>,
  TError,
  { domainId: string; data: DomainDnseditorEditBody },
  TContext
> => {
  const mutationOptions = getDomainDnseditorEditMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns all the types of DNS records to default state on that domain or id
 * @summary Reset your nameservers and advanced DNS records.
 */
export const domainDnszoneReset = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnszoneReset200>> => {
  return axios.get(`/v1/domains/${domainId}/dns-zone-reset`, options);
};

export const getDomainDnszoneResetQueryKey = (domainId: string) => {
  return [`/v1/domains/${domainId}/dns-zone-reset`] as const;
};

export const getDomainDnszoneResetQueryOptions = <
  TData = Awaited<ReturnType<typeof domainDnszoneReset>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnszoneReset>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainDnszoneResetQueryKey(domainId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof domainDnszoneReset>>
  > = ({ signal }) => domainDnszoneReset(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainDnszoneReset>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainDnszoneResetQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainDnszoneReset>>
>;
export type DomainDnszoneResetQueryError = AxiosError<unknown>;

export function useDomainDnszoneReset<
  TData = Awaited<ReturnType<typeof domainDnszoneReset>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnszoneReset>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnszoneReset>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnszoneReset<
  TData = Awaited<ReturnType<typeof domainDnszoneReset>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnszoneReset>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnszoneReset>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnszoneReset<
  TData = Awaited<ReturnType<typeof domainDnszoneReset>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnszoneReset>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Reset your nameservers and advanced DNS records.
 */

export function useDomainDnszoneReset<
  TData = Awaited<ReturnType<typeof domainDnszoneReset>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnszoneReset>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainDnszoneResetQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provides the status of the domain DNS Records and manage mail-related DNS records.
 * @summary Email deliverability check
 */
export const domainEmailDeliverability = (
  domainId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainEmailDeliverability200>> => {
  return axios.get(`/v1/domains/${domainId}/email-deliverability`, options);
};

export const getDomainEmailDeliverabilityQueryKey = (domainId: number) => {
  return [`/v1/domains/${domainId}/email-deliverability`] as const;
};

export const getDomainEmailDeliverabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof domainEmailDeliverability>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainEmailDeliverability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainEmailDeliverabilityQueryKey(domainId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof domainEmailDeliverability>>
  > = ({ signal }) =>
    domainEmailDeliverability(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainEmailDeliverability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainEmailDeliverabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainEmailDeliverability>>
>;
export type DomainEmailDeliverabilityQueryError = AxiosError<unknown>;

export function useDomainEmailDeliverability<
  TData = Awaited<ReturnType<typeof domainEmailDeliverability>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainEmailDeliverability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainEmailDeliverability>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainEmailDeliverability<
  TData = Awaited<ReturnType<typeof domainEmailDeliverability>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainEmailDeliverability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainEmailDeliverability>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainEmailDeliverability<
  TData = Awaited<ReturnType<typeof domainEmailDeliverability>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainEmailDeliverability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Email deliverability check
 */

export function useDomainEmailDeliverability<
  TData = Awaited<ReturnType<typeof domainEmailDeliverability>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainEmailDeliverability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainEmailDeliverabilityQueryOptions(
    domainId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Sets meta_used_entri and meta_entri_last_success on the HAL domain. customerErrors: entriLastSuccessAtRequired, linkDomainOperationNotSupported, domainOperationNotSupported.
 * @summary Record Entri last successful connection
 */
export const domainsEntriLastSuccess = (
  domainId: string,
  domainsEntriLastSuccessBody: DomainsEntriLastSuccessBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainsEntriLastSuccess200>> => {
  return axios.post(
    `/v1/domains/${domainId}/entri/last-success`,
    domainsEntriLastSuccessBody,
    options,
  );
};

export const getDomainsEntriLastSuccessMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsEntriLastSuccess>>,
    TError,
    { domainId: string; data: DomainsEntriLastSuccessBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainsEntriLastSuccess>>,
  TError,
  { domainId: string; data: DomainsEntriLastSuccessBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainsEntriLastSuccess>>,
    { domainId: string; data: DomainsEntriLastSuccessBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return domainsEntriLastSuccess(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainsEntriLastSuccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainsEntriLastSuccess>>
>;
export type DomainsEntriLastSuccessMutationBody = DomainsEntriLastSuccessBody;
export type DomainsEntriLastSuccessMutationError = AxiosError<unknown>;

/**
 * @summary Record Entri last successful connection
 */
export const useDomainsEntriLastSuccess = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsEntriLastSuccess>>,
    TError,
    { domainId: string; data: DomainsEntriLastSuccessBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainsEntriLastSuccess>>,
  TError,
  { domainId: string; data: DomainsEntriLastSuccessBody },
  TContext
> => {
  const mutationOptions = getDomainsEntriLastSuccessMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Sets hal domain meta_used_entri that indicates the domain was set up using Entri
 * @summary Set hal domain meta_used_entri
 */
export const domainsSetEntriUsed = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainsSetEntriUsed200>> => {
  return axios.post(`/v1/domains/${domainId}/entri/used`, undefined, options);
};

export const getDomainsSetEntriUsedMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsSetEntriUsed>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainsSetEntriUsed>>,
  TError,
  { domainId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainsSetEntriUsed>>,
    { domainId: string }
  > = (props) => {
    const { domainId } = props ?? {};

    return domainsSetEntriUsed(domainId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainsSetEntriUsedMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainsSetEntriUsed>>
>;

export type DomainsSetEntriUsedMutationError = AxiosError<unknown>;

/**
 * @summary Set hal domain meta_used_entri
 */
export const useDomainsSetEntriUsed = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsSetEntriUsed>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainsSetEntriUsed>>,
  TError,
  { domainId: string },
  TContext
> => {
  const mutationOptions = getDomainsSetEntriUsedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Unsets hal domain meta_used_entri that indicates the domain was set up using Entri
 * @summary Unset hal domain meta_used_entri
 */
export const domainsUnsetEntriUsed = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainsUnsetEntriUsed200>> => {
  return axios.delete(`/v1/domains/${domainId}/entri/used`, options);
};

export const getDomainsUnsetEntriUsedMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsUnsetEntriUsed>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainsUnsetEntriUsed>>,
  TError,
  { domainId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainsUnsetEntriUsed>>,
    { domainId: string }
  > = (props) => {
    const { domainId } = props ?? {};

    return domainsUnsetEntriUsed(domainId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainsUnsetEntriUsedMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainsUnsetEntriUsed>>
>;

export type DomainsUnsetEntriUsedMutationError = AxiosError<unknown>;

/**
 * @summary Unset hal domain meta_used_entri
 */
export const useDomainsUnsetEntriUsed = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainsUnsetEntriUsed>>,
    TError,
    { domainId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainsUnsetEntriUsed>>,
  TError,
  { domainId: string },
  TContext
> => {
  const mutationOptions = getDomainsUnsetEntriUsedMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Provides the health status of the domain.
 * @summary DNS Align Check
 */
export const domainHealth = (
  domainId: string,
  params?: DomainHealthParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainHealth200>> => {
  return axios.get(`/v1/domains/${domainId}/health`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDomainHealthQueryKey = (
  domainId: string,
  params?: DomainHealthParams,
) => {
  return [
    `/v1/domains/${domainId}/health`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDomainHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof domainHealth>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  params?: DomainHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainHealth>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainHealthQueryKey(domainId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domainHealth>>> = ({
    signal,
  }) => domainHealth(domainId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainHealth>>
>;
export type DomainHealthQueryError = AxiosError<unknown>;

export function useDomainHealth<
  TData = Awaited<ReturnType<typeof domainHealth>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  params: undefined | DomainHealthParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainHealth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainHealth>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainHealth<
  TData = Awaited<ReturnType<typeof domainHealth>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  params?: DomainHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainHealth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainHealth>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainHealth<
  TData = Awaited<ReturnType<typeof domainHealth>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  params?: DomainHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainHealth>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary DNS Align Check
 */

export function useDomainHealth<
  TData = Awaited<ReturnType<typeof domainHealth>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  params?: DomainHealthParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domainHealth>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainHealthQueryOptions(domainId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Access logs
 * @summary Access logs
 */
export const accessLogs = (
  domainId: number,
  params?: AccessLogsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccessLogs200>> => {
  return axios.get(`/v1/domains/${domainId}/logs/access`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccessLogsQueryKey = (
  domainId: number,
  params?: AccessLogsParams,
) => {
  return [
    `/v1/domains/${domainId}/logs/access`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAccessLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof accessLogs>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  params?: AccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accessLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccessLogsQueryKey(domainId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof accessLogs>>> = ({
    signal,
  }) => accessLogs(domainId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accessLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccessLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof accessLogs>>
>;
export type AccessLogsQueryError = AxiosError<unknown>;

export function useAccessLogs<
  TData = Awaited<ReturnType<typeof accessLogs>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  params: undefined | AccessLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accessLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccessLogs<
  TData = Awaited<ReturnType<typeof accessLogs>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  params?: AccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accessLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accessLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccessLogs<
  TData = Awaited<ReturnType<typeof accessLogs>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  params?: AccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accessLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Access logs
 */

export function useAccessLogs<
  TData = Awaited<ReturnType<typeof accessLogs>>,
  TError = AxiosError<unknown>,
>(
  domainId: number,
  params?: AccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof accessLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccessLogsQueryOptions(domainId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns DNS resource records for a domain. Works for both internal and external nameservers.
 * @summary List domain DNS resource records
 */
export const domainResourceRecords = (
  domainId: string,
  params?: DomainResourceRecordsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainResourceRecords200>> => {
  return axios.get(`/v1/domains/${domainId}/resource-records`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDomainResourceRecordsQueryKey = (
  domainId: string,
  params?: DomainResourceRecordsParams,
) => {
  return [
    `/v1/domains/${domainId}/resource-records`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDomainResourceRecordsQueryOptions = <
  TData = Awaited<ReturnType<typeof domainResourceRecords>>,
  TError = AxiosError<
    | DomainResourceRecords400
    | DomainResourceRecords401
    | DomainResourceRecords502
  >,
>(
  domainId: string,
  params?: DomainResourceRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainResourceRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDomainResourceRecordsQueryKey(domainId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof domainResourceRecords>>
  > = ({ signal }) =>
    domainResourceRecords(domainId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainResourceRecords>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainResourceRecordsQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainResourceRecords>>
>;
export type DomainResourceRecordsQueryError = AxiosError<
  DomainResourceRecords400 | DomainResourceRecords401 | DomainResourceRecords502
>;

export function useDomainResourceRecords<
  TData = Awaited<ReturnType<typeof domainResourceRecords>>,
  TError = AxiosError<
    | DomainResourceRecords400
    | DomainResourceRecords401
    | DomainResourceRecords502
  >,
>(
  domainId: string,
  params: undefined | DomainResourceRecordsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainResourceRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainResourceRecords>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainResourceRecords<
  TData = Awaited<ReturnType<typeof domainResourceRecords>>,
  TError = AxiosError<
    | DomainResourceRecords400
    | DomainResourceRecords401
    | DomainResourceRecords502
  >,
>(
  domainId: string,
  params?: DomainResourceRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainResourceRecords>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainResourceRecords>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainResourceRecords<
  TData = Awaited<ReturnType<typeof domainResourceRecords>>,
  TError = AxiosError<
    | DomainResourceRecords400
    | DomainResourceRecords401
    | DomainResourceRecords502
  >,
>(
  domainId: string,
  params?: DomainResourceRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainResourceRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List domain DNS resource records
 */

export function useDomainResourceRecords<
  TData = Awaited<ReturnType<typeof domainResourceRecords>>,
  TError = AxiosError<
    | DomainResourceRecords400
    | DomainResourceRecords401
    | DomainResourceRecords502
  >,
>(
  domainId: string,
  params?: DomainResourceRecordsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainResourceRecords>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainResourceRecordsQueryOptions(
    domainId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates DNS resource records for a domain by removing the outdated DNS and adding the new one.
 * @summary Updates domain DNS resource records
 */
export const updateDomainResourceRecords = (
  domainId: string,
  updateDomainResourceRecordsBody: UpdateDomainResourceRecordsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateDomainResourceRecords200>> => {
  return axios.put(
    `/v1/domains/${domainId}/resource-records`,
    updateDomainResourceRecordsBody,
    options,
  );
};

export const getUpdateDomainResourceRecordsMutationOptions = <
  TError = AxiosError<
    | UpdateDomainResourceRecords400
    | UpdateDomainResourceRecords401
    | UpdateDomainResourceRecords502
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDomainResourceRecords>>,
    TError,
    { domainId: string; data: UpdateDomainResourceRecordsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDomainResourceRecords>>,
  TError,
  { domainId: string; data: UpdateDomainResourceRecordsBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDomainResourceRecords>>,
    { domainId: string; data: UpdateDomainResourceRecordsBody }
  > = (props) => {
    const { domainId, data } = props ?? {};

    return updateDomainResourceRecords(domainId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDomainResourceRecordsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDomainResourceRecords>>
>;
export type UpdateDomainResourceRecordsMutationBody =
  UpdateDomainResourceRecordsBody;
export type UpdateDomainResourceRecordsMutationError = AxiosError<
  | UpdateDomainResourceRecords400
  | UpdateDomainResourceRecords401
  | UpdateDomainResourceRecords502
>;

/**
 * @summary Updates domain DNS resource records
 */
export const useUpdateDomainResourceRecords = <
  TError = AxiosError<
    | UpdateDomainResourceRecords400
    | UpdateDomainResourceRecords401
    | UpdateDomainResourceRecords502
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDomainResourceRecords>>,
    TError,
    { domainId: string; data: UpdateDomainResourceRecordsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateDomainResourceRecords>>,
  TError,
  { domainId: string; data: UpdateDomainResourceRecordsBody },
  TContext
> => {
  const mutationOptions =
    getUpdateDomainResourceRecordsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Unassign a domain name
 * @summary domain unassign
 */
export const domainUnassign = (
  domainId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainUnassign200>> => {
  return axios.post(`/v1/domains/${domainId}/unassign`, undefined, options);
};

export const getDomainUnassignMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainUnassign>>,
    TError,
    { domainId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainUnassign>>,
  TError,
  { domainId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainUnassign>>,
    { domainId: number }
  > = (props) => {
    const { domainId } = props ?? {};

    return domainUnassign(domainId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainUnassignMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainUnassign>>
>;

export type DomainUnassignMutationError = AxiosError<unknown>;

/**
 * @summary domain unassign
 */
export const useDomainUnassign = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainUnassign>>,
    TError,
    { domainId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainUnassign>>,
  TError,
  { domainId: number },
  TContext
> => {
  const mutationOptions = getDomainUnassignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a url for navigating to dns zone editor.
 * @summary domain zone editor url
 */
export const domainZoneeditorUrl = (
  domainId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainZoneeditorUrl200>> => {
  return axios.get(`/v1/domains/${domainId}/zoneeditor-url`, options);
};

export const getDomainZoneeditorUrlQueryKey = (domainId: string) => {
  return [`/v1/domains/${domainId}/zoneeditor-url`] as const;
};

export const getDomainZoneeditorUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof domainZoneeditorUrl>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainZoneeditorUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainZoneeditorUrlQueryKey(domainId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof domainZoneeditorUrl>>
  > = ({ signal }) =>
    domainZoneeditorUrl(domainId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!domainId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainZoneeditorUrl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainZoneeditorUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainZoneeditorUrl>>
>;
export type DomainZoneeditorUrlQueryError = AxiosError<unknown>;

export function useDomainZoneeditorUrl<
  TData = Awaited<ReturnType<typeof domainZoneeditorUrl>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainZoneeditorUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainZoneeditorUrl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainZoneeditorUrl<
  TData = Awaited<ReturnType<typeof domainZoneeditorUrl>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainZoneeditorUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainZoneeditorUrl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainZoneeditorUrl<
  TData = Awaited<ReturnType<typeof domainZoneeditorUrl>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainZoneeditorUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain zone editor url
 */

export function useDomainZoneeditorUrl<
  TData = Awaited<ReturnType<typeof domainZoneeditorUrl>>,
  TError = AxiosError<unknown>,
>(
  domainId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainZoneeditorUrl>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainZoneeditorUrlQueryOptions(domainId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves a JWT token from the Entri API for domain DNS configuration. Requires bearer JWT authentication.
 * @summary Get Entri JWT
 */
export const entriJwt = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EntriJwt200>> => {
  return axios.get(`/v1/entri/jwt`, options);
};

export const getEntriJwtQueryKey = () => {
  return [`/v1/entri/jwt`] as const;
};

export const getEntriJwtQueryOptions = <
  TData = Awaited<ReturnType<typeof entriJwt>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof entriJwt>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getEntriJwtQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof entriJwt>>> = ({
    signal,
  }) => entriJwt({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof entriJwt>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type EntriJwtQueryResult = NonNullable<
  Awaited<ReturnType<typeof entriJwt>>
>;
export type EntriJwtQueryError = AxiosError<void>;

export function useEntriJwt<
  TData = Awaited<ReturnType<typeof entriJwt>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof entriJwt>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof entriJwt>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useEntriJwt<
  TData = Awaited<ReturnType<typeof entriJwt>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof entriJwt>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof entriJwt>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useEntriJwt<
  TData = Awaited<ReturnType<typeof entriJwt>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof entriJwt>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get Entri JWT
 */

export function useEntriJwt<
  TData = Awaited<ReturnType<typeof entriJwt>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof entriJwt>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEntriJwtQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns HAL hosting account-level information
 * @summary HAL Hosting Account Info
 */
export const hostingAccount = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAccount200>> => {
  return axios.get(`/v1/hosting/${hostingId}`, options);
};

export const getHostingAccountQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}`] as const;
};

export const getHostingAccountQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAccount>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAccount>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAccountQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingAccount>>> = ({
    signal,
  }) => hostingAccount(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAccount>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAccountQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAccount>>
>;
export type HostingAccountQueryError = AxiosError<unknown>;

export function useHostingAccount<
  TData = Awaited<ReturnType<typeof hostingAccount>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAccount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAccount>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAccount<
  TData = Awaited<ReturnType<typeof hostingAccount>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAccount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAccount>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAccount<
  TData = Awaited<ReturnType<typeof hostingAccount>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAccount>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary HAL Hosting Account Info
 */

export function useHostingAccount<
  TData = Awaited<ReturnType<typeof hostingAccount>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAccount>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAccountQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of activities log
 * @summary To get all the recent activities log on user account level
 */
export const activityLog = (
  hostingId: string,
  params?: ActivityLogParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ActivityLog200>> => {
  return axios.get(`/v1/hosting/${hostingId}/activity-log`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getActivityLogQueryKey = (
  hostingId: string,
  params?: ActivityLogParams,
) => {
  return [
    `/v1/hosting/${hostingId}/activity-log`,
    ...(params ? [params] : []),
  ] as const;
};

export const getActivityLogQueryOptions = <
  TData = Awaited<ReturnType<typeof activityLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getActivityLogQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof activityLog>>> = ({
    signal,
  }) => activityLog(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof activityLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ActivityLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof activityLog>>
>;
export type ActivityLogQueryError = AxiosError<unknown>;

export function useActivityLog<
  TData = Awaited<ReturnType<typeof activityLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | ActivityLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityLog>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useActivityLog<
  TData = Awaited<ReturnType<typeof activityLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof activityLog>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useActivityLog<
  TData = Awaited<ReturnType<typeof activityLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary To get all the recent activities log on user account level
 */

export function useActivityLog<
  TData = Awaited<ReturnType<typeof activityLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ActivityLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof activityLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getActivityLogQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of addons.
 * @summary addon list
 */
export const hostingAddons = (
  hostingId: string,
  params?: HostingAddonsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAddons200>> => {
  return axios.get(`/v1/hosting/${hostingId}/addons`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingAddonsQueryKey = (
  hostingId: string,
  params?: HostingAddonsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/addons`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingAddonsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAddons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAddonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAddons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAddonsQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingAddons>>> = ({
    signal,
  }) => hostingAddons(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAddons>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAddonsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAddons>>
>;
export type HostingAddonsQueryError = AxiosError<unknown>;

export function useHostingAddons<
  TData = Awaited<ReturnType<typeof hostingAddons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingAddonsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAddons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAddons>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAddons<
  TData = Awaited<ReturnType<typeof hostingAddons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAddonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAddons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAddons>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAddons<
  TData = Awaited<ReturnType<typeof hostingAddons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAddonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAddons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary addon list
 */

export function useHostingAddons<
  TData = Awaited<ReturnType<typeof hostingAddons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAddonsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingAddons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAddonsQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the advanced hosting server connect url
 * @summary advanced hosting server connect url
 */
export const hostingAdvancedConsole = (
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedConsole200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/console`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingAdvancedConsoleQueryKey = (
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
) => {
  return [
    `/v1/hosting/${hostingId}/advanced/console`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingAdvancedConsoleQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingAdvancedConsoleQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedConsole>>
  > = ({ signal }) =>
    hostingAdvancedConsole(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedConsole>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedConsoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedConsole>>
>;
export type HostingAdvancedConsoleQueryError = AxiosError<unknown>;

export function useHostingAdvancedConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingAdvancedConsoleParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedConsole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedConsole>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedConsole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedConsole>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary advanced hosting server connect url
 */

export function useHostingAdvancedConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedConsoleParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedConsoleQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Checks for dns already exists
 * @summary advanced hosting dns check
 */
export const hostingAdvancedDns = (
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedDns200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/dns`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingAdvancedDnsQueryKey = (
  hostingId: string,
  params: HostingAdvancedDnsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/advanced/dns`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingAdvancedDnsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedDns>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDns>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAdvancedDnsQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedDns>>
  > = ({ signal }) =>
    hostingAdvancedDns(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedDns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedDnsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedDns>>
>;
export type HostingAdvancedDnsQueryError = AxiosError<unknown>;

export function useHostingAdvancedDns<
  TData = Awaited<ReturnType<typeof hostingAdvancedDns>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDns>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedDns>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedDns<
  TData = Awaited<ReturnType<typeof hostingAdvancedDns>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDns>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedDns>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedDns<
  TData = Awaited<ReturnType<typeof hostingAdvancedDns>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDns>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary advanced hosting dns check
 */

export function useHostingAdvancedDns<
  TData = Awaited<ReturnType<typeof hostingAdvancedDns>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingAdvancedDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDns>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedDnsQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update DNS Zone Info if it doesnt exists
 * @summary advanced hosting dns zone update
 */
export const hostingAdvancedDnsUpdate = (
  hostingId: string,
  hostingAdvancedDnsUpdateBody: HostingAdvancedDnsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedDnsUpdate200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/advanced/dns`,
    hostingAdvancedDnsUpdateBody,
    options,
  );
};

export const getHostingAdvancedDnsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>,
    TError,
    { hostingId: string; data: HostingAdvancedDnsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>,
  TError,
  { hostingId: string; data: HostingAdvancedDnsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>,
    { hostingId: string; data: HostingAdvancedDnsUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingAdvancedDnsUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingAdvancedDnsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>
>;
export type HostingAdvancedDnsUpdateMutationBody = HostingAdvancedDnsUpdateBody;
export type HostingAdvancedDnsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary advanced hosting dns zone update
 */
export const useHostingAdvancedDnsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>,
    TError,
    { hostingId: string; data: HostingAdvancedDnsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingAdvancedDnsUpdate>>,
  TError,
  { hostingId: string; data: HostingAdvancedDnsUpdateBody },
  TContext
> => {
  const mutationOptions = getHostingAdvancedDnsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * To check for the domain services configuration
 * @summary Domain services configuration check
 */
export const hostingAdvancedDomainServicesCheck = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedDomainServicesCheck200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/advanced/domain/services`,
    options,
  );
};

export const getHostingAdvancedDomainServicesCheckQueryKey = (
  hostingId: string,
) => {
  return [`/v1/hosting/${hostingId}/advanced/domain/services`] as const;
};

export const getHostingAdvancedDomainServicesCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingAdvancedDomainServicesCheckQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>
  > = ({ signal }) =>
    hostingAdvancedDomainServicesCheck(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedDomainServicesCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>
>;
export type HostingAdvancedDomainServicesCheckQueryError = AxiosError<unknown>;

export function useHostingAdvancedDomainServicesCheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedDomainServicesCheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedDomainServicesCheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Domain services configuration check
 */

export function useHostingAdvancedDomainServicesCheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedDomainServicesCheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedDomainServicesCheckQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * To configure domain services
 * @summary Domain services configuration
 */
export const hostingAdvancedDomainServices = (
  hostingId: string,
  hostingAdvancedDomainServicesBody: HostingAdvancedDomainServicesBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedDomainServices200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/advanced/domain/services`,
    hostingAdvancedDomainServicesBody,
    options,
  );
};

export const getHostingAdvancedDomainServicesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedDomainServices>>,
    TError,
    { hostingId: string; data: HostingAdvancedDomainServicesBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingAdvancedDomainServices>>,
  TError,
  { hostingId: string; data: HostingAdvancedDomainServicesBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingAdvancedDomainServices>>,
    { hostingId: string; data: HostingAdvancedDomainServicesBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingAdvancedDomainServices(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingAdvancedDomainServicesMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedDomainServices>>
>;
export type HostingAdvancedDomainServicesMutationBody =
  HostingAdvancedDomainServicesBody;
export type HostingAdvancedDomainServicesMutationError = AxiosError<unknown>;

/**
 * @summary Domain services configuration
 */
export const useHostingAdvancedDomainServices = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedDomainServices>>,
    TError,
    { hostingId: string; data: HostingAdvancedDomainServicesBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingAdvancedDomainServices>>,
  TError,
  { hostingId: string; data: HostingAdvancedDomainServicesBody },
  TContext
> => {
  const mutationOptions =
    getHostingAdvancedDomainServicesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of images avaiable to rebuild a server with
 * @summary list of server images
 */
export const hostingAdvancedImages = (
  hostingId: string,
  params?: HostingAdvancedImagesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedImages200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/images`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingAdvancedImagesQueryKey = (
  hostingId: string,
  params?: HostingAdvancedImagesParams,
) => {
  return [
    `/v1/hosting/${hostingId}/advanced/images`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingAdvancedImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedImages>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedImages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingAdvancedImagesQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedImages>>
  > = ({ signal }) =>
    hostingAdvancedImages(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedImages>>
>;
export type HostingAdvancedImagesQueryError = AxiosError<unknown>;

export function useHostingAdvancedImages<
  TData = Awaited<ReturnType<typeof hostingAdvancedImages>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingAdvancedImagesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedImages>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedImages>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedImages<
  TData = Awaited<ReturnType<typeof hostingAdvancedImages>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedImages>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedImages>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedImages<
  TData = Awaited<ReturnType<typeof hostingAdvancedImages>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedImages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary list of server images
 */

export function useHostingAdvancedImages<
  TData = Awaited<ReturnType<typeof hostingAdvancedImages>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingAdvancedImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedImages>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedImagesQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting server info
 * @summary server status/info
 */
export const hostingAdvancedServer = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedServer200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/server`, options);
};

export const getHostingAdvancedServerQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/advanced/server`] as const;
};

export const getHostingAdvancedServerQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedServer>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServer>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAdvancedServerQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedServer>>
  > = ({ signal }) =>
    hostingAdvancedServer(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedServer>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedServerQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedServer>>
>;
export type HostingAdvancedServerQueryError = AxiosError<unknown>;

export function useHostingAdvancedServer<
  TData = Awaited<ReturnType<typeof hostingAdvancedServer>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServer>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServer>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServer<
  TData = Awaited<ReturnType<typeof hostingAdvancedServer>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServer>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServer>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServer<
  TData = Awaited<ReturnType<typeof hostingAdvancedServer>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServer>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary server status/info
 */

export function useHostingAdvancedServer<
  TData = Awaited<ReturnType<typeof hostingAdvancedServer>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServer>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedServerQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows for managing server status
 * @summary server_status
 */
export const hostingAdvancedServerStatus = (
  hostingId: number,
  hostingAdvancedServerStatusBody: HostingAdvancedServerStatusBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedServerStatus200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/advanced/server`,
    hostingAdvancedServerStatusBody,
    options,
  );
};

export const getHostingAdvancedServerStatusMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedServerStatus>>,
    TError,
    { hostingId: number; data: HostingAdvancedServerStatusBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingAdvancedServerStatus>>,
  TError,
  { hostingId: number; data: HostingAdvancedServerStatusBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingAdvancedServerStatus>>,
    { hostingId: number; data: HostingAdvancedServerStatusBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingAdvancedServerStatus(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingAdvancedServerStatusMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedServerStatus>>
>;
export type HostingAdvancedServerStatusMutationBody =
  HostingAdvancedServerStatusBody;
export type HostingAdvancedServerStatusMutationError = AxiosError<unknown>;

/**
 * @summary server_status
 */
export const useHostingAdvancedServerStatus = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedServerStatus>>,
    TError,
    { hostingId: number; data: HostingAdvancedServerStatusBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingAdvancedServerStatus>>,
  TError,
  { hostingId: number; data: HostingAdvancedServerStatusBody },
  TContext
> => {
  const mutationOptions =
    getHostingAdvancedServerStatusMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Check whether the server guest is reachable and capable of performing actions that require a healthy server
 * @summary server healthcheck
 */
export const hostingAdvancedServerHealthcheck = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedServerHealthcheck200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/advanced/server/healthcheck`,
    options,
  );
};

export const getHostingAdvancedServerHealthcheckQueryKey = (
  hostingId: string,
) => {
  return [`/v1/hosting/${hostingId}/advanced/server/healthcheck`] as const;
};

export const getHostingAdvancedServerHealthcheckQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingAdvancedServerHealthcheckQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>
  > = ({ signal }) =>
    hostingAdvancedServerHealthcheck(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedServerHealthcheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>
>;
export type HostingAdvancedServerHealthcheckQueryError = AxiosError<unknown>;

export function useHostingAdvancedServerHealthcheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServerHealthcheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServerHealthcheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary server healthcheck
 */

export function useHostingAdvancedServerHealthcheck<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerHealthcheck>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedServerHealthcheckQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update user account's password
 * @summary Update user account password
 */
export const hostingAdvancedPassword = (
  hostingId: number,
  hostingAdvancedPasswordBody: HostingAdvancedPasswordBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedPassword200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/advanced/server/password`,
    hostingAdvancedPasswordBody,
    options,
  );
};

export const getHostingAdvancedPasswordMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedPassword>>,
    TError,
    { hostingId: number; data: HostingAdvancedPasswordBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingAdvancedPassword>>,
  TError,
  { hostingId: number; data: HostingAdvancedPasswordBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingAdvancedPassword>>,
    { hostingId: number; data: HostingAdvancedPasswordBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingAdvancedPassword(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingAdvancedPasswordMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedPassword>>
>;
export type HostingAdvancedPasswordMutationBody = HostingAdvancedPasswordBody;
export type HostingAdvancedPasswordMutationError = AxiosError<unknown>;

/**
 * @summary Update user account password
 */
export const useHostingAdvancedPassword = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingAdvancedPassword>>,
    TError,
    { hostingId: number; data: HostingAdvancedPasswordBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingAdvancedPassword>>,
  TError,
  { hostingId: number; data: HostingAdvancedPasswordBody },
  TContext
> => {
  const mutationOptions = getHostingAdvancedPasswordMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the hosting sso_whm login url
 * @summary hosting sso_whm
 */
export const hostingAdvancedSsoWhm = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedSsoWhm200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/sso_whm`, options);
};

export const getHostingAdvancedSsoWhmQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/advanced/sso_whm`] as const;
};

export const getHostingAdvancedSsoWhmQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAdvancedSsoWhmQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>
  > = ({ signal }) =>
    hostingAdvancedSsoWhm(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedSsoWhmQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>
>;
export type HostingAdvancedSsoWhmQueryError = AxiosError<unknown>;

export function useHostingAdvancedSsoWhm<
  TData = Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedSsoWhm<
  TData = Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedSsoWhm<
  TData = Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting sso_whm
 */

export function useHostingAdvancedSsoWhm<
  TData = Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedSsoWhmQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting system_console url
 * @deprecated
 * @summary hosting system_console
 */
export const hostingAdvancedSystemConsole = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedSystemConsole200>> => {
  return axios.get(`/v1/hosting/${hostingId}/advanced/system-console`, options);
};

export const getHostingAdvancedSystemConsoleQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/advanced/system-console`] as const;
};

export const getHostingAdvancedSystemConsoleQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingAdvancedSystemConsoleQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>
  > = ({ signal }) =>
    hostingAdvancedSystemConsole(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedSystemConsoleQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>
>;
export type HostingAdvancedSystemConsoleQueryError = AxiosError<unknown>;

export function useHostingAdvancedSystemConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedSystemConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedSystemConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary hosting system_console
 */

export function useHostingAdvancedSystemConsole<
  TData = Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedSystemConsole>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedSystemConsoleQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all applications on a managed hosting server. Returns each application's deployment status, configuration completeness, live URL, and a summary block with dashboard triage counts (total, healthy, needs attention). Applications with incomplete configuration, in-flight deployments, failed candidates, or no deployment yet count toward needs_attention.
 * @summary List applications on a hosting server
 */
export const hostingApplicationsList = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationListResponse>> => {
  return axios.get(`/v1/hosting/${hostingId}/applications/`, options);
};

export const getHostingApplicationsListQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/applications/`] as const;
};

export const getHostingApplicationsListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingApplicationsListQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationsList>>
  > = ({ signal }) =>
    hostingApplicationsList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationsList>>
>;
export type HostingApplicationsListQueryError =
  AxiosError<HostingErrorResponse>;

export function useHostingApplicationsList<
  TData = Awaited<ReturnType<typeof hostingApplicationsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationsList<
  TData = Awaited<ReturnType<typeof hostingApplicationsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationsList<
  TData = Awaited<ReturnType<typeof hostingApplicationsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List applications on a hosting server
 */

export function useHostingApplicationsList<
  TData = Awaited<ReturnType<typeof hostingApplicationsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationsListQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the application overview used for the live deployment card, health status, hostname list and primary URL, configuration completeness, target wildcard SSL status (active | none | unknown from Control Plane lifecycle), and whether redeploy or rollback is currently allowed. When a newer deployment is building, rolling back, or has failed, a banner explains the situation and which deployment continues serving live traffic. The deployed_by field is always null. When health probes are unavailable, health is null and the rest of the overview still returns 200. When SSL status cannot be loaded, ssl.status is unknown and the overview still returns 200.
 * @summary Get application overview
 */
export const hostingApplicationGet = (
  hostingId: string,
  applicationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationOverviewResponse>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/applications/${applicationId}/`,
    options,
  );
};

export const getHostingApplicationGetQueryKey = (
  hostingId: string,
  applicationId: string,
) => {
  return [`/v1/hosting/${hostingId}/applications/${applicationId}/`] as const;
};

export const getHostingApplicationGetQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingApplicationGetQueryKey(hostingId, applicationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationGet>>
  > = ({ signal }) =>
    hostingApplicationGet(hostingId, applicationId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && applicationId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationGet>>
>;
export type HostingApplicationGetQueryError = AxiosError<HostingErrorResponse>;

export function useHostingApplicationGet<
  TData = Awaited<ReturnType<typeof hostingApplicationGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationGet<
  TData = Awaited<ReturnType<typeof hostingApplicationGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationGet<
  TData = Awaited<ReturnType<typeof hostingApplicationGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get application overview
 */

export function useHostingApplicationGet<
  TData = Awaited<ReturnType<typeof hostingApplicationGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationGetQueryOptions(
    hostingId,
    applicationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Removes an application from this hosting server. The app stops serving traffic, its configuration is cleared, and it no longer appears in the applications list. Deleting an application that has already been removed returns not found. Ask the user to confirm before calling this endpoint.
 * @summary Delete application
 */
export const hostingApplicationDelete = (
  hostingId: string,
  applicationId: string,
  params?: HostingApplicationDeleteParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationDeleteResponse>> => {
  return axios.delete(
    `/v1/hosting/${hostingId}/applications/${applicationId}/`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getHostingApplicationDeleteMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationDelete>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      params?: HostingApplicationDeleteParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationDelete>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    params?: HostingApplicationDeleteParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationDelete>>,
    {
      hostingId: string;
      applicationId: string;
      params?: HostingApplicationDeleteParams;
    }
  > = (props) => {
    const { hostingId, applicationId, params } = props ?? {};

    return hostingApplicationDelete(
      hostingId,
      applicationId,
      params,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationDelete>>
>;

export type HostingApplicationDeleteMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Delete application
 */
export const useHostingApplicationDelete = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationDelete>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      params?: HostingApplicationDeleteParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationDelete>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    params?: HostingApplicationDeleteParams;
  },
  TContext
> => {
  const mutationOptions = getHostingApplicationDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the production-scoped configuration for an application. Secrets are listed without their values (use action replace or set_value to update). Plain environment variables include their full value when set (use action edit or set_value to update). When required values are missing, deploys_blocked is true and deploys_blocked_message explains what is blocking redeploy and rollback.
 * @summary Get application configuration
 */
export const hostingApplicationConfigGet = (
  hostingId: string,
  applicationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationConfigResponse>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/applications/${applicationId}/config`,
    options,
  );
};

export const getHostingApplicationConfigGetQueryKey = (
  hostingId: string,
  applicationId: string,
) => {
  return [
    `/v1/hosting/${hostingId}/applications/${applicationId}/config`,
  ] as const;
};

export const getHostingApplicationConfigGetQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingApplicationConfigGetQueryKey(hostingId, applicationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationConfigGet>>
  > = ({ signal }) =>
    hostingApplicationConfigGet(hostingId, applicationId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && applicationId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationConfigGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationConfigGet>>
>;
export type HostingApplicationConfigGetQueryError =
  AxiosError<HostingErrorResponse>;

export function useHostingApplicationConfigGet<
  TData = Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationConfigGet<
  TData = Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationConfigGet<
  TData = Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get application configuration
 */

export function useHostingApplicationConfigGet<
  TData = Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationConfigGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationConfigGetQueryOptions(
    hostingId,
    applicationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set or replace a plain or secret config variable for the application. Config writes are saved immediately but do not trigger a deployment; call Redeploy to apply changes to the live application. The response is an acknowledgment only and never echoes the submitted value. Refresh configuration state via GET config after a successful write.
 * @summary Set or replace a config value
 */
export const hostingApplicationConfigSet = (
  hostingId: string,
  applicationId: string,
  name: string,
  hostingConfigSetVariableRequest: HostingConfigSetVariableRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingConfigMutationResponse>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/applications/${applicationId}/config/${name}`,
    hostingConfigSetVariableRequest,
    options,
  );
};

export const getHostingApplicationConfigSetMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationConfigSet>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      name: string;
      data: HostingConfigSetVariableRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationConfigSet>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    name: string;
    data: HostingConfigSetVariableRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationConfigSet>>,
    {
      hostingId: string;
      applicationId: string;
      name: string;
      data: HostingConfigSetVariableRequest;
    }
  > = (props) => {
    const { hostingId, applicationId, name, data } = props ?? {};

    return hostingApplicationConfigSet(
      hostingId,
      applicationId,
      name,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationConfigSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationConfigSet>>
>;
export type HostingApplicationConfigSetMutationBody =
  HostingConfigSetVariableRequest;
export type HostingApplicationConfigSetMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Set or replace a config value
 */
export const useHostingApplicationConfigSet = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationConfigSet>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      name: string;
      data: HostingConfigSetVariableRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationConfigSet>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    name: string;
    data: HostingConfigSetVariableRequest;
  },
  TContext
> => {
  const mutationOptions =
    getHostingApplicationConfigSetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * HC-703: unset a plain or secret variable via Control Plane Delete Config (environment=production). Config writes are durable-only — no deployment is minted; apply changes via Redeploy. Idempotent when the variable is already absent (config_version and config_digest may be null). MFE refreshes via GET config.
 * @summary Delete a config variable
 */
export const hostingApplicationConfigDelete = (
  hostingId: string,
  applicationId: string,
  name: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingConfigMutationResponse>> => {
  return axios.delete(
    `/v1/hosting/${hostingId}/applications/${applicationId}/config/${name}`,
    options,
  );
};

export const getHostingApplicationConfigDeleteMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationConfigDelete>>,
    TError,
    { hostingId: string; applicationId: string; name: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationConfigDelete>>,
  TError,
  { hostingId: string; applicationId: string; name: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationConfigDelete>>,
    { hostingId: string; applicationId: string; name: string }
  > = (props) => {
    const { hostingId, applicationId, name } = props ?? {};

    return hostingApplicationConfigDelete(
      hostingId,
      applicationId,
      name,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationConfigDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationConfigDelete>>
>;

export type HostingApplicationConfigDeleteMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Delete a config variable
 */
export const useHostingApplicationConfigDelete = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationConfigDelete>>,
    TError,
    { hostingId: string; applicationId: string; name: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationConfigDelete>>,
  TError,
  { hostingId: string; applicationId: string; name: string },
  TContext
> => {
  const mutationOptions =
    getHostingApplicationConfigDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns deployment history for an application, sorted newest first. Each row includes is_live (currently serving traffic) and is_rollback_eligible (valid rollback target). Also returns actions indicating whether redeploy and rollback are currently allowed, plus deploy-blocking state when required configuration values are missing.
 * @summary List application deployments
 */
export const hostingApplicationDeploymentsList = (
  hostingId: string,
  applicationId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationDeploymentHistoryResponse>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments`,
    options,
  );
};

export const getHostingApplicationDeploymentsListQueryKey = (
  hostingId: string,
  applicationId: string,
) => {
  return [
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments`,
  ] as const;
};

export const getHostingApplicationDeploymentsListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingApplicationDeploymentsListQueryKey(hostingId, applicationId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>
  > = ({ signal }) =>
    hostingApplicationDeploymentsList(hostingId, applicationId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && applicationId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationDeploymentsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>
>;
export type HostingApplicationDeploymentsListQueryError =
  AxiosError<HostingErrorResponse>;

export function useHostingApplicationDeploymentsList<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentsList<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentsList<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List application deployments
 */

export function useHostingApplicationDeploymentsList<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationDeploymentsListQueryOptions(
    hostingId,
    applicationId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enqueue a new deployment by replaying the build inputs from the currently active deployment. The caller sends only optional idempotency_key and correlation_id; all other enqueue fields are derived server-side. Returns 422 when configuration is incomplete, a deployment is already in flight, there is no active deployment to replay from, or required build inputs are unavailable.
 * @summary Redeploy an application
 */
export const hostingApplicationRedeploy = (
  hostingId: string,
  applicationId: string,
  hostingRedeployRequest?: HostingRedeployRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRedeployResponse>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments`,
    hostingRedeployRequest,
    options,
  );
};

export const getHostingApplicationRedeployMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationRedeploy>>,
    TError,
    { hostingId: string; applicationId: string; data: HostingRedeployRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationRedeploy>>,
  TError,
  { hostingId: string; applicationId: string; data: HostingRedeployRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationRedeploy>>,
    { hostingId: string; applicationId: string; data: HostingRedeployRequest }
  > = (props) => {
    const { hostingId, applicationId, data } = props ?? {};

    return hostingApplicationRedeploy(
      hostingId,
      applicationId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationRedeployMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationRedeploy>>
>;
export type HostingApplicationRedeployMutationBody = HostingRedeployRequest;
export type HostingApplicationRedeployMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Redeploy an application
 */
export const useHostingApplicationRedeploy = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationRedeploy>>,
    TError,
    { hostingId: string; applicationId: string; data: HostingRedeployRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationRedeploy>>,
  TError,
  { hostingId: string; applicationId: string; data: HostingRedeployRequest },
  TContext
> => {
  const mutationOptions = getHostingApplicationRedeployMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a single deployment with progress stepper, current stage message, health probes, status transition history, and an optional failure callout when the deployment ended in terminal_failure. Use is_rollback_eligible from the history list to identify valid rollback targets. When health probes are unavailable, health is null and the rest of the detail still returns 200. During rollback, stepper.current is rolling_back or rolled_back (not active); rollback stages are appended to stepper.stages when relevant.
 * @summary Get application deployment detail
 */
export const hostingApplicationDeploymentGet = (
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationDeploymentDetailResponse>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments/${deploymentId}`,
    options,
  );
};

export const getHostingApplicationDeploymentGetQueryKey = (
  hostingId: string,
  applicationId: string,
  deploymentId: string,
) => {
  return [
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments/${deploymentId}`,
  ] as const;
};

export const getHostingApplicationDeploymentGetQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingApplicationDeploymentGetQueryKey(
      hostingId,
      applicationId,
      deploymentId,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>
  > = ({ signal }) =>
    hostingApplicationDeploymentGet(hostingId, applicationId, deploymentId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && applicationId && deploymentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationDeploymentGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>
>;
export type HostingApplicationDeploymentGetQueryError =
  AxiosError<HostingErrorResponse>;

export function useHostingApplicationDeploymentGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get application deployment detail
 */

export function useHostingApplicationDeploymentGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationDeploymentGetQueryOptions(
    hostingId,
    applicationId,
    deploymentId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns one page of redacted deployment logs. Logs are paged, not streamed; use cursor and next_cursor to load additional pages. An empty segments array is a successful response (no log lines yet). The deployment must belong to the application under the resolved hosting server.
 * @summary Get paged safe deployment logs
 */
export const hostingApplicationDeploymentLogsGet = (
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationDeploymentLogsResponse>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments/${deploymentId}/logs`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getHostingApplicationDeploymentLogsGetQueryKey = (
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
) => {
  return [
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments/${deploymentId}/logs`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingApplicationDeploymentLogsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingApplicationDeploymentLogsGetQueryKey(
      hostingId,
      applicationId,
      deploymentId,
      params,
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>
  > = ({ signal }) =>
    hostingApplicationDeploymentLogsGet(
      hostingId,
      applicationId,
      deploymentId,
      params,
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && applicationId && deploymentId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingApplicationDeploymentLogsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>
>;
export type HostingApplicationDeploymentLogsGetQueryError =
  AxiosError<HostingErrorResponse>;

export function useHostingApplicationDeploymentLogsGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params: undefined | HostingApplicationDeploymentLogsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentLogsGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingApplicationDeploymentLogsGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get paged safe deployment logs
 */

export function useHostingApplicationDeploymentLogsGet<
  TData = Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
  TError = AxiosError<HostingErrorResponse>,
>(
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  params?: HostingApplicationDeploymentLogsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingApplicationDeploymentLogsGet>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingApplicationDeploymentLogsGetQueryOptions(
    hostingId,
    applicationId,
    deploymentId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Execute a rollback from the path deployment_id (typically the current live deployment) to body.to_deployment_id (an eligible prior deployment). confirmation_application_id must exactly match the path application_id as a safety check. Returns 422 when configuration is incomplete, a deployment is in flight, confirmation does not match, or the target deployment is not rollback-eligible.
 * @summary Roll back an application deployment
 */
export const hostingApplicationDeploymentRollback = (
  hostingId: string,
  applicationId: string,
  deploymentId: string,
  hostingRollbackRequest: HostingRollbackRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRollbackResponse>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/applications/${applicationId}/deployments/${deploymentId}/rollback`,
    hostingRollbackRequest,
    options,
  );
};

export const getHostingApplicationDeploymentRollbackMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      deploymentId: string;
      data: HostingRollbackRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    deploymentId: string;
    data: HostingRollbackRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>,
    {
      hostingId: string;
      applicationId: string;
      deploymentId: string;
      data: HostingRollbackRequest;
    }
  > = (props) => {
    const { hostingId, applicationId, deploymentId, data } = props ?? {};

    return hostingApplicationDeploymentRollback(
      hostingId,
      applicationId,
      deploymentId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationDeploymentRollbackMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>
>;
export type HostingApplicationDeploymentRollbackMutationBody =
  HostingRollbackRequest;
export type HostingApplicationDeploymentRollbackMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Roll back an application deployment
 */
export const useHostingApplicationDeploymentRollback = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      deploymentId: string;
      data: HostingRollbackRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationDeploymentRollback>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    deploymentId: string;
    data: HostingRollbackRequest;
  },
  TContext
> => {
  const mutationOptions =
    getHostingApplicationDeploymentRollbackMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Replace the full set of hostnames bound to this application. The request body is the complete replacement list; an empty list clears all bindings. Each hostname must be a non-blank string. Returns 409 hostnameConflict when a hostname is already bound to another application. Returns 422 hostnameValidationError for invalid hostname format. Does not provision DNS or SSL certificates.
 * @summary Replace application hostnames
 */
export const hostingApplicationHostnamesPut = (
  hostingId: string,
  applicationId: string,
  hostingApplicationHostnamesRequest: HostingApplicationHostnamesRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingApplicationHostnamesResponse>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/applications/${applicationId}/hostnames`,
    hostingApplicationHostnamesRequest,
    options,
  );
};

export const getHostingApplicationHostnamesPutMutationOptions = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      data: HostingApplicationHostnamesRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    data: HostingApplicationHostnamesRequest;
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>,
    {
      hostingId: string;
      applicationId: string;
      data: HostingApplicationHostnamesRequest;
    }
  > = (props) => {
    const { hostingId, applicationId, data } = props ?? {};

    return hostingApplicationHostnamesPut(
      hostingId,
      applicationId,
      data,
      axiosOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingApplicationHostnamesPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>
>;
export type HostingApplicationHostnamesPutMutationBody =
  HostingApplicationHostnamesRequest;
export type HostingApplicationHostnamesPutMutationError =
  AxiosError<HostingErrorResponse>;

/**
 * @summary Replace application hostnames
 */
export const useHostingApplicationHostnamesPut = <
  TError = AxiosError<HostingErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>,
    TError,
    {
      hostingId: string;
      applicationId: string;
      data: HostingApplicationHostnamesRequest;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingApplicationHostnamesPut>>,
  TError,
  {
    hostingId: string;
    applicationId: string;
    data: HostingApplicationHostnamesRequest;
  },
  TContext
> => {
  const mutationOptions =
    getHostingApplicationHostnamesPutMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns details about the backup options available for the hosting
 * @summary hosting backup details
 */
export const hostingBackups = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingBackups200>> => {
  return axios.get(`/v1/hosting/${hostingId}/backups`, options);
};

export const getHostingBackupsQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/backups`] as const;
};

export const getHostingBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingBackups>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingBackupsQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingBackups>>> = ({
    signal,
  }) => hostingBackups(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingBackups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingBackups>>
>;
export type HostingBackupsQueryError = AxiosError<unknown>;

export function useHostingBackups<
  TData = Awaited<ReturnType<typeof hostingBackups>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingBackups>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingBackups<
  TData = Awaited<ReturnType<typeof hostingBackups>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingBackups>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingBackups<
  TData = Awaited<ReturnType<typeof hostingBackups>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting backup details
 */

export function useHostingBackups<
  TData = Awaited<ReturnType<typeof hostingBackups>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingBackupsQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting capabilities
 * @summary hosting capabilities
 */
export const hostingCapabilities = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingCapabilities200>> => {
  return axios.get(`/v1/hosting/${hostingId}/capabilities`, options);
};

export const getHostingCapabilitiesQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/capabilities`] as const;
};

export const getHostingCapabilitiesQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingCapabilities>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingCapabilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingCapabilitiesQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingCapabilities>>
  > = ({ signal }) =>
    hostingCapabilities(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingCapabilities>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingCapabilitiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingCapabilities>>
>;
export type HostingCapabilitiesQueryError = AxiosError<unknown>;

export function useHostingCapabilities<
  TData = Awaited<ReturnType<typeof hostingCapabilities>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingCapabilities>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingCapabilities<
  TData = Awaited<ReturnType<typeof hostingCapabilities>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingCapabilities>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingCapabilities>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingCapabilities<
  TData = Awaited<ReturnType<typeof hostingCapabilities>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingCapabilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting capabilities
 */

export function useHostingCapabilities<
  TData = Awaited<ReturnType<typeof hostingCapabilities>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingCapabilities>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingCapabilitiesQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of cron jobs
 * @summary cron_list
 */
export const listCrons = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ListCrons200>> => {
  return axios.get(`/v1/hosting/${hostingId}/crontab`, options);
};

export const getListCronsQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/crontab`] as const;
};

export const getListCronsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCrons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCronsQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCrons>>> = ({
    signal,
  }) => listCrons(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListCronsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCrons>>
>;
export type ListCronsQueryError = AxiosError<unknown>;

export function useListCrons<
  TData = Awaited<ReturnType<typeof listCrons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrons>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListCrons<
  TData = Awaited<ReturnType<typeof listCrons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCrons>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListCrons<
  TData = Awaited<ReturnType<typeof listCrons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary cron_list
 */

export function useListCrons<
  TData = Awaited<ReturnType<typeof listCrons>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listCrons>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCronsQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds a new cron job
 * @summary cron_add
 */
export const addCron = (
  hostingId: number,
  addCronBody: AddCronBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddCron200>> => {
  return axios.post(`/v1/hosting/${hostingId}/crontab`, addCronBody, options);
};

export const getAddCronMutationOptions = <
  TError = AxiosError<AddCron400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCron>>,
    TError,
    { hostingId: number; data: AddCronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addCron>>,
  TError,
  { hostingId: number; data: AddCronBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addCron>>,
    { hostingId: number; data: AddCronBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return addCron(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddCronMutationResult = NonNullable<
  Awaited<ReturnType<typeof addCron>>
>;
export type AddCronMutationBody = AddCronBody;
export type AddCronMutationError = AxiosError<AddCron400>;

/**
 * @summary cron_add
 */
export const useAddCron = <
  TError = AxiosError<AddCron400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addCron>>,
    TError,
    { hostingId: number; data: AddCronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addCron>>,
  TError,
  { hostingId: number; data: AddCronBody },
  TContext
> => {
  const mutationOptions = getAddCronMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates a cron job
 * @summary cron_update
 */
export const updateCron = (
  hostingId: number,
  updateCronBody: UpdateCronBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UpdateCron200>> => {
  return axios.put(`/v1/hosting/${hostingId}/crontab`, updateCronBody, options);
};

export const getUpdateCronMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCron>>,
    TError,
    { hostingId: number; data: UpdateCronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCron>>,
  TError,
  { hostingId: number; data: UpdateCronBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCron>>,
    { hostingId: number; data: UpdateCronBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return updateCron(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCronMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCron>>
>;
export type UpdateCronMutationBody = UpdateCronBody;
export type UpdateCronMutationError = AxiosError<unknown>;

/**
 * @summary cron_update
 */
export const useUpdateCron = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCron>>,
    TError,
    { hostingId: number; data: UpdateCronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCron>>,
  TError,
  { hostingId: number; data: UpdateCronBody },
  TContext
> => {
  const mutationOptions = getUpdateCronMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes a cron job
 * @summary cron_delete
 */
export const cron = (
  hostingId: number,
  cronBody: CronBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Cron200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/crontab`, {
    data: cronBody,
    ...options,
  });
};

export const getCronMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cron>>,
    TError,
    { hostingId: number; data: CronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof cron>>,
  TError,
  { hostingId: number; data: CronBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof cron>>,
    { hostingId: number; data: CronBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return cron(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CronMutationResult = NonNullable<Awaited<ReturnType<typeof cron>>>;
export type CronMutationBody = CronBody;
export type CronMutationError = AxiosError<unknown>;

/**
 * @summary cron_delete
 */
export const useCron = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof cron>>,
    TError,
    { hostingId: number; data: CronBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof cron>>,
  TError,
  { hostingId: number; data: CronBody },
  TContext
> => {
  const mutationOptions = getCronMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Cron last run
 * @summary Cron last run
 */
export const cronLastRun = (
  hostingId: number,
  params: CronLastRunParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CronLastRun200>> => {
  return axios.get(`/v1/hosting/${hostingId}/crontab/last-run`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getCronLastRunQueryKey = (
  hostingId: number,
  params: CronLastRunParams,
) => {
  return [
    `/v1/hosting/${hostingId}/crontab/last-run`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCronLastRunQueryOptions = <
  TData = Awaited<ReturnType<typeof cronLastRun>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: CronLastRunParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cronLastRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCronLastRunQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof cronLastRun>>> = ({
    signal,
  }) => cronLastRun(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof cronLastRun>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type CronLastRunQueryResult = NonNullable<
  Awaited<ReturnType<typeof cronLastRun>>
>;
export type CronLastRunQueryError = AxiosError<unknown>;

export function useCronLastRun<
  TData = Awaited<ReturnType<typeof cronLastRun>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: CronLastRunParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cronLastRun>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof cronLastRun>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCronLastRun<
  TData = Awaited<ReturnType<typeof cronLastRun>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: CronLastRunParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cronLastRun>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof cronLastRun>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useCronLastRun<
  TData = Awaited<ReturnType<typeof cronLastRun>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: CronLastRunParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cronLastRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Cron last run
 */

export function useCronLastRun<
  TData = Awaited<ReturnType<typeof cronLastRun>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: CronLastRunParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof cronLastRun>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getCronLastRunQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a new db to an account
 * @summary Create a database for an account
 */
export const dbAdd = (
  hostingId: number,
  dbAddBody: DbAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbAdd200>> => {
  return axios.post(`/v1/hosting/${hostingId}/db`, dbAddBody, options);
};

export const getDbAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbAdd>>,
    TError,
    { hostingId: number; data: DbAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbAdd>>,
  TError,
  { hostingId: number; data: DbAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbAdd>>,
    { hostingId: number; data: DbAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbAdd>>
>;
export type DbAddMutationBody = DbAddBody;
export type DbAddMutationError = AxiosError<unknown>;

/**
 * @summary Create a database for an account
 */
export const useDbAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbAdd>>,
    TError,
    { hostingId: number; data: DbAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbAdd>>,
  TError,
  { hostingId: number; data: DbAddBody },
  TContext
> => {
  const mutationOptions = getDbAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete db account
 * @summary Delete db account
 */
export const db = (
  hostingId: number,
  dbBody: DbBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Db200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/db`, {
    data: dbBody,
    ...options,
  });
};

export const getDbMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof db>>,
    TError,
    { hostingId: number; data: DbBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof db>>,
  TError,
  { hostingId: number; data: DbBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof db>>,
    { hostingId: number; data: DbBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return db(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbMutationResult = NonNullable<Awaited<ReturnType<typeof db>>>;
export type DbMutationBody = DbBody;
export type DbMutationError = AxiosError<unknown>;

/**
 * @summary Delete db account
 */
export const useDb = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof db>>,
    TError,
    { hostingId: number; data: DbBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof db>>,
  TError,
  { hostingId: number; data: DbBody },
  TContext
> => {
  const mutationOptions = getDbMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of Remote IP
 * @summary Returns a list of authorized DB hosts / ips
 */
export const hostingDbAuthorizedHosts = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDbAuthorizedHosts200>> => {
  return axios.get(`/v1/hosting/${hostingId}/db/authorized-hosts`, options);
};

export const getHostingDbAuthorizedHostsQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/db/authorized-hosts`] as const;
};

export const getHostingDbAuthorizedHostsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingDbAuthorizedHostsQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>
  > = ({ signal }) =>
    hostingDbAuthorizedHosts(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingDbAuthorizedHostsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>
>;
export type HostingDbAuthorizedHostsQueryError = AxiosError<unknown>;

export function useHostingDbAuthorizedHosts<
  TData = Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDbAuthorizedHosts<
  TData = Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDbAuthorizedHosts<
  TData = Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns a list of authorized DB hosts / ips
 */

export function useHostingDbAuthorizedHosts<
  TData = Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDbAuthorizedHosts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingDbAuthorizedHostsQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds an authorized DB host / ip and label
 * @summary Adds an authorized DB host / ip and label
 */
export const hostingDbAuthorizedHostsAdd = (
  hostingId: string,
  hostingDbAuthorizedHostsAddBody: HostingDbAuthorizedHostsAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDbAuthorizedHostsAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/authorized-hosts`,
    hostingDbAuthorizedHostsAddBody,
    options,
  );
};

export const getHostingDbAuthorizedHostsAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>,
    { hostingId: string; data: HostingDbAuthorizedHostsAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDbAuthorizedHostsAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDbAuthorizedHostsAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>
>;
export type HostingDbAuthorizedHostsAddMutationBody =
  HostingDbAuthorizedHostsAddBody;
export type HostingDbAuthorizedHostsAddMutationError = AxiosError<unknown>;

/**
 * @summary Adds an authorized DB host / ip and label
 */
export const useHostingDbAuthorizedHostsAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsAdd>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsAddBody },
  TContext
> => {
  const mutationOptions =
    getHostingDbAuthorizedHostsAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates an authorized DB host / ip or label
 * @summary Updates an authorized DB host / ip or label
 */
export const hostingDbAuthorizedHostsUpdate = (
  hostingId: string,
  hostingDbAuthorizedHostsUpdateBody: HostingDbAuthorizedHostsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDbAuthorizedHostsUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/db/authorized-hosts`,
    hostingDbAuthorizedHostsUpdateBody,
    options,
  );
};

export const getHostingDbAuthorizedHostsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>,
    { hostingId: string; data: HostingDbAuthorizedHostsUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDbAuthorizedHostsUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDbAuthorizedHostsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>
>;
export type HostingDbAuthorizedHostsUpdateMutationBody =
  HostingDbAuthorizedHostsUpdateBody;
export type HostingDbAuthorizedHostsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Updates an authorized DB host / ip or label
 */
export const useHostingDbAuthorizedHostsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsUpdate>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsUpdateBody },
  TContext
> => {
  const mutationOptions =
    getHostingDbAuthorizedHostsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * deletes the authorized DB host/ip
 * @summary Deletes an authorized DB host / ip
 */
export const hostingDbAuthorizedHostsDelete = (
  hostingId: string,
  hostingDbAuthorizedHostsDeleteBody: HostingDbAuthorizedHostsDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDbAuthorizedHostsDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/db/authorized-hosts`, {
    data: hostingDbAuthorizedHostsDeleteBody,
    ...options,
  });
};

export const getHostingDbAuthorizedHostsDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>,
    { hostingId: string; data: HostingDbAuthorizedHostsDeleteBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDbAuthorizedHostsDelete(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDbAuthorizedHostsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>
>;
export type HostingDbAuthorizedHostsDeleteMutationBody =
  HostingDbAuthorizedHostsDeleteBody;
export type HostingDbAuthorizedHostsDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Deletes an authorized DB host / ip
 */
export const useHostingDbAuthorizedHostsDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>,
    TError,
    { hostingId: string; data: HostingDbAuthorizedHostsDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDbAuthorizedHostsDelete>>,
  TError,
  { hostingId: string; data: HostingDbAuthorizedHostsDeleteBody },
  TContext
> => {
  const mutationOptions =
    getHostingDbAuthorizedHostsDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Check database.
 * @summary Check database.
 */
export const dbCheckDatabase = (
  hostingId: number,
  dbCheckDatabaseBody: DbCheckDatabaseBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbCheckDatabase200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/check`,
    dbCheckDatabaseBody,
    options,
  );
};

export const getDbCheckDatabaseMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbCheckDatabase>>,
    TError,
    { hostingId: number; data: DbCheckDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbCheckDatabase>>,
  TError,
  { hostingId: number; data: DbCheckDatabaseBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbCheckDatabase>>,
    { hostingId: number; data: DbCheckDatabaseBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbCheckDatabase(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbCheckDatabaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbCheckDatabase>>
>;
export type DbCheckDatabaseMutationBody = DbCheckDatabaseBody;
export type DbCheckDatabaseMutationError = AxiosError<unknown>;

/**
 * @summary Check database.
 */
export const useDbCheckDatabase = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbCheckDatabase>>,
    TError,
    { hostingId: number; data: DbCheckDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbCheckDatabase>>,
  TError,
  { hostingId: number; data: DbCheckDatabaseBody },
  TContext
> => {
  const mutationOptions = getDbCheckDatabaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Repair database.
 * @summary Repair database.
 */
export const repairDatabase = (
  hostingId: string,
  repairDatabaseBody: RepairDatabaseBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<RepairDatabase200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/repair`,
    repairDatabaseBody,
    options,
  );
};

export const getRepairDatabaseMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repairDatabase>>,
    TError,
    { hostingId: string; data: RepairDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof repairDatabase>>,
  TError,
  { hostingId: string; data: RepairDatabaseBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof repairDatabase>>,
    { hostingId: string; data: RepairDatabaseBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return repairDatabase(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RepairDatabaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof repairDatabase>>
>;
export type RepairDatabaseMutationBody = RepairDatabaseBody;
export type RepairDatabaseMutationError = AxiosError<unknown>;

/**
 * @summary Repair database.
 */
export const useRepairDatabase = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof repairDatabase>>,
    TError,
    { hostingId: string; data: RepairDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof repairDatabase>>,
  TError,
  { hostingId: string; data: RepairDatabaseBody },
  TContext
> => {
  const mutationOptions = getRepairDatabaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of db and table limits and usage.
 * @summary DB usage
 */
export const dbUsage = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUsage200>> => {
  return axios.get(`/v1/hosting/${hostingId}/db/usage`, options);
};

export const getDbUsageQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/db/usage`] as const;
};

export const getDbUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof dbUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDbUsageQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dbUsage>>> = ({
    signal,
  }) => dbUsage(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DbUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof dbUsage>>
>;
export type DbUsageQueryError = AxiosError<unknown>;

export function useDbUsage<
  TData = Awaited<ReturnType<typeof dbUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUsage<
  TData = Awaited<ReturnType<typeof dbUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUsage<
  TData = Awaited<ReturnType<typeof dbUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary DB usage
 */

export function useDbUsage<
  TData = Awaited<ReturnType<typeof dbUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUsage>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDbUsageQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update database user password
 * @summary Update database user password
 */
export const dbUserPasswordSet = (
  hostingId: number,
  dbUserPasswordSetBody: DbUserPasswordSetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserPasswordSet200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/user/password`,
    dbUserPasswordSetBody,
    options,
  );
};

export const getDbUserPasswordSetMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserPasswordSet>>,
    TError,
    { hostingId: number; data: DbUserPasswordSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbUserPasswordSet>>,
  TError,
  { hostingId: number; data: DbUserPasswordSetBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbUserPasswordSet>>,
    { hostingId: number; data: DbUserPasswordSetBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbUserPasswordSet(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbUserPasswordSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbUserPasswordSet>>
>;
export type DbUserPasswordSetMutationBody = DbUserPasswordSetBody;
export type DbUserPasswordSetMutationError = AxiosError<unknown>;

/**
 * @summary Update database user password
 */
export const useDbUserPasswordSet = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserPasswordSet>>,
    TError,
    { hostingId: number; data: DbUserPasswordSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbUserPasswordSet>>,
  TError,
  { hostingId: number; data: DbUserPasswordSetBody },
  TContext
> => {
  const mutationOptions = getDbUserPasswordSetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get user privileges on a database.
 * @summary Get user privileges on a database.
 */
export const dbUserPrivsGet = (
  hostingId: number,
  params: DbUserPrivsGetParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserPrivsGet200>> => {
  return axios.get(`/v1/hosting/${hostingId}/db/user/privileges`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDbUserPrivsGetQueryKey = (
  hostingId: number,
  params: DbUserPrivsGetParams,
) => {
  return [
    `/v1/hosting/${hostingId}/db/user/privileges`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDbUserPrivsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof dbUserPrivsGet>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: DbUserPrivsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserPrivsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDbUserPrivsGetQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dbUserPrivsGet>>> = ({
    signal,
  }) => dbUserPrivsGet(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof dbUserPrivsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DbUserPrivsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof dbUserPrivsGet>>
>;
export type DbUserPrivsGetQueryError = AxiosError<unknown>;

export function useDbUserPrivsGet<
  TData = Awaited<ReturnType<typeof dbUserPrivsGet>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: DbUserPrivsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserPrivsGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUserPrivsGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUserPrivsGet<
  TData = Awaited<ReturnType<typeof dbUserPrivsGet>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: DbUserPrivsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserPrivsGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUserPrivsGet>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUserPrivsGet<
  TData = Awaited<ReturnType<typeof dbUserPrivsGet>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: DbUserPrivsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserPrivsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get user privileges on a database.
 */

export function useDbUserPrivsGet<
  TData = Awaited<ReturnType<typeof dbUserPrivsGet>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: DbUserPrivsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserPrivsGet>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDbUserPrivsGetQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add/Update user privileges on a database.
 * @summary Add/Update user privileges on a database.
 */
export const dbUserPrivsSet = (
  hostingId: number,
  dbUserPrivsSetBody: DbUserPrivsSetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserPrivsSet200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/user/privileges`,
    dbUserPrivsSetBody,
    options,
  );
};

export const getDbUserPrivsSetMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserPrivsSet>>,
    TError,
    { hostingId: number; data: DbUserPrivsSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbUserPrivsSet>>,
  TError,
  { hostingId: number; data: DbUserPrivsSetBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbUserPrivsSet>>,
    { hostingId: number; data: DbUserPrivsSetBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbUserPrivsSet(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbUserPrivsSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbUserPrivsSet>>
>;
export type DbUserPrivsSetMutationBody = DbUserPrivsSetBody;
export type DbUserPrivsSetMutationError = AxiosError<unknown>;

/**
 * @summary Add/Update user privileges on a database.
 */
export const useDbUserPrivsSet = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserPrivsSet>>,
    TError,
    { hostingId: number; data: DbUserPrivsSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbUserPrivsSet>>,
  TError,
  { hostingId: number; data: DbUserPrivsSetBody },
  TContext
> => {
  const mutationOptions = getDbUserPrivsSetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a database user with privileges. The final username cannot exceed 16 characters, and will have the cpanel account username's first eight characters prepended to it.
 * @summary Create a database user with privileges
 */
export const dbUserAdd = (
  hostingId: number,
  dbUserAddBody: DbUserAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/db/users`,
    dbUserAddBody,
    options,
  );
};

export const getDbUserAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserAdd>>,
    TError,
    { hostingId: number; data: DbUserAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbUserAdd>>,
  TError,
  { hostingId: number; data: DbUserAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbUserAdd>>,
    { hostingId: number; data: DbUserAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbUserAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbUserAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbUserAdd>>
>;
export type DbUserAddMutationBody = DbUserAddBody;
export type DbUserAddMutationError = AxiosError<unknown>;

/**
 * @summary Create a database user with privileges
 */
export const useDbUserAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserAdd>>,
    TError,
    { hostingId: number; data: DbUserAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbUserAdd>>,
  TError,
  { hostingId: number; data: DbUserAddBody },
  TContext
> => {
  const mutationOptions = getDbUserAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete db user
 * @summary Delete db user
 */
export const dbUserDelete = (
  hostingId: number,
  dbUserDeleteBody: DbUserDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/db/users`, {
    data: dbUserDeleteBody,
    ...options,
  });
};

export const getDbUserDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserDelete>>,
    TError,
    { hostingId: number; data: DbUserDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbUserDelete>>,
  TError,
  { hostingId: number; data: DbUserDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbUserDelete>>,
    { hostingId: number; data: DbUserDeleteBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbUserDelete(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbUserDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbUserDelete>>
>;
export type DbUserDeleteMutationBody = DbUserDeleteBody;
export type DbUserDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Delete db user
 */
export const useDbUserDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserDelete>>,
    TError,
    { hostingId: number; data: DbUserDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbUserDelete>>,
  TError,
  { hostingId: number; data: DbUserDeleteBody },
  TContext
> => {
  const mutationOptions = getDbUserDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List all DB users
 * @summary Get list of db users
 */
export const dbUserList = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/db/users`, options);
};

export const getDbUserListQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/db/users`] as const;
};

export const getDbUserListQueryOptions = <
  TData = Awaited<ReturnType<typeof dbUserList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDbUserListQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dbUserList>>> = ({
    signal,
  }) => dbUserList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof dbUserList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DbUserListQueryResult = NonNullable<
  Awaited<ReturnType<typeof dbUserList>>
>;
export type DbUserListQueryError = AxiosError<unknown>;

export function useDbUserList<
  TData = Awaited<ReturnType<typeof dbUserList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUserList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUserList<
  TData = Awaited<ReturnType<typeof dbUserList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbUserList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbUserList<
  TData = Awaited<ReturnType<typeof dbUserList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get list of db users
 */

export function useDbUserList<
  TData = Awaited<ReturnType<typeof dbUserList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbUserList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDbUserListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Rename db user
 * @summary Rename db user
 */
export const dbUserRename = (
  hostingId: number,
  dbUserRenameBody: DbUserRenameBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbUserRename200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/db/users`,
    dbUserRenameBody,
    options,
  );
};

export const getDbUserRenameMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserRename>>,
    TError,
    { hostingId: number; data: DbUserRenameBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbUserRename>>,
  TError,
  { hostingId: number; data: DbUserRenameBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbUserRename>>,
    { hostingId: number; data: DbUserRenameBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbUserRename(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbUserRenameMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbUserRename>>
>;
export type DbUserRenameMutationBody = DbUserRenameBody;
export type DbUserRenameMutationError = AxiosError<unknown>;

/**
 * @summary Rename db user
 */
export const useDbUserRename = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbUserRename>>,
    TError,
    { hostingId: number; data: DbUserRenameBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbUserRename>>,
  TError,
  { hostingId: number; data: DbUserRenameBody },
  TContext
> => {
  const mutationOptions = getDbUserRenameMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete multiple database users / databases
 * @summary Delete multiple database users / databases
 */
export const dbMultipleUserDatabase = (
  hostingId: string,
  dbMultipleUserDatabaseBody: DbMultipleUserDatabaseBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbMultipleUserDatabase200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/db/users/bulk`, {
    data: dbMultipleUserDatabaseBody,
    ...options,
  });
};

export const getDbMultipleUserDatabaseMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbMultipleUserDatabase>>,
    TError,
    { hostingId: string; data: DbMultipleUserDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof dbMultipleUserDatabase>>,
  TError,
  { hostingId: string; data: DbMultipleUserDatabaseBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dbMultipleUserDatabase>>,
    { hostingId: string; data: DbMultipleUserDatabaseBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return dbMultipleUserDatabase(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DbMultipleUserDatabaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof dbMultipleUserDatabase>>
>;
export type DbMultipleUserDatabaseMutationBody = DbMultipleUserDatabaseBody;
export type DbMultipleUserDatabaseMutationError = AxiosError<unknown>;

/**
 * @summary Delete multiple database users / databases
 */
export const useDbMultipleUserDatabase = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof dbMultipleUserDatabase>>,
    TError,
    { hostingId: string; data: DbMultipleUserDatabaseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof dbMultipleUserDatabase>>,
  TError,
  { hostingId: string; data: DbMultipleUserDatabaseBody },
  TContext
> => {
  const mutationOptions = getDbMultipleUserDatabaseMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Allow user to secure specific folders
 * @summary Allow users to secure specific folders on their websites
 */
export const directoryPrivacy = (
  hostingId: string,
  params?: DirectoryPrivacyParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DirectoryPrivacy200>> => {
  return axios.get(`/v1/hosting/${hostingId}/directoryprivacy`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDirectoryPrivacyQueryKey = (
  hostingId: string,
  params?: DirectoryPrivacyParams,
) => {
  return [
    `/v1/hosting/${hostingId}/directoryprivacy`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDirectoryPrivacyQueryOptions = <
  TData = Awaited<ReturnType<typeof directoryPrivacy>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DirectoryPrivacyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoryPrivacy>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDirectoryPrivacyQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof directoryPrivacy>>
  > = ({ signal }) =>
    directoryPrivacy(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof directoryPrivacy>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DirectoryPrivacyQueryResult = NonNullable<
  Awaited<ReturnType<typeof directoryPrivacy>>
>;
export type DirectoryPrivacyQueryError = AxiosError<unknown>;

export function useDirectoryPrivacy<
  TData = Awaited<ReturnType<typeof directoryPrivacy>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | DirectoryPrivacyParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoryPrivacy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoryPrivacy>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDirectoryPrivacy<
  TData = Awaited<ReturnType<typeof directoryPrivacy>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DirectoryPrivacyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoryPrivacy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof directoryPrivacy>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDirectoryPrivacy<
  TData = Awaited<ReturnType<typeof directoryPrivacy>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DirectoryPrivacyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoryPrivacy>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Allow users to secure specific folders on their websites
 */

export function useDirectoryPrivacy<
  TData = Awaited<ReturnType<typeof directoryPrivacy>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DirectoryPrivacyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof directoryPrivacy>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDirectoryPrivacyQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allow user to add specific folders
 * @summary Allow users to secure specific folders on their websites
 */
export const addPrivacy = (
  hostingId: string,
  addPrivacyBody: AddPrivacyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddPrivacy200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/directoryprivacy`,
    addPrivacyBody,
    options,
  );
};

export const getAddPrivacyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPrivacy>>,
    TError,
    { hostingId: string; data: AddPrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addPrivacy>>,
  TError,
  { hostingId: string; data: AddPrivacyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addPrivacy>>,
    { hostingId: string; data: AddPrivacyBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return addPrivacy(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddPrivacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof addPrivacy>>
>;
export type AddPrivacyMutationBody = AddPrivacyBody;
export type AddPrivacyMutationError = AxiosError<unknown>;

/**
 * @summary Allow users to secure specific folders on their websites
 */
export const useAddPrivacy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addPrivacy>>,
    TError,
    { hostingId: string; data: AddPrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addPrivacy>>,
  TError,
  { hostingId: string; data: AddPrivacyBody },
  TContext
> => {
  const mutationOptions = getAddPrivacyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Allow user to delete specific folders
 * @summary Allow users to delete specific folders on their websites
 */
export const privacy = (
  hostingId: string,
  privacyBody: PrivacyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Privacy200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/directoryprivacy`, {
    data: privacyBody,
    ...options,
  });
};

export const getPrivacyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof privacy>>,
    TError,
    { hostingId: string; data: PrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof privacy>>,
  TError,
  { hostingId: string; data: PrivacyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof privacy>>,
    { hostingId: string; data: PrivacyBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return privacy(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrivacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof privacy>>
>;
export type PrivacyMutationBody = PrivacyBody;
export type PrivacyMutationError = AxiosError<unknown>;

/**
 * @summary Allow users to delete specific folders on their websites
 */
export const usePrivacy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof privacy>>,
    TError,
    { hostingId: string; data: PrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof privacy>>,
  TError,
  { hostingId: string; data: PrivacyBody },
  TContext
> => {
  const mutationOptions = getPrivacyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Allow user to secure specific folders
 * @summary Allow users to edit secure specific folders on their websites
 */
export const editPrivacy = (
  hostingId: string,
  editPrivacyBody: EditPrivacyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EditPrivacy200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/directoryprivacy`,
    editPrivacyBody,
    options,
  );
};

export const getEditPrivacyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPrivacy>>,
    TError,
    { hostingId: string; data: EditPrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof editPrivacy>>,
  TError,
  { hostingId: string; data: EditPrivacyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof editPrivacy>>,
    { hostingId: string; data: EditPrivacyBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return editPrivacy(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type EditPrivacyMutationResult = NonNullable<
  Awaited<ReturnType<typeof editPrivacy>>
>;
export type EditPrivacyMutationBody = EditPrivacyBody;
export type EditPrivacyMutationError = AxiosError<unknown>;

/**
 * @summary Allow users to edit secure specific folders on their websites
 */
export const useEditPrivacy = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof editPrivacy>>,
    TError,
    { hostingId: string; data: EditPrivacyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof editPrivacy>>,
  TError,
  { hostingId: string; data: EditPrivacyBody },
  TContext
> => {
  const mutationOptions = getEditPrivacyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete user for password protected directory
 * @summary Delete user for password protected directory
 */
export const privacyUser = (
  hostingId: string,
  privacyUserBody: PrivacyUserBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PrivacyUser200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/directoryprivacy/user`, {
    data: privacyUserBody,
    ...options,
  });
};

export const getPrivacyUserMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof privacyUser>>,
    TError,
    { hostingId: string; data: PrivacyUserBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof privacyUser>>,
  TError,
  { hostingId: string; data: PrivacyUserBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof privacyUser>>,
    { hostingId: string; data: PrivacyUserBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return privacyUser(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PrivacyUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof privacyUser>>
>;
export type PrivacyUserMutationBody = PrivacyUserBody;
export type PrivacyUserMutationError = AxiosError<unknown>;

/**
 * @summary Delete user for password protected directory
 */
export const usePrivacyUser = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof privacyUser>>,
    TError,
    { hostingId: string; data: PrivacyUserBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof privacyUser>>,
  TError,
  { hostingId: string; data: PrivacyUserBody },
  TContext
> => {
  const mutationOptions = getPrivacyUserMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Assign the domain
 * @summary Assign the domain
 */
export const hostingDomainAssign = (
  hostingId: string,
  hostingDomainAssignBody: HostingDomainAssignBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainAssign200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/domain/assign`,
    hostingDomainAssignBody,
    options,
  );
};

export const getHostingDomainAssignMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainAssign>>,
    TError,
    { hostingId: string; data: HostingDomainAssignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDomainAssign>>,
  TError,
  { hostingId: string; data: HostingDomainAssignBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDomainAssign>>,
    { hostingId: string; data: HostingDomainAssignBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDomainAssign(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDomainAssignMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainAssign>>
>;
export type HostingDomainAssignMutationBody = HostingDomainAssignBody;
export type HostingDomainAssignMutationError = AxiosError<unknown>;

/**
 * @summary Assign the domain
 */
export const useHostingDomainAssign = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainAssign>>,
    TError,
    { hostingId: string; data: HostingDomainAssignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDomainAssign>>,
  TError,
  { hostingId: string; data: HostingDomainAssignBody },
  TContext
> => {
  const mutationOptions = getHostingDomainAssignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * domain availability
 * @summary Domain availability
 */
export const hostingDomainAvailability = (
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainAvailability200>> => {
  return axios.get(`/v1/hosting/${hostingId}/domain/availability`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingDomainAvailabilityQueryKey = (
  hostingId: string,
  params: HostingDomainAvailabilityParams,
) => {
  return [
    `/v1/hosting/${hostingId}/domain/availability`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingDomainAvailabilityQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingDomainAvailability>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainAvailability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingDomainAvailabilityQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingDomainAvailability>>
  > = ({ signal }) =>
    hostingDomainAvailability(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingDomainAvailability>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingDomainAvailabilityQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainAvailability>>
>;
export type HostingDomainAvailabilityQueryError = AxiosError<unknown>;

export function useHostingDomainAvailability<
  TData = Awaited<ReturnType<typeof hostingDomainAvailability>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDomainAvailability>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDomainAvailability<
  TData = Awaited<ReturnType<typeof hostingDomainAvailability>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainAvailability>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDomainAvailability>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDomainAvailability<
  TData = Awaited<ReturnType<typeof hostingDomainAvailability>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainAvailability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Domain availability
 */

export function useHostingDomainAvailability<
  TData = Awaited<ReturnType<typeof hostingDomainAvailability>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingDomainAvailabilityParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainAvailability>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingDomainAvailabilityQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of domains
 * @summary domain list
 */
export const domains = (
  hostingId: string,
  params?: DomainsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Domains200>> => {
  return axios.get(`/v1/hosting/${hostingId}/domains`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDomainsQueryKey = (
  hostingId: string,
  params?: DomainsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/domains`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDomainsQueryOptions = <
  TData = Awaited<ReturnType<typeof domains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DomainsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainsQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domains>>> = ({
    signal,
  }) => domains(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DomainsQueryResult = NonNullable<
  Awaited<ReturnType<typeof domains>>
>;
export type DomainsQueryError = AxiosError<unknown>;

export function useDomains<
  TData = Awaited<ReturnType<typeof domains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | DomainsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domains>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomains<
  TData = Awaited<ReturnType<typeof domains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DomainsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domains>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomains<
  TData = Awaited<ReturnType<typeof domains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DomainsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain list
 */

export function useDomains<
  TData = Awaited<ReturnType<typeof domains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: DomainsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof domains>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainsQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the content of the zone file of the domain
 * @summary Export DNS Zone file
 */
export const domainDnsExport = (
  hostingId: string,
  params: DomainDnsExportParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnsExport200>> => {
  return axios.get(`/v1/hosting/${hostingId}/domains/dns/export`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDomainDnsExportQueryKey = (
  hostingId: string,
  params: DomainDnsExportParams,
) => {
  return [
    `/v1/hosting/${hostingId}/domains/dns/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getDomainDnsExportQueryOptions = <
  TData = Awaited<ReturnType<typeof domainDnsExport>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: DomainDnsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnsExport>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDomainDnsExportQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof domainDnsExport>>> = ({
    signal,
  }) => domainDnsExport(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof domainDnsExport>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DomainDnsExportQueryResult = NonNullable<
  Awaited<ReturnType<typeof domainDnsExport>>
>;
export type DomainDnsExportQueryError = AxiosError<unknown>;

export function useDomainDnsExport<
  TData = Awaited<ReturnType<typeof domainDnsExport>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: DomainDnsExportParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnsExport>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnsExport<
  TData = Awaited<ReturnType<typeof domainDnsExport>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: DomainDnsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnsExport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof domainDnsExport>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDomainDnsExport<
  TData = Awaited<ReturnType<typeof domainDnsExport>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: DomainDnsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnsExport>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Export DNS Zone file
 */

export function useDomainDnsExport<
  TData = Awaited<ReturnType<typeof domainDnsExport>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: DomainDnsExportParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof domainDnsExport>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDomainDnsExportQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the content of the zone file
 * @summary Import DNS Zone file
 */
export const domainDnsImport = (
  hostingId: string,
  domainDnsImportBody: DomainDnsImportBody,
  params: DomainDnsImportParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DomainDnsImport200>> => {
  const formData = new FormData();
  formData.append('file', domainDnsImportBody.file);

  return axios.post(`/v1/hosting/${hostingId}/domains/dns/import`, formData, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDomainDnsImportMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnsImport>>,
    TError,
    {
      hostingId: string;
      data: DomainDnsImportBody;
      params: DomainDnsImportParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof domainDnsImport>>,
  TError,
  {
    hostingId: string;
    data: DomainDnsImportBody;
    params: DomainDnsImportParams;
  },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof domainDnsImport>>,
    {
      hostingId: string;
      data: DomainDnsImportBody;
      params: DomainDnsImportParams;
    }
  > = (props) => {
    const { hostingId, data, params } = props ?? {};

    return domainDnsImport(hostingId, data, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DomainDnsImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof domainDnsImport>>
>;
export type DomainDnsImportMutationBody = DomainDnsImportBody;
export type DomainDnsImportMutationError = AxiosError<unknown>;

/**
 * @summary Import DNS Zone file
 */
export const useDomainDnsImport = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof domainDnsImport>>,
    TError,
    {
      hostingId: string;
      data: DomainDnsImportBody;
      params: DomainDnsImportParams;
    },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof domainDnsImport>>,
  TError,
  {
    hostingId: string;
    data: DomainDnsImportBody;
    params: DomainDnsImportParams;
  },
  TContext
> => {
  const mutationOptions = getDomainDnsImportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates a HAL domain record with type link on self-managed VPS or dedicated hosting (no panel provisioning). customerErrors: domainInvalid, linkDomainHostingTypeNotSupported, domainAlreadyExists, domainAlreadyOnServer, invalidDomain, domainLinkCreateFailed.
 * @summary Link a third-party domain to hosting
 */
export const hostingDomainsLink = (
  hostingId: string,
  hostingDomainsLinkBody: HostingDomainsLinkBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainsLink200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/domains/link`,
    hostingDomainsLinkBody,
    options,
  );
};

export const getHostingDomainsLinkMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsLink>>,
    TError,
    { hostingId: string; data: HostingDomainsLinkBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDomainsLink>>,
  TError,
  { hostingId: string; data: HostingDomainsLinkBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDomainsLink>>,
    { hostingId: string; data: HostingDomainsLinkBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDomainsLink(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDomainsLinkMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainsLink>>
>;
export type HostingDomainsLinkMutationBody = HostingDomainsLinkBody;
export type HostingDomainsLinkMutationError = AxiosError<unknown>;

/**
 * @summary Link a third-party domain to hosting
 */
export const useHostingDomainsLink = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsLink>>,
    TError,
    { hostingId: string; data: HostingDomainsLinkBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDomainsLink>>,
  TError,
  { hostingId: string; data: HostingDomainsLinkBody },
  TContext
> => {
  const mutationOptions = getHostingDomainsLinkMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Unassign the domain associated with the hosting account
 * @summary Unassign the domain
 */
export const hostingDomainsUnassign = (
  hostingId: string,
  hostingDomainsUnassignBody: HostingDomainsUnassignBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainsUnassign200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/domains/unassign`,
    hostingDomainsUnassignBody,
    options,
  );
};

export const getHostingDomainsUnassignMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsUnassign>>,
    TError,
    { hostingId: string; data: HostingDomainsUnassignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDomainsUnassign>>,
  TError,
  { hostingId: string; data: HostingDomainsUnassignBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDomainsUnassign>>,
    { hostingId: string; data: HostingDomainsUnassignBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDomainsUnassign(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDomainsUnassignMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainsUnassign>>
>;
export type HostingDomainsUnassignMutationBody = HostingDomainsUnassignBody;
export type HostingDomainsUnassignMutationError = AxiosError<unknown>;

/**
 * @summary Unassign the domain
 */
export const useHostingDomainsUnassign = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsUnassign>>,
    TError,
    { hostingId: string; data: HostingDomainsUnassignBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDomainsUnassign>>,
  TError,
  { hostingId: string; data: HostingDomainsUnassignBody },
  TContext
> => {
  const mutationOptions = getHostingDomainsUnassignMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns info about an existing ecommerce addon otherwise it returns null
 * @summary ecommerce info
 */
export const hostingEcommerceInfo = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEcommerceInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/ecommerce`, options);
};

export const getHostingEcommerceInfoQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/ecommerce`] as const;
};

export const getHostingEcommerceInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEcommerceInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEcommerceInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingEcommerceInfoQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEcommerceInfo>>
  > = ({ signal }) =>
    hostingEcommerceInfo(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEcommerceInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEcommerceInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEcommerceInfo>>
>;
export type HostingEcommerceInfoQueryError = AxiosError<unknown>;

export function useHostingEcommerceInfo<
  TData = Awaited<ReturnType<typeof hostingEcommerceInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEcommerceInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEcommerceInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEcommerceInfo<
  TData = Awaited<ReturnType<typeof hostingEcommerceInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEcommerceInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEcommerceInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEcommerceInfo<
  TData = Awaited<ReturnType<typeof hostingEcommerceInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEcommerceInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary ecommerce info
 */

export function useHostingEcommerceInfo<
  TData = Awaited<ReturnType<typeof hostingEcommerceInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEcommerceInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEcommerceInfoQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Use to add a new email box, domainalias, alias, forwarder, discard, pipe or list
 * @summary email add
 */
export const hostingEmailAdd = (
  hostingId: string,
  hostingEmailAddBody: HostingEmailAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails`,
    hostingEmailAddBody,
    options,
  );
};

export const getHostingEmailAddMutationOptions = <
  TError = AxiosError<
    | HostingEmailAdd400
    | HostingEmailAdd403
    | HostingEmailAdd409
    | HostingEmailAdd512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAdd>>,
    TError,
    { hostingId: string; data: HostingEmailAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailAdd>>,
  TError,
  { hostingId: string; data: HostingEmailAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailAdd>>,
    { hostingId: string; data: HostingEmailAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAdd>>
>;
export type HostingEmailAddMutationBody = HostingEmailAddBody;
export type HostingEmailAddMutationError = AxiosError<
  | HostingEmailAdd400
  | HostingEmailAdd403
  | HostingEmailAdd409
  | HostingEmailAdd512
>;

/**
 * @summary email add
 */
export const useHostingEmailAdd = <
  TError = AxiosError<
    | HostingEmailAdd400
    | HostingEmailAdd403
    | HostingEmailAdd409
    | HostingEmailAdd512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAdd>>,
    TError,
    { hostingId: string; data: HostingEmailAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailAdd>>,
  TError,
  { hostingId: string; data: HostingEmailAddBody },
  TContext
> => {
  const mutationOptions = getHostingEmailAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes an email account by address
 * @summary email delete
 */
export const hostingEmailDelete = (
  hostingId: string,
  params: HostingEmailDeleteParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/emails`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailDelete>>,
    TError,
    { hostingId: string; params: HostingEmailDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailDelete>>,
  TError,
  { hostingId: string; params: HostingEmailDeleteParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailDelete>>,
    { hostingId: string; params: HostingEmailDeleteParams }
  > = (props) => {
    const { hostingId, params } = props ?? {};

    return hostingEmailDelete(hostingId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailDelete>>
>;

export type HostingEmailDeleteMutationError = AxiosError<unknown>;

/**
 * @summary email delete
 */
export const useHostingEmailDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailDelete>>,
    TError,
    { hostingId: string; params: HostingEmailDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailDelete>>,
  TError,
  { hostingId: string; params: HostingEmailDeleteParams },
  TContext
> => {
  const mutationOptions = getHostingEmailDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists existing email resources by type
 * @summary email list
 */
export const hostingEmailList = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails`, options);
};

export const getHostingEmailListQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/emails`] as const;
};

export const getHostingEmailListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingEmailListQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailList>>
  > = ({ signal }) => hostingEmailList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailList>>
>;
export type HostingEmailListQueryError = AxiosError<unknown>;

export function useHostingEmailList<
  TData = Awaited<ReturnType<typeof hostingEmailList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailList<
  TData = Awaited<ReturnType<typeof hostingEmailList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailList<
  TData = Awaited<ReturnType<typeof hostingEmailList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email list
 */

export function useHostingEmailList<
  TData = Awaited<ReturnType<typeof hostingEmailList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates an email account
 * @summary email update
 */
export const hostingEmailUpdate = (
  hostingId: string,
  hostingEmailUpdateBody: HostingEmailUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails`,
    hostingEmailUpdateBody,
    options,
  );
};

export const getHostingEmailUpdateMutationOptions = <
  TError = AxiosError<
    HostingEmailUpdate400 | HostingEmailUpdate403 | HostingEmailUpdate512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailUpdate>>,
    { hostingId: string; data: HostingEmailUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailUpdate>>
>;
export type HostingEmailUpdateMutationBody = HostingEmailUpdateBody;
export type HostingEmailUpdateMutationError = AxiosError<
  HostingEmailUpdate400 | HostingEmailUpdate403 | HostingEmailUpdate512
>;

/**
 * @summary email update
 */
export const useHostingEmailUpdate = <
  TError = AxiosError<
    HostingEmailUpdate400 | HostingEmailUpdate403 | HostingEmailUpdate512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailUpdateBody },
  TContext
> => {
  const mutationOptions = getHostingEmailUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get info of email autoresponder based on the address associated
 * @summary email autoresponder get
 */
export const hostingEmailAutoresponderInfo = (
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAutoresponderInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/autoresponder`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailAutoresponderInfoQueryKey = (
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/autoresponder`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingEmailAutoresponderInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
  TError = AxiosError<HostingEmailAutoresponderInfo404>,
>(
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailAutoresponderInfoQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>
  > = ({ signal }) =>
    hostingEmailAutoresponderInfo(hostingId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailAutoresponderInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>
>;
export type HostingEmailAutoresponderInfoQueryError =
  AxiosError<HostingEmailAutoresponderInfo404>;

export function useHostingEmailAutoresponderInfo<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
  TError = AxiosError<HostingEmailAutoresponderInfo404>,
>(
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailAutoresponderInfo<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
  TError = AxiosError<HostingEmailAutoresponderInfo404>,
>(
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailAutoresponderInfo<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
  TError = AxiosError<HostingEmailAutoresponderInfo404>,
>(
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email autoresponder get
 */

export function useHostingEmailAutoresponderInfo<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
  TError = AxiosError<HostingEmailAutoresponderInfo404>,
>(
  hostingId: string,
  params: HostingEmailAutoresponderInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailAutoresponderInfoQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Creates/Updates existing email autoresponder
 * @summary email autoresponder update
 */
export const hostingEmailAutoresponderUpdate = (
  hostingId: string,
  hostingEmailAutoresponderUpdateBody: HostingEmailAutoresponderUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAutoresponderUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails/autoresponder`,
    hostingEmailAutoresponderUpdateBody,
    options,
  );
};

export const getHostingEmailAutoresponderUpdateMutationOptions = <
  TError = AxiosError<HostingEmailAutoresponderUpdate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailAutoresponderUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailAutoresponderUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>,
    { hostingId: string; data: HostingEmailAutoresponderUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailAutoresponderUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailAutoresponderUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>
>;
export type HostingEmailAutoresponderUpdateMutationBody =
  HostingEmailAutoresponderUpdateBody;
export type HostingEmailAutoresponderUpdateMutationError =
  AxiosError<HostingEmailAutoresponderUpdate400>;

/**
 * @summary email autoresponder update
 */
export const useHostingEmailAutoresponderUpdate = <
  TError = AxiosError<HostingEmailAutoresponderUpdate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailAutoresponderUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailAutoresponderUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailAutoresponderUpdateBody },
  TContext
> => {
  const mutationOptions =
    getHostingEmailAutoresponderUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates/Updates existing email autoresponder
 * @summary email autoresponder create or update
 */
export const hostingEmailAutoresponderCreate = (
  hostingId: string,
  hostingEmailAutoresponderCreateBody: HostingEmailAutoresponderCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAutoresponderCreate200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/autoresponder`,
    hostingEmailAutoresponderCreateBody,
    options,
  );
};

export const getHostingEmailAutoresponderCreateMutationOptions = <
  TError = AxiosError<HostingEmailAutoresponderCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>,
    TError,
    { hostingId: string; data: HostingEmailAutoresponderCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>,
  TError,
  { hostingId: string; data: HostingEmailAutoresponderCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>,
    { hostingId: string; data: HostingEmailAutoresponderCreateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailAutoresponderCreate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailAutoresponderCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>
>;
export type HostingEmailAutoresponderCreateMutationBody =
  HostingEmailAutoresponderCreateBody;
export type HostingEmailAutoresponderCreateMutationError =
  AxiosError<HostingEmailAutoresponderCreate400>;

/**
 * @summary email autoresponder create or update
 */
export const useHostingEmailAutoresponderCreate = <
  TError = AxiosError<HostingEmailAutoresponderCreate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>,
    TError,
    { hostingId: string; data: HostingEmailAutoresponderCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailAutoresponderCreate>>,
  TError,
  { hostingId: string; data: HostingEmailAutoresponderCreateBody },
  TContext
> => {
  const mutationOptions =
    getHostingEmailAutoresponderCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes autorespond emails
 * @summary delete email autoresponder
 */
export const hostingEmailAutoresponderDelete = (
  hostingId: string,
  params?: HostingEmailAutoresponderDeleteParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAutoresponderDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/emails/autoresponder`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailAutoresponderDeleteMutationOptions = <
  TError = AxiosError<
    HostingEmailAutoresponderDelete400 | HostingEmailAutoresponderDelete404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>,
    TError,
    { hostingId: string; params?: HostingEmailAutoresponderDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>,
  TError,
  { hostingId: string; params?: HostingEmailAutoresponderDeleteParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>,
    { hostingId: string; params?: HostingEmailAutoresponderDeleteParams }
  > = (props) => {
    const { hostingId, params } = props ?? {};

    return hostingEmailAutoresponderDelete(hostingId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailAutoresponderDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>
>;

export type HostingEmailAutoresponderDeleteMutationError = AxiosError<
  HostingEmailAutoresponderDelete400 | HostingEmailAutoresponderDelete404
>;

/**
 * @summary delete email autoresponder
 */
export const useHostingEmailAutoresponderDelete = <
  TError = AxiosError<
    HostingEmailAutoresponderDelete400 | HostingEmailAutoresponderDelete404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>,
    TError,
    { hostingId: string; params?: HostingEmailAutoresponderDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailAutoresponderDelete>>,
  TError,
  { hostingId: string; params?: HostingEmailAutoresponderDeleteParams },
  TContext
> => {
  const mutationOptions =
    getHostingEmailAutoresponderDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists existing email autoresponders
 * @summary email autoresponder list
 */
export const hostingEmailAutoresponderList = (
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailAutoresponderList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/autoresponders`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailAutoresponderListQueryKey = (
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/autoresponders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingEmailAutoresponderListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailAutoresponderListQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailAutoresponderList>>
  > = ({ signal }) =>
    hostingEmailAutoresponderList(hostingId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailAutoresponderListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailAutoresponderList>>
>;
export type HostingEmailAutoresponderListQueryError = AxiosError<unknown>;

export function useHostingEmailAutoresponderList<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingEmailAutoresponderListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailAutoresponderList<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailAutoresponderList<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email autoresponder list
 */

export function useHostingEmailAutoresponderList<
  TData = Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailAutoresponderListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailAutoresponderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailAutoresponderListQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Lists existing email account and domain filters
 * @summary email filters list
 */
export const hostingEmailFiltersList = (
  hostingId: string,
  params?: HostingEmailFiltersListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailFiltersList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/filters`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailFiltersListQueryKey = (
  hostingId: string,
  params?: HostingEmailFiltersListParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/filters`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingEmailFiltersListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailFiltersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailFiltersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFiltersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailFiltersListQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailFiltersList>>
  > = ({ signal }) =>
    hostingEmailFiltersList(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailFiltersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailFiltersList>>
>;
export type HostingEmailFiltersListQueryError = AxiosError<unknown>;

export function useHostingEmailFiltersList<
  TData = Awaited<ReturnType<typeof hostingEmailFiltersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingEmailFiltersListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFiltersList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailFiltersList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailFiltersList<
  TData = Awaited<ReturnType<typeof hostingEmailFiltersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailFiltersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFiltersList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailFiltersList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailFiltersList<
  TData = Awaited<ReturnType<typeof hostingEmailFiltersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailFiltersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFiltersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email filters list
 */

export function useHostingEmailFiltersList<
  TData = Awaited<ReturnType<typeof hostingEmailFiltersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingEmailFiltersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFiltersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailFiltersListQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Use to add an email filter
 * @summary email filters add
 */
export const hostingEmailFiltersAdd = (
  hostingId: string,
  hostingEmailFiltersAddBody: HostingEmailFiltersAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailFiltersAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/filters`,
    hostingEmailFiltersAddBody,
    options,
  );
};

export const getHostingEmailFiltersAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersAdd>>,
    TError,
    { hostingId: string; data: HostingEmailFiltersAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailFiltersAdd>>,
  TError,
  { hostingId: string; data: HostingEmailFiltersAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailFiltersAdd>>,
    { hostingId: string; data: HostingEmailFiltersAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailFiltersAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailFiltersAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailFiltersAdd>>
>;
export type HostingEmailFiltersAddMutationBody = HostingEmailFiltersAddBody;
export type HostingEmailFiltersAddMutationError = AxiosError<unknown>;

/**
 * @summary email filters add
 */
export const useHostingEmailFiltersAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersAdd>>,
    TError,
    { hostingId: string; data: HostingEmailFiltersAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailFiltersAdd>>,
  TError,
  { hostingId: string; data: HostingEmailFiltersAddBody },
  TContext
> => {
  const mutationOptions = getHostingEmailFiltersAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates an existing email filter
 * @summary email filters update
 */
export const hostingEmailFiltersUpdate = (
  hostingId: string,
  hostingEmailFiltersUpdateBody: HostingEmailFiltersUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailFiltersUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails/filters`,
    hostingEmailFiltersUpdateBody,
    options,
  );
};

export const getHostingEmailFiltersUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailFiltersUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailFiltersUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>,
    { hostingId: string; data: HostingEmailFiltersUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailFiltersUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailFiltersUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>
>;
export type HostingEmailFiltersUpdateMutationBody =
  HostingEmailFiltersUpdateBody;
export type HostingEmailFiltersUpdateMutationError = AxiosError<unknown>;

/**
 * @summary email filters update
 */
export const useHostingEmailFiltersUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailFiltersUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailFiltersUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailFiltersUpdateBody },
  TContext
> => {
  const mutationOptions = getHostingEmailFiltersUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists existing email account and domain filters
 * @summary delete email filters
 */
export const hostingEmailFiltersDelete = (
  hostingId: string,
  params?: HostingEmailFiltersDeleteParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailFiltersDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/emails/filters`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailFiltersDeleteMutationOptions = <
  TError = AxiosError<
    HostingEmailFiltersDelete400 | HostingEmailFiltersDelete404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersDelete>>,
    TError,
    { hostingId: string; params?: HostingEmailFiltersDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailFiltersDelete>>,
  TError,
  { hostingId: string; params?: HostingEmailFiltersDeleteParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailFiltersDelete>>,
    { hostingId: string; params?: HostingEmailFiltersDeleteParams }
  > = (props) => {
    const { hostingId, params } = props ?? {};

    return hostingEmailFiltersDelete(hostingId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailFiltersDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailFiltersDelete>>
>;

export type HostingEmailFiltersDeleteMutationError = AxiosError<
  HostingEmailFiltersDelete400 | HostingEmailFiltersDelete404
>;

/**
 * @summary delete email filters
 */
export const useHostingEmailFiltersDelete = <
  TError = AxiosError<
    HostingEmailFiltersDelete400 | HostingEmailFiltersDelete404
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailFiltersDelete>>,
    TError,
    { hostingId: string; params?: HostingEmailFiltersDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailFiltersDelete>>,
  TError,
  { hostingId: string; params?: HostingEmailFiltersDeleteParams },
  TContext
> => {
  const mutationOptions = getHostingEmailFiltersDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists existing email account and domain forwarders
 * @summary email forwarders lists
 */
export const hostingEmailForwardersList = (
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailForwardersList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/forwarders`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailForwardersListQueryKey = (
  hostingId: string,
  params: HostingEmailForwardersListParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/forwarders`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingEmailForwardersListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailForwardersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailForwardersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailForwardersListQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailForwardersList>>
  > = ({ signal }) =>
    hostingEmailForwardersList(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailForwardersList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailForwardersListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailForwardersList>>
>;
export type HostingEmailForwardersListQueryError = AxiosError<unknown>;

export function useHostingEmailForwardersList<
  TData = Awaited<ReturnType<typeof hostingEmailForwardersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailForwardersList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailForwardersList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailForwardersList<
  TData = Awaited<ReturnType<typeof hostingEmailForwardersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailForwardersList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailForwardersList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailForwardersList<
  TData = Awaited<ReturnType<typeof hostingEmailForwardersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailForwardersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email forwarders lists
 */

export function useHostingEmailForwardersList<
  TData = Awaited<ReturnType<typeof hostingEmailForwardersList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailForwardersListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailForwardersList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailForwardersListQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Email forwarding is a feature that automatically redirects incoming emails sent to one email address to another specified email address
 * @summary email forwarder add
 */
export const hostingEmailForwarderAdd = (
  hostingId: string,
  hostingEmailForwarderAddBody: HostingEmailForwarderAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailForwarderAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/forwarders`,
    hostingEmailForwarderAddBody,
    options,
  );
};

export const getHostingEmailForwarderAddMutationOptions = <
  TError = AxiosError<
    | HostingEmailForwarderAdd400
    | HostingEmailForwarderAdd403
    | HostingEmailForwarderAdd409
    | HostingEmailForwarderAdd512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailForwarderAdd>>,
    TError,
    { hostingId: string; data: HostingEmailForwarderAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailForwarderAdd>>,
  TError,
  { hostingId: string; data: HostingEmailForwarderAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailForwarderAdd>>,
    { hostingId: string; data: HostingEmailForwarderAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailForwarderAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailForwarderAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailForwarderAdd>>
>;
export type HostingEmailForwarderAddMutationBody = HostingEmailForwarderAddBody;
export type HostingEmailForwarderAddMutationError = AxiosError<
  | HostingEmailForwarderAdd400
  | HostingEmailForwarderAdd403
  | HostingEmailForwarderAdd409
  | HostingEmailForwarderAdd512
>;

/**
 * @summary email forwarder add
 */
export const useHostingEmailForwarderAdd = <
  TError = AxiosError<
    | HostingEmailForwarderAdd400
    | HostingEmailForwarderAdd403
    | HostingEmailForwarderAdd409
    | HostingEmailForwarderAdd512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailForwarderAdd>>,
    TError,
    { hostingId: string; data: HostingEmailForwarderAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailForwarderAdd>>,
  TError,
  { hostingId: string; data: HostingEmailForwarderAddBody },
  TContext
> => {
  const mutationOptions = getHostingEmailForwarderAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete email forwarder
 * @summary email forwarder delete
 */
export const hostingEmailForwardDelete = (
  hostingId: string,
  params: HostingEmailForwardDeleteParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailForwardDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/emails/forwarders`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailForwardDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailForwardDelete>>,
    TError,
    { hostingId: string; params: HostingEmailForwardDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailForwardDelete>>,
  TError,
  { hostingId: string; params: HostingEmailForwardDeleteParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailForwardDelete>>,
    { hostingId: string; params: HostingEmailForwardDeleteParams }
  > = (props) => {
    const { hostingId, params } = props ?? {};

    return hostingEmailForwardDelete(hostingId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailForwardDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailForwardDelete>>
>;

export type HostingEmailForwardDeleteMutationError = AxiosError<unknown>;

/**
 * @summary email forwarder delete
 */
export const useHostingEmailForwardDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailForwardDelete>>,
    TError,
    { hostingId: string; params: HostingEmailForwardDeleteParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailForwardDelete>>,
  TError,
  { hostingId: string; params: HostingEmailForwardDeleteParams },
  TContext
> => {
  const mutationOptions = getHostingEmailForwardDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Generates a GnuPG (GPG) key.
 * @summary Encryption add
 */
export const hostingEmailKeysAdd = (
  hostingId: string,
  hostingEmailKeysAddBody: HostingEmailKeysAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailKeysAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/keys`,
    hostingEmailKeysAddBody,
    options,
  );
};

export const getHostingEmailKeysAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailKeysAdd>>,
    TError,
    { hostingId: string; data: HostingEmailKeysAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailKeysAdd>>,
  TError,
  { hostingId: string; data: HostingEmailKeysAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailKeysAdd>>,
    { hostingId: string; data: HostingEmailKeysAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailKeysAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailKeysAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailKeysAdd>>
>;
export type HostingEmailKeysAddMutationBody = HostingEmailKeysAddBody;
export type HostingEmailKeysAddMutationError = AxiosError<unknown>;

/**
 * @summary Encryption add
 */
export const useHostingEmailKeysAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailKeysAdd>>,
    TError,
    { hostingId: string; data: HostingEmailKeysAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailKeysAdd>>,
  TError,
  { hostingId: string; data: HostingEmailKeysAddBody },
  TContext
> => {
  const mutationOptions = getHostingEmailKeysAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists the GnuPG (GPG) public and secret keys for the currently-authenticated account.
 * @summary Encryption lists
 */
export const hostingEmailKeysList = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailKeysList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/keys`, options);
};

export const getHostingEmailKeysListQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/emails/keys`] as const;
};

export const getHostingEmailKeysListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailKeysList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailKeysList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingEmailKeysListQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailKeysList>>
  > = ({ signal }) =>
    hostingEmailKeysList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailKeysList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailKeysListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailKeysList>>
>;
export type HostingEmailKeysListQueryError = AxiosError<unknown>;

export function useHostingEmailKeysList<
  TData = Awaited<ReturnType<typeof hostingEmailKeysList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailKeysList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailKeysList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailKeysList<
  TData = Awaited<ReturnType<typeof hostingEmailKeysList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailKeysList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailKeysList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailKeysList<
  TData = Awaited<ReturnType<typeof hostingEmailKeysList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailKeysList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Encryption lists
 */

export function useHostingEmailKeysList<
  TData = Awaited<ReturnType<typeof hostingEmailKeysList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailKeysList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailKeysListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the email routing type used when an email is delivered for a domain
 * @summary Email routing get
 */
export const hostingEmailDomainRouting = (
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailDomainRouting200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/routing`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingEmailDomainRoutingQueryKey = (
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/routing`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingEmailDomainRoutingQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailDomainRoutingQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailDomainRouting>>
  > = ({ signal }) =>
    hostingEmailDomainRouting(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailDomainRoutingQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailDomainRouting>>
>;
export type HostingEmailDomainRoutingQueryError = AxiosError<unknown>;

export function useHostingEmailDomainRouting<
  TData = Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailDomainRouting<
  TData = Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailDomainRouting<
  TData = Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Email routing get
 */

export function useHostingEmailDomainRouting<
  TData = Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingEmailDomainRoutingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailDomainRouting>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailDomainRoutingQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Sets the email routing type used when an email is delivered for a domain
 * @summary Email routing set
 */
export const hostingEmailDomainRoutingSet = (
  hostingId: string,
  hostingEmailDomainRoutingSetBody: HostingEmailDomainRoutingSetBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailDomainRoutingSet200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails/routing`,
    hostingEmailDomainRoutingSetBody,
    options,
  );
};

export const getHostingEmailDomainRoutingSetMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>,
    TError,
    { hostingId: string; data: HostingEmailDomainRoutingSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>,
  TError,
  { hostingId: string; data: HostingEmailDomainRoutingSetBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>,
    { hostingId: string; data: HostingEmailDomainRoutingSetBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailDomainRoutingSet(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailDomainRoutingSetMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>
>;
export type HostingEmailDomainRoutingSetMutationBody =
  HostingEmailDomainRoutingSetBody;
export type HostingEmailDomainRoutingSetMutationError = AxiosError<unknown>;

/**
 * @summary Email routing set
 */
export const useHostingEmailDomainRoutingSet = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>,
    TError,
    { hostingId: string; data: HostingEmailDomainRoutingSetBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailDomainRoutingSet>>,
  TError,
  { hostingId: string; data: HostingEmailDomainRoutingSetBody },
  TContext
> => {
  const mutationOptions =
    getHostingEmailDomainRoutingSetMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update an email address's settings, depending on address type
 * @summary update email account settings
 */
export const hostingEmailSettings = (
  hostingId: string,
  hostingEmailSettingsBody: HostingEmailSettingsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSettings200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/settings`,
    hostingEmailSettingsBody,
    options,
  );
};

export const getHostingEmailSettingsMutationOptions = <
  TError = AxiosError<
    HostingEmailSettings403 | HostingEmailSettings404 | HostingEmailSettings512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSettings>>,
    TError,
    { hostingId: string; data: HostingEmailSettingsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailSettings>>,
  TError,
  { hostingId: string; data: HostingEmailSettingsBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailSettings>>,
    { hostingId: string; data: HostingEmailSettingsBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailSettings(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailSettingsMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSettings>>
>;
export type HostingEmailSettingsMutationBody = HostingEmailSettingsBody;
export type HostingEmailSettingsMutationError = AxiosError<
  HostingEmailSettings403 | HostingEmailSettings404 | HostingEmailSettings512
>;

/**
 * @summary update email account settings
 */
export const useHostingEmailSettings = <
  TError = AxiosError<
    HostingEmailSettings403 | HostingEmailSettings404 | HostingEmailSettings512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSettings>>,
    TError,
    { hostingId: string; data: HostingEmailSettingsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailSettings>>,
  TError,
  { hostingId: string; data: HostingEmailSettingsBody },
  TContext
> => {
  const mutationOptions = getHostingEmailSettingsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists email spam custom settings including allowlist, blocklist, and custom scores
 * @summary Get email spam custom settings
 */
export const hostingEmailSpamCustomSettings = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSpamCustomSettings200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/emails/spam/custom-settings`,
    options,
  );
};

export const getHostingEmailSpamCustomSettingsQueryKey = (
  hostingId: string,
) => {
  return [`/v1/hosting/${hostingId}/emails/spam/custom-settings`] as const;
};

export const getHostingEmailSpamCustomSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailSpamCustomSettingsQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>
  > = ({ signal }) =>
    hostingEmailSpamCustomSettings(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailSpamCustomSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>
>;
export type HostingEmailSpamCustomSettingsQueryError = AxiosError<unknown>;

export function useHostingEmailSpamCustomSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSpamCustomSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSpamCustomSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get email spam custom settings
 */

export function useHostingEmailSpamCustomSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamCustomSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailSpamCustomSettingsQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update one or more of allowlist, blocklist, and custom scores
 * @summary Set email spam custom settings
 */
export const hostingEmailSpamCustomSettingsUpdate = (
  hostingId: string,
  hostingEmailSpamCustomSettingsUpdateBody: HostingEmailSpamCustomSettingsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSpamCustomSettingsUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails/spam/custom-settings`,
    hostingEmailSpamCustomSettingsUpdateBody,
    options,
  );
};

export const getHostingEmailSpamCustomSettingsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailSpamCustomSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailSpamCustomSettingsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>,
    { hostingId: string; data: HostingEmailSpamCustomSettingsUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailSpamCustomSettingsUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailSpamCustomSettingsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>
>;
export type HostingEmailSpamCustomSettingsUpdateMutationBody =
  HostingEmailSpamCustomSettingsUpdateBody;
export type HostingEmailSpamCustomSettingsUpdateMutationError =
  AxiosError<unknown>;

/**
 * @summary Set email spam custom settings
 */
export const useHostingEmailSpamCustomSettingsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailSpamCustomSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailSpamCustomSettingsUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailSpamCustomSettingsUpdateBody },
  TContext
> => {
  const mutationOptions =
    getHostingEmailSpamCustomSettingsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Empty the account's email spam box
 * @summary empty spam box
 */
export const hostingEmailSpamEmpty = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSpamEmpty200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/spam/empty`,
    undefined,
    options,
  );
};

export const getHostingEmailSpamEmptyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamEmpty>>,
    TError,
    { hostingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailSpamEmpty>>,
  TError,
  { hostingId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailSpamEmpty>>,
    { hostingId: string }
  > = (props) => {
    const { hostingId } = props ?? {};

    return hostingEmailSpamEmpty(hostingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailSpamEmptyMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSpamEmpty>>
>;

export type HostingEmailSpamEmptyMutationError = AxiosError<unknown>;

/**
 * @summary empty spam box
 */
export const useHostingEmailSpamEmpty = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamEmpty>>,
    TError,
    { hostingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailSpamEmpty>>,
  TError,
  { hostingId: string },
  TContext
> => {
  const mutationOptions = getHostingEmailSpamEmptyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns current account-wide spam-related settings
 * @summary Get account spam settings
 */
export const hostingEmailSpamSettings = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSpamSettings200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/spam/settings`, options);
};

export const getHostingEmailSpamSettingsQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/emails/spam/settings`] as const;
};

export const getHostingEmailSpamSettingsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingEmailSpamSettingsQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailSpamSettings>>
  > = ({ signal }) =>
    hostingEmailSpamSettings(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailSpamSettingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSpamSettings>>
>;
export type HostingEmailSpamSettingsQueryError = AxiosError<unknown>;

export function useHostingEmailSpamSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSpamSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSpamSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get account spam settings
 */

export function useHostingEmailSpamSettings<
  TData = Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSpamSettings>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailSpamSettingsQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates one or more account-wide spam-related settings
 * @summary Update account spam settings
 */
export const hostingEmailSpamSettingsUpdate = (
  hostingId: string,
  hostingEmailSpamSettingsUpdateBody: HostingEmailSpamSettingsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSpamSettingsUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/emails/spam/settings`,
    hostingEmailSpamSettingsUpdateBody,
    options,
  );
};

export const getHostingEmailSpamSettingsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailSpamSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailSpamSettingsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>,
    { hostingId: string; data: HostingEmailSpamSettingsUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailSpamSettingsUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailSpamSettingsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>
>;
export type HostingEmailSpamSettingsUpdateMutationBody =
  HostingEmailSpamSettingsUpdateBody;
export type HostingEmailSpamSettingsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Update account spam settings
 */
export const useHostingEmailSpamSettingsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>,
    TError,
    { hostingId: string; data: HostingEmailSpamSettingsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailSpamSettingsUpdate>>,
  TError,
  { hostingId: string; data: HostingEmailSpamSettingsUpdateBody },
  TContext
> => {
  const mutationOptions =
    getHostingEmailSpamSettingsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a SSO login token for an email account by using the query parameters. If the email address is not provided, the SSO token will be generated using the account's username by default.
 * @summary email sso
 */
export const emailSso = (
  hostingId: string,
  params?: EmailSsoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<EmailSso200>> => {
  return axios.get(`/v1/hosting/${hostingId}/emails/sso`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getEmailSsoQueryKey = (
  hostingId: string,
  params?: EmailSsoParams,
) => {
  return [
    `/v1/hosting/${hostingId}/emails/sso`,
    ...(params ? [params] : []),
  ] as const;
};

export const getEmailSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof emailSso>>,
  TError = AxiosError<EmailSso400 | EmailSso512>,
>(
  hostingId: string,
  params?: EmailSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getEmailSsoQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof emailSso>>> = ({
    signal,
  }) => emailSso(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type EmailSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof emailSso>>
>;
export type EmailSsoQueryError = AxiosError<EmailSso400 | EmailSso512>;

export function useEmailSso<
  TData = Awaited<ReturnType<typeof emailSso>>,
  TError = AxiosError<EmailSso400 | EmailSso512>,
>(
  hostingId: string,
  params: undefined | EmailSsoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useEmailSso<
  TData = Awaited<ReturnType<typeof emailSso>>,
  TError = AxiosError<EmailSso400 | EmailSso512>,
>(
  hostingId: string,
  params?: EmailSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof emailSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useEmailSso<
  TData = Awaited<ReturnType<typeof emailSso>>,
  TError = AxiosError<EmailSso400 | EmailSso512>,
>(
  hostingId: string,
  params?: EmailSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email sso
 */

export function useEmailSso<
  TData = Awaited<ReturnType<typeof emailSso>>,
  TError = AxiosError<EmailSso400 | EmailSso512>,
>(
  hostingId: string,
  params?: EmailSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof emailSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getEmailSsoQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Send a test email to the specified address
 * @summary send a test email
 */
export const hostingEmailTestSend = (
  hostingId: string,
  hostingEmailTestSendBody: HostingEmailTestSendBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailTestSend200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/test/send`,
    hostingEmailTestSendBody,
    options,
  );
};

export const getHostingEmailTestSendMutationOptions = <
  TError = AxiosError<
    HostingEmailTestSend403 | HostingEmailTestSend404 | HostingEmailTestSend512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailTestSend>>,
    TError,
    { hostingId: string; data: HostingEmailTestSendBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingEmailTestSend>>,
  TError,
  { hostingId: string; data: HostingEmailTestSendBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingEmailTestSend>>,
    { hostingId: string; data: HostingEmailTestSendBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingEmailTestSend(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingEmailTestSendMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailTestSend>>
>;
export type HostingEmailTestSendMutationBody = HostingEmailTestSendBody;
export type HostingEmailTestSendMutationError = AxiosError<
  HostingEmailTestSend403 | HostingEmailTestSend404 | HostingEmailTestSend512
>;

/**
 * @summary send a test email
 */
export const useHostingEmailTestSend = <
  TError = AxiosError<
    HostingEmailTestSend403 | HostingEmailTestSend404 | HostingEmailTestSend512
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingEmailTestSend>>,
    TError,
    { hostingId: string; data: HostingEmailTestSendBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingEmailTestSend>>,
  TError,
  { hostingId: string; data: HostingEmailTestSendBody },
  TContext
> => {
  const mutationOptions = getHostingEmailTestSendMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Lists existing email address folders
 * @summary email folder list
 */
export const hostingEmailFolderList = (
  hostingId: string,
  address: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailFolderList200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/emails/${address}/folders`,
    options,
  );
};

export const getHostingEmailFolderListQueryKey = (
  hostingId: string,
  address: string,
) => {
  return [`/v1/hosting/${hostingId}/emails/${address}/folders`] as const;
};

export const getHostingEmailFolderListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailFolderList>>,
  TError = AxiosError<HostingEmailFolderList404>,
>(
  hostingId: string,
  address: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFolderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailFolderListQueryKey(hostingId, address);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailFolderList>>
  > = ({ signal }) =>
    hostingEmailFolderList(hostingId, address, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && address),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailFolderList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailFolderListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailFolderList>>
>;
export type HostingEmailFolderListQueryError =
  AxiosError<HostingEmailFolderList404>;

export function useHostingEmailFolderList<
  TData = Awaited<ReturnType<typeof hostingEmailFolderList>>,
  TError = AxiosError<HostingEmailFolderList404>,
>(
  hostingId: string,
  address: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFolderList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailFolderList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailFolderList<
  TData = Awaited<ReturnType<typeof hostingEmailFolderList>>,
  TError = AxiosError<HostingEmailFolderList404>,
>(
  hostingId: string,
  address: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFolderList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailFolderList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailFolderList<
  TData = Awaited<ReturnType<typeof hostingEmailFolderList>>,
  TError = AxiosError<HostingEmailFolderList404>,
>(
  hostingId: string,
  address: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFolderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email folder list
 */

export function useHostingEmailFolderList<
  TData = Awaited<ReturnType<typeof hostingEmailFolderList>>,
  TError = AxiosError<HostingEmailFolderList404>,
>(
  hostingId: string,
  address: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailFolderList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailFolderListQueryOptions(
    hostingId,
    address,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Info incoming and outgoing email configuration
 * @summary email configuration settings
 */
export const hostingEmailSetupInfo = (
  hostingId: string,
  email: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingEmailSetupInfo200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/emails/${email}/setup-info`,
    options,
  );
};

export const getHostingEmailSetupInfoQueryKey = (
  hostingId: string,
  email: string,
) => {
  return [`/v1/hosting/${hostingId}/emails/${email}/setup-info`] as const;
};

export const getHostingEmailSetupInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
  TError = AxiosError<HostingEmailSetupInfo404>,
>(
  hostingId: string,
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingEmailSetupInfoQueryKey(hostingId, email);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingEmailSetupInfo>>
  > = ({ signal }) =>
    hostingEmailSetupInfo(hostingId, email, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(hostingId && email),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingEmailSetupInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingEmailSetupInfo>>
>;
export type HostingEmailSetupInfoQueryError =
  AxiosError<HostingEmailSetupInfo404>;

export function useHostingEmailSetupInfo<
  TData = Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
  TError = AxiosError<HostingEmailSetupInfo404>,
>(
  hostingId: string,
  email: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSetupInfo<
  TData = Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
  TError = AxiosError<HostingEmailSetupInfo404>,
>(
  hostingId: string,
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingEmailSetupInfo<
  TData = Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
  TError = AxiosError<HostingEmailSetupInfo404>,
>(
  hostingId: string,
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary email configuration settings
 */

export function useHostingEmailSetupInfo<
  TData = Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
  TError = AxiosError<HostingEmailSetupInfo404>,
>(
  hostingId: string,
  email: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingEmailSetupInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingEmailSetupInfoQueryOptions(
    hostingId,
    email,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Send an email with incoming and outgoing email configuration to the specified email address. Must be a valid email address on the hosting account.
 * @summary email configuration settings
 */
export const hostingSendEmailSetupInfo = (
  hostingId: string,
  email: string,
  hostingSendEmailSetupInfoBody: HostingSendEmailSetupInfoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSendEmailSetupInfo200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/emails/${email}/setup-info/send`,
    hostingSendEmailSetupInfoBody,
    options,
  );
};

export const getHostingSendEmailSetupInfoMutationOptions = <
  TError = AxiosError<HostingSendEmailSetupInfo404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>,
    TError,
    { hostingId: string; email: string; data: HostingSendEmailSetupInfoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>,
  TError,
  { hostingId: string; email: string; data: HostingSendEmailSetupInfoBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>,
    { hostingId: string; email: string; data: HostingSendEmailSetupInfoBody }
  > = (props) => {
    const { hostingId, email, data } = props ?? {};

    return hostingSendEmailSetupInfo(hostingId, email, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingSendEmailSetupInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>
>;
export type HostingSendEmailSetupInfoMutationBody =
  HostingSendEmailSetupInfoBody;
export type HostingSendEmailSetupInfoMutationError =
  AxiosError<HostingSendEmailSetupInfo404>;

/**
 * @summary email configuration settings
 */
export const useHostingSendEmailSetupInfo = <
  TError = AxiosError<HostingSendEmailSetupInfo404>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>,
    TError,
    { hostingId: string; email: string; data: HostingSendEmailSetupInfoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingSendEmailSetupInfo>>,
  TError,
  { hostingId: string; email: string; data: HostingSendEmailSetupInfoBody },
  TContext
> => {
  const mutationOptions = getHostingSendEmailSetupInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Re-enforces correct ownership on user dirs and files
 * @summary Fix file ownership
 */
export const hostingFixownership = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingFixownership200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/fixownership`,
    undefined,
    options,
  );
};

export const getHostingFixownershipMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFixownership>>,
    TError,
    { hostingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingFixownership>>,
  TError,
  { hostingId: string },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingFixownership>>,
    { hostingId: string }
  > = (props) => {
    const { hostingId } = props ?? {};

    return hostingFixownership(hostingId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingFixownershipMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingFixownership>>
>;

export type HostingFixownershipMutationError = AxiosError<unknown>;

/**
 * @summary Fix file ownership
 */
export const useHostingFixownership = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFixownership>>,
    TError,
    { hostingId: string },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingFixownership>>,
  TError,
  { hostingId: string },
  TContext
> => {
  const mutationOptions = getHostingFixownershipMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of FTP accounts.
 * @summary ftp list
 */
export const hostingFtpList = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingFtpList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/ftp`, options);
};

export const getHostingFtpListQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/ftp`] as const;
};

export const getHostingFtpListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingFtpList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingFtpList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingFtpListQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingFtpList>>> = ({
    signal,
  }) => hostingFtpList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingFtpList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingFtpListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingFtpList>>
>;
export type HostingFtpListQueryError = AxiosError<unknown>;

export function useHostingFtpList<
  TData = Awaited<ReturnType<typeof hostingFtpList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingFtpList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingFtpList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingFtpList<
  TData = Awaited<ReturnType<typeof hostingFtpList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingFtpList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingFtpList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingFtpList<
  TData = Awaited<ReturnType<typeof hostingFtpList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingFtpList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary ftp list
 */

export function useHostingFtpList<
  TData = Awaited<ReturnType<typeof hostingFtpList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingFtpList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingFtpListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add ftp account
 * @summary Add ftp account
 */
export const hostingFtpAdd = (
  hostingId: number,
  hostingFtpAddBody: HostingFtpAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingFtpAdd200>> => {
  return axios.post(`/v1/hosting/${hostingId}/ftp`, hostingFtpAddBody, options);
};

export const getHostingFtpAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtpAdd>>,
    TError,
    { hostingId: number; data: HostingFtpAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingFtpAdd>>,
  TError,
  { hostingId: number; data: HostingFtpAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingFtpAdd>>,
    { hostingId: number; data: HostingFtpAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingFtpAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingFtpAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingFtpAdd>>
>;
export type HostingFtpAddMutationBody = HostingFtpAddBody;
export type HostingFtpAddMutationError = AxiosError<unknown>;

/**
 * @summary Add ftp account
 */
export const useHostingFtpAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtpAdd>>,
    TError,
    { hostingId: number; data: HostingFtpAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingFtpAdd>>,
  TError,
  { hostingId: number; data: HostingFtpAddBody },
  TContext
> => {
  const mutationOptions = getHostingFtpAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update ftp account
 * @summary Update ftp account
 */
export const hostingFtpUpdate = (
  hostingId: number,
  hostingFtpUpdateBody: HostingFtpUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingFtpUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/ftp`,
    hostingFtpUpdateBody,
    options,
  );
};

export const getHostingFtpUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtpUpdate>>,
    TError,
    { hostingId: number; data: HostingFtpUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingFtpUpdate>>,
  TError,
  { hostingId: number; data: HostingFtpUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingFtpUpdate>>,
    { hostingId: number; data: HostingFtpUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingFtpUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingFtpUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingFtpUpdate>>
>;
export type HostingFtpUpdateMutationBody = HostingFtpUpdateBody;
export type HostingFtpUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Update ftp account
 */
export const useHostingFtpUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtpUpdate>>,
    TError,
    { hostingId: number; data: HostingFtpUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingFtpUpdate>>,
  TError,
  { hostingId: number; data: HostingFtpUpdateBody },
  TContext
> => {
  const mutationOptions = getHostingFtpUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete ftp account
 * @summary Delete ftp account
 */
export const hostingFtp = (
  hostingId: number,
  hostingFtpBody: HostingFtpBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingFtp200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/ftp`, {
    data: hostingFtpBody,
    ...options,
  });
};

export const getHostingFtpMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtp>>,
    TError,
    { hostingId: number; data: HostingFtpBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingFtp>>,
  TError,
  { hostingId: number; data: HostingFtpBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingFtp>>,
    { hostingId: number; data: HostingFtpBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingFtp(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingFtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingFtp>>
>;
export type HostingFtpMutationBody = HostingFtpBody;
export type HostingFtpMutationError = AxiosError<unknown>;

/**
 * @summary Delete ftp account
 */
export const useHostingFtp = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingFtp>>,
    TError,
    { hostingId: number; data: HostingFtpBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingFtp>>,
  TError,
  { hostingId: number; data: HostingFtpBody },
  TContext
> => {
  const mutationOptions = getHostingFtpMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of Git repositories associated
 * @summary List Git repositories
 */
export const hostingRepoList = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRepoList200Item[]>> => {
  return axios.get(`/v1/hosting/${hostingId}/git-repos`, options);
};

export const getHostingRepoListQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/git-repos`] as const;
};

export const getHostingRepoListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingRepoList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRepoList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingRepoListQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingRepoList>>> = ({
    signal,
  }) => hostingRepoList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingRepoList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingRepoListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingRepoList>>
>;
export type HostingRepoListQueryError = AxiosError<unknown>;

export function useHostingRepoList<
  TData = Awaited<ReturnType<typeof hostingRepoList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRepoList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRepoList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRepoList<
  TData = Awaited<ReturnType<typeof hostingRepoList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRepoList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRepoList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRepoList<
  TData = Awaited<ReturnType<typeof hostingRepoList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRepoList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List Git repositories
 */

export function useHostingRepoList<
  TData = Awaited<ReturnType<typeof hostingRepoList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRepoList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingRepoListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Clone a new Git repo or pull latest changes into the given path (deployment)
 * @summary Clone or pull Git repository(deploy)
 */
export const hostingRepoSync = (
  hostingId: string,
  hostingRepoSyncBody: HostingRepoSyncBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRepoSync200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/git-repos`,
    hostingRepoSyncBody,
    options,
  );
};

export const getHostingRepoSyncMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRepoSync>>,
    TError,
    { hostingId: string; data: HostingRepoSyncBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingRepoSync>>,
  TError,
  { hostingId: string; data: HostingRepoSyncBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingRepoSync>>,
    { hostingId: string; data: HostingRepoSyncBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingRepoSync(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingRepoSyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingRepoSync>>
>;
export type HostingRepoSyncMutationBody = HostingRepoSyncBody;
export type HostingRepoSyncMutationError = AxiosError<unknown>;

/**
 * @summary Clone or pull Git repository(deploy)
 */
export const useHostingRepoSync = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRepoSync>>,
    TError,
    { hostingId: string; data: HostingRepoSyncBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingRepoSync>>,
  TError,
  { hostingId: string; data: HostingRepoSyncBody },
  TContext
> => {
  const mutationOptions = getHostingRepoSyncMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Deletes the local clone of a Git repository at the specified path
 * @summary Delete Git repository
 */
export const hostingRepo = (
  hostingId: number,
  hostingRepoBody: HostingRepoBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRepo200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/git-repos`, {
    data: hostingRepoBody,
    ...options,
  });
};

export const getHostingRepoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRepo>>,
    TError,
    { hostingId: number; data: HostingRepoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingRepo>>,
  TError,
  { hostingId: number; data: HostingRepoBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingRepo>>,
    { hostingId: number; data: HostingRepoBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingRepo(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingRepoMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingRepo>>
>;
export type HostingRepoMutationBody = HostingRepoBody;
export type HostingRepoMutationError = AxiosError<unknown>;

/**
 * @summary Delete Git repository
 */
export const useHostingRepo = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRepo>>,
    TError,
    { hostingId: number; data: HostingRepoBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingRepo>>,
  TError,
  { hostingId: number; data: HostingRepoBody },
  TContext
> => {
  const mutationOptions = getHostingRepoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the deployment log for a Git repository identified by the path
 * @summary View Git repository deployment log
 */
export const hostingRepoLog = (
  hostingId: string,
  params: HostingRepoLogParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRepoLog200>> => {
  return axios.get(`/v1/hosting/${hostingId}/git-repos/log`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingRepoLogQueryKey = (
  hostingId: string,
  params: HostingRepoLogParams,
) => {
  return [
    `/v1/hosting/${hostingId}/git-repos/log`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingRepoLogQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingRepoLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingRepoLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingRepoLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingRepoLogQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingRepoLog>>> = ({
    signal,
  }) => hostingRepoLog(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingRepoLog>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingRepoLogQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingRepoLog>>
>;
export type HostingRepoLogQueryError = AxiosError<unknown>;

export function useHostingRepoLog<
  TData = Awaited<ReturnType<typeof hostingRepoLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingRepoLogParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingRepoLog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRepoLog>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRepoLog<
  TData = Awaited<ReturnType<typeof hostingRepoLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingRepoLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingRepoLog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRepoLog>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRepoLog<
  TData = Awaited<ReturnType<typeof hostingRepoLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingRepoLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingRepoLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary View Git repository deployment log
 */

export function useHostingRepoLog<
  TData = Awaited<ReturnType<typeof hostingRepoLog>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingRepoLogParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingRepoLog>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingRepoLogQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Hotlink configuration details
 * @summary Hotlink configuration details
 */
export const hotlinkconfigDetails = (
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HotlinkconfigDetails200>> => {
  return axios.get(`/v1/hosting/${hostingId}/hotlinkconfig`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHotlinkconfigDetailsQueryKey = (
  hostingId: string,
  params: HotlinkconfigDetailsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/hotlinkconfig`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHotlinkconfigDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof hotlinkconfigDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hotlinkconfigDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHotlinkconfigDetailsQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hotlinkconfigDetails>>
  > = ({ signal }) =>
    hotlinkconfigDetails(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hotlinkconfigDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HotlinkconfigDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hotlinkconfigDetails>>
>;
export type HotlinkconfigDetailsQueryError = AxiosError<unknown>;

export function useHotlinkconfigDetails<
  TData = Awaited<ReturnType<typeof hotlinkconfigDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hotlinkconfigDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hotlinkconfigDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHotlinkconfigDetails<
  TData = Awaited<ReturnType<typeof hotlinkconfigDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hotlinkconfigDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hotlinkconfigDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHotlinkconfigDetails<
  TData = Awaited<ReturnType<typeof hotlinkconfigDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hotlinkconfigDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Hotlink configuration details
 */

export function useHotlinkconfigDetails<
  TData = Awaited<ReturnType<typeof hotlinkconfigDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HotlinkconfigDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hotlinkconfigDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHotlinkconfigDetailsQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add/Update hotlink configuration
 * @summary Add/Update hotlink configuration
 */
export const hotlinkconfigAdd = (
  hostingId: string,
  hotlinkconfigAddBody: HotlinkconfigAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HotlinkconfigAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/hotlinkconfig`,
    hotlinkconfigAddBody,
    options,
  );
};

export const getHotlinkconfigAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hotlinkconfigAdd>>,
    TError,
    { hostingId: string; data: HotlinkconfigAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hotlinkconfigAdd>>,
  TError,
  { hostingId: string; data: HotlinkconfigAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hotlinkconfigAdd>>,
    { hostingId: string; data: HotlinkconfigAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hotlinkconfigAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HotlinkconfigAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hotlinkconfigAdd>>
>;
export type HotlinkconfigAddMutationBody = HotlinkconfigAddBody;
export type HotlinkconfigAddMutationError = AxiosError<unknown>;

/**
 * @summary Add/Update hotlink configuration
 */
export const useHotlinkconfigAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hotlinkconfigAdd>>,
    TError,
    { hostingId: string; data: HotlinkconfigAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hotlinkconfigAdd>>,
  TError,
  { hostingId: string; data: HotlinkconfigAddBody },
  TContext
> => {
  const mutationOptions = getHotlinkconfigAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete hotlink configuration
 * @summary Delete hotlink configuration
 */
export const hotlinkconfigDelete = (
  hostingId: string,
  hotlinkconfigDeleteBody: HotlinkconfigDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HotlinkconfigDelete200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/hotlinkconfig`, {
    data: hotlinkconfigDeleteBody,
    ...options,
  });
};

export const getHotlinkconfigDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hotlinkconfigDelete>>,
    TError,
    { hostingId: string; data: HotlinkconfigDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hotlinkconfigDelete>>,
  TError,
  { hostingId: string; data: HotlinkconfigDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hotlinkconfigDelete>>,
    { hostingId: string; data: HotlinkconfigDeleteBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hotlinkconfigDelete(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HotlinkconfigDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof hotlinkconfigDelete>>
>;
export type HotlinkconfigDeleteMutationBody = HotlinkconfigDeleteBody;
export type HotlinkconfigDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Delete hotlink configuration
 */
export const useHotlinkconfigDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hotlinkconfigDelete>>,
    TError,
    { hostingId: string; data: HotlinkconfigDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hotlinkconfigDelete>>,
  TError,
  { hostingId: string; data: HotlinkconfigDeleteBody },
  TContext
> => {
  const mutationOptions = getHotlinkconfigDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List indexed files/folders
 * @summary List indexed files/folders
 */
export const listIndex = (
  hostingId: string,
  params?: ListIndexParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ListIndex200>> => {
  return axios.get(`/v1/hosting/${hostingId}/index`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListIndexQueryKey = (
  hostingId: string,
  params?: ListIndexParams,
) => {
  return [
    `/v1/hosting/${hostingId}/index`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListIndexQueryOptions = <
  TData = Awaited<ReturnType<typeof listIndex>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ListIndexParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListIndexQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listIndex>>> = ({
    signal,
  }) => listIndex(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type ListIndexQueryResult = NonNullable<
  Awaited<ReturnType<typeof listIndex>>
>;
export type ListIndexQueryError = AxiosError<unknown>;

export function useListIndex<
  TData = Awaited<ReturnType<typeof listIndex>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | ListIndexParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndex>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListIndex<
  TData = Awaited<ReturnType<typeof listIndex>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ListIndexParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listIndex>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListIndex<
  TData = Awaited<ReturnType<typeof listIndex>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ListIndexParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List indexed files/folders
 */

export function useListIndex<
  TData = Awaited<ReturnType<typeof listIndex>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: ListIndexParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listIndex>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListIndexQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add index to given file/folder
 * @summary Add index to file/folder
 */
export const addIndex = (
  hostingId: string,
  addIndexBody: AddIndexBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddIndex200>> => {
  return axios.post(`/v1/hosting/${hostingId}/index`, addIndexBody, options);
};

export const getAddIndexMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addIndex>>,
    TError,
    { hostingId: string; data: AddIndexBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addIndex>>,
  TError,
  { hostingId: string; data: AddIndexBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addIndex>>,
    { hostingId: string; data: AddIndexBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return addIndex(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddIndexMutationResult = NonNullable<
  Awaited<ReturnType<typeof addIndex>>
>;
export type AddIndexMutationBody = AddIndexBody;
export type AddIndexMutationError = AxiosError<unknown>;

/**
 * @summary Add index to file/folder
 */
export const useAddIndex = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addIndex>>,
    TError,
    { hostingId: string; data: AddIndexBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addIndex>>,
  TError,
  { hostingId: string; data: AddIndexBody },
  TContext
> => {
  const mutationOptions = getAddIndexMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete index to given file/folder
 * @summary Delete index to file/folder
 */
export const index = (
  hostingId: string,
  indexBody: IndexBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Index200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/index`, {
    data: indexBody,
    ...options,
  });
};

export const getIndexMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof index>>,
    TError,
    { hostingId: string; data: IndexBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof index>>,
  TError,
  { hostingId: string; data: IndexBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof index>>,
    { hostingId: string; data: IndexBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return index(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type IndexMutationResult = NonNullable<
  Awaited<ReturnType<typeof index>>
>;
export type IndexMutationBody = IndexBody;
export type IndexMutationError = AxiosError<unknown>;

/**
 * @summary Delete index to file/folder
 */
export const useIndex = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof index>>,
    TError,
    { hostingId: string; data: IndexBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof index>>,
  TError,
  { hostingId: string; data: IndexBody },
  TContext
> => {
  const mutationOptions = getIndexMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns hosting account info
 * @summary Hosting info
 */
export const hostingInfo = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/info`, options);
};

export const getHostingInfoQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/info`] as const;
};

export const getHostingInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHostingInfoQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingInfo>>> = ({
    signal,
  }) => hostingInfo(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingInfo>>
>;
export type HostingInfoQueryError = AxiosError<unknown>;

export function useHostingInfo<
  TData = Awaited<ReturnType<typeof hostingInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingInfo<
  TData = Awaited<ReturnType<typeof hostingInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingInfo<
  TData = Awaited<ReturnType<typeof hostingInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Hosting info
 */

export function useHostingInfo<
  TData = Awaited<ReturnType<typeof hostingInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingInfoQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting account's disk usage
 * @summary info disk usage
 */
export const hostingInfoDiskUsage = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingInfoDiskUsage200>> => {
  return axios.get(`/v1/hosting/${hostingId}/info/diskusage`, options);
};

export const getHostingInfoDiskUsageQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/info/diskusage`] as const;
};

export const getHostingInfoDiskUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingInfoDiskUsageQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingInfoDiskUsage>>
  > = ({ signal }) =>
    hostingInfoDiskUsage(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingInfoDiskUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingInfoDiskUsage>>
>;
export type HostingInfoDiskUsageQueryError = AxiosError<unknown>;

export function useHostingInfoDiskUsage<
  TData = Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingInfoDiskUsage<
  TData = Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingInfoDiskUsage<
  TData = Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary info disk usage
 */

export function useHostingInfoDiskUsage<
  TData = Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingInfoDiskUsage>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingInfoDiskUsageQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns lead info for the user of the hosting account
 * @summary Lead info
 */
export const hostingLead = (
  hostingId: string,
  params?: HostingLeadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingLead200>> => {
  return axios.post(`/v1/hosting/${hostingId}/lead`, undefined, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingLeadMutationOptions = <
  TError = AxiosError<HostingLead400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingLead>>,
    TError,
    { hostingId: string; params?: HostingLeadParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingLead>>,
  TError,
  { hostingId: string; params?: HostingLeadParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingLead>>,
    { hostingId: string; params?: HostingLeadParams }
  > = (props) => {
    const { hostingId, params } = props ?? {};

    return hostingLead(hostingId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingLeadMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingLead>>
>;

export type HostingLeadMutationError = AxiosError<HostingLead400>;

/**
 * @summary Lead info
 */
export const useHostingLead = <
  TError = AxiosError<HostingLead400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingLead>>,
    TError,
    { hostingId: string; params?: HostingLeadParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingLead>>,
  TError,
  { hostingId: string; params?: HostingLeadParams },
  TContext
> => {
  const mutationOptions = getHostingLeadMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Various information pertaining to a hosting license
 * @summary hosting license info
 */
export const hostingLicenseInfo = (
  hostingId: string,
  params?: HostingLicenseInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingLicenseInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/license`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingLicenseInfoQueryKey = (
  hostingId: string,
  params?: HostingLicenseInfoParams,
) => {
  return [
    `/v1/hosting/${hostingId}/license`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingLicenseInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingLicenseInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingLicenseInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingLicenseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingLicenseInfoQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingLicenseInfo>>
  > = ({ signal }) =>
    hostingLicenseInfo(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingLicenseInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingLicenseInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingLicenseInfo>>
>;
export type HostingLicenseInfoQueryError = AxiosError<unknown>;

export function useHostingLicenseInfo<
  TData = Awaited<ReturnType<typeof hostingLicenseInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingLicenseInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingLicenseInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingLicenseInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingLicenseInfo<
  TData = Awaited<ReturnType<typeof hostingLicenseInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingLicenseInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingLicenseInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingLicenseInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingLicenseInfo<
  TData = Awaited<ReturnType<typeof hostingLicenseInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingLicenseInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingLicenseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting license info
 */

export function useHostingLicenseInfo<
  TData = Awaited<ReturnType<typeof hostingLicenseInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingLicenseInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingLicenseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingLicenseInfoQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the Wordpress migration status
 * @summary Wordpress migration status
 */
export const hostingMigrationStatus = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMigrationStatus200>> => {
  return axios.get(`/v1/hosting/${hostingId}/migrations`, options);
};

export const getHostingMigrationStatusQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/migrations`] as const;
};

export const getHostingMigrationStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingMigrationStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingMigrationStatusQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingMigrationStatus>>
  > = ({ signal }) =>
    hostingMigrationStatus(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingMigrationStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingMigrationStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingMigrationStatus>>
>;
export type HostingMigrationStatusQueryError = AxiosError<unknown>;

export function useHostingMigrationStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Wordpress migration status
 */

export function useHostingMigrationStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingMigrationStatusQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds the wordpressmigrate addon for a given migration id and hosting account
 * @summary start the migration process for a site
 */
export const hostingMigrations = (
  hostingId: string,
  hostingMigrationsBody: HostingMigrationsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMigrations200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/migrations`,
    hostingMigrationsBody,
    options,
  );
};

export const getHostingMigrationsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingMigrations>>,
    TError,
    { hostingId: string; data: HostingMigrationsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingMigrations>>,
  TError,
  { hostingId: string; data: HostingMigrationsBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingMigrations>>,
    { hostingId: string; data: HostingMigrationsBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingMigrations(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingMigrationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingMigrations>>
>;
export type HostingMigrationsMutationBody = HostingMigrationsBody;
export type HostingMigrationsMutationError = AxiosError<unknown>;

/**
 * @summary start the migration process for a site
 */
export const useHostingMigrations = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingMigrations>>,
    TError,
    { hostingId: string; data: HostingMigrationsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingMigrations>>,
  TError,
  { hostingId: string; data: HostingMigrationsBody },
  TContext
> => {
  const mutationOptions = getHostingMigrationsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Post migration event to CWM
 * @summary hosting migrations event
 */
export const hostingMigrationsEvent = (
  hostingId: string,
  hostingMigrationsEventBody: HostingMigrationsEventBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMigrationsEvent200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/migrations/event`,
    hostingMigrationsEventBody,
    options,
  );
};

export const getHostingMigrationsEventMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingMigrationsEvent>>,
    TError,
    { hostingId: string; data: HostingMigrationsEventBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingMigrationsEvent>>,
  TError,
  { hostingId: string; data: HostingMigrationsEventBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingMigrationsEvent>>,
    { hostingId: string; data: HostingMigrationsEventBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingMigrationsEvent(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingMigrationsEventMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingMigrationsEvent>>
>;
export type HostingMigrationsEventMutationBody = HostingMigrationsEventBody;
export type HostingMigrationsEventMutationError = AxiosError<unknown>;

/**
 * @summary hosting migrations event
 */
export const useHostingMigrationsEvent = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingMigrationsEvent>>,
    TError,
    { hostingId: string; data: HostingMigrationsEventBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingMigrationsEvent>>,
  TError,
  { hostingId: string; data: HostingMigrationsEventBody },
  TContext
> => {
  const mutationOptions = getHostingMigrationsEventMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Gets the Wordpress migration information
 * @summary Wordpress migration information
 */
export const hostingMigrationInfo = (
  hostingId: number,
  params: HostingMigrationInfoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMigrationInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/migrations/info`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingMigrationInfoQueryKey = (
  hostingId: number,
  params: HostingMigrationInfoParams,
) => {
  return [
    `/v1/hosting/${hostingId}/migrations/info`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingMigrationInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingMigrationInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingMigrationInfoQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingMigrationInfo>>
  > = ({ signal }) =>
    hostingMigrationInfo(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingMigrationInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingMigrationInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingMigrationInfo>>
>;
export type HostingMigrationInfoQueryError = AxiosError<unknown>;

export function useHostingMigrationInfo<
  TData = Awaited<ReturnType<typeof hostingMigrationInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationInfoParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationInfo<
  TData = Awaited<ReturnType<typeof hostingMigrationInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationInfo<
  TData = Awaited<ReturnType<typeof hostingMigrationInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Wordpress migration information
 */

export function useHostingMigrationInfo<
  TData = Awaited<ReturnType<typeof hostingMigrationInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationInfoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingMigrationInfoQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provides the status of SiteMigration site_scan and deeplink to WordPress admin page
 * @summary SiteMigration site_scan status
 */
export const hostingMigrationSiteScanStatus = (
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMigrationSiteScanStatus200>> => {
  return axios.get(`/v1/hosting/${hostingId}/migrations/site-scan`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingMigrationSiteScanStatusQueryKey = (
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
) => {
  return [
    `/v1/hosting/${hostingId}/migrations/site-scan`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingMigrationSiteScanStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingMigrationSiteScanStatusQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>
  > = ({ signal }) =>
    hostingMigrationSiteScanStatus(hostingId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingMigrationSiteScanStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>
>;
export type HostingMigrationSiteScanStatusQueryError = AxiosError<unknown>;

export function useHostingMigrationSiteScanStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationSiteScanStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMigrationSiteScanStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary SiteMigration site_scan status
 */

export function useHostingMigrationSiteScanStatus<
  TData = Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: HostingMigrationSiteScanStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMigrationSiteScanStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingMigrationSiteScanStatusQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the list of Monarx addons for the hosting account.
 * @summary Monarx addons list for a hosting account
 */
export const hostingMonarxAddonsList = (
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingMonarxAddonsList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/monarx/addons`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingMonarxAddonsListQueryKey = (
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
) => {
  return [
    `/v1/hosting/${hostingId}/monarx/addons`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingMonarxAddonsListQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
  TError = AxiosError<void>,
>(
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingMonarxAddonsListQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingMonarxAddonsList>>
  > = ({ signal }) =>
    hostingMonarxAddonsList(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingMonarxAddonsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingMonarxAddonsList>>
>;
export type HostingMonarxAddonsListQueryError = AxiosError<void>;

export function useHostingMonarxAddonsList<
  TData = Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
  TError = AxiosError<void>,
>(
  hostingId: string,
  params: undefined | HostingMonarxAddonsListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMonarxAddonsList<
  TData = Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
  TError = AxiosError<void>,
>(
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingMonarxAddonsList<
  TData = Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
  TError = AxiosError<void>,
>(
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Monarx addons list for a hosting account
 */

export function useHostingMonarxAddonsList<
  TData = Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
  TError = AxiosError<void>,
>(
  hostingId: string,
  params?: HostingMonarxAddonsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingMonarxAddonsList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingMonarxAddonsListQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting brand nameservers
 * @deprecated
 * @summary hosting nameservers
 */
export const hostingNameservers = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingNameservers200>> => {
  return axios.get(`/v1/hosting/${hostingId}/nameservers`, options);
};

export const getHostingNameserversQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/nameservers`] as const;
};

export const getHostingNameserversQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingNameservers>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameservers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingNameserversQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingNameservers>>
  > = ({ signal }) =>
    hostingNameservers(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingNameservers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingNameserversQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingNameservers>>
>;
export type HostingNameserversQueryError = AxiosError<unknown>;

export function useHostingNameservers<
  TData = Awaited<ReturnType<typeof hostingNameservers>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameservers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingNameservers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingNameservers<
  TData = Awaited<ReturnType<typeof hostingNameservers>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameservers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingNameservers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingNameservers<
  TData = Awaited<ReturnType<typeof hostingNameservers>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameservers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary hosting nameservers
 */

export function useHostingNameservers<
  TData = Awaited<ReturnType<typeof hostingNameservers>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameservers>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingNameserversQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns onboarding data
 * @summary Returns hosting onboarding data
 */
export const hostingOnboardingData = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingOnboardingData200>> => {
  return axios.get(`/v1/hosting/${hostingId}/onboarding`, options);
};

export const getHostingOnboardingDataQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/onboarding`] as const;
};

export const getHostingOnboardingDataQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingOnboardingData>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingOnboardingData>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingOnboardingDataQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingOnboardingData>>
  > = ({ signal }) =>
    hostingOnboardingData(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingOnboardingData>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingOnboardingDataQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingOnboardingData>>
>;
export type HostingOnboardingDataQueryError = AxiosError<unknown>;

export function useHostingOnboardingData<
  TData = Awaited<ReturnType<typeof hostingOnboardingData>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingOnboardingData>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingOnboardingData>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingOnboardingData<
  TData = Awaited<ReturnType<typeof hostingOnboardingData>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingOnboardingData>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingOnboardingData>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingOnboardingData<
  TData = Awaited<ReturnType<typeof hostingOnboardingData>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingOnboardingData>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns hosting onboarding data
 */

export function useHostingOnboardingData<
  TData = Awaited<ReturnType<typeof hostingOnboardingData>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingOnboardingData>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingOnboardingDataQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Updates hosting onboarding data
 */
export const hostingOnboardingDataUpdate = (
  hostingId: string,
  hostingOnboardingDataUpdateBody: HostingOnboardingDataUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingOnboardingDataUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/onboarding`,
    hostingOnboardingDataUpdateBody,
    options,
  );
};

export const getHostingOnboardingDataUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>,
    TError,
    { hostingId: string; data: HostingOnboardingDataUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>,
  TError,
  { hostingId: string; data: HostingOnboardingDataUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>,
    { hostingId: string; data: HostingOnboardingDataUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingOnboardingDataUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingOnboardingDataUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>
>;
export type HostingOnboardingDataUpdateMutationBody =
  HostingOnboardingDataUpdateBody;
export type HostingOnboardingDataUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Updates hosting onboarding data
 */
export const useHostingOnboardingDataUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>,
    TError,
    { hostingId: string; data: HostingOnboardingDataUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingOnboardingDataUpdate>>,
  TError,
  { hostingId: string; data: HostingOnboardingDataUpdateBody },
  TContext
> => {
  const mutationOptions =
    getHostingOnboardingDataUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the hosting account password for the specified hosting account.
 * @summary Update the hosting account password
 */
export const hostingPasswordUpdate = (
  hostingId: string,
  hostingPasswordUpdateBody: HostingPasswordUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingPasswordUpdate200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/password`,
    hostingPasswordUpdateBody,
    options,
  );
};

export const getHostingPasswordUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingPasswordUpdate>>,
    TError,
    { hostingId: string; data: HostingPasswordUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingPasswordUpdate>>,
  TError,
  { hostingId: string; data: HostingPasswordUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingPasswordUpdate>>,
    { hostingId: string; data: HostingPasswordUpdateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingPasswordUpdate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingPasswordUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingPasswordUpdate>>
>;
export type HostingPasswordUpdateMutationBody = HostingPasswordUpdateBody;
export type HostingPasswordUpdateMutationError = AxiosError<unknown>;

/**
 * @summary Update the hosting account password
 */
export const useHostingPasswordUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingPasswordUpdate>>,
    TError,
    { hostingId: string; data: HostingPasswordUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingPasswordUpdate>>,
  TError,
  { hostingId: string; data: HostingPasswordUpdateBody },
  TContext
> => {
  const mutationOptions = getHostingPasswordUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Generate account password
 * @summary Generate account password
 */
export const passwordGenerate = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PasswordGenerate200>> => {
  return axios.get(`/v1/hosting/${hostingId}/password/generate`, options);
};

export const getPasswordGenerateQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/password/generate`] as const;
};

export const getPasswordGenerateQueryOptions = <
  TData = Awaited<ReturnType<typeof passwordGenerate>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof passwordGenerate>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPasswordGenerateQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof passwordGenerate>>
  > = ({ signal }) => passwordGenerate(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof passwordGenerate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasswordGenerateQueryResult = NonNullable<
  Awaited<ReturnType<typeof passwordGenerate>>
>;
export type PasswordGenerateQueryError = AxiosError<unknown>;

export function usePasswordGenerate<
  TData = Awaited<ReturnType<typeof passwordGenerate>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof passwordGenerate>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof passwordGenerate>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePasswordGenerate<
  TData = Awaited<ReturnType<typeof passwordGenerate>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof passwordGenerate>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof passwordGenerate>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePasswordGenerate<
  TData = Awaited<ReturnType<typeof passwordGenerate>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof passwordGenerate>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Generate account password
 */

export function usePasswordGenerate<
  TData = Awaited<ReturnType<typeof passwordGenerate>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof passwordGenerate>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPasswordGenerateQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Calculate account password score
 * @summary Calculate account password score
 */
export const passwordScore = (
  hostingId: string,
  params: PasswordScoreParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PasswordScore200>> => {
  return axios.get(`/v1/hosting/${hostingId}/password/score`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getPasswordScoreQueryKey = (
  hostingId: string,
  params: PasswordScoreParams,
) => {
  return [
    `/v1/hosting/${hostingId}/password/score`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPasswordScoreQueryOptions = <
  TData = Awaited<ReturnType<typeof passwordScore>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PasswordScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof passwordScore>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPasswordScoreQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof passwordScore>>> = ({
    signal,
  }) => passwordScore(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof passwordScore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PasswordScoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof passwordScore>>
>;
export type PasswordScoreQueryError = AxiosError<unknown>;

export function usePasswordScore<
  TData = Awaited<ReturnType<typeof passwordScore>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PasswordScoreParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof passwordScore>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof passwordScore>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePasswordScore<
  TData = Awaited<ReturnType<typeof passwordScore>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PasswordScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof passwordScore>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof passwordScore>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePasswordScore<
  TData = Awaited<ReturnType<typeof passwordScore>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PasswordScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof passwordScore>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Calculate account password score
 */

export function usePasswordScore<
  TData = Awaited<ReturnType<typeof passwordScore>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PasswordScoreParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof passwordScore>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPasswordScoreQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of php error logs
 * @summary To get all the php error activities log on user account associated to that domain
 */
export const phpErrors = (
  hostingId: string,
  params: PhpErrorsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PhpErrors200>> => {
  return axios.get(`/v1/hosting/${hostingId}/php-errors`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getPhpErrorsQueryKey = (
  hostingId: string,
  params: PhpErrorsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/php-errors`,
    ...(params ? [params] : []),
  ] as const;
};

export const getPhpErrorsQueryOptions = <
  TData = Awaited<ReturnType<typeof phpErrors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PhpErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPhpErrorsQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof phpErrors>>> = ({
    signal,
  }) => phpErrors(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type PhpErrorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof phpErrors>>
>;
export type PhpErrorsQueryError = AxiosError<unknown>;

export function usePhpErrors<
  TData = Awaited<ReturnType<typeof phpErrors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PhpErrorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof phpErrors>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePhpErrors<
  TData = Awaited<ReturnType<typeof phpErrors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PhpErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof phpErrors>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePhpErrors<
  TData = Awaited<ReturnType<typeof phpErrors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PhpErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary To get all the php error activities log on user account associated to that domain
 */

export function usePhpErrors<
  TData = Awaited<ReturnType<typeof phpErrors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: PhpErrorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof phpErrors>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPhpErrorsQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Product license details
 * @summary Product license details
 */
export const productLicenseDetails = (
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ProductLicenseDetails200>> => {
  return axios.get(`/v1/hosting/${hostingId}/product/license-details`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getProductLicenseDetailsQueryKey = (
  hostingId: string,
  params: ProductLicenseDetailsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/product/license-details`,
    ...(params ? [params] : []),
  ] as const;
};

export const getProductLicenseDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof productLicenseDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productLicenseDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getProductLicenseDetailsQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof productLicenseDetails>>
  > = ({ signal }) =>
    productLicenseDetails(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof productLicenseDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ProductLicenseDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof productLicenseDetails>>
>;
export type ProductLicenseDetailsQueryError = AxiosError<unknown>;

export function useProductLicenseDetails<
  TData = Awaited<ReturnType<typeof productLicenseDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productLicenseDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof productLicenseDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useProductLicenseDetails<
  TData = Awaited<ReturnType<typeof productLicenseDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productLicenseDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof productLicenseDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useProductLicenseDetails<
  TData = Awaited<ReturnType<typeof productLicenseDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productLicenseDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Product license details
 */

export function useProductLicenseDetails<
  TData = Awaited<ReturnType<typeof productLicenseDetails>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ProductLicenseDetailsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof productLicenseDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getProductLicenseDetailsQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the list of site's redirects
 * @summary List redirects
 */
export const hostingRedirects = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRedirects200Item[]>> => {
  return axios.get(`/v1/hosting/${hostingId}/redirects`, options);
};

export const getHostingRedirectsQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/redirects`] as const;
};

export const getHostingRedirectsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingRedirects>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirects>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingRedirectsQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingRedirects>>
  > = ({ signal }) => hostingRedirects(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingRedirects>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingRedirectsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingRedirects>>
>;
export type HostingRedirectsQueryError = AxiosError<unknown>;

export function useHostingRedirects<
  TData = Awaited<ReturnType<typeof hostingRedirects>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirects>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRedirects>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRedirects<
  TData = Awaited<ReturnType<typeof hostingRedirects>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirects>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRedirects>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRedirects<
  TData = Awaited<ReturnType<typeof hostingRedirects>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirects>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List redirects
 */

export function useHostingRedirects<
  TData = Awaited<ReturnType<typeof hostingRedirects>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirects>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingRedirectsQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete the user site redirect
 * @summary Delete redirects
 */
export const hostingRedirect = (
  hostingId: string,
  hostingRedirectBody: HostingRedirectBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRedirect200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/redirects`, {
    data: hostingRedirectBody,
    ...options,
  });
};

export const getHostingRedirectMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRedirect>>,
    TError,
    { hostingId: string; data: HostingRedirectBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingRedirect>>,
  TError,
  { hostingId: string; data: HostingRedirectBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingRedirect>>,
    { hostingId: string; data: HostingRedirectBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingRedirect(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingRedirectMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingRedirect>>
>;
export type HostingRedirectMutationBody = HostingRedirectBody;
export type HostingRedirectMutationError = AxiosError<unknown>;

/**
 * @summary Delete redirects
 */
export const useHostingRedirect = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingRedirect>>,
    TError,
    { hostingId: string; data: HostingRedirectBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingRedirect>>,
  TError,
  { hostingId: string; data: HostingRedirectBody },
  TContext
> => {
  const mutationOptions = getHostingRedirectMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Add the redirect url path for the site
 * @summary Add redirects
 */
export const addHostingRedirects = (
  hostingId: string,
  addHostingRedirectsBody: AddHostingRedirectsBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddHostingRedirects200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/redirects`,
    addHostingRedirectsBody,
    options,
  );
};

export const getAddHostingRedirectsMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addHostingRedirects>>,
    TError,
    { hostingId: string; data: AddHostingRedirectsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addHostingRedirects>>,
  TError,
  { hostingId: string; data: AddHostingRedirectsBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addHostingRedirects>>,
    { hostingId: string; data: AddHostingRedirectsBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return addHostingRedirects(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddHostingRedirectsMutationResult = NonNullable<
  Awaited<ReturnType<typeof addHostingRedirects>>
>;
export type AddHostingRedirectsMutationBody = AddHostingRedirectsBody;
export type AddHostingRedirectsMutationError = AxiosError<unknown>;

/**
 * @summary Add redirects
 */
export const useAddHostingRedirects = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addHostingRedirects>>,
    TError,
    { hostingId: string; data: AddHostingRedirectsBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addHostingRedirects>>,
  TError,
  { hostingId: string; data: AddHostingRedirectsBody },
  TContext
> => {
  const mutationOptions = getAddHostingRedirectsMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the hosting sso_whm login url
 * @summary hosting sso_whm
 */
export const hostingResellerSsoWhm = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingResellerSsoWhm200>> => {
  return axios.get(`/v1/hosting/${hostingId}/reseller/sso/whm`, options);
};

export const getHostingResellerSsoWhmQueryKey = (hostingId: number) => {
  return [`/v1/hosting/${hostingId}/reseller/sso/whm`] as const;
};

export const getHostingResellerSsoWhmQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingResellerSsoWhmQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingResellerSsoWhm>>
  > = ({ signal }) =>
    hostingResellerSsoWhm(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingResellerSsoWhmQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingResellerSsoWhm>>
>;
export type HostingResellerSsoWhmQueryError = AxiosError<unknown>;

export function useHostingResellerSsoWhm<
  TData = Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingResellerSsoWhm<
  TData = Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingResellerSsoWhm<
  TData = Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting sso_whm
 */

export function useHostingResellerSsoWhm<
  TData = Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingResellerSsoWhm>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingResellerSsoWhmQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns total hits and a list of hits for the last N number of days passed as input
 * @summary Hosting server hits
 */
export const hostingServerHits = (
  hostingId: string,
  params: HostingServerHitsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingServerHits200>> => {
  return axios.get(`/v1/hosting/${hostingId}/server-hits`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingServerHitsQueryKey = (
  hostingId: string,
  params: HostingServerHitsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/server-hits`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingServerHitsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingServerHits>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingServerHitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingServerHits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingServerHitsQueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingServerHits>>
  > = ({ signal }) =>
    hostingServerHits(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingServerHits>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingServerHitsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingServerHits>>
>;
export type HostingServerHitsQueryError = AxiosError<unknown>;

export function useHostingServerHits<
  TData = Awaited<ReturnType<typeof hostingServerHits>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingServerHitsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingServerHits>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingServerHits>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingServerHits<
  TData = Awaited<ReturnType<typeof hostingServerHits>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingServerHitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingServerHits>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingServerHits>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingServerHits<
  TData = Awaited<ReturnType<typeof hostingServerHits>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingServerHitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingServerHits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Hosting server hits
 */

export function useHostingServerHits<
  TData = Awaited<ReturnType<typeof hostingServerHits>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingServerHitsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingServerHits>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingServerHitsQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enable or disable shell access on an account by setting the shell.SSH key access must be established separately.
 * @summary hosting shell toggle
 */
export const hostingShellToggle = (
  hostingId: string,
  hostingShellToggleBody: HostingShellToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingShellToggle200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/shell`,
    hostingShellToggleBody,
    options,
  );
};

export const getHostingShellToggleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingShellToggle>>,
    TError,
    { hostingId: string; data: HostingShellToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingShellToggle>>,
  TError,
  { hostingId: string; data: HostingShellToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingShellToggle>>,
    { hostingId: string; data: HostingShellToggleBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingShellToggle(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingShellToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingShellToggle>>
>;
export type HostingShellToggleMutationBody = HostingShellToggleBody;
export type HostingShellToggleMutationError = AxiosError<unknown>;

/**
 * @summary hosting shell toggle
 */
export const useHostingShellToggle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingShellToggle>>,
    TError,
    { hostingId: string; data: HostingShellToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingShellToggle>>,
  TError,
  { hostingId: string; data: HostingShellToggleBody },
  TContext
> => {
  const mutationOptions = getHostingShellToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Determine shell access status for an account.
 * @summary hosting shell_status
 */
export const hostingShellInfo = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingShellInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/shell`, options);
};

export const getHostingShellInfoQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/shell`] as const;
};

export const getHostingShellInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingShellInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingShellInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingShellInfoQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingShellInfo>>
  > = ({ signal }) => hostingShellInfo(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingShellInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingShellInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingShellInfo>>
>;
export type HostingShellInfoQueryError = AxiosError<unknown>;

export function useHostingShellInfo<
  TData = Awaited<ReturnType<typeof hostingShellInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingShellInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingShellInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingShellInfo<
  TData = Awaited<ReturnType<typeof hostingShellInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingShellInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingShellInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingShellInfo<
  TData = Awaited<ReturnType<typeof hostingShellInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingShellInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting shell_status
 */

export function useHostingShellInfo<
  TData = Awaited<ReturnType<typeof hostingShellInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingShellInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingShellInfoQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a site to the current hosting.
 * @deprecated
 * @summary sites add
 */
export const hostingSiteAdd = (
  hostingId: number,
  hostingSiteAddBody: HostingSiteAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSiteAdd200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/sites`,
    hostingSiteAddBody,
    options,
  );
};

export const getHostingSiteAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAdd>>,
    TError,
    { hostingId: number; data: HostingSiteAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingSiteAdd>>,
  TError,
  { hostingId: number; data: HostingSiteAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingSiteAdd>>,
    { hostingId: number; data: HostingSiteAddBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingSiteAdd(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingSiteAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingSiteAdd>>
>;
export type HostingSiteAddMutationBody = HostingSiteAddBody;
export type HostingSiteAddMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary sites add
 */
export const useHostingSiteAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAdd>>,
    TError,
    { hostingId: number; data: HostingSiteAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingSiteAdd>>,
  TError,
  { hostingId: number; data: HostingSiteAddBody },
  TContext
> => {
  const mutationOptions = getHostingSiteAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update Sites in batches.
 * @summary sites update batch
 */
export const sitesBatch = (
  hostingId: number,
  sitesBatchBody: SitesBatchBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesBatch200>> => {
  return axios.put(
    `/v1/hosting/${hostingId}/sites/batch`,
    sitesBatchBody,
    options,
  );
};

export const getSitesBatchMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBatch>>,
    TError,
    { hostingId: number; data: SitesBatchBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesBatch>>,
  TError,
  { hostingId: number; data: SitesBatchBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesBatch>>,
    { hostingId: number; data: SitesBatchBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sitesBatch(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesBatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesBatch>>
>;
export type SitesBatchMutationBody = SitesBatchBody;
export type SitesBatchMutationError = AxiosError<unknown>;

/**
 * @summary sites update batch
 */
export const useSitesBatch = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBatch>>,
    TError,
    { hostingId: number; data: SitesBatchBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesBatch>>,
  TError,
  { hostingId: number; data: SitesBatchBody },
  TContext
> => {
  const mutationOptions = getSitesBatchMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns domains on the hosting account that are eligible for SpamExperts domain assignment
 * @summary SpamExperts eligible domains
 */
export const hostingSpamexpertsEligibleDomains = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSpamexpertsEligibleDomains200>> => {
  return axios.get(
    `/v1/hosting/${hostingId}/spamexperts/eligible-domains`,
    options,
  );
};

export const getHostingSpamexpertsEligibleDomainsQueryKey = (
  hostingId: string,
) => {
  return [`/v1/hosting/${hostingId}/spamexperts/eligible-domains`] as const;
};

export const getHostingSpamexpertsEligibleDomainsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getHostingSpamexpertsEligibleDomainsQueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>
  > = ({ signal }) =>
    hostingSpamexpertsEligibleDomains(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingSpamexpertsEligibleDomainsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>
>;
export type HostingSpamexpertsEligibleDomainsQueryError = AxiosError<unknown>;

export function useHostingSpamexpertsEligibleDomains<
  TData = Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSpamexpertsEligibleDomains<
  TData = Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSpamexpertsEligibleDomains<
  TData = Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary SpamExperts eligible domains
 */

export function useHostingSpamexpertsEligibleDomains<
  TData = Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingSpamexpertsEligibleDomains>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingSpamexpertsEligibleDomainsQueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting account's SSH information
 * @summary ssh info
 */
export const hostingSshInfo = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSshInfo200>> => {
  return axios.get(`/v1/hosting/${hostingId}/ssh`, options);
};

export const getHostingSshInfoQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/ssh`] as const;
};

export const getHostingSshInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingSshInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSshInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingSshInfoQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingSshInfo>>> = ({
    signal,
  }) => hostingSshInfo(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingSshInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingSshInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingSshInfo>>
>;
export type HostingSshInfoQueryError = AxiosError<unknown>;

export function useHostingSshInfo<
  TData = Awaited<ReturnType<typeof hostingSshInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSshInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSshInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSshInfo<
  TData = Awaited<ReturnType<typeof hostingSshInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSshInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSshInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSshInfo<
  TData = Awaited<ReturnType<typeof hostingSshInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSshInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary ssh info
 */

export function useHostingSshInfo<
  TData = Awaited<ReturnType<typeof hostingSshInfo>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSshInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingSshInfoQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Fetches an SSH public key.
 * @summary ssh key fetch
 */
export const sshKeyFetch = (
  hostingId: string,
  params: SshKeyFetchParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyFetch200>> => {
  return axios.get(`/v1/hosting/${hostingId}/ssh/fetch`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSshKeyFetchQueryKey = (
  hostingId: string,
  params: SshKeyFetchParams,
) => {
  return [
    `/v1/hosting/${hostingId}/ssh/fetch`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSshKeyFetchQueryOptions = <
  TData = Awaited<ReturnType<typeof sshKeyFetch>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: SshKeyFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyFetch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSshKeyFetchQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sshKeyFetch>>> = ({
    signal,
  }) => sshKeyFetch(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sshKeyFetch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SshKeyFetchQueryResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyFetch>>
>;
export type SshKeyFetchQueryError = AxiosError<unknown>;

export function useSshKeyFetch<
  TData = Awaited<ReturnType<typeof sshKeyFetch>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: SshKeyFetchParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyFetch>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyFetch>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyFetch<
  TData = Awaited<ReturnType<typeof sshKeyFetch>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: SshKeyFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyFetch>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyFetch>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyFetch<
  TData = Awaited<ReturnType<typeof sshKeyFetch>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: SshKeyFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyFetch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary ssh key fetch
 */

export function useSshKeyFetch<
  TData = Awaited<ReturnType<typeof sshKeyFetch>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: SshKeyFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyFetch>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSshKeyFetchQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Import public/private ssh key
 * @deprecated
 * @summary Import ssh key
 */
export const sshKeyImport = (
  hostingId: number,
  sshKeyImportBody: SshKeyImportBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyImport200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/ssh/import`,
    sshKeyImportBody,
    options,
  );
};

export const getSshKeyImportMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImport>>,
    TError,
    { hostingId: number; data: SshKeyImportBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKeyImport>>,
  TError,
  { hostingId: number; data: SshKeyImportBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKeyImport>>,
    { hostingId: number; data: SshKeyImportBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKeyImport(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyImportMutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyImport>>
>;
export type SshKeyImportMutationBody = SshKeyImportBody;
export type SshKeyImportMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary Import ssh key
 */
export const useSshKeyImport = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImport>>,
    TError,
    { hostingId: number; data: SshKeyImportBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKeyImport>>,
  TError,
  { hostingId: number; data: SshKeyImportBody },
  TContext
> => {
  const mutationOptions = getSshKeyImportMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export const sshKeyList = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyList200>> => {
  return axios.get(`/v1/hosting/${hostingId}/ssh/keys`, options);
};

export const getSshKeyListQueryKey = (hostingId: string) => {
  return [`/v1/hosting/${hostingId}/ssh/keys`] as const;
};

export const getSshKeyListQueryOptions = <
  TData = Awaited<ReturnType<typeof sshKeyList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSshKeyListQueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sshKeyList>>> = ({
    signal,
  }) => sshKeyList(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sshKeyList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SshKeyListQueryResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyList>>
>;
export type SshKeyListQueryError = AxiosError<unknown>;

export function useSshKeyList<
  TData = Awaited<ReturnType<typeof sshKeyList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyList>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyList<
  TData = Awaited<ReturnType<typeof sshKeyList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyList>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyList<
  TData = Awaited<ReturnType<typeof sshKeyList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Deprecated - ssh keys list
 */

export function useSshKeyList<
  TData = Awaited<ReturnType<typeof sshKeyList>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyList>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSshKeyListQueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes an SSH key
 * @deprecated
 * @summary ssh key delete
 */
export const sshKey = (
  hostingId: string,
  sshKeyBody: SshKeyBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKey200>> => {
  return axios.delete(`/v1/hosting/${hostingId}/ssh/keys`, {
    data: sshKeyBody,
    ...options,
  });
};

export const getSshKeyMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKey>>,
    TError,
    { hostingId: string; data: SshKeyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKey>>,
  TError,
  { hostingId: string; data: SshKeyBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKey>>,
    { hostingId: string; data: SshKeyBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKey(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyMutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKey>>
>;
export type SshKeyMutationBody = SshKeyBody;
export type SshKeyMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary ssh key delete
 */
export const useSshKey = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKey>>,
    TError,
    { hostingId: string; data: SshKeyBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKey>>,
  TError,
  { hostingId: string; data: SshKeyBody },
  TContext
> => {
  const mutationOptions = getSshKeyMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Generates public/private ssh keys
 * @summary Generate ssh key
 */
export const sshKeyGenerate = (
  hostingId: number,
  sshKeyGenerateBody: SshKeyGenerateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyGenerate200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/ssh/keys`,
    sshKeyGenerateBody,
    options,
  );
};

export const getSshKeyGenerateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyGenerate>>,
    TError,
    { hostingId: number; data: SshKeyGenerateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKeyGenerate>>,
  TError,
  { hostingId: number; data: SshKeyGenerateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKeyGenerate>>,
    { hostingId: number; data: SshKeyGenerateBody }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKeyGenerate(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyGenerate>>
>;
export type SshKeyGenerateMutationBody = SshKeyGenerateBody;
export type SshKeyGenerateMutationError = AxiosError<unknown>;

/**
 * @summary Generate ssh key
 */
export const useSshKeyGenerate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyGenerate>>,
    TError,
    { hostingId: number; data: SshKeyGenerateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKeyGenerate>>,
  TError,
  { hostingId: number; data: SshKeyGenerateBody },
  TContext
> => {
  const mutationOptions = getSshKeyGenerateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Reinstalls a customer SSH public key from HAL storage onto the VPS server. Used when a key exists in the panel database but is missing from the server (for example after a reimage).
 * @summary Sync a VPS SSH public key to the server
 */
export const hostingVpsSshKeySync = (
  hostingId: string,
  id: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingVpsSshKeySync200>> => {
  return axios.post(
    `/v1/hosting/${hostingId}/ssh/keys/${id}/sync`,
    undefined,
    options,
  );
};

export const getHostingVpsSshKeySyncMutationOptions = <
  TError = AxiosError<HostingVpsSshKeySync404 | HostingVpsSshKeySync500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingVpsSshKeySync>>,
    TError,
    { hostingId: string; id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingVpsSshKeySync>>,
  TError,
  { hostingId: string; id: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingVpsSshKeySync>>,
    { hostingId: string; id: number }
  > = (props) => {
    const { hostingId, id } = props ?? {};

    return hostingVpsSshKeySync(hostingId, id, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingVpsSshKeySyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingVpsSshKeySync>>
>;

export type HostingVpsSshKeySyncMutationError = AxiosError<
  HostingVpsSshKeySync404 | HostingVpsSshKeySync500
>;

/**
 * @summary Sync a VPS SSH public key to the server
 */
export const useHostingVpsSshKeySync = <
  TError = AxiosError<HostingVpsSshKeySync404 | HostingVpsSshKeySync500>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingVpsSshKeySync>>,
    TError,
    { hostingId: string; id: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingVpsSshKeySync>>,
  TError,
  { hostingId: string; id: number },
  TContext
> => {
  const mutationOptions = getHostingVpsSshKeySyncMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a SSO login token for a hosting account by default, or directly to various apps within the hosting account by using the optional query parameter.
 * @summary sso
 */
export const sso = (
  hostingId: number,
  params?: SsoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Sso200>> => {
  return axios.get(`/v1/hosting/${hostingId}/sso`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSsoQueryKey = (hostingId: number, params?: SsoParams) => {
  return [`/v1/hosting/${hostingId}/sso`, ...(params ? [params] : [])] as const;
};

export const getSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof sso>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params?: SsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSsoQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sso>>> = ({
    signal,
  }) => sso(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SsoQueryResult = NonNullable<Awaited<ReturnType<typeof sso>>>;
export type SsoQueryError = AxiosError<unknown>;

export function useSso<
  TData = Awaited<ReturnType<typeof sso>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params: undefined | SsoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSso<
  TData = Awaited<ReturnType<typeof sso>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params?: SsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSso<
  TData = Awaited<ReturnType<typeof sso>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params?: SsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sso
 */

export function useSso<
  TData = Awaited<ReturnType<typeof sso>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  params?: SsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSsoQueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site x axis for graphical representation
 * @summary domain visitors
 */
export const hostingVisitors = (
  hostingId: string,
  params: HostingVisitorsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingVisitors200>> => {
  return axios.get(`/v1/hosting/${hostingId}/visitors`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingVisitorsQueryKey = (
  hostingId: string,
  params: HostingVisitorsParams,
) => {
  return [
    `/v1/hosting/${hostingId}/visitors`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingVisitorsQueryOptions = <
  TData = Awaited<ReturnType<typeof hostingVisitors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingVisitors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingVisitorsQueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingVisitors>>> = ({
    signal,
  }) => hostingVisitors(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingVisitors>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingVisitorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingVisitors>>
>;
export type HostingVisitorsQueryError = AxiosError<unknown>;

export function useHostingVisitors<
  TData = Awaited<ReturnType<typeof hostingVisitors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingVisitorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingVisitors>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingVisitors>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingVisitors<
  TData = Awaited<ReturnType<typeof hostingVisitors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingVisitors>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingVisitors>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingVisitors<
  TData = Awaited<ReturnType<typeof hostingVisitors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingVisitors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain visitors
 */

export function useHostingVisitors<
  TData = Awaited<ReturnType<typeof hostingVisitors>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: HostingVisitorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingVisitors>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingVisitorsQueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of images available for public use.
 * @summary Public OS image list
 */
export const publicImages = (
  params?: PublicImagesParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicImages200>> => {
  return axios.get(`/v1/public/images`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getPublicImagesQueryKey = (params?: PublicImagesParams) => {
  return [`/v1/public/images`, ...(params ? [params] : [])] as const;
};

export const getPublicImagesQueryOptions = <
  TData = Awaited<ReturnType<typeof publicImages>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImages>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPublicImagesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof publicImages>>> = ({
    signal,
  }) => publicImages(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof publicImages>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PublicImagesQueryResult = NonNullable<
  Awaited<ReturnType<typeof publicImages>>
>;
export type PublicImagesQueryError = AxiosError<unknown>;

export function usePublicImages<
  TData = Awaited<ReturnType<typeof publicImages>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | PublicImagesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImages>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicImages>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicImages<
  TData = Awaited<ReturnType<typeof publicImages>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImages>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicImages>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicImages<
  TData = Awaited<ReturnType<typeof publicImages>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImages>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Public OS image list
 */

export function usePublicImages<
  TData = Awaited<ReturnType<typeof publicImages>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImages>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPublicImagesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of regions available for public use.
 * @summary public hal region list
 */
export const publicRegions = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicRegions200>> => {
  return axios.get(`/v1/public/regions`, options);
};

export const getPublicRegionsQueryKey = () => {
  return [`/v1/public/regions`] as const;
};

export const getPublicRegionsQueryOptions = <
  TData = Awaited<ReturnType<typeof publicRegions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof publicRegions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPublicRegionsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof publicRegions>>> = ({
    signal,
  }) => publicRegions({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof publicRegions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PublicRegionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof publicRegions>>
>;
export type PublicRegionsQueryError = AxiosError<unknown>;

export function usePublicRegions<
  TData = Awaited<ReturnType<typeof publicRegions>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof publicRegions>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof publicRegions>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicRegions<
  TData = Awaited<ReturnType<typeof publicRegions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof publicRegions>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof publicRegions>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicRegions<
  TData = Awaited<ReturnType<typeof publicRegions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof publicRegions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary public hal region list
 */

export function usePublicRegions<
  TData = Awaited<ReturnType<typeof publicRegions>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof publicRegions>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPublicRegionsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns hosting VPS SKU catalog entries with live account-specific prices (including tax when a billing address is on file). Returns 502 purchasePricingFailed when live pricing is unavailable.
 * @summary List purchasable hosting products
 */
export const accountPurchaseProducts = (
  billingAccountId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPurchaseProducts200>> => {
  return axios.get(
    `/v1/purchase/accounts/${billingAccountId}/hosting`,
    options,
  );
};

export const getAccountPurchaseProductsQueryKey = (
  billingAccountId: string,
) => {
  return [`/v1/purchase/accounts/${billingAccountId}/hosting`] as const;
};

export const getAccountPurchaseProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof accountPurchaseProducts>>,
  TError = AxiosError<
    | AccountPurchaseProducts400
    | AccountPurchaseProducts401
    | AccountPurchaseProducts403
    | AccountPurchaseProducts502
  >,
>(
  billingAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseProducts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccountPurchaseProductsQueryKey(billingAccountId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountPurchaseProducts>>
  > = ({ signal }) =>
    accountPurchaseProducts(billingAccountId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!billingAccountId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accountPurchaseProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountPurchaseProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountPurchaseProducts>>
>;
export type AccountPurchaseProductsQueryError = AxiosError<
  | AccountPurchaseProducts400
  | AccountPurchaseProducts401
  | AccountPurchaseProducts403
  | AccountPurchaseProducts502
>;

export function useAccountPurchaseProducts<
  TData = Awaited<ReturnType<typeof accountPurchaseProducts>>,
  TError = AxiosError<
    | AccountPurchaseProducts400
    | AccountPurchaseProducts401
    | AccountPurchaseProducts403
    | AccountPurchaseProducts502
  >,
>(
  billingAccountId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPurchaseProducts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPurchaseProducts<
  TData = Awaited<ReturnType<typeof accountPurchaseProducts>>,
  TError = AxiosError<
    | AccountPurchaseProducts400
    | AccountPurchaseProducts401
    | AccountPurchaseProducts403
    | AccountPurchaseProducts502
  >,
>(
  billingAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseProducts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPurchaseProducts>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPurchaseProducts<
  TData = Awaited<ReturnType<typeof accountPurchaseProducts>>,
  TError = AxiosError<
    | AccountPurchaseProducts400
    | AccountPurchaseProducts401
    | AccountPurchaseProducts403
    | AccountPurchaseProducts502
  >,
>(
  billingAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseProducts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List purchasable hosting products
 */

export function useAccountPurchaseProducts<
  TData = Awaited<ReturnType<typeof accountPurchaseProducts>>,
  TError = AxiosError<
    | AccountPurchaseProducts400
    | AccountPurchaseProducts401
    | AccountPurchaseProducts403
    | AccountPurchaseProducts502
  >,
>(
  billingAccountId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseProducts>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountPurchaseProductsQueryOptions(
    billingAccountId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Submits a hosting VPS purchase order and returns order metadata.
 * @summary Submit a hosting VPS purchase order
 */
export const accountPurchaseHosting = (
  billingAccountId: string,
  accountPurchaseHostingBody: AccountPurchaseHostingBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPurchaseHosting200>> => {
  return axios.post(
    `/v1/purchase/accounts/${billingAccountId}/hosting`,
    accountPurchaseHostingBody,
    options,
  );
};

export const getAccountPurchaseHostingMutationOptions = <
  TError = AxiosError<
    | AccountPurchaseHosting400
    | AccountPurchaseHosting401
    | AccountPurchaseHosting403
    | AccountPurchaseHosting404
    | AccountPurchaseHosting502
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPurchaseHosting>>,
    TError,
    { billingAccountId: string; data: AccountPurchaseHostingBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof accountPurchaseHosting>>,
  TError,
  { billingAccountId: string; data: AccountPurchaseHostingBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof accountPurchaseHosting>>,
    { billingAccountId: string; data: AccountPurchaseHostingBody }
  > = (props) => {
    const { billingAccountId, data } = props ?? {};

    return accountPurchaseHosting(billingAccountId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AccountPurchaseHostingMutationResult = NonNullable<
  Awaited<ReturnType<typeof accountPurchaseHosting>>
>;
export type AccountPurchaseHostingMutationBody = AccountPurchaseHostingBody;
export type AccountPurchaseHostingMutationError = AxiosError<
  | AccountPurchaseHosting400
  | AccountPurchaseHosting401
  | AccountPurchaseHosting403
  | AccountPurchaseHosting404
  | AccountPurchaseHosting502
>;

/**
 * @summary Submit a hosting VPS purchase order
 */
export const useAccountPurchaseHosting = <
  TError = AxiosError<
    | AccountPurchaseHosting400
    | AccountPurchaseHosting401
    | AccountPurchaseHosting403
    | AccountPurchaseHosting404
    | AccountPurchaseHosting502
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof accountPurchaseHosting>>,
    TError,
    { billingAccountId: string; data: AccountPurchaseHostingBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof accountPurchaseHosting>>,
  TError,
  { billingAccountId: string; data: AccountPurchaseHostingBody },
  TContext
> => {
  const mutationOptions = getAccountPurchaseHostingMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Polls FG order fulfillment and hosting provisioning status for a submitted hosting VPS purchase order.
 * @summary Get hosting purchase order status by order id
 */
export const accountPurchaseOrder = (
  billingAccountId: string,
  orderId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountPurchaseOrder200>> => {
  return axios.get(
    `/v1/purchase/accounts/${billingAccountId}/orders/${orderId}`,
    options,
  );
};

export const getAccountPurchaseOrderQueryKey = (
  billingAccountId: string,
  orderId: string,
) => {
  return [
    `/v1/purchase/accounts/${billingAccountId}/orders/${orderId}`,
  ] as const;
};

export const getAccountPurchaseOrderQueryOptions = <
  TData = Awaited<ReturnType<typeof accountPurchaseOrder>>,
  TError = AxiosError<
    | AccountPurchaseOrder400
    | AccountPurchaseOrder401
    | AccountPurchaseOrder403
    | AccountPurchaseOrder404
  >,
>(
  billingAccountId: string,
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseOrder>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getAccountPurchaseOrderQueryKey(billingAccountId, orderId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountPurchaseOrder>>
  > = ({ signal }) =>
    accountPurchaseOrder(billingAccountId, orderId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(billingAccountId && orderId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof accountPurchaseOrder>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountPurchaseOrderQueryResult = NonNullable<
  Awaited<ReturnType<typeof accountPurchaseOrder>>
>;
export type AccountPurchaseOrderQueryError = AxiosError<
  | AccountPurchaseOrder400
  | AccountPurchaseOrder401
  | AccountPurchaseOrder403
  | AccountPurchaseOrder404
>;

export function useAccountPurchaseOrder<
  TData = Awaited<ReturnType<typeof accountPurchaseOrder>>,
  TError = AxiosError<
    | AccountPurchaseOrder400
    | AccountPurchaseOrder401
    | AccountPurchaseOrder403
    | AccountPurchaseOrder404
  >,
>(
  billingAccountId: string,
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPurchaseOrder>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPurchaseOrder<
  TData = Awaited<ReturnType<typeof accountPurchaseOrder>>,
  TError = AxiosError<
    | AccountPurchaseOrder400
    | AccountPurchaseOrder401
    | AccountPurchaseOrder403
    | AccountPurchaseOrder404
  >,
>(
  billingAccountId: string,
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseOrder>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountPurchaseOrder>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountPurchaseOrder<
  TData = Awaited<ReturnType<typeof accountPurchaseOrder>>,
  TError = AxiosError<
    | AccountPurchaseOrder400
    | AccountPurchaseOrder401
    | AccountPurchaseOrder403
    | AccountPurchaseOrder404
  >,
>(
  billingAccountId: string,
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseOrder>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get hosting purchase order status by order id
 */

export function useAccountPurchaseOrder<
  TData = Awaited<ReturnType<typeof accountPurchaseOrder>>,
  TError = AxiosError<
    | AccountPurchaseOrder400
    | AccountPurchaseOrder401
    | AccountPurchaseOrder403
    | AccountPurchaseOrder404
  >,
>(
  billingAccountId: string,
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountPurchaseOrder>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountPurchaseOrderQueryOptions(
    billingAccountId,
    orderId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site information.
 * @summary info
 */
export const sitesInfo = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesInfo200>> => {
  return axios.get(`/v1/sites/${siteId}`, options);
};

export const getSitesInfoQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}`] as const;
};

export const getSitesInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesInfoQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesInfo>>> = ({
    signal,
  }) => sitesInfo(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SitesInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesInfo>>
>;
export type SitesInfoQueryError = AxiosError<unknown>;

export function useSitesInfo<
  TData = Awaited<ReturnType<typeof sitesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfo<
  TData = Awaited<ReturnType<typeof sitesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfo<
  TData = Awaited<ReturnType<typeof sitesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary info
 */

export function useSitesInfo<
  TData = Awaited<ReturnType<typeof sitesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfo>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesInfoQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Allows for updating a site's attributes
 * @summary site update
 */
export const siteUpdate = (
  siteId: number,
  siteUpdateBody: SiteUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteUpdate200>> => {
  return axios.put(`/v1/sites/${siteId}`, siteUpdateBody, options);
};

export const getSiteUpdateMutationOptions = <
  TError = AxiosError<SiteUpdate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteUpdate>>,
    TError,
    { siteId: number; data: SiteUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteUpdate>>,
  TError,
  { siteId: number; data: SiteUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteUpdate>>,
    { siteId: number; data: SiteUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return siteUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteUpdate>>
>;
export type SiteUpdateMutationBody = SiteUpdateBody;
export type SiteUpdateMutationError = AxiosError<SiteUpdate400>;

/**
 * @summary site update
 */
export const useSiteUpdate = <
  TError = AxiosError<SiteUpdate400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteUpdate>>,
    TError,
    { siteId: number; data: SiteUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteUpdate>>,
  TError,
  { siteId: number; data: SiteUpdateBody },
  TContext
> => {
  const mutationOptions = getSiteUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Allows deleting a site
 * @summary site delete
 */
export const site = (
  siteId: number,
  siteBody: SiteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<Site200>> => {
  return axios.delete(`/v1/sites/${siteId}`, { data: siteBody, ...options });
};

export const getSiteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof site>>,
    TError,
    { siteId: number; data: SiteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof site>>,
  TError,
  { siteId: number; data: SiteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof site>>,
    { siteId: number; data: SiteBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return site(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteMutationResult = NonNullable<Awaited<ReturnType<typeof site>>>;
export type SiteMutationBody = SiteBody;
export type SiteMutationError = AxiosError<unknown>;

/**
 * @summary site delete
 */
export const useSite = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof site>>,
    TError,
    { siteId: number; data: SiteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof site>>,
  TError,
  { siteId: number; data: SiteBody },
  TContext
> => {
  const mutationOptions = getSiteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns raw periods data or day-wise summarized hits for a given site based on metric/dimension.
 * @summary Fetch atomic site metrics (raw or daywise)
 */
export const sitesAtomicMetrics = (
  siteId: number,
  params?: SitesAtomicMetricsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesAtomicMetrics200>> => {
  return axios.get(`/v1/sites/${siteId}/atomic/metrics`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesAtomicMetricsQueryKey = (
  siteId: number,
  params?: SitesAtomicMetricsParams,
) => {
  return [
    `/v1/sites/${siteId}/atomic/metrics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesAtomicMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesAtomicMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAtomicMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAtomicMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesAtomicMetricsQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesAtomicMetrics>>
  > = ({ signal }) =>
    sitesAtomicMetrics(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesAtomicMetrics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesAtomicMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesAtomicMetrics>>
>;
export type SitesAtomicMetricsQueryError = AxiosError<unknown>;

export function useSitesAtomicMetrics<
  TData = Awaited<ReturnType<typeof sitesAtomicMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesAtomicMetricsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAtomicMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAtomicMetrics>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAtomicMetrics<
  TData = Awaited<ReturnType<typeof sitesAtomicMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAtomicMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAtomicMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAtomicMetrics>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAtomicMetrics<
  TData = Awaited<ReturnType<typeof sitesAtomicMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAtomicMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAtomicMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Fetch atomic site metrics (raw or daywise)
 */

export function useSitesAtomicMetrics<
  TData = Awaited<ReturnType<typeof sitesAtomicMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAtomicMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAtomicMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesAtomicMetricsQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the autoupdate status of the site's core, themes, and plugins
 * @summary settings autoupdates
 */
export const sitesAutoupdatesInfo = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesAutoupdatesResponse>> => {
  return axios.get(`/v1/sites/${siteId}/autoupdates`, options);
};

export const getSitesAutoupdatesInfoQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/autoupdates`] as const;
};

export const getSitesAutoupdatesInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesAutoupdatesInfoQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesAutoupdatesInfo>>
  > = ({ signal }) => sitesAutoupdatesInfo(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesAutoupdatesInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesAutoupdatesInfo>>
>;
export type SitesAutoupdatesInfoQueryError = AxiosError<unknown>;

export function useSitesAutoupdatesInfo<
  TData = Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAutoupdatesInfo<
  TData = Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAutoupdatesInfo<
  TData = Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary settings autoupdates
 */

export function useSitesAutoupdatesInfo<
  TData = Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAutoupdatesInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesAutoupdatesInfoQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enable / disable core, themes, or plugins autoupdates
 * @summary settings autoupdates toggle
 */
export const sitesAutoupdatesUpdate = (
  siteId: number,
  sitesAutoupdatesUpdateBody: SitesAutoupdatesUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesAutoupdatesResponse>> => {
  return axios.put(
    `/v1/sites/${siteId}/autoupdates`,
    sitesAutoupdatesUpdateBody,
    options,
  );
};

export const getSitesAutoupdatesUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>,
    TError,
    { siteId: number; data: SitesAutoupdatesUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>,
  TError,
  { siteId: number; data: SitesAutoupdatesUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>,
    { siteId: number; data: SitesAutoupdatesUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesAutoupdatesUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesAutoupdatesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>
>;
export type SitesAutoupdatesUpdateMutationBody = SitesAutoupdatesUpdateBody;
export type SitesAutoupdatesUpdateMutationError = AxiosError<unknown>;

/**
 * @summary settings autoupdates toggle
 */
export const useSitesAutoupdatesUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>,
    TError,
    { siteId: number; data: SitesAutoupdatesUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesAutoupdatesUpdate>>,
  TError,
  { siteId: number; data: SitesAutoupdatesUpdateBody },
  TContext
> => {
  const mutationOptions = getSitesAutoupdatesUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns whether the site has either Codeguard or Jetpack-backup.
 * @deprecated
 * @summary Deprecated - has backup
 */
export const sitesBackups = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesBackups200>> => {
  return axios.get(`/v1/sites/${siteId}/backups`, options);
};

export const getSitesBackupsQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/backups`] as const;
};

export const getSitesBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesBackupsQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesBackups>>> = ({
    signal,
  }) => sitesBackups(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesBackups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesBackups>>
>;
export type SitesBackupsQueryError = AxiosError<unknown>;

export function useSitesBackups<
  TData = Awaited<ReturnType<typeof sitesBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesBackups>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesBackups<
  TData = Awaited<ReturnType<typeof sitesBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesBackups>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesBackups<
  TData = Awaited<ReturnType<typeof sitesBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Deprecated - has backup
 */

export function useSitesBackups<
  TData = Awaited<ReturnType<typeof sitesBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesBackups>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesBackupsQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns whether the site has either Codeguard or Jetpack-backup.
 * @summary has backups
 */
export const sitesHasBackups = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesHasBackups200>> => {
  return axios.get(`/v1/sites/${siteId}/backups/check`, options);
};

export const getSitesHasBackupsQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/backups/check`] as const;
};

export const getSitesHasBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesHasBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesHasBackups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesHasBackupsQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesHasBackups>>> = ({
    signal,
  }) => sitesHasBackups(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesHasBackups>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesHasBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesHasBackups>>
>;
export type SitesHasBackupsQueryError = AxiosError<unknown>;

export function useSitesHasBackups<
  TData = Awaited<ReturnType<typeof sitesHasBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesHasBackups>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesHasBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesHasBackups<
  TData = Awaited<ReturnType<typeof sitesHasBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesHasBackups>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesHasBackups>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesHasBackups<
  TData = Awaited<ReturnType<typeof sitesHasBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesHasBackups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary has backups
 */

export function useSitesHasBackups<
  TData = Awaited<ReturnType<typeof sitesHasBackups>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesHasBackups>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesHasBackupsQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Adds the site to the codeguard
 * @summary Add additional sites to codeguard
 */
export const sitesBackupsCodeguard = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesBackupsCodeguard200>> => {
  return axios.post(
    `/v1/sites/${siteId}/backups/codeguard`,
    undefined,
    options,
  );
};

export const getSitesBackupsCodeguardMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBackupsCodeguard>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesBackupsCodeguard>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesBackupsCodeguard>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesBackupsCodeguard(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesBackupsCodeguardMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesBackupsCodeguard>>
>;

export type SitesBackupsCodeguardMutationError = AxiosError<unknown>;

/**
 * @summary Add additional sites to codeguard
 */
export const useSitesBackupsCodeguard = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBackupsCodeguard>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesBackupsCodeguard>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitesBackupsCodeguardMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns details about the backup options available for the site, i.e. details about the codeguard backup addon and the jetpack based on if one or both of them are added to the account.
 * @summary site backup details
 */
export const sitesBackupsDetails = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesBackupsDetails200>> => {
  return axios.get(`/v1/sites/${siteId}/backups/details`, options);
};

export const getSitesBackupsDetailsQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/backups/details`] as const;
};

export const getSitesBackupsDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesBackupsDetails>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesBackupsDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesBackupsDetailsQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesBackupsDetails>>
  > = ({ signal }) => sitesBackupsDetails(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesBackupsDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesBackupsDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesBackupsDetails>>
>;
export type SitesBackupsDetailsQueryError = AxiosError<unknown>;

export function useSitesBackupsDetails<
  TData = Awaited<ReturnType<typeof sitesBackupsDetails>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesBackupsDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesBackupsDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesBackupsDetails<
  TData = Awaited<ReturnType<typeof sitesBackupsDetails>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesBackupsDetails>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesBackupsDetails>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesBackupsDetails<
  TData = Awaited<ReturnType<typeof sitesBackupsDetails>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesBackupsDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary site backup details
 */

export function useSitesBackupsDetails<
  TData = Awaited<ReturnType<typeof sitesBackupsDetails>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesBackupsDetails>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesBackupsDetailsQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The products supported jetpack-backup addon and jetpack-backup plugin
 * @summary Returns the status of the jetpack-backup product
 */
export const jetpackBackupStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<JetpackBackupStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/backups/jetpack`, options);
};

export const getJetpackBackupStatusQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/backups/jetpack`] as const;
};

export const getJetpackBackupStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof jetpackBackupStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof jetpackBackupStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getJetpackBackupStatusQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof jetpackBackupStatus>>
  > = ({ signal }) => jetpackBackupStatus(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof jetpackBackupStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type JetpackBackupStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof jetpackBackupStatus>>
>;
export type JetpackBackupStatusQueryError = AxiosError<unknown>;

export function useJetpackBackupStatus<
  TData = Awaited<ReturnType<typeof jetpackBackupStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof jetpackBackupStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof jetpackBackupStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useJetpackBackupStatus<
  TData = Awaited<ReturnType<typeof jetpackBackupStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof jetpackBackupStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof jetpackBackupStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useJetpackBackupStatus<
  TData = Awaited<ReturnType<typeof jetpackBackupStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof jetpackBackupStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Returns the status of the jetpack-backup product
 */

export function useJetpackBackupStatus<
  TData = Awaited<ReturnType<typeof jetpackBackupStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof jetpackBackupStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getJetpackBackupStatusQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
 * @summary Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
 */
export const backupsJetpackBackup = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupsJetpackBackup200>> => {
  return axios.put(`/v1/sites/${siteId}/backups/jetpack`, undefined, options);
};

export const getBackupsJetpackBackupMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupsJetpackBackup>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupsJetpackBackup>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupsJetpackBackup>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return backupsJetpackBackup(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupsJetpackBackupMutationResult = NonNullable<
  Awaited<ReturnType<typeof backupsJetpackBackup>>
>;

export type BackupsJetpackBackupMutationError = AxiosError<void>;

/**
 * @summary Toggles the pending_upgrade meta of the provided jetpackbackup HAL addon
 */
export const useBackupsJetpackBackup = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupsJetpackBackup>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupsJetpackBackup>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getBackupsJetpackBackupMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Adds the site to the Xcitium account
 * @summary Add site to xcitium
 */
export const sitesBackupsXcitium = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesBackupsXcitium200>> => {
  return axios.post(`/v1/sites/${siteId}/backups/xcitium`, undefined, options);
};

export const getSitesBackupsXcitiumMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBackupsXcitium>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesBackupsXcitium>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesBackupsXcitium>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesBackupsXcitium(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesBackupsXcitiumMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesBackupsXcitium>>
>;

export type SitesBackupsXcitiumMutationError = AxiosError<unknown>;

/**
 * @summary Add site to xcitium
 */
export const useSitesBackupsXcitium = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesBackupsXcitium>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesBackupsXcitium>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitesBackupsXcitiumMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates cloudflare basic addon using site_id
 * @summary Install cloudflare basic addon using site_id
 */
export const siteAddonCloudflare = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteAddonCloudflare200>> => {
  return axios.post(`/v1/sites/${siteId}/cloudflare`, undefined, options);
};

export const getSiteAddonCloudflareMutationOptions = <
  TError = AxiosError<SiteAddonCloudflare400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteAddonCloudflare>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteAddonCloudflare>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteAddonCloudflare>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return siteAddonCloudflare(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteAddonCloudflareMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteAddonCloudflare>>
>;

export type SiteAddonCloudflareMutationError =
  AxiosError<SiteAddonCloudflare400>;

/**
 * @summary Install cloudflare basic addon using site_id
 */
export const useSiteAddonCloudflare = <
  TError = AxiosError<SiteAddonCloudflare400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteAddonCloudflare>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteAddonCloudflare>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSiteAddonCloudflareMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get info about site database
 * @summary site - database info
 */
export const sitesDatabaseInfo = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDatabaseInfo200>> => {
  return axios.get(`/v1/sites/${siteId}/database`, options);
};

export const getSitesDatabaseInfoQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/database`] as const;
};

export const getSitesDatabaseInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesDatabaseInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesDatabaseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesDatabaseInfoQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesDatabaseInfo>>
  > = ({ signal }) => sitesDatabaseInfo(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesDatabaseInfo>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesDatabaseInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesDatabaseInfo>>
>;
export type SitesDatabaseInfoQueryError = AxiosError<unknown>;

export function useSitesDatabaseInfo<
  TData = Awaited<ReturnType<typeof sitesDatabaseInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesDatabaseInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDatabaseInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDatabaseInfo<
  TData = Awaited<ReturnType<typeof sitesDatabaseInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesDatabaseInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDatabaseInfo>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDatabaseInfo<
  TData = Awaited<ReturnType<typeof sitesDatabaseInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesDatabaseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary site - database info
 */

export function useSitesDatabaseInfo<
  TData = Awaited<ReturnType<typeof sitesDatabaseInfo>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesDatabaseInfo>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesDatabaseInfoQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resync database password with whats in wp-config
 * @summary site - database - password sync
 */
export const sitesDatabasePasswordsync = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDatabasePasswordsync200>> => {
  return axios.post(
    `/v1/sites/${siteId}/database/password-sync`,
    undefined,
    options,
  );
};

export const getSitesDatabasePasswordsyncMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDatabasePasswordsync>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesDatabasePasswordsync>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesDatabasePasswordsync>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesDatabasePasswordsync(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesDatabasePasswordsyncMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesDatabasePasswordsync>>
>;

export type SitesDatabasePasswordsyncMutationError = AxiosError<unknown>;

/**
 * @summary site - database - password sync
 */
export const useSitesDatabasePasswordsync = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDatabasePasswordsync>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesDatabasePasswordsync>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitesDatabasePasswordsyncMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of DNS records for the site's domain.
 * @summary dns
 */
export const sitesDns = (
  siteId: string,
  params?: SitesDnsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDns200>> => {
  return axios.get(`/v1/sites/${siteId}/dns`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesDnsQueryKey = (
  siteId: string,
  params?: SitesDnsParams,
) => {
  return [`/v1/sites/${siteId}/dns`, ...(params ? [params] : [])] as const;
};

export const getSitesDnsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesDns>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesDnsQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesDns>>> = ({
    signal,
  }) => sitesDns(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SitesDnsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesDns>>
>;
export type SitesDnsQueryError = AxiosError<unknown>;

export function useSitesDns<
  TData = Awaited<ReturnType<typeof sitesDns>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: undefined | SitesDnsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDns>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDns<
  TData = Awaited<ReturnType<typeof sitesDns>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDns>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDns<
  TData = Awaited<ReturnType<typeof sitesDns>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary dns
 */

export function useSitesDns<
  TData = Awaited<ReturnType<typeof sitesDns>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDnsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDns>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesDnsQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Determines if the domain has the correct DNS setup for site
 * @summary Get DNS connection info for a site and given domain
 */
export const sitesDomain = (
  siteId: string,
  params?: SitesDomainParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDomain200>> => {
  return axios.get(`/v1/sites/${siteId}/domain`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesDomainQueryKey = (
  siteId: string,
  params?: SitesDomainParams,
) => {
  return [`/v1/sites/${siteId}/domain`, ...(params ? [params] : [])] as const;
};

export const getSitesDomainQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesDomain>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomain>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesDomainQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesDomain>>> = ({
    signal,
  }) => sitesDomain(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesDomain>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesDomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesDomain>>
>;
export type SitesDomainQueryError = AxiosError<unknown>;

export function useSitesDomain<
  TData = Awaited<ReturnType<typeof sitesDomain>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: undefined | SitesDomainParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDomain>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDomain<
  TData = Awaited<ReturnType<typeof sitesDomain>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDomain>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDomain<
  TData = Awaited<ReturnType<typeof sitesDomain>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomain>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get DNS connection info for a site and given domain
 */

export function useSitesDomain<
  TData = Awaited<ReturnType<typeof sitesDomain>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomain>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesDomainQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add or promote pending site url
 * @summary Add pending site url
 */
export const sitesDomainUrl = (
  siteId: number,
  sitesDomainUrlBody: SitesDomainUrlBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDomainUrl200>> => {
  return axios.post(`/v1/sites/${siteId}/domain`, sitesDomainUrlBody, options);
};

export const getSitesDomainUrlMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDomainUrl>>,
    TError,
    { siteId: number; data: SitesDomainUrlBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesDomainUrl>>,
  TError,
  { siteId: number; data: SitesDomainUrlBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesDomainUrl>>,
    { siteId: number; data: SitesDomainUrlBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesDomainUrl(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesDomainUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesDomainUrl>>
>;
export type SitesDomainUrlMutationBody = SitesDomainUrlBody;
export type SitesDomainUrlMutationError = AxiosError<unknown>;

/**
 * @summary Add pending site url
 */
export const useSitesDomainUrl = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDomainUrl>>,
    TError,
    { siteId: number; data: SitesDomainUrlBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesDomainUrl>>,
  TError,
  { siteId: number; data: SitesDomainUrlBody },
  TContext
> => {
  const mutationOptions = getSitesDomainUrlMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Add the domain
 * @summary Add domain for the site
 */
export const sitesDomainsCreate = (
  siteId: number,
  sitesDomainsCreateBody: SitesDomainsCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDomainsCreate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/domains`,
    sitesDomainsCreateBody,
    options,
  );
};

export const getSitesDomainsCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDomainsCreate>>,
    TError,
    { siteId: number; data: SitesDomainsCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesDomainsCreate>>,
  TError,
  { siteId: number; data: SitesDomainsCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesDomainsCreate>>,
    { siteId: number; data: SitesDomainsCreateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesDomainsCreate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesDomainsCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesDomainsCreate>>
>;
export type SitesDomainsCreateMutationBody = SitesDomainsCreateBody;
export type SitesDomainsCreateMutationError = AxiosError<unknown>;

/**
 * @summary Add domain for the site
 */
export const useSitesDomainsCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesDomainsCreate>>,
    TError,
    { siteId: number; data: SitesDomainsCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesDomainsCreate>>,
  TError,
  { siteId: number; data: SitesDomainsCreateBody },
  TContext
> => {
  const mutationOptions = getSitesDomainsCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get error pages
 * @summary Get error pages
 */
export const errorPagesFetch = (
  siteId: number,
  params: ErrorPagesFetchParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErrorPagesFetch200>> => {
  return axios.get(`/v1/sites/${siteId}/error-pages`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getErrorPagesFetchQueryKey = (
  siteId: number,
  params: ErrorPagesFetchParams,
) => {
  return [
    `/v1/sites/${siteId}/error-pages`,
    ...(params ? [params] : []),
  ] as const;
};

export const getErrorPagesFetchQueryOptions = <
  TData = Awaited<ReturnType<typeof errorPagesFetch>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: ErrorPagesFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof errorPagesFetch>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getErrorPagesFetchQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof errorPagesFetch>>> = ({
    signal,
  }) => errorPagesFetch(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof errorPagesFetch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ErrorPagesFetchQueryResult = NonNullable<
  Awaited<ReturnType<typeof errorPagesFetch>>
>;
export type ErrorPagesFetchQueryError = AxiosError<unknown>;

export function useErrorPagesFetch<
  TData = Awaited<ReturnType<typeof errorPagesFetch>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: ErrorPagesFetchParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof errorPagesFetch>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof errorPagesFetch>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useErrorPagesFetch<
  TData = Awaited<ReturnType<typeof errorPagesFetch>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: ErrorPagesFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof errorPagesFetch>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof errorPagesFetch>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useErrorPagesFetch<
  TData = Awaited<ReturnType<typeof errorPagesFetch>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: ErrorPagesFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof errorPagesFetch>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get error pages
 */

export function useErrorPagesFetch<
  TData = Awaited<ReturnType<typeof errorPagesFetch>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: ErrorPagesFetchParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof errorPagesFetch>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getErrorPagesFetchQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add error pages
 * @summary Add error pages
 */
export const errorPagesAdd = (
  siteId: number,
  errorPagesAddBody: ErrorPagesAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErrorPagesAdd200>> => {
  return axios.post(
    `/v1/sites/${siteId}/error-pages`,
    errorPagesAddBody,
    options,
  );
};

export const getErrorPagesAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof errorPagesAdd>>,
    TError,
    { siteId: number; data: ErrorPagesAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof errorPagesAdd>>,
  TError,
  { siteId: number; data: ErrorPagesAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof errorPagesAdd>>,
    { siteId: number; data: ErrorPagesAddBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return errorPagesAdd(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ErrorPagesAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof errorPagesAdd>>
>;
export type ErrorPagesAddMutationBody = ErrorPagesAddBody;
export type ErrorPagesAddMutationError = AxiosError<unknown>;

/**
 * @summary Add error pages
 */
export const useErrorPagesAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof errorPagesAdd>>,
    TError,
    { siteId: number; data: ErrorPagesAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof errorPagesAdd>>,
  TError,
  { siteId: number; data: ErrorPagesAddBody },
  TContext
> => {
  const mutationOptions = getErrorPagesAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Delete error pages
 * @summary Delete error pages
 */
export const errorPagesDelete = (
  siteId: number,
  errorPagesDeleteBody: ErrorPagesDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ErrorPagesDelete200>> => {
  return axios.delete(`/v1/sites/${siteId}/error-pages`, {
    data: errorPagesDeleteBody,
    ...options,
  });
};

export const getErrorPagesDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof errorPagesDelete>>,
    TError,
    { siteId: number; data: ErrorPagesDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof errorPagesDelete>>,
  TError,
  { siteId: number; data: ErrorPagesDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof errorPagesDelete>>,
    { siteId: number; data: ErrorPagesDeleteBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return errorPagesDelete(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ErrorPagesDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof errorPagesDelete>>
>;
export type ErrorPagesDeleteMutationBody = ErrorPagesDeleteBody;
export type ErrorPagesDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Delete error pages
 */
export const useErrorPagesDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof errorPagesDelete>>,
    TError,
    { siteId: number; data: ErrorPagesDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof errorPagesDelete>>,
  TError,
  { siteId: number; data: ErrorPagesDeleteBody },
  TContext
> => {
  const mutationOptions = getErrorPagesDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the list of  blocked ipaddress
 * @summary List blocked IPAddress
 */
export const siteIpaddressList = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteIpaddressList200Item[]>> => {
  return axios.get(`/v1/sites/${siteId}/ipblocker`, options);
};

export const getSiteIpaddressListQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/ipblocker`] as const;
};

export const getSiteIpaddressListQueryOptions = <
  TData = Awaited<ReturnType<typeof siteIpaddressList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteIpaddressList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSiteIpaddressListQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof siteIpaddressList>>
  > = ({ signal }) => siteIpaddressList(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteIpaddressList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteIpaddressListQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteIpaddressList>>
>;
export type SiteIpaddressListQueryError = AxiosError<unknown>;

export function useSiteIpaddressList<
  TData = Awaited<ReturnType<typeof siteIpaddressList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteIpaddressList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteIpaddressList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteIpaddressList<
  TData = Awaited<ReturnType<typeof siteIpaddressList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteIpaddressList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteIpaddressList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteIpaddressList<
  TData = Awaited<ReturnType<typeof siteIpaddressList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteIpaddressList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List blocked IPAddress
 */

export function useSiteIpaddressList<
  TData = Awaited<ReturnType<typeof siteIpaddressList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteIpaddressList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteIpaddressListQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete the user site ipaddress
 * @summary Delete ipAddress
 */
export const siteIpaddress = (
  siteId: number,
  siteIpaddressBody: SiteIpaddressBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteIpaddress200>> => {
  return axios.delete(`/v1/sites/${siteId}/ipblocker`, {
    data: siteIpaddressBody,
    ...options,
  });
};

export const getSiteIpaddressMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteIpaddress>>,
    TError,
    { siteId: number; data: SiteIpaddressBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteIpaddress>>,
  TError,
  { siteId: number; data: SiteIpaddressBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteIpaddress>>,
    { siteId: number; data: SiteIpaddressBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return siteIpaddress(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteIpaddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteIpaddress>>
>;
export type SiteIpaddressMutationBody = SiteIpaddressBody;
export type SiteIpaddressMutationError = AxiosError<unknown>;

/**
 * @summary Delete ipAddress
 */
export const useSiteIpaddress = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteIpaddress>>,
    TError,
    { siteId: number; data: SiteIpaddressBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteIpaddress>>,
  TError,
  { siteId: number; data: SiteIpaddressBody },
  TContext
> => {
  const mutationOptions = getSiteIpaddressMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Add the ipaddress url for the site
 * @summary Add blocked ipaddress
 */
export const addSiteIpaddress = (
  siteId: number,
  addSiteIpaddressBody: AddSiteIpaddressBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddSiteIpaddress200>> => {
  return axios.post(
    `/v1/sites/${siteId}/ipblocker`,
    addSiteIpaddressBody,
    options,
  );
};

export const getAddSiteIpaddressMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSiteIpaddress>>,
    TError,
    { siteId: number; data: AddSiteIpaddressBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addSiteIpaddress>>,
  TError,
  { siteId: number; data: AddSiteIpaddressBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addSiteIpaddress>>,
    { siteId: number; data: AddSiteIpaddressBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return addSiteIpaddress(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddSiteIpaddressMutationResult = NonNullable<
  Awaited<ReturnType<typeof addSiteIpaddress>>
>;
export type AddSiteIpaddressMutationBody = AddSiteIpaddressBody;
export type AddSiteIpaddressMutationError = AxiosError<unknown>;

/**
 * @summary Add blocked ipaddress
 */
export const useAddSiteIpaddress = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addSiteIpaddress>>,
    TError,
    { siteId: number; data: AddSiteIpaddressBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof addSiteIpaddress>>,
  TError,
  { siteId: number; data: AddSiteIpaddressBody },
  TContext
> => {
  const mutationOptions = getAddSiteIpaddressMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns whether the jetpack backup addon can be purchased
 * @summary Jetpack backup purchase
 */
export const sitesJetpackPurchase = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesJetpackPurchase200>> => {
  return axios.get(`/v1/sites/${siteId}/jetpack/purchase`, options);
};

export const getSitesJetpackPurchaseQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/jetpack/purchase`] as const;
};

export const getSitesJetpackPurchaseQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesJetpackPurchase>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesJetpackPurchase>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesJetpackPurchaseQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesJetpackPurchase>>
  > = ({ signal }) => sitesJetpackPurchase(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesJetpackPurchase>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesJetpackPurchaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesJetpackPurchase>>
>;
export type SitesJetpackPurchaseQueryError = AxiosError<unknown>;

export function useSitesJetpackPurchase<
  TData = Awaited<ReturnType<typeof sitesJetpackPurchase>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesJetpackPurchase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesJetpackPurchase>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesJetpackPurchase<
  TData = Awaited<ReturnType<typeof sitesJetpackPurchase>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesJetpackPurchase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesJetpackPurchase>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesJetpackPurchase<
  TData = Awaited<ReturnType<typeof sitesJetpackPurchase>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesJetpackPurchase>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Jetpack backup purchase
 */

export function useSitesJetpackPurchase<
  TData = Awaited<ReturnType<typeof sitesJetpackPurchase>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesJetpackPurchase>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesJetpackPurchaseQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site access logs.
 * @summary Site access logs
 */
export const sitesAccessLogs = (
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesAccessLogs200>> => {
  return axios.get(`/v1/sites/${siteId}/logs/access`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesAccessLogsQueryKey = (
  siteId: number,
  params?: SitesAccessLogsParams,
) => {
  return [
    `/v1/sites/${siteId}/logs/access`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesAccessLogsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    SitesAccessLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        QueryKey,
        SitesAccessLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesAccessLogsQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    QueryKey,
    SitesAccessLogsParams['page_id']
  > = ({ signal, pageParam }) =>
    sitesAccessLogs(
      siteId,
      { ...params, page_id: pageParam || params?.['page_id'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    TError,
    TData,
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    QueryKey,
    SitesAccessLogsParams['page_id']
  > & { queryKey: QueryKey };
};

export type SitesAccessLogsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesAccessLogs>>
>;
export type SitesAccessLogsInfiniteQueryError = AxiosError<unknown>;

export function useSitesAccessLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    SitesAccessLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesAccessLogsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        QueryKey,
        SitesAccessLogsParams['page_id']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogs>>,
          TError,
          TData,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    SitesAccessLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        QueryKey,
        SitesAccessLogsParams['page_id']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogs>>,
          TError,
          TData,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    SitesAccessLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        QueryKey,
        SitesAccessLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site access logs
 */

export function useSitesAccessLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    SitesAccessLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        QueryKey,
        SitesAccessLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesAccessLogsInfiniteQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSitesAccessLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesAccessLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesAccessLogsQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesAccessLogs>>> = ({
    signal,
  }) => sitesAccessLogs(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesAccessLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesAccessLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesAccessLogs>>
>;
export type SitesAccessLogsQueryError = AxiosError<unknown>;

export function useSitesAccessLogs<
  TData = Awaited<ReturnType<typeof sitesAccessLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesAccessLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogs<
  TData = Awaited<ReturnType<typeof sitesAccessLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogs<
  TData = Awaited<ReturnType<typeof sitesAccessLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site access logs
 */

export function useSitesAccessLogs<
  TData = Awaited<ReturnType<typeof sitesAccessLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogs>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesAccessLogsQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site access logs.
 * @summary Site access logs
 */
export const sitesAccessLogsDownload = (
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.get(`/v1/sites/${siteId}/logs/access/download`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesAccessLogsDownloadQueryKey = (
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
) => {
  return [
    `/v1/sites/${siteId}/logs/access/download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesAccessLogsDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesAccessLogsDownloadQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesAccessLogsDownload>>
  > = ({ signal }) =>
    sitesAccessLogsDownload(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesAccessLogsDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesAccessLogsDownload>>
>;
export type SitesAccessLogsDownloadQueryError = AxiosError<unknown>;

export function useSitesAccessLogsDownload<
  TData = Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesAccessLogsDownloadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogsDownload<
  TData = Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesAccessLogsDownload<
  TData = Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site access logs
 */

export function useSitesAccessLogsDownload<
  TData = Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesAccessLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesAccessLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesAccessLogsDownloadQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site error logs.
 * @summary Site error logs
 */
export const sitesErrorLogs = (
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesErrorLogs200>> => {
  return axios.get(`/v1/sites/${siteId}/logs/error`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesErrorLogsQueryKey = (
  siteId: number,
  params?: SitesErrorLogsParams,
) => {
  return [
    `/v1/sites/${siteId}/logs/error`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesErrorLogsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    SitesErrorLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        QueryKey,
        SitesErrorLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesErrorLogsQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    QueryKey,
    SitesErrorLogsParams['page_id']
  > = ({ signal, pageParam }) =>
    sitesErrorLogs(
      siteId,
      { ...params, page_id: pageParam || params?.['page_id'] },
      { signal, ...axiosOptions },
    );

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    TError,
    TData,
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    QueryKey,
    SitesErrorLogsParams['page_id']
  > & { queryKey: QueryKey };
};

export type SitesErrorLogsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesErrorLogs>>
>;
export type SitesErrorLogsInfiniteQueryError = AxiosError<unknown>;

export function useSitesErrorLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    SitesErrorLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesErrorLogsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        QueryKey,
        SitesErrorLogsParams['page_id']
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogs>>,
          TError,
          TData,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    SitesErrorLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        QueryKey,
        SitesErrorLogsParams['page_id']
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogs>>,
          TError,
          TData,
          QueryKey
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    SitesErrorLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        QueryKey,
        SitesErrorLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site error logs
 */

export function useSitesErrorLogsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    SitesErrorLogsParams['page_id']
  >,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        TError,
        TData,
        Awaited<ReturnType<typeof sitesErrorLogs>>,
        QueryKey,
        SitesErrorLogsParams['page_id']
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesErrorLogsInfiniteQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useInfiniteQuery(queryOptions) as UseInfiniteQueryResult<
    TData,
    TError
  > & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSitesErrorLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesErrorLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesErrorLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesErrorLogsQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesErrorLogs>>> = ({
    signal,
  }) => sitesErrorLogs(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesErrorLogs>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesErrorLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesErrorLogs>>
>;
export type SitesErrorLogsQueryError = AxiosError<unknown>;

export function useSitesErrorLogs<
  TData = Awaited<ReturnType<typeof sitesErrorLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesErrorLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesErrorLogs>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogs<
  TData = Awaited<ReturnType<typeof sitesErrorLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesErrorLogs>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogs>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogs<
  TData = Awaited<ReturnType<typeof sitesErrorLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesErrorLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site error logs
 */

export function useSitesErrorLogs<
  TData = Awaited<ReturnType<typeof sitesErrorLogs>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesErrorLogs>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesErrorLogsQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site error logs.
 * @summary Site error logs
 */
export const sitesErrorLogsDownload = (
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.get(`/v1/sites/${siteId}/logs/error/download`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesErrorLogsDownloadQueryKey = (
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
) => {
  return [
    `/v1/sites/${siteId}/logs/error/download`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesErrorLogsDownloadQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesErrorLogsDownloadQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesErrorLogsDownload>>
  > = ({ signal }) =>
    sitesErrorLogsDownload(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesErrorLogsDownloadQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesErrorLogsDownload>>
>;
export type SitesErrorLogsDownloadQueryError = AxiosError<unknown>;

export function useSitesErrorLogsDownload<
  TData = Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesErrorLogsDownloadParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogsDownload<
  TData = Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesErrorLogsDownload<
  TData = Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site error logs
 */

export function useSitesErrorLogsDownload<
  TData = Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesErrorLogsDownloadParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesErrorLogsDownload>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesErrorLogsDownloadQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns malware status of atomic site
 * @deprecated
 * @summary malware status of atomic site
 */
export const siteMalwareStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteMalwareStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/malware-status`, options);
};

export const getSiteMalwareStatusQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/malware-status`] as const;
};

export const getSiteMalwareStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof siteMalwareStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSiteMalwareStatusQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof siteMalwareStatus>>
  > = ({ signal }) => siteMalwareStatus(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteMalwareStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteMalwareStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteMalwareStatus>>
>;
export type SiteMalwareStatusQueryError = AxiosError<unknown>;

export function useSiteMalwareStatus<
  TData = Awaited<ReturnType<typeof siteMalwareStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteMalwareStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteMalwareStatus<
  TData = Awaited<ReturnType<typeof siteMalwareStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteMalwareStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteMalwareStatus<
  TData = Awaited<ReturnType<typeof siteMalwareStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary malware status of atomic site
 */

export function useSiteMalwareStatus<
  TData = Awaited<ReturnType<typeof siteMalwareStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteMalwareStatusQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site metrics summary
 * @summary metrics
 */
export const sitesMetricsDimensionAveraged = (
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler' = 'http_host',
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesMetricsDimensionAveraged200>> => {
  return axios.get(
    `/v1/sites/${siteId}/metrics/dimension/${dimension}/averaged`,
    {
      ...options,
      params: { ...params, ...options?.params },
    },
  );
};

export const getSitesMetricsDimensionAveragedQueryKey = (
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler' = 'http_host',
) => {
  return [
    `/v1/sites/${siteId}/metrics/dimension/${dimension}/averaged`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesMetricsDimensionAveragedQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler' = 'http_host',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesMetricsDimensionAveragedQueryKey(siteId, params, dimension);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>
  > = ({ signal }) =>
    sitesMetricsDimensionAveraged(siteId, params, dimension, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(siteId && dimension),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesMetricsDimensionAveragedQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>
>;
export type SitesMetricsDimensionAveragedQueryError = AxiosError<unknown>;

export function useSitesMetricsDimensionAveraged<
  TData = Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesMetricsDimensionAveragedParams,
  dimension:
    | undefined
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler',
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesMetricsDimensionAveraged<
  TData = Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension?:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesMetricsDimensionAveraged<
  TData = Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension?:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary metrics
 */

export function useSitesMetricsDimensionAveraged<
  TData = Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesMetricsDimensionAveragedParams,
  dimension:
    | 'http_version'
    | 'http_verb'
    | 'http_host'
    | 'http_status'
    | 'page_renderer'
    | 'page_is_cached'
    | 'wp_admin_ajax_action'
    | 'visitor_asn'
    | 'visitor_country_code'
    | 'visitor_is_crawler' = 'http_host',
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricsDimensionAveraged>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesMetricsDimensionAveragedQueryOptions(
    siteId,
    params,
    dimension,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site metrics.
 * @summary metrics
 */
export const sitesMetricDimensions = (
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesMetricDimensions200>> => {
  return axios.get(`/v1/sites/${siteId}/metrics/${metric}/dimensions`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesMetricDimensionsQueryKey = (
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
) => {
  return [
    `/v1/sites/${siteId}/metrics/${metric}/dimensions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesMetricDimensionsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesMetricDimensions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricDimensions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesMetricDimensionsQueryKey(siteId, metric, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesMetricDimensions>>
  > = ({ signal }) =>
    sitesMetricDimensions(siteId, metric, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(siteId && metric),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesMetricDimensions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesMetricDimensionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesMetricDimensions>>
>;
export type SitesMetricDimensionsQueryError = AxiosError<unknown>;

export function useSitesMetricDimensions<
  TData = Awaited<ReturnType<typeof sitesMetricDimensions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params: undefined | SitesMetricDimensionsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricDimensions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesMetricDimensions>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesMetricDimensions<
  TData = Awaited<ReturnType<typeof sitesMetricDimensions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricDimensions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesMetricDimensions>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesMetricDimensions<
  TData = Awaited<ReturnType<typeof sitesMetricDimensions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricDimensions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary metrics
 */

export function useSitesMetricDimensions<
  TData = Awaited<ReturnType<typeof sitesMetricDimensions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  metric:
    | 'response_time_average'
    | 'response_bytes_average'
    | 'response_bytes_persec'
    | 'requests_persec',
  params?: SitesMetricDimensionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesMetricDimensions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesMetricDimensionsQueryOptions(
    siteId,
    metric,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of onboarding steps for this site
 * @summary A list of onboarding steps for this site
 */
export const sitesOnboardingSteps = (
  siteId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesOnboardingSteps200>> => {
  return axios.get(`/v1/sites/${siteId}/onboarding/steps`, options);
};

export const getSitesOnboardingStepsQueryKey = (siteId: string) => {
  return [`/v1/sites/${siteId}/onboarding/steps`] as const;
};

export const getSitesOnboardingStepsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesOnboardingSteps>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesOnboardingSteps>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesOnboardingStepsQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesOnboardingSteps>>
  > = ({ signal }) => sitesOnboardingSteps(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesOnboardingSteps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesOnboardingStepsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesOnboardingSteps>>
>;
export type SitesOnboardingStepsQueryError = AxiosError<unknown>;

export function useSitesOnboardingSteps<
  TData = Awaited<ReturnType<typeof sitesOnboardingSteps>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesOnboardingSteps>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesOnboardingSteps>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesOnboardingSteps<
  TData = Awaited<ReturnType<typeof sitesOnboardingSteps>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesOnboardingSteps>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesOnboardingSteps>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesOnboardingSteps<
  TData = Awaited<ReturnType<typeof sitesOnboardingSteps>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesOnboardingSteps>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary A list of onboarding steps for this site
 */

export function useSitesOnboardingSteps<
  TData = Awaited<ReturnType<typeof sitesOnboardingSteps>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesOnboardingSteps>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesOnboardingStepsQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Delete pending domain
 * @summary Delete pending domain
 */
export const sitePendingDomainDelete = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePendingDomainDelete200>> => {
  return axios.delete(`/v1/sites/${siteId}/pending-domain`, options);
};

export const getSitePendingDomainDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePendingDomainDelete>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePendingDomainDelete>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePendingDomainDelete>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitePendingDomainDelete(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePendingDomainDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePendingDomainDelete>>
>;

export type SitePendingDomainDeleteMutationError = AxiosError<unknown>;

/**
 * @summary Delete pending domain
 */
export const useSitePendingDomainDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePendingDomainDelete>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePendingDomainDelete>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitePendingDomainDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * cache purge site and url
 * @summary cache purge url
 */
export const sitesPerformanceCachepurge = (
  siteId: number,
  sitesPerformanceCachepurgeBody: SitesPerformanceCachepurgeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceCachepurge200>> => {
  return axios.post(
    `/v1/sites/${siteId}/performance/cachepurge`,
    sitesPerformanceCachepurgeBody,
    options,
  );
};

export const getSitesPerformanceCachepurgeMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceCachepurge>>,
    TError,
    { siteId: number; data: SitesPerformanceCachepurgeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceCachepurge>>,
  TError,
  { siteId: number; data: SitesPerformanceCachepurgeBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceCachepurge>>,
    { siteId: number; data: SitesPerformanceCachepurgeBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceCachepurge(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceCachepurgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceCachepurge>>
>;
export type SitesPerformanceCachepurgeMutationBody =
  SitesPerformanceCachepurgeBody;
export type SitesPerformanceCachepurgeMutationError = AxiosError<unknown>;

/**
 * @summary cache purge url
 */
export const useSitesPerformanceCachepurge = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceCachepurge>>,
    TError,
    { siteId: number; data: SitesPerformanceCachepurgeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceCachepurge>>,
  TError,
  { siteId: number; data: SitesPerformanceCachepurgeBody },
  TContext
> => {
  const mutationOptions = getSitesPerformanceCachepurgeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update the edge cache
 * @summary edge cache toggle for atomic site
 */
export const sitesPerformanceEdgecache = (
  siteId: number,
  sitesPerformanceEdgecacheBody: SitesPerformanceEdgecacheBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceEdgecache200>> => {
  return axios.put(
    `/v1/sites/${siteId}/performance/edge_cache`,
    sitesPerformanceEdgecacheBody,
    options,
  );
};

export const getSitesPerformanceEdgecacheMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEdgecache>>,
    TError,
    { siteId: number; data: SitesPerformanceEdgecacheBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceEdgecache>>,
  TError,
  { siteId: number; data: SitesPerformanceEdgecacheBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceEdgecache>>,
    { siteId: number; data: SitesPerformanceEdgecacheBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceEdgecache(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceEdgecacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceEdgecache>>
>;
export type SitesPerformanceEdgecacheMutationBody =
  SitesPerformanceEdgecacheBody;
export type SitesPerformanceEdgecacheMutationError = AxiosError<unknown>;

/**
 * @summary edge cache toggle for atomic site
 */
export const useSitesPerformanceEdgecache = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEdgecache>>,
    TError,
    { siteId: number; data: SitesPerformanceEdgecacheBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceEdgecache>>,
  TError,
  { siteId: number; data: SitesPerformanceEdgecacheBody },
  TContext
> => {
  const mutationOptions = getSitesPerformanceEdgecacheMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the status of endurance_cache_level
 * @summary Get status of endurance cache level
 */
export const sitesPerformanceEnduranceCacheLevelStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceEnduranceCacheLevelStatus200>> => {
  return axios.get(
    `/v1/sites/${siteId}/performance/endurance_cache_level`,
    options,
  );
};

export const getSitesPerformanceEnduranceCacheLevelStatusQueryKey = (
  siteId: number,
) => {
  return [`/v1/sites/${siteId}/performance/endurance_cache_level`] as const;
};

export const getSitesPerformanceEnduranceCacheLevelStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesPerformanceEnduranceCacheLevelStatusQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>
  > = ({ signal }) =>
    sitesPerformanceEnduranceCacheLevelStatus(siteId, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesPerformanceEnduranceCacheLevelStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>
>;
export type SitesPerformanceEnduranceCacheLevelStatusQueryError =
  AxiosError<unknown>;

export function useSitesPerformanceEnduranceCacheLevelStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceEnduranceCacheLevelStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceEnduranceCacheLevelStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get status of endurance cache level
 */

export function useSitesPerformanceEnduranceCacheLevelStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevelStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesPerformanceEnduranceCacheLevelStatusQueryOptions(
    siteId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Set endurance cache level to 0, 1,2 or 3
 * @summary Set endurance cache level
 */
export const sitesPerformanceEnduranceCacheLevel = (
  siteId: number,
  sitesPerformanceEnduranceCacheLevelBody: SitesPerformanceEnduranceCacheLevelBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceEnduranceCacheLevel200>> => {
  return axios.post(
    `/v1/sites/${siteId}/performance/endurance_cache_level`,
    sitesPerformanceEnduranceCacheLevelBody,
    options,
  );
};

export const getSitesPerformanceEnduranceCacheLevelMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>,
    TError,
    { siteId: number; data: SitesPerformanceEnduranceCacheLevelBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>,
  TError,
  { siteId: number; data: SitesPerformanceEnduranceCacheLevelBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>,
    { siteId: number; data: SitesPerformanceEnduranceCacheLevelBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceEnduranceCacheLevel(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceEnduranceCacheLevelMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>
>;
export type SitesPerformanceEnduranceCacheLevelMutationBody =
  SitesPerformanceEnduranceCacheLevelBody;
export type SitesPerformanceEnduranceCacheLevelMutationError =
  AxiosError<unknown>;

/**
 * @summary Set endurance cache level
 */
export const useSitesPerformanceEnduranceCacheLevel = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>,
    TError,
    { siteId: number; data: SitesPerformanceEnduranceCacheLevelBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceEnduranceCacheLevel>>,
  TError,
  { siteId: number; data: SitesPerformanceEnduranceCacheLevelBody },
  TContext
> => {
  const mutationOptions =
    getSitesPerformanceEnduranceCacheLevelMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update the endurance page cache
 * @summary update the endurance cache page
 */
export const sitesPerformanceEndurancePageCache = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceEndurancePageCache200>> => {
  return axios.put(
    `/v1/sites/${siteId}/performance/endurance_page_cache`,
    undefined,
    options,
  );
};

export const getSitesPerformanceEndurancePageCacheMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesPerformanceEndurancePageCache(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceEndurancePageCacheMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>
>;

export type SitesPerformanceEndurancePageCacheMutationError =
  AxiosError<unknown>;

/**
 * @summary update the endurance cache page
 */
export const useSitesPerformanceEndurancePageCache = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceEndurancePageCache>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions =
    getSitesPerformanceEndurancePageCacheMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update the redis object cache
 * @summary Toggle redis object caching for a site
 */
export const sitesPerformanceRedisToggle = (
  siteId: number,
  sitesPerformanceRedisToggleBody: SitesPerformanceRedisToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceRedisToggle200>> => {
  return axios.put(
    `/v1/sites/${siteId}/performance/redis`,
    sitesPerformanceRedisToggleBody,
    options,
  );
};

export const getSitesPerformanceRedisToggleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>,
    TError,
    { siteId: number; data: SitesPerformanceRedisToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>,
  TError,
  { siteId: number; data: SitesPerformanceRedisToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>,
    { siteId: number; data: SitesPerformanceRedisToggleBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceRedisToggle(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceRedisToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>
>;
export type SitesPerformanceRedisToggleMutationBody =
  SitesPerformanceRedisToggleBody;
export type SitesPerformanceRedisToggleMutationError = AxiosError<unknown>;

/**
 * @summary Toggle redis object caching for a site
 */
export const useSitesPerformanceRedisToggle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>,
    TError,
    { siteId: number; data: SitesPerformanceRedisToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceRedisToggle>>,
  TError,
  { siteId: number; data: SitesPerformanceRedisToggleBody },
  TContext
> => {
  const mutationOptions =
    getSitesPerformanceRedisToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get state of redis object caching for a site
 * @summary Get state of redis object caching for a site
 */
export const sitesPerformanceRedisStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceRedisStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/performance/redis`, options);
};

export const getSitesPerformanceRedisStatusQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/performance/redis`] as const;
};

export const getSitesPerformanceRedisStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesPerformanceRedisStatusQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>
  > = ({ signal }) =>
    sitesPerformanceRedisStatus(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesPerformanceRedisStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>
>;
export type SitesPerformanceRedisStatusQueryError = AxiosError<unknown>;

export function useSitesPerformanceRedisStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceRedisStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceRedisStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get state of redis object caching for a site
 */

export function useSitesPerformanceRedisStatus<
  TData = Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceRedisStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesPerformanceRedisStatusQueryOptions(
    siteId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Uninstall redis object caching for a site
 * @summary Uninstall redis object caching for a site
 */
export const sitesPerformanceRedisUninstall = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceRedisUninstall200>> => {
  return axios.delete(`/v1/sites/${siteId}/performance/redis`, options);
};

export const getSitesPerformanceRedisUninstallMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesPerformanceRedisUninstall(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceRedisUninstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>
>;

export type SitesPerformanceRedisUninstallMutationError = AxiosError<unknown>;

/**
 * @summary Uninstall redis object caching for a site
 */
export const useSitesPerformanceRedisUninstall = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceRedisUninstall>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions =
    getSitesPerformanceRedisUninstallMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Purge redis object caching for a site
 * @summary Purge redis object caching for a site
 */
export const sitesPerformanceRedisPurge = (
  siteId: number,
  sitesPerformanceRedisPurgeBody: SitesPerformanceRedisPurgeBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceRedisPurge200>> => {
  return axios.post(
    `/v1/sites/${siteId}/performance/redis`,
    sitesPerformanceRedisPurgeBody,
    options,
  );
};

export const getSitesPerformanceRedisPurgeMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>,
    TError,
    { siteId: number; data: SitesPerformanceRedisPurgeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>,
  TError,
  { siteId: number; data: SitesPerformanceRedisPurgeBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>,
    { siteId: number; data: SitesPerformanceRedisPurgeBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceRedisPurge(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceRedisPurgeMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>
>;
export type SitesPerformanceRedisPurgeMutationBody =
  SitesPerformanceRedisPurgeBody;
export type SitesPerformanceRedisPurgeMutationError = AxiosError<unknown>;

/**
 * @summary Purge redis object caching for a site
 */
export const useSitesPerformanceRedisPurge = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>,
    TError,
    { siteId: number; data: SitesPerformanceRedisPurgeBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceRedisPurge>>,
  TError,
  { siteId: number; data: SitesPerformanceRedisPurgeBody },
  TContext
> => {
  const mutationOptions = getSitesPerformanceRedisPurgeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get performance scan results for a site
 * @summary Site performance scans (lighthouse)
 */
export const sitesPerformanceScansList = (
  siteId: number,
  params?: SitesPerformanceScansListParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceScansList200>> => {
  return axios.get(`/v1/sites/${siteId}/performance/scans`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesPerformanceScansListQueryKey = (
  siteId: number,
  params?: SitesPerformanceScansListParams,
) => {
  return [
    `/v1/sites/${siteId}/performance/scans`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesPerformanceScansListQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesPerformanceScansList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesPerformanceScansListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceScansList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesPerformanceScansListQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesPerformanceScansList>>
  > = ({ signal }) =>
    sitesPerformanceScansList(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesPerformanceScansList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesPerformanceScansListQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceScansList>>
>;
export type SitesPerformanceScansListQueryError = AxiosError<unknown>;

export function useSitesPerformanceScansList<
  TData = Awaited<ReturnType<typeof sitesPerformanceScansList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesPerformanceScansListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceScansList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceScansList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceScansList<
  TData = Awaited<ReturnType<typeof sitesPerformanceScansList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesPerformanceScansListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceScansList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesPerformanceScansList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesPerformanceScansList<
  TData = Awaited<ReturnType<typeof sitesPerformanceScansList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesPerformanceScansListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceScansList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site performance scans (lighthouse)
 */

export function useSitesPerformanceScansList<
  TData = Awaited<ReturnType<typeof sitesPerformanceScansList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesPerformanceScansListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesPerformanceScansList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesPerformanceScansListQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Remove performance scanning for a site url
 * @summary Remove performance scanning for a site url
 */
export const sitesPerformanceScans = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceScans200>> => {
  return axios.delete(`/v1/sites/${siteId}/performance/scans`, options);
};

export const getSitesPerformanceScansMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceScans>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceScans>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceScans>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesPerformanceScans(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceScansMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceScans>>
>;

export type SitesPerformanceScansMutationError = AxiosError<unknown>;

/**
 * @summary Remove performance scanning for a site url
 */
export const useSitesPerformanceScans = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceScans>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceScans>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitesPerformanceScansMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Get performance scan results for a site
 * @summary Site performance scans (lighthouse)
 */
export const sitesPerformanceScansAdd = (
  siteId: number,
  sitesPerformanceScansAddBody: SitesPerformanceScansAddBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesPerformanceScansAdd200>> => {
  return axios.post(
    `/v1/sites/${siteId}/performance/scans`,
    sitesPerformanceScansAddBody,
    options,
  );
};

export const getSitesPerformanceScansAddMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceScansAdd>>,
    TError,
    { siteId: number; data: SitesPerformanceScansAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesPerformanceScansAdd>>,
  TError,
  { siteId: number; data: SitesPerformanceScansAddBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesPerformanceScansAdd>>,
    { siteId: number; data: SitesPerformanceScansAddBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesPerformanceScansAdd(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesPerformanceScansAddMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesPerformanceScansAdd>>
>;
export type SitesPerformanceScansAddMutationBody = SitesPerformanceScansAddBody;
export type SitesPerformanceScansAddMutationError = AxiosError<unknown>;

/**
 * @summary Site performance scans (lighthouse)
 */
export const useSitesPerformanceScansAdd = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesPerformanceScansAdd>>,
    TError,
    { siteId: number; data: SitesPerformanceScansAddBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesPerformanceScansAdd>>,
  TError,
  { siteId: number; data: SitesPerformanceScansAddBody },
  TContext
> => {
  const mutationOptions = getSitesPerformanceScansAddMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Create php info for a site
 * @summary Create php info for a site
 */
export const createPhpInfo = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<CreatePhpInfo200>> => {
  return axios.post(`/v1/sites/${siteId}/php-info`, undefined, options);
};

export const getCreatePhpInfoMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhpInfo>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createPhpInfo>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPhpInfo>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return createPhpInfo(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatePhpInfoMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPhpInfo>>
>;

export type CreatePhpInfoMutationError = AxiosError<unknown>;

/**
 * @summary Create php info for a site
 */
export const useCreatePhpInfo = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createPhpInfo>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof createPhpInfo>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getCreatePhpInfoMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of the site's plugins
 * @summary plugins
 */
export const sitePlugins = (
  siteId: number,
  params?: SitePluginsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePlugins200>> => {
  return axios.get(`/v1/sites/${siteId}/plugins`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitePluginsQueryKey = (
  siteId: number,
  params?: SitePluginsParams,
) => {
  return [`/v1/sites/${siteId}/plugins`, ...(params ? [params] : [])] as const;
};

export const getSitePluginsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitePlugins>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitePluginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitePlugins>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitePluginsQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitePlugins>>> = ({
    signal,
  }) => sitePlugins(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitePlugins>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitePluginsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitePlugins>>
>;
export type SitePluginsQueryError = AxiosError<unknown>;

export function useSitePlugins<
  TData = Awaited<ReturnType<typeof sitePlugins>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitePluginsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitePlugins>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitePlugins>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitePlugins<
  TData = Awaited<ReturnType<typeof sitePlugins>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitePluginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitePlugins>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitePlugins>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitePlugins<
  TData = Awaited<ReturnType<typeof sitePlugins>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitePluginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitePlugins>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary plugins
 */

export function useSitePlugins<
  TData = Awaited<ReturnType<typeof sitePlugins>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitePluginsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitePlugins>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitePluginsQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enables / disables a plugin
 * @summary plugins toggle
 */
export const sitePluginUpdate = (
  siteId: string,
  sitePluginUpdateBody: SitePluginUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginUpdate200>> => {
  return axios.put(
    `/v1/sites/${siteId}/plugins`,
    sitePluginUpdateBody,
    options,
  );
};

export const getSitePluginUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginUpdate>>,
    TError,
    { siteId: string; data: SitePluginUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginUpdate>>,
  TError,
  { siteId: string; data: SitePluginUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginUpdate>>,
    { siteId: string; data: SitePluginUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginUpdate>>
>;
export type SitePluginUpdateMutationBody = SitePluginUpdateBody;
export type SitePluginUpdateMutationError = AxiosError<unknown>;

/**
 * @summary plugins toggle
 */
export const useSitePluginUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginUpdate>>,
    TError,
    { siteId: string; data: SitePluginUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginUpdate>>,
  TError,
  { siteId: string; data: SitePluginUpdateBody },
  TContext
> => {
  const mutationOptions = getSitePluginUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Installs and activates a plugin
 * @summary plugin install
 */
export const sitePluginInstall = (
  siteId: string,
  sitePluginInstallBody: SitePluginInstallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginInstall200>> => {
  return axios.post(
    `/v1/sites/${siteId}/plugins`,
    sitePluginInstallBody,
    options,
  );
};

export const getSitePluginInstallMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginInstall>>,
    TError,
    { siteId: string; data: SitePluginInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginInstall>>,
  TError,
  { siteId: string; data: SitePluginInstallBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginInstall>>,
    { siteId: string; data: SitePluginInstallBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginInstall(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginInstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginInstall>>
>;
export type SitePluginInstallMutationBody = SitePluginInstallBody;
export type SitePluginInstallMutationError = AxiosError<unknown>;

/**
 * @summary plugin install
 */
export const useSitePluginInstall = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginInstall>>,
    TError,
    { siteId: string; data: SitePluginInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginInstall>>,
  TError,
  { siteId: string; data: SitePluginInstallBody },
  TContext
> => {
  const mutationOptions = getSitePluginInstallMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Enables / disables plugin auto-updates
 * @deprecated
 * @summary plugins autoupdate
 */
export const sitePluginsAutoupdate = (
  siteId: string,
  sitePluginsAutoupdateBody: SitePluginsAutoupdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginsAutoupdate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/plugins/autoupdate`,
    sitePluginsAutoupdateBody,
    options,
  );
};

export const getSitePluginsAutoupdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsAutoupdate>>,
    TError,
    { siteId: string; data: SitePluginsAutoupdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginsAutoupdate>>,
  TError,
  { siteId: string; data: SitePluginsAutoupdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginsAutoupdate>>,
    { siteId: string; data: SitePluginsAutoupdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginsAutoupdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginsAutoupdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginsAutoupdate>>
>;
export type SitePluginsAutoupdateMutationBody = SitePluginsAutoupdateBody;
export type SitePluginsAutoupdateMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary plugins autoupdate
 */
export const useSitePluginsAutoupdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsAutoupdate>>,
    TError,
    { siteId: string; data: SitePluginsAutoupdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginsAutoupdate>>,
  TError,
  { siteId: string; data: SitePluginsAutoupdateBody },
  TContext
> => {
  const mutationOptions = getSitePluginsAutoupdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Installs a WordPress plugin using either plugin slug (preferred) or plugin_url. If both are provided, plugin takes priority.
 * @summary Install plugin by slug or URL
 */
export const sitePluginInstaller = (
  siteId: string,
  sitePluginInstallerBody: SitePluginInstallerBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginInstaller200>> => {
  return axios.post(
    `/v1/sites/${siteId}/plugins/installer`,
    sitePluginInstallerBody,
    options,
  );
};

export const getSitePluginInstallerMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginInstaller>>,
    TError,
    { siteId: string; data: SitePluginInstallerBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginInstaller>>,
  TError,
  { siteId: string; data: SitePluginInstallerBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginInstaller>>,
    { siteId: string; data: SitePluginInstallerBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginInstaller(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginInstallerMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginInstaller>>
>;
export type SitePluginInstallerMutationBody = SitePluginInstallerBody;
export type SitePluginInstallerMutationError = AxiosError<unknown>;

/**
 * @summary Install plugin by slug or URL
 */
export const useSitePluginInstaller = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginInstaller>>,
    TError,
    { siteId: string; data: SitePluginInstallerBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginInstaller>>,
  TError,
  { siteId: string; data: SitePluginInstallerBody },
  TContext
> => {
  const mutationOptions = getSitePluginInstallerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Enables / disables a plugin
 * @deprecated
 * @summary Deprecated - plugins toggle
 */
export const sitePluginsToggle = (
  siteId: string,
  sitePluginsToggleBody: SitePluginsToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginsToggle200>> => {
  return axios.post(
    `/v1/sites/${siteId}/plugins/toggle`,
    sitePluginsToggleBody,
    options,
  );
};

export const getSitePluginsToggleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsToggle>>,
    TError,
    { siteId: string; data: SitePluginsToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginsToggle>>,
  TError,
  { siteId: string; data: SitePluginsToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginsToggle>>,
    { siteId: string; data: SitePluginsToggleBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginsToggle(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginsToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginsToggle>>
>;
export type SitePluginsToggleMutationBody = SitePluginsToggleBody;
export type SitePluginsToggleMutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary Deprecated - plugins toggle
 */
export const useSitePluginsToggle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsToggle>>,
    TError,
    { siteId: string; data: SitePluginsToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginsToggle>>,
  TError,
  { siteId: string; data: SitePluginsToggleBody },
  TContext
> => {
  const mutationOptions = getSitePluginsToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates a plugin
 * @summary plugins update
 */
export const sitePluginsUpdate = (
  siteId: string,
  sitePluginsUpdateBody: SitePluginsUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitePluginsUpdate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/plugins/update`,
    sitePluginsUpdateBody,
    options,
  );
};

export const getSitePluginsUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsUpdate>>,
    TError,
    { siteId: string; data: SitePluginsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitePluginsUpdate>>,
  TError,
  { siteId: string; data: SitePluginsUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitePluginsUpdate>>,
    { siteId: string; data: SitePluginsUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitePluginsUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitePluginsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitePluginsUpdate>>
>;
export type SitePluginsUpdateMutationBody = SitePluginsUpdateBody;
export type SitePluginsUpdateMutationError = AxiosError<unknown>;

/**
 * @summary plugins update
 */
export const useSitePluginsUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitePluginsUpdate>>,
    TError,
    { siteId: string; data: SitePluginsUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitePluginsUpdate>>,
  TError,
  { siteId: string; data: SitePluginsUpdateBody },
  TContext
> => {
  const mutationOptions = getSitePluginsUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns metric for a site url from pagespeed
 * @summary get pagespeed index api data for a site
 */
export const siteQualityMetrics = (
  siteId: string,
  params: SiteQualityMetricsParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteQualityMetrics200>> => {
  return axios.get(`/v1/sites/${siteId}/quality-metrics`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSiteQualityMetricsQueryKey = (
  siteId: string,
  params: SiteQualityMetricsParams,
) => {
  return [
    `/v1/sites/${siteId}/quality-metrics`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSiteQualityMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof siteQualityMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: SiteQualityMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteQualityMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSiteQualityMetricsQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof siteQualityMetrics>>
  > = ({ signal }) =>
    siteQualityMetrics(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteQualityMetrics>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteQualityMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteQualityMetrics>>
>;
export type SiteQualityMetricsQueryError = AxiosError<unknown>;

export function useSiteQualityMetrics<
  TData = Awaited<ReturnType<typeof siteQualityMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: SiteQualityMetricsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteQualityMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteQualityMetrics>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteQualityMetrics<
  TData = Awaited<ReturnType<typeof siteQualityMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: SiteQualityMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteQualityMetrics>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteQualityMetrics>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteQualityMetrics<
  TData = Awaited<ReturnType<typeof siteQualityMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: SiteQualityMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteQualityMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary get pagespeed index api data for a site
 */

export function useSiteQualityMetrics<
  TData = Awaited<ReturnType<typeof siteQualityMetrics>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: SiteQualityMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteQualityMetrics>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteQualityMetricsQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resets a site - deletes/reinstalls the site.
 * @summary reset site
 */
export const resetSite = (
  siteId: number,
  resetSiteBody: ResetSiteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ResetSite200>> => {
  return axios.post(`/v1/sites/${siteId}/reset`, resetSiteBody, options);
};

export const getResetSiteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetSite>>,
    TError,
    { siteId: number; data: ResetSiteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetSite>>,
  TError,
  { siteId: number; data: ResetSiteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetSite>>,
    { siteId: number; data: ResetSiteBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return resetSite(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetSiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetSite>>
>;
export type ResetSiteMutationBody = ResetSiteBody;
export type ResetSiteMutationError = AxiosError<unknown>;

/**
 * @summary reset site
 */
export const useResetSite = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetSite>>,
    TError,
    { siteId: number; data: ResetSiteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetSite>>,
  TError,
  { siteId: number; data: ResetSiteBody },
  TContext
> => {
  const mutationOptions = getResetSiteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * if security bundle to be enabled.
 * @summary security bundle
 */
export const sitesSecurityBundle = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecurityBundle200>> => {
  return axios.get(`/v1/sites/${siteId}/security/bundle`, options);
};

export const getSitesSecurityBundleQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/security/bundle`] as const;
};

export const getSitesSecurityBundleQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecurityBundle>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityBundle>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSecurityBundleQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecurityBundle>>
  > = ({ signal }) => sitesSecurityBundle(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecurityBundle>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecurityBundleQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecurityBundle>>
>;
export type SitesSecurityBundleQueryError = AxiosError<unknown>;

export function useSitesSecurityBundle<
  TData = Awaited<ReturnType<typeof sitesSecurityBundle>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityBundle>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityBundle>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityBundle<
  TData = Awaited<ReturnType<typeof sitesSecurityBundle>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityBundle>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityBundle>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityBundle<
  TData = Awaited<ReturnType<typeof sitesSecurityBundle>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityBundle>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary security bundle
 */

export function useSitesSecurityBundle<
  TData = Awaited<ReturnType<typeof sitesSecurityBundle>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityBundle>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecurityBundleQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Performs a checksum of the site's core files to verify integrity.
 * @summary core files checksum
 */
export const sitesSecurityCheckCore = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecurityCheckCore200>> => {
  return axios.get(`/v1/sites/${siteId}/security/core/check`, options);
};

export const getSitesSecurityCheckCoreQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/security/core/check`] as const;
};

export const getSitesSecurityCheckCoreQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSecurityCheckCoreQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecurityCheckCore>>
  > = ({ signal }) =>
    sitesSecurityCheckCore(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecurityCheckCoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecurityCheckCore>>
>;
export type SitesSecurityCheckCoreQueryError = AxiosError<unknown>;

export function useSitesSecurityCheckCore<
  TData = Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityCheckCore<
  TData = Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityCheckCore<
  TData = Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary core files checksum
 */

export function useSitesSecurityCheckCore<
  TData = Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityCheckCore>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecurityCheckCoreQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Resets the site's core files.
 * @summary core files reset
 */
export const sitesSecurityResetCoreFiles = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecurityResetCoreFiles200>> => {
  return axios.post(
    `/v1/sites/${siteId}/security/core/reset`,
    undefined,
    options,
  );
};

export const getSitesSecurityResetCoreFilesMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesSecurityResetCoreFiles(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSecurityResetCoreFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>
>;

export type SitesSecurityResetCoreFilesMutationError = AxiosError<unknown>;

/**
 * @summary core files reset
 */
export const useSitesSecurityResetCoreFiles = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSecurityResetCoreFiles>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions =
    getSitesSecurityResetCoreFilesMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the HTTPS redirection status.
 * @summary https redirection status
 */
export const sitesSecurityHttpsRedirectionStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecurityHttpsRedirectionStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/security/https`, options);
};

export const getSitesSecurityHttpsRedirectionStatusQueryKey = (
  siteId: number,
) => {
  return [`/v1/sites/${siteId}/security/https`] as const;
};

export const getSitesSecurityHttpsRedirectionStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesSecurityHttpsRedirectionStatusQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>
  > = ({ signal }) =>
    sitesSecurityHttpsRedirectionStatus(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecurityHttpsRedirectionStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>
>;
export type SitesSecurityHttpsRedirectionStatusQueryError = AxiosError<unknown>;

export function useSitesSecurityHttpsRedirectionStatus<
  TData = Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityHttpsRedirectionStatus<
  TData = Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecurityHttpsRedirectionStatus<
  TData = Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary https redirection status
 */

export function useSitesSecurityHttpsRedirectionStatus<
  TData = Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecurityHttpsRedirectionStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecurityHttpsRedirectionStatusQueryOptions(
    siteId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enables / disables HTTPS redirection.
 * @summary https redirection toggle
 */
export const sitesSecurityHttpsEnableDisableSsl = (
  siteId: number,
  sitesSecurityHttpsEnableDisableSslBody: SitesSecurityHttpsEnableDisableSslBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecurityHttpsEnableDisableSsl200>> => {
  return axios.post(
    `/v1/sites/${siteId}/security/https`,
    sitesSecurityHttpsEnableDisableSslBody,
    options,
  );
};

export const getSitesSecurityHttpsEnableDisableSslMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>,
    TError,
    { siteId: number; data: SitesSecurityHttpsEnableDisableSslBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>,
  TError,
  { siteId: number; data: SitesSecurityHttpsEnableDisableSslBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>,
    { siteId: number; data: SitesSecurityHttpsEnableDisableSslBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSecurityHttpsEnableDisableSsl(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSecurityHttpsEnableDisableSslMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>
>;
export type SitesSecurityHttpsEnableDisableSslMutationBody =
  SitesSecurityHttpsEnableDisableSslBody;
export type SitesSecurityHttpsEnableDisableSslMutationError =
  AxiosError<unknown>;

/**
 * @summary https redirection toggle
 */
export const useSitesSecurityHttpsEnableDisableSsl = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>,
    TError,
    { siteId: number; data: SitesSecurityHttpsEnableDisableSslBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSecurityHttpsEnableDisableSsl>>,
  TError,
  { siteId: number; data: SitesSecurityHttpsEnableDisableSslBody },
  TContext
> => {
  const mutationOptions =
    getSitesSecurityHttpsEnableDisableSslMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the site's sitelock information.
 * @summary sitelock info
 */
export const sitesSecuritySitelock = (
  siteId: number,
  params?: SitesSecuritySitelockParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecuritySitelock200>> => {
  return axios.get(`/v1/sites/${siteId}/security/sitelock`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesSecuritySitelockQueryKey = (
  siteId: number,
  params?: SitesSecuritySitelockParams,
) => {
  return [
    `/v1/sites/${siteId}/security/sitelock`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesSecuritySitelockQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecuritySitelock>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSecuritySitelockQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecuritySitelock>>
  > = ({ signal }) =>
    sitesSecuritySitelock(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecuritySitelock>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecuritySitelockQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecuritySitelock>>
>;
export type SitesSecuritySitelockQueryError = AxiosError<unknown>;

export function useSitesSecuritySitelock<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelock>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesSecuritySitelockParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelock>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySitelock>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySitelock<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelock>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelock>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySitelock>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySitelock<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelock>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sitelock info
 */

export function useSitesSecuritySitelock<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelock>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelock>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecuritySitelockQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Disables / enables cPanel to generate Let's Encrypt SSLs for the site.
 * @summary ssl lets encrypt toggle
 */
export const sitesSecuritySslAcme = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecuritySslAcme200>> => {
  return axios.post(
    `/v1/sites/${siteId}/security/ssl/acme`,
    undefined,
    options,
  );
};

export const getSitesSecuritySslAcmeMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecuritySslAcme>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSecuritySslAcme>>,
  TError,
  { siteId: number },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSecuritySslAcme>>,
    { siteId: number }
  > = (props) => {
    const { siteId } = props ?? {};

    return sitesSecuritySslAcme(siteId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSecuritySslAcmeMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecuritySslAcme>>
>;

export type SitesSecuritySslAcmeMutationError = AxiosError<unknown>;

/**
 * @summary ssl lets encrypt toggle
 */
export const useSitesSecuritySslAcme = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSecuritySslAcme>>,
    TError,
    { siteId: number },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSecuritySslAcme>>,
  TError,
  { siteId: number },
  TContext
> => {
  const mutationOptions = getSitesSecuritySslAcmeMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the site's SSL Status
 * @deprecated
 * @summary ssl status
 */
export const sitesSecuritySslStatus = (
  siteId: number,
  params?: SitesSecuritySslStatusParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecuritySslStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/security/ssl/status`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesSecuritySslStatusQueryKey = (
  siteId: number,
  params?: SitesSecuritySslStatusParams,
) => {
  return [
    `/v1/sites/${siteId}/security/ssl/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesSecuritySslStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySslStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSecuritySslStatusQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecuritySslStatus>>
  > = ({ signal }) =>
    sitesSecuritySslStatus(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecuritySslStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecuritySslStatus>>
>;
export type SitesSecuritySslStatusQueryError = AxiosError<unknown>;

export function useSitesSecuritySslStatus<
  TData = Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesSecuritySslStatusParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySslStatus<
  TData = Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySslStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySslStatus<
  TData = Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySslStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary ssl status
 */

export function useSitesSecuritySslStatus<
  TData = Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySslStatusParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySslStatus>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecuritySslStatusQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns whether the coming soon setting is enable or disabled
 * @summary settings coming soon page status
 */
export const sitesSettingsComingSoon = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsComingSoon200>> => {
  return axios.get(`/v1/sites/${siteId}/settings/coming-soon`, options);
};

export const getSitesSettingsComingSoonQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/settings/coming-soon`] as const;
};

export const getSitesSettingsComingSoonQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSettingsComingSoonQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSettingsComingSoon>>
  > = ({ signal }) =>
    sitesSettingsComingSoon(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSettingsComingSoonQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsComingSoon>>
>;
export type SitesSettingsComingSoonQueryError = AxiosError<unknown>;

export function useSitesSettingsComingSoon<
  TData = Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsComingSoon<
  TData = Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsComingSoon<
  TData = Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary settings coming soon page status
 */

export function useSitesSettingsComingSoon<
  TData = Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsComingSoon>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSettingsComingSoonQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enables/disables the coming soon (under-construction) page
 * @summary settings coming soon toggle
 */
export const sitesSettingsComingSoonToggle = (
  siteId: number,
  sitesSettingsComingSoonToggleBody: SitesSettingsComingSoonToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsComingSoonToggle200>> => {
  return axios.post(
    `/v1/sites/${siteId}/settings/coming-soon`,
    sitesSettingsComingSoonToggleBody,
    options,
  );
};

export const getSitesSettingsComingSoonToggleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>,
    TError,
    { siteId: number; data: SitesSettingsComingSoonToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>,
  TError,
  { siteId: number; data: SitesSettingsComingSoonToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>,
    { siteId: number; data: SitesSettingsComingSoonToggleBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSettingsComingSoonToggle(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSettingsComingSoonToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>
>;
export type SitesSettingsComingSoonToggleMutationBody =
  SitesSettingsComingSoonToggleBody;
export type SitesSettingsComingSoonToggleMutationError = AxiosError<unknown>;

/**
 * @summary settings coming soon toggle
 */
export const useSitesSettingsComingSoonToggle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>,
    TError,
    { siteId: number; data: SitesSettingsComingSoonToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSettingsComingSoonToggle>>,
  TError,
  { siteId: number; data: SitesSettingsComingSoonToggleBody },
  TContext
> => {
  const mutationOptions =
    getSitesSettingsComingSoonToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns the site's debug mode status
 * @summary settings debug status
 */
export const sitesSettingsDebug = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsDebug200>> => {
  return axios.get(`/v1/sites/${siteId}/settings/debug`, options);
};

export const getSitesSettingsDebugQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/settings/debug`] as const;
};

export const getSitesSettingsDebugQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSettingsDebug>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsDebug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSettingsDebugQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSettingsDebug>>
  > = ({ signal }) => sitesSettingsDebug(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSettingsDebug>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSettingsDebugQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsDebug>>
>;
export type SitesSettingsDebugQueryError = AxiosError<unknown>;

export function useSitesSettingsDebug<
  TData = Awaited<ReturnType<typeof sitesSettingsDebug>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsDebug>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsDebug>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsDebug<
  TData = Awaited<ReturnType<typeof sitesSettingsDebug>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsDebug>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsDebug>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsDebug<
  TData = Awaited<ReturnType<typeof sitesSettingsDebug>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsDebug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary settings debug status
 */

export function useSitesSettingsDebug<
  TData = Awaited<ReturnType<typeof sitesSettingsDebug>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsDebug>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSettingsDebugQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Enables or disables the output and display of site generated errors on the site
 * @summary settings debug toggle
 */
export const sitesSettingsDebugToggle = (
  siteId: number,
  sitesSettingsDebugToggleBody: SitesSettingsDebugToggleBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsDebugToggle200>> => {
  return axios.post(
    `/v1/sites/${siteId}/settings/debug`,
    sitesSettingsDebugToggleBody,
    options,
  );
};

export const getSitesSettingsDebugToggleMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsDebugToggle>>,
    TError,
    { siteId: number; data: SitesSettingsDebugToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSettingsDebugToggle>>,
  TError,
  { siteId: number; data: SitesSettingsDebugToggleBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSettingsDebugToggle>>,
    { siteId: number; data: SitesSettingsDebugToggleBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSettingsDebugToggle(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSettingsDebugToggleMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsDebugToggle>>
>;
export type SitesSettingsDebugToggleMutationBody = SitesSettingsDebugToggleBody;
export type SitesSettingsDebugToggleMutationError = AxiosError<unknown>;

/**
 * @summary settings debug toggle
 */
export const useSitesSettingsDebugToggle = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsDebugToggle>>,
    TError,
    { siteId: number; data: SitesSettingsDebugToggleBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSettingsDebugToggle>>,
  TError,
  { siteId: number; data: SitesSettingsDebugToggleBody },
  TContext
> => {
  const mutationOptions = getSitesSettingsDebugToggleMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Updates the site's PHP version
 * @summary settings php version update
 */
export const sitesSettingsPhpVersionUpdate = (
  siteId: number,
  sitesSettingsPhpVersionUpdateBody: SitesSettingsPhpVersionUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsPhpVersionUpdate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/settings/php-version`,
    sitesSettingsPhpVersionUpdateBody,
    options,
  );
};

export const getSitesSettingsPhpVersionUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>,
    TError,
    { siteId: number; data: SitesSettingsPhpVersionUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>,
  TError,
  { siteId: number; data: SitesSettingsPhpVersionUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>,
    { siteId: number; data: SitesSettingsPhpVersionUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSettingsPhpVersionUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSettingsPhpVersionUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>
>;
export type SitesSettingsPhpVersionUpdateMutationBody =
  SitesSettingsPhpVersionUpdateBody;
export type SitesSettingsPhpVersionUpdateMutationError = AxiosError<unknown>;

/**
 * @summary settings php version update
 */
export const useSitesSettingsPhpVersionUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>,
    TError,
    { siteId: number; data: SitesSettingsPhpVersionUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSettingsPhpVersionUpdate>>,
  TError,
  { siteId: number; data: SitesSettingsPhpVersionUpdateBody },
  TContext
> => {
  const mutationOptions =
    getSitesSettingsPhpVersionUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of nested site docpaths and URLs that inherit the PHP version from the given site's docpath.
 * @summary Get PHP version inheritance for a site
 */
export const sitesSettingsPhpVersionInheritance = (
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsPhpVersionInheritance200>> => {
  return axios.get(`/v1/sites/${siteId}/settings/php-version/inheritance`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesSettingsPhpVersionInheritanceQueryKey = (
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
) => {
  return [
    `/v1/sites/${siteId}/settings/php-version/inheritance`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesSettingsPhpVersionInheritanceQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesSettingsPhpVersionInheritanceQueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>
  > = ({ signal }) =>
    sitesSettingsPhpVersionInheritance(siteId, params, {
      signal,
      ...axiosOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSettingsPhpVersionInheritanceQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>
>;
export type SitesSettingsPhpVersionInheritanceQueryError = AxiosError<unknown>;

export function useSitesSettingsPhpVersionInheritance<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: undefined | SitesSettingsPhpVersionInheritanceParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsPhpVersionInheritance<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsPhpVersionInheritance<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get PHP version inheritance for a site
 */

export function useSitesSettingsPhpVersionInheritance<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesSettingsPhpVersionInheritanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersionInheritance>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSettingsPhpVersionInheritanceQueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Gets the list of PHP versions available/installed
 * @summary settings php versions list
 */
export const sitesSettingsPhpVersions = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSettingsPhpVersions200>> => {
  return axios.get(`/v1/sites/${siteId}/settings/php-versions`, options);
};

export const getSitesSettingsPhpVersionsQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/settings/php-versions`] as const;
};

export const getSitesSettingsPhpVersionsQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSettingsPhpVersionsQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSettingsPhpVersions>>
  > = ({ signal }) =>
    sitesSettingsPhpVersions(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSettingsPhpVersionsQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSettingsPhpVersions>>
>;
export type SitesSettingsPhpVersionsQueryError = AxiosError<unknown>;

export function useSitesSettingsPhpVersions<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsPhpVersions<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSettingsPhpVersions<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary settings php versions list
 */

export function useSitesSettingsPhpVersions<
  TData = Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSettingsPhpVersions>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSettingsPhpVersionsQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List ssh users
 * @deprecated
 * @summary site - ssh - list users
 */
export const sitesSshUserList = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSshUserList200>> => {
  return axios.get(`/v1/sites/${siteId}/ssh-users`, options);
};

export const getSitesSshUserListQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/ssh-users`] as const;
};

export const getSitesSshUserListQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSshUserList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSshUserListQueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSshUserList>>
  > = ({ signal }) => sitesSshUserList(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSshUserList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSshUserListQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSshUserList>>
>;
export type SitesSshUserListQueryError = AxiosError<unknown>;

export function useSitesSshUserList<
  TData = Awaited<ReturnType<typeof sitesSshUserList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSshUserList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSshUserList<
  TData = Awaited<ReturnType<typeof sitesSshUserList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSshUserList>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSshUserList<
  TData = Awaited<ReturnType<typeof sitesSshUserList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary site - ssh - list users
 */

export function useSitesSshUserList<
  TData = Awaited<ReturnType<typeof sitesSshUserList>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserList>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSshUserListQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create ssh user
 * @summary site - ssh - create user
 */
export const sitesSshUserCreate = (
  siteId: number,
  sitesSshUserCreateBody: SitesSshUserCreateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSshUserCreate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/ssh-users`,
    sitesSshUserCreateBody,
    options,
  );
};

export const getSitesSshUserCreateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserCreate>>,
    TError,
    { siteId: number; data: SitesSshUserCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSshUserCreate>>,
  TError,
  { siteId: number; data: SitesSshUserCreateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSshUserCreate>>,
    { siteId: number; data: SitesSshUserCreateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSshUserCreate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSshUserCreateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSshUserCreate>>
>;
export type SitesSshUserCreateMutationBody = SitesSshUserCreateBody;
export type SitesSshUserCreateMutationError = AxiosError<unknown>;

/**
 * @summary site - ssh - create user
 */
export const useSitesSshUserCreate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserCreate>>,
    TError,
    { siteId: number; data: SitesSshUserCreateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSshUserCreate>>,
  TError,
  { siteId: number; data: SitesSshUserCreateBody },
  TContext
> => {
  const mutationOptions = getSitesSshUserCreateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * delete ssh user
 * @summary site - ssh - delete user
 */
export const sitesSshUserDelete = (
  siteId: number,
  sitesSshUserDeleteBody: SitesSshUserDeleteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSshUserDelete200>> => {
  return axios.delete(`/v1/sites/${siteId}/ssh-users`, {
    data: sitesSshUserDeleteBody,
    ...options,
  });
};

export const getSitesSshUserDeleteMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserDelete>>,
    TError,
    { siteId: number; data: SitesSshUserDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSshUserDelete>>,
  TError,
  { siteId: number; data: SitesSshUserDeleteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSshUserDelete>>,
    { siteId: number; data: SitesSshUserDeleteBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSshUserDelete(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSshUserDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSshUserDelete>>
>;
export type SitesSshUserDeleteMutationBody = SitesSshUserDeleteBody;
export type SitesSshUserDeleteMutationError = AxiosError<unknown>;

/**
 * @summary site - ssh - delete user
 */
export const useSitesSshUserDelete = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserDelete>>,
    TError,
    { siteId: number; data: SitesSshUserDeleteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSshUserDelete>>,
  TError,
  { siteId: number; data: SitesSshUserDeleteBody },
  TContext
> => {
  const mutationOptions = getSitesSshUserDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * update ssh user
 * @summary site - ssh - update user
 */
export const sitesSshUserUpdate = (
  siteId: number,
  sitesSshUserUpdateBody: SitesSshUserUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSshUserUpdate200>> => {
  return axios.put(
    `/v1/sites/${siteId}/ssh-users`,
    sitesSshUserUpdateBody,
    options,
  );
};

export const getSitesSshUserUpdateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserUpdate>>,
    TError,
    { siteId: number; data: SitesSshUserUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sitesSshUserUpdate>>,
  TError,
  { siteId: number; data: SitesSshUserUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sitesSshUserUpdate>>,
    { siteId: number; data: SitesSshUserUpdateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return sitesSshUserUpdate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SitesSshUserUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof sitesSshUserUpdate>>
>;
export type SitesSshUserUpdateMutationBody = SitesSshUserUpdateBody;
export type SitesSshUserUpdateMutationError = AxiosError<unknown>;

/**
 * @summary site - ssh - update user
 */
export const useSitesSshUserUpdate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sitesSshUserUpdate>>,
    TError,
    { siteId: number; data: SitesSshUserUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sitesSshUserUpdate>>,
  TError,
  { siteId: number; data: SitesSshUserUpdateBody },
  TContext
> => {
  const mutationOptions = getSitesSshUserUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns information about the site domain's SSL/TLS certificate
 * @summary Site domain SSL cert info
 */
export const sitesSsl = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSsl200>> => {
  return axios.get(`/v1/sites/${siteId}/ssl`, options);
};

export const getSitesSslQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/ssl`] as const;
};

export const getSitesSslQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSsl>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesSslQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesSsl>>> = ({
    signal,
  }) => sitesSsl(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SitesSslQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSsl>>
>;
export type SitesSslQueryError = AxiosError<unknown>;

export function useSitesSsl<
  TData = Awaited<ReturnType<typeof sitesSsl>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSsl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSsl<
  TData = Awaited<ReturnType<typeof sitesSsl>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSsl>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSsl<
  TData = Awaited<ReturnType<typeof sitesSsl>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site domain SSL cert info
 */

export function useSitesSsl<
  TData = Awaited<ReturnType<typeof sitesSsl>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSsl>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSslQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an SSO token or login URL for the site (if supported).
 * @summary sso
 */
export const sitesSso = (
  siteId: number,
  params?: SitesSsoParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSso200>> => {
  return axios.get(`/v1/sites/${siteId}/sso`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesSsoQueryKey = (
  siteId: number,
  params?: SitesSsoParams,
) => {
  return [`/v1/sites/${siteId}/sso`, ...(params ? [params] : [])] as const;
};

export const getSitesSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSso>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSsoQueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesSso>>> = ({
    signal,
  }) => sitesSso(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SitesSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSso>>
>;
export type SitesSsoQueryError = AxiosError<unknown>;

export function useSitesSso<
  TData = Awaited<ReturnType<typeof sitesSso>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesSsoParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSso<
  TData = Awaited<ReturnType<typeof sitesSso>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSso<
  TData = Awaited<ReturnType<typeof sitesSso>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sso
 */

export function useSitesSso<
  TData = Awaited<ReturnType<typeof sitesSso>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSsoParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSsoQueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Promote a staging site
 * @summary Staging site promotion
 */
export const stagingSitePromote = (
  siteId: number,
  stagingSitePromoteBody: StagingSitePromoteBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<StagingSitePromote200>> => {
  return axios.post(
    `/v1/sites/${siteId}/staging`,
    stagingSitePromoteBody,
    options,
  );
};

export const getStagingSitePromoteMutationOptions = <
  TError = AxiosError<StagingSitePromote409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stagingSitePromote>>,
    TError,
    { siteId: number; data: StagingSitePromoteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stagingSitePromote>>,
  TError,
  { siteId: number; data: StagingSitePromoteBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stagingSitePromote>>,
    { siteId: number; data: StagingSitePromoteBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return stagingSitePromote(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StagingSitePromoteMutationResult = NonNullable<
  Awaited<ReturnType<typeof stagingSitePromote>>
>;
export type StagingSitePromoteMutationBody = StagingSitePromoteBody;
export type StagingSitePromoteMutationError = AxiosError<StagingSitePromote409>;

/**
 * @summary Staging site promotion
 */
export const useStagingSitePromote = <
  TError = AxiosError<StagingSitePromote409>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stagingSitePromote>>,
    TError,
    { siteId: number; data: StagingSitePromoteBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof stagingSitePromote>>,
  TError,
  { siteId: number; data: StagingSitePromoteBody },
  TContext
> => {
  const mutationOptions = getStagingSitePromoteMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary site status
 */
export const siteStatus = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteStatus200>> => {
  return axios.get(`/v1/sites/${siteId}/status`, options);
};

export const getSiteStatusQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/status`] as const;
};

export const getSiteStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof siteStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSiteStatusQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof siteStatus>>> = ({
    signal,
  }) => siteStatus(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteStatus>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteStatus>>
>;
export type SiteStatusQueryError = AxiosError<unknown>;

export function useSiteStatus<
  TData = Awaited<ReturnType<typeof siteStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteStatus>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteStatus<
  TData = Awaited<ReturnType<typeof siteStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteStatus>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteStatus>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteStatus<
  TData = Awaited<ReturnType<typeof siteStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary site status
 */

export function useSiteStatus<
  TData = Awaited<ReturnType<typeof siteStatus>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteStatus>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteStatusQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of the site's users
 * @deprecated
 * @summary users
 */
export const siteUsers = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteUsers200>> => {
  return axios.get(`/v1/sites/${siteId}/users`, options);
};

export const getSiteUsersQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/users`] as const;
};

export const getSiteUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof siteUsers>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSiteUsersQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsers>>> = ({
    signal,
  }) => siteUsers(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type SiteUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof siteUsers>>
>;
export type SiteUsersQueryError = AxiosError<unknown>;

export function useSiteUsers<
  TData = Awaited<ReturnType<typeof siteUsers>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteUsers<
  TData = Awaited<ReturnType<typeof siteUsers>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteUsers<
  TData = Awaited<ReturnType<typeof siteUsers>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary users
 */

export function useSiteUsers<
  TData = Awaited<ReturnType<typeof siteUsers>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteUsersQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns site version information.
 * @summary version
 */
export const sitesVersion = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesVersion200>> => {
  return axios.get(`/v1/sites/${siteId}/version`, options);
};

export const getSitesVersionQueryKey = (siteId: number) => {
  return [`/v1/sites/${siteId}/version`] as const;
};

export const getSitesVersionQueryOptions = <
  TData = Awaited<ReturnType<typeof sitesVersion>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesVersion>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesVersionQueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesVersion>>> = ({
    signal,
  }) => sitesVersion(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesVersion>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesVersionQueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesVersion>>
>;
export type SitesVersionQueryError = AxiosError<unknown>;

export function useSitesVersion<
  TData = Awaited<ReturnType<typeof sitesVersion>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesVersion>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesVersion>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesVersion<
  TData = Awaited<ReturnType<typeof sitesVersion>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesVersion>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesVersion>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesVersion<
  TData = Awaited<ReturnType<typeof sitesVersion>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesVersion>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary version
 */

export function useSitesVersion<
  TData = Awaited<ReturnType<typeof sitesVersion>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesVersion>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesVersionQueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generates site content based on prompt value passed
 * @summary Generate site content based on prompt
 */
export const siteWpGenerate = (
  siteId: string,
  siteWpGenerateBody: SiteWpGenerateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteWpGenerate200>> => {
  return axios.post(
    `/v1/sites/${siteId}/wp/generate`,
    siteWpGenerateBody,
    options,
  );
};

export const getSiteWpGenerateMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteWpGenerate>>,
    TError,
    { siteId: string; data: SiteWpGenerateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteWpGenerate>>,
  TError,
  { siteId: string; data: SiteWpGenerateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteWpGenerate>>,
    { siteId: string; data: SiteWpGenerateBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return siteWpGenerate(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteWpGenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteWpGenerate>>
>;
export type SiteWpGenerateMutationBody = SiteWpGenerateBody;
export type SiteWpGenerateMutationError = AxiosError<unknown>;

/**
 * @summary Generate site content based on prompt
 */
export const useSiteWpGenerate = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteWpGenerate>>,
    TError,
    { siteId: string; data: SiteWpGenerateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteWpGenerate>>,
  TError,
  { siteId: string; data: SiteWpGenerateBody },
  TContext
> => {
  const mutationOptions = getSiteWpGenerateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Installs and activates a theme
 * @summary theme install
 */
export const siteThemeInstall = (
  siteId: string,
  siteThemeInstallBody: SiteThemeInstallBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteThemeInstall200>> => {
  return axios.post(
    `/v1/sites/${siteId}/wp/themes`,
    siteThemeInstallBody,
    options,
  );
};

export const getSiteThemeInstallMutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteThemeInstall>>,
    TError,
    { siteId: string; data: SiteThemeInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteThemeInstall>>,
  TError,
  { siteId: string; data: SiteThemeInstallBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteThemeInstall>>,
    { siteId: string; data: SiteThemeInstallBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return siteThemeInstall(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteThemeInstallMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteThemeInstall>>
>;
export type SiteThemeInstallMutationBody = SiteThemeInstallBody;
export type SiteThemeInstallMutationError = AxiosError<unknown>;

/**
 * @summary theme install
 */
export const useSiteThemeInstall = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteThemeInstall>>,
    TError,
    { siteId: string; data: SiteThemeInstallBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteThemeInstall>>,
  TError,
  { siteId: string; data: SiteThemeInstallBody },
  TContext
> => {
  const mutationOptions = getSiteThemeInstallMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Creates wpsolution license addon for site_id
 * @summary configure wpsolution license for site_id
 */
export const siteAddonWpsolution = (
  siteId: number,
  siteAddonWpsolutionBody: SiteAddonWpsolutionBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteAddonWpsolution200>> => {
  return axios.post(
    `/v1/sites/${siteId}/wpsolution`,
    siteAddonWpsolutionBody,
    options,
  );
};

export const getSiteAddonWpsolutionMutationOptions = <
  TError = AxiosError<SiteAddonWpsolution400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteAddonWpsolution>>,
    TError,
    { siteId: number; data: SiteAddonWpsolutionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof siteAddonWpsolution>>,
  TError,
  { siteId: number; data: SiteAddonWpsolutionBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof siteAddonWpsolution>>,
    { siteId: number; data: SiteAddonWpsolutionBody }
  > = (props) => {
    const { siteId, data } = props ?? {};

    return siteAddonWpsolution(siteId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SiteAddonWpsolutionMutationResult = NonNullable<
  Awaited<ReturnType<typeof siteAddonWpsolution>>
>;
export type SiteAddonWpsolutionMutationBody = SiteAddonWpsolutionBody;
export type SiteAddonWpsolutionMutationError =
  AxiosError<SiteAddonWpsolution400>;

/**
 * @summary configure wpsolution license for site_id
 */
export const useSiteAddonWpsolution = <
  TError = AxiosError<SiteAddonWpsolution400>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof siteAddonWpsolution>>,
    TError,
    { siteId: number; data: SiteAddonWpsolutionBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof siteAddonWpsolution>>,
  TError,
  { siteId: number; data: SiteAddonWpsolutionBody },
  TContext
> => {
  const mutationOptions = getSiteAddonWpsolutionMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns billing accounts for the authenticated user.
 * @summary List user billing accounts
 */
export const userBillingAccounts = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserBillingAccounts200>> => {
  return axios.get(`/v1/user/billing-accounts`, options);
};

export const getUserBillingAccountsQueryKey = () => {
  return [`/v1/user/billing-accounts`] as const;
};

export const getUserBillingAccountsQueryOptions = <
  TData = Awaited<ReturnType<typeof userBillingAccounts>>,
  TError = AxiosError<UserBillingAccounts401 | UserBillingAccounts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userBillingAccounts>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserBillingAccountsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userBillingAccounts>>
  > = ({ signal }) => userBillingAccounts({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userBillingAccounts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserBillingAccountsQueryResult = NonNullable<
  Awaited<ReturnType<typeof userBillingAccounts>>
>;
export type UserBillingAccountsQueryError = AxiosError<
  UserBillingAccounts401 | UserBillingAccounts502
>;

export function useUserBillingAccounts<
  TData = Awaited<ReturnType<typeof userBillingAccounts>>,
  TError = AxiosError<UserBillingAccounts401 | UserBillingAccounts502>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userBillingAccounts>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userBillingAccounts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserBillingAccounts<
  TData = Awaited<ReturnType<typeof userBillingAccounts>>,
  TError = AxiosError<UserBillingAccounts401 | UserBillingAccounts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userBillingAccounts>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userBillingAccounts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserBillingAccounts<
  TData = Awaited<ReturnType<typeof userBillingAccounts>>,
  TError = AxiosError<UserBillingAccounts401 | UserBillingAccounts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userBillingAccounts>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List user billing accounts
 */

export function useUserBillingAccounts<
  TData = Awaited<ReturnType<typeof userBillingAccounts>>,
  TError = AxiosError<UserBillingAccounts401 | UserBillingAccounts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userBillingAccounts>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserBillingAccountsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns all internal and external domains for the authenticated user, keyed by domain name with per-source sub-objects.
 * @summary List user domains
 */
export const userDomains = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserDomains200>> => {
  return axios.get(`/v1/user/domains`, options);
};

export const getUserDomainsQueryKey = () => {
  return [`/v1/user/domains`] as const;
};

export const getUserDomainsQueryOptions = <
  TData = Awaited<ReturnType<typeof userDomains>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userDomains>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserDomainsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userDomains>>> = ({
    signal,
  }) => userDomains({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userDomains>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserDomainsQueryResult = NonNullable<
  Awaited<ReturnType<typeof userDomains>>
>;
export type UserDomainsQueryError = AxiosError<void>;

export function useUserDomains<
  TData = Awaited<ReturnType<typeof userDomains>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userDomains>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userDomains>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserDomains<
  TData = Awaited<ReturnType<typeof userDomains>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userDomains>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userDomains>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserDomains<
  TData = Awaited<ReturnType<typeof userDomains>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userDomains>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List user domains
 */

export function useUserDomains<
  TData = Awaited<ReturnType<typeof userDomains>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userDomains>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserDomainsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of feature information such as addon, features, sites, du, fs, db
 * @summary Return a list of accounts and info about each (account, addon, sites), plus extra optional info (disk usage, userbox limits, etc)
 */
export const userHosting = (
  params?: UserHostingParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserHosting200>> => {
  return axios.get(`/v1/user/hosting`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUserHostingQueryKey = (params?: UserHostingParams) => {
  return [`/v1/user/hosting`, ...(params ? [params] : [])] as const;
};

export const getUserHostingQueryOptions = <
  TData = Awaited<ReturnType<typeof userHosting>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userHosting>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserHostingQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userHosting>>> = ({
    signal,
  }) => userHosting(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userHosting>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserHostingQueryResult = NonNullable<
  Awaited<ReturnType<typeof userHosting>>
>;
export type UserHostingQueryError = AxiosError<unknown>;

export function useUserHosting<
  TData = Awaited<ReturnType<typeof userHosting>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | UserHostingParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userHosting>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHosting>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserHosting<
  TData = Awaited<ReturnType<typeof userHosting>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userHosting>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHosting>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserHosting<
  TData = Awaited<ReturnType<typeof userHosting>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userHosting>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Return a list of accounts and info about each (account, addon, sites), plus extra optional info (disk usage, userbox limits, etc)
 */

export function useUserHosting<
  TData = Awaited<ReturnType<typeof userHosting>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userHosting>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserHostingQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Aggregates various information about all of the hosting accounts manageable by the user
 * @summary High-level information about a user's manageable hosting accounts
 */
export const userHostingOverview = (
  params?: UserHostingOverviewParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserHostingOverview200>> => {
  return axios.get(`/v1/user/hosting/overview`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUserHostingOverviewQueryKey = (
  params?: UserHostingOverviewParams,
) => {
  return [`/v1/user/hosting/overview`, ...(params ? [params] : [])] as const;
};

export const getUserHostingOverviewQueryOptions = <
  TData = Awaited<ReturnType<typeof userHostingOverview>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userHostingOverview>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUserHostingOverviewQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userHostingOverview>>
  > = ({ signal }) => userHostingOverview(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userHostingOverview>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserHostingOverviewQueryResult = NonNullable<
  Awaited<ReturnType<typeof userHostingOverview>>
>;
export type UserHostingOverviewQueryError = AxiosError<unknown>;

export function useUserHostingOverview<
  TData = Awaited<ReturnType<typeof userHostingOverview>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | UserHostingOverviewParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userHostingOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHostingOverview>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserHostingOverview<
  TData = Awaited<ReturnType<typeof userHostingOverview>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userHostingOverview>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userHostingOverview>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserHostingOverview<
  TData = Awaited<ReturnType<typeof userHostingOverview>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userHostingOverview>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary High-level information about a user's manageable hosting accounts
 */

export function useUserHostingOverview<
  TData = Awaited<ReturnType<typeof userHostingOverview>>,
  TError = AxiosError<unknown>,
>(
  params?: UserHostingOverviewParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userHostingOverview>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserHostingOverviewQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * For the authenticated tenant, returns the Monarx details for the user.
 * @summary List Monarx details for the user
 */
export const allUserMonarxDetails = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AllUserMonarxDetails200>> => {
  return axios.get(`/v1/user/monarx/details`, options);
};

export const getAllUserMonarxDetailsQueryKey = () => {
  return [`/v1/user/monarx/details`] as const;
};

export const getAllUserMonarxDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof allUserMonarxDetails>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof allUserMonarxDetails>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAllUserMonarxDetailsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof allUserMonarxDetails>>
  > = ({ signal }) => allUserMonarxDetails({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof allUserMonarxDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AllUserMonarxDetailsQueryResult = NonNullable<
  Awaited<ReturnType<typeof allUserMonarxDetails>>
>;
export type AllUserMonarxDetailsQueryError = AxiosError<void>;

export function useAllUserMonarxDetails<
  TData = Awaited<ReturnType<typeof allUserMonarxDetails>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof allUserMonarxDetails>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof allUserMonarxDetails>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAllUserMonarxDetails<
  TData = Awaited<ReturnType<typeof allUserMonarxDetails>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof allUserMonarxDetails>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof allUserMonarxDetails>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAllUserMonarxDetails<
  TData = Awaited<ReturnType<typeof allUserMonarxDetails>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof allUserMonarxDetails>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List Monarx details for the user
 */

export function useAllUserMonarxDetails<
  TData = Awaited<ReturnType<typeof allUserMonarxDetails>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof allUserMonarxDetails>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAllUserMonarxDetailsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns whether the authenticated user is eligible for Phase 1 onboarding and whether the interstitial survey is complete. When the user is ineligible, message explains why (including more than 10 qualifying products). When upstream survey read is temporarily unavailable for an eligible user, survey_completed defaults to false and message explains that survey status is unknown (HTTP 200 degradation).
 * @summary Check onboarding eligibility
 */
export const userOnboarding = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserOnboarding200>> => {
  return axios.get(`/v1/user/onboarding`, options);
};

export const getUserOnboardingQueryKey = () => {
  return [`/v1/user/onboarding`] as const;
};

export const getUserOnboardingQueryOptions = <
  TData = Awaited<ReturnType<typeof userOnboarding>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userOnboarding>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserOnboardingQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userOnboarding>>> = ({
    signal,
  }) => userOnboarding({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userOnboarding>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserOnboardingQueryResult = NonNullable<
  Awaited<ReturnType<typeof userOnboarding>>
>;
export type UserOnboardingQueryError = AxiosError<void>;

export function useUserOnboarding<
  TData = Awaited<ReturnType<typeof userOnboarding>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userOnboarding>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboarding>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboarding<
  TData = Awaited<ReturnType<typeof userOnboarding>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userOnboarding>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboarding>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboarding<
  TData = Awaited<ReturnType<typeof userOnboarding>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userOnboarding>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Check onboarding eligibility
 */

export function useUserOnboarding<
  TData = Awaited<ReturnType<typeof userOnboarding>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userOnboarding>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserOnboardingQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns product group and person-level Setup checklist state for the authenticated user. Explore AI All-Access appears only on AI Site groups (prod_code AI_SITE_* or type AI Site); HUAPI omits that step from LLM Pack and other non-AI Site groups. When the user owns an LLM Pack (BLU_LLM_PACK_*), Explore AI All-Access on AI Site groups is returned completed=true. Unknown product steps without a stable step_id mapping are filtered from the response and logged (HTTP 200 degradation). Users who fail onboarding eligibility receive eligible=false with an explanatory message and an empty products array. When upstream checklist state is temporarily unavailable, eligible users receive eligible=true with message explaining checklist status is unknown and an empty products array with default person-level steps (HTTP 200 degradation).
 * @summary Get onboarding checklist steps
 */
export const userOnboardingSteps = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OnboardingGetStepsResponse>> => {
  return axios.get(`/v1/user/onboarding/steps`, options);
};

export const getUserOnboardingStepsQueryKey = () => {
  return [`/v1/user/onboarding/steps`] as const;
};

export const getUserOnboardingStepsQueryOptions = <
  TData = Awaited<ReturnType<typeof userOnboardingSteps>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSteps>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserOnboardingStepsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userOnboardingSteps>>
  > = ({ signal }) => userOnboardingSteps({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userOnboardingSteps>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserOnboardingStepsQueryResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingSteps>>
>;
export type UserOnboardingStepsQueryError = AxiosError<void>;

export function useUserOnboardingSteps<
  TData = Awaited<ReturnType<typeof userOnboardingSteps>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSteps>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboardingSteps>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboardingSteps<
  TData = Awaited<ReturnType<typeof userOnboardingSteps>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSteps>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboardingSteps>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboardingSteps<
  TData = Awaited<ReturnType<typeof userOnboardingSteps>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSteps>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get onboarding checklist steps
 */

export function useUserOnboardingSteps<
  TData = Awaited<ReturnType<typeof userOnboardingSteps>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSteps>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserOnboardingStepsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Saves click-attested completion for the Explore AI All-Access step on an AI Site checklist product group (prodCode AI_SITE_*). Returns HTTP 200 with an empty body only — no SSO or purchase link. Portal handles redirect separately (static my-account URL or GET /v1/user/wald-ai/{prod_inst_id}/sso). Re-fetch GET /v1/user/onboarding/steps for the product step completed=true.
 * @summary Record Explore AI All-Access step click
 */
export const userOnboardingExploreAiAllAccessClick = (
  onboardingExploreAiAllAccessClickRequest: OnboardingExploreAiAllAccessClickRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/v1/user/onboarding/steps/explore-ai-all-access/click`,
    onboardingExploreAiAllAccessClickRequest,
    options,
  );
};

export const getUserOnboardingExploreAiAllAccessClickMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>,
    TError,
    { data: OnboardingExploreAiAllAccessClickRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>,
  TError,
  { data: OnboardingExploreAiAllAccessClickRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>,
    { data: OnboardingExploreAiAllAccessClickRequest }
  > = (props) => {
    const { data } = props ?? {};

    return userOnboardingExploreAiAllAccessClick(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserOnboardingExploreAiAllAccessClickMutationResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>
>;
export type UserOnboardingExploreAiAllAccessClickMutationBody =
  OnboardingExploreAiAllAccessClickRequest;
export type UserOnboardingExploreAiAllAccessClickMutationError =
  AxiosError<void>;

/**
 * @summary Record Explore AI All-Access step click
 */
export const useUserOnboardingExploreAiAllAccessClick = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>,
    TError,
    { data: OnboardingExploreAiAllAccessClickRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof userOnboardingExploreAiAllAccessClick>>,
  TError,
  { data: OnboardingExploreAiAllAccessClickRequest },
  TContext
> => {
  const mutationOptions =
    getUserOnboardingExploreAiAllAccessClickMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Saves click-attested completion for the person-level Meet with your welcome team step in DAPI onboarding state. Returns HTTP 200 with an empty body only — no booking or redirect URL. Portal opens the Outlook booking link separately. Re-fetch GET /v1/user/onboarding/steps for user.meet_welcome_team.completed=true.
 * @summary Record Schedule a Call step click
 */
export const userOnboardingMeetWelcomeTeamClick = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/v1/user/onboarding/steps/meet-welcome-team/click`,
    undefined,
    options,
  );
};

export const getUserOnboardingMeetWelcomeTeamClickMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>,
  TError,
  void,
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>,
    void
  > = () => {
    return userOnboardingMeetWelcomeTeamClick(axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserOnboardingMeetWelcomeTeamClickMutationResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>
>;

export type UserOnboardingMeetWelcomeTeamClickMutationError = AxiosError<void>;

/**
 * @summary Record Schedule a Call step click
 */
export const useUserOnboardingMeetWelcomeTeamClick = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>,
    TError,
    void,
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof userOnboardingMeetWelcomeTeamClick>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions =
    getUserOnboardingMeetWelcomeTeamClickMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Saves click-attested completion for the Sign in to the AI dashboard step on an LLM Pack checklist product group (prodCode BLU_LLM_PACK_*). Returns HTTP 200 with an empty body only — Portal opens the AI dashboard separately. Re-fetch GET /v1/user/onboarding/steps for sign_in_ai_dashboard completed=true.
 * @summary Record Sign in to the AI dashboard step click
 */
export const userOnboardingSignInAiDashboardClick = (
  onboardingSignInAiDashboardClickRequest: OnboardingSignInAiDashboardClickRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<void>> => {
  return axios.post(
    `/v1/user/onboarding/steps/sign-in-ai-dashboard/click`,
    onboardingSignInAiDashboardClickRequest,
    options,
  );
};

export const getUserOnboardingSignInAiDashboardClickMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>,
    TError,
    { data: OnboardingSignInAiDashboardClickRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>,
  TError,
  { data: OnboardingSignInAiDashboardClickRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>,
    { data: OnboardingSignInAiDashboardClickRequest }
  > = (props) => {
    const { data } = props ?? {};

    return userOnboardingSignInAiDashboardClick(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserOnboardingSignInAiDashboardClickMutationResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>
>;
export type UserOnboardingSignInAiDashboardClickMutationBody =
  OnboardingSignInAiDashboardClickRequest;
export type UserOnboardingSignInAiDashboardClickMutationError =
  AxiosError<void>;

/**
 * @summary Record Sign in to the AI dashboard step click
 */
export const useUserOnboardingSignInAiDashboardClick = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>,
    TError,
    { data: OnboardingSignInAiDashboardClickRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof userOnboardingSignInAiDashboardClick>>,
  TError,
  { data: OnboardingSignInAiDashboardClickRequest },
  TContext
> => {
  const mutationOptions =
    getUserOnboardingSignInAiDashboardClickMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns stored interstitial survey answers for the authenticated user. Returns empty arrays when none saved. When upstream survey read is temporarily unavailable, returns empty arrays with survey_unavailable=true (HTTP 200 degradation).
 * @summary Get onboarding survey answers
 */
export const userOnboardingSurveyGet = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OnboardingSurveyResponse>> => {
  return axios.get(`/v1/user/onboarding/survey`, options);
};

export const getUserOnboardingSurveyGetQueryKey = () => {
  return [`/v1/user/onboarding/survey`] as const;
};

export const getUserOnboardingSurveyGetQueryOptions = <
  TData = Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUserOnboardingSurveyGetQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userOnboardingSurveyGet>>
  > = ({ signal }) => userOnboardingSurveyGet({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserOnboardingSurveyGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingSurveyGet>>
>;
export type UserOnboardingSurveyGetQueryError = AxiosError<void>;

export function useUserOnboardingSurveyGet<
  TData = Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
  TError = AxiosError<void>,
>(options: {
  query: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
      TError,
      TData
    >
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboardingSurveyGet<
  TData = Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
      TError,
      TData
    >
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserOnboardingSurveyGet<
  TData = Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get onboarding survey answers
 */

export function useUserOnboardingSurveyGet<
  TData = Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
  TError = AxiosError<void>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof userOnboardingSurveyGet>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserOnboardingSurveyGetQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Validates and persists post-purchase interstitial survey answers.
 * @summary Submit onboarding survey answers
 */
export const userOnboardingSurveyPost = (
  onboardingSurveyRequest: OnboardingSurveyRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<OnboardingSurveyResponse>> => {
  return axios.post(
    `/v1/user/onboarding/survey`,
    onboardingSurveyRequest,
    options,
  );
};

export const getUserOnboardingSurveyPostMutationOptions = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingSurveyPost>>,
    TError,
    { data: OnboardingSurveyRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userOnboardingSurveyPost>>,
  TError,
  { data: OnboardingSurveyRequest },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userOnboardingSurveyPost>>,
    { data: OnboardingSurveyRequest }
  > = (props) => {
    const { data } = props ?? {};

    return userOnboardingSurveyPost(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserOnboardingSurveyPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof userOnboardingSurveyPost>>
>;
export type UserOnboardingSurveyPostMutationBody = OnboardingSurveyRequest;
export type UserOnboardingSurveyPostMutationError = AxiosError<void>;

/**
 * @summary Submit onboarding survey answers
 */
export const useUserOnboardingSurveyPost = <
  TError = AxiosError<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userOnboardingSurveyPost>>,
    TError,
    { data: OnboardingSurveyRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof userOnboardingSurveyPost>>,
  TError,
  { data: OnboardingSurveyRequest },
  TContext
> => {
  const mutationOptions = getUserOnboardingSurveyPostMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieves the latest brand/country-wise phone SMS consent record for the authenticated user's phone number.
 * @summary Get phone SMS opt-in/opt-out consent
 */
export const userPhoneSmsConsent = (
  params: UserPhoneSmsConsentParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserPhoneSmsConsent200>> => {
  return axios.get(`/v1/user/phone-sms-consent`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUserPhoneSmsConsentQueryKey = (
  params: UserPhoneSmsConsentParams,
) => {
  return [`/v1/user/phone-sms-consent`, ...(params ? [params] : [])] as const;
};

export const getUserPhoneSmsConsentQueryOptions = <
  TData = Awaited<ReturnType<typeof userPhoneSmsConsent>>,
  TError = AxiosError<UserPhoneSmsConsent400 | void>,
>(
  params: UserPhoneSmsConsentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userPhoneSmsConsent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getUserPhoneSmsConsentQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof userPhoneSmsConsent>>
  > = ({ signal }) => userPhoneSmsConsent(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userPhoneSmsConsent>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserPhoneSmsConsentQueryResult = NonNullable<
  Awaited<ReturnType<typeof userPhoneSmsConsent>>
>;
export type UserPhoneSmsConsentQueryError =
  AxiosError<UserPhoneSmsConsent400 | void>;

export function useUserPhoneSmsConsent<
  TData = Awaited<ReturnType<typeof userPhoneSmsConsent>>,
  TError = AxiosError<UserPhoneSmsConsent400 | void>,
>(
  params: UserPhoneSmsConsentParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userPhoneSmsConsent>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPhoneSmsConsent>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserPhoneSmsConsent<
  TData = Awaited<ReturnType<typeof userPhoneSmsConsent>>,
  TError = AxiosError<UserPhoneSmsConsent400 | void>,
>(
  params: UserPhoneSmsConsentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userPhoneSmsConsent>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userPhoneSmsConsent>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserPhoneSmsConsent<
  TData = Awaited<ReturnType<typeof userPhoneSmsConsent>>,
  TError = AxiosError<UserPhoneSmsConsent400 | void>,
>(
  params: UserPhoneSmsConsentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userPhoneSmsConsent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get phone SMS opt-in/opt-out consent
 */

export function useUserPhoneSmsConsent<
  TData = Awaited<ReturnType<typeof userPhoneSmsConsent>>,
  TError = AxiosError<UserPhoneSmsConsent400 | void>,
>(
  params: UserPhoneSmsConsentParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof userPhoneSmsConsent>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserPhoneSmsConsentQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates customer phone SMS consent for the authenticated user's phone number.
 * @summary Update phone SMS opt-in/opt-out consent
 */
export const userPhoneSmsConsentUpdate = (
  userPhoneSmsConsentUpdateBody: UserPhoneSmsConsentUpdateBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserPhoneSmsConsentUpdate200>> => {
  return axios.put(
    `/v1/user/phone-sms-consent`,
    userPhoneSmsConsentUpdateBody,
    options,
  );
};

export const getUserPhoneSmsConsentUpdateMutationOptions = <
  TError = AxiosError<UserPhoneSmsConsentUpdate400 | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>,
    TError,
    { data: UserPhoneSmsConsentUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>,
  TError,
  { data: UserPhoneSmsConsentUpdateBody },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>,
    { data: UserPhoneSmsConsentUpdateBody }
  > = (props) => {
    const { data } = props ?? {};

    return userPhoneSmsConsentUpdate(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UserPhoneSmsConsentUpdateMutationResult = NonNullable<
  Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>
>;
export type UserPhoneSmsConsentUpdateMutationBody =
  UserPhoneSmsConsentUpdateBody;
export type UserPhoneSmsConsentUpdateMutationError =
  AxiosError<UserPhoneSmsConsentUpdate400 | void>;

/**
 * @summary Update phone SMS opt-in/opt-out consent
 */
export const useUserPhoneSmsConsentUpdate = <
  TError = AxiosError<UserPhoneSmsConsentUpdate400 | void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>,
    TError,
    { data: UserPhoneSmsConsentUpdateBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof userPhoneSmsConsentUpdate>>,
  TError,
  { data: UserPhoneSmsConsentUpdateBody },
  TContext
> => {
  const mutationOptions = getUserPhoneSmsConsentUpdateMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of products belonging to the user
 * @summary Get user product lites
 */
export const userProducts = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserProducts200>> => {
  return axios.get(`/v1/user/products`, options);
};

export const getUserProductsQueryKey = () => {
  return [`/v1/user/products`] as const;
};

export const getUserProductsQueryOptions = <
  TData = Awaited<ReturnType<typeof userProducts>>,
  TError = AxiosError<UserProducts401 | UserProducts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProducts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserProductsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userProducts>>> = ({
    signal,
  }) => userProducts({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userProducts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserProductsQueryResult = NonNullable<
  Awaited<ReturnType<typeof userProducts>>
>;
export type UserProductsQueryError = AxiosError<
  UserProducts401 | UserProducts502
>;

export function useUserProducts<
  TData = Awaited<ReturnType<typeof userProducts>>,
  TError = AxiosError<UserProducts401 | UserProducts502>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProducts>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userProducts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserProducts<
  TData = Awaited<ReturnType<typeof userProducts>>,
  TError = AxiosError<UserProducts401 | UserProducts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProducts>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userProducts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserProducts<
  TData = Awaited<ReturnType<typeof userProducts>>,
  TError = AxiosError<UserProducts401 | UserProducts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProducts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get user product lites
 */

export function useUserProducts<
  TData = Awaited<ReturnType<typeof userProducts>>,
  TError = AxiosError<UserProducts401 | UserProducts502>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProducts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserProductsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns pro-services FG products for the authenticated user
 * @summary Return pro-services products for the user
 */
export const userProservices = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserProservices200>> => {
  return axios.get(`/v1/user/proservices`, options);
};

export const getUserProservicesQueryKey = () => {
  return [`/v1/user/proservices`] as const;
};

export const getUserProservicesQueryOptions = <
  TData = Awaited<ReturnType<typeof userProservices>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProservices>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserProservicesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userProservices>>> = ({
    signal,
  }) => userProservices({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userProservices>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserProservicesQueryResult = NonNullable<
  Awaited<ReturnType<typeof userProservices>>
>;
export type UserProservicesQueryError = AxiosError<unknown>;

export function useUserProservices<
  TData = Awaited<ReturnType<typeof userProservices>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProservices>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userProservices>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserProservices<
  TData = Awaited<ReturnType<typeof userProservices>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProservices>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userProservices>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserProservices<
  TData = Awaited<ReturnType<typeof userProservices>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProservices>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Return pro-services products for the user
 */

export function useUserProservices<
  TData = Awaited<ReturnType<typeof userProservices>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userProservices>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserProservicesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns deployable VPS servers purchased by the authenticated user (HAL server_type vps). User-subject JWTs scope HAL with user_back_ref; account-subject JWTs (e.g. Network Solutions user-fe) scope with tenant_back_ref from the token account, matching other user-namespace HAL list routes. Servers in terminal lifecycle states (deleted, decom, disabled, destroy, pending_destroy) are omitted. hostname and primary_ip may be null while a server is still provisioning. Optionally filter by image name, Jarvis account (HAL tenant_back_ref), and/or Jarvis product instance id (HAL back_reference).
 * @summary User server list
 */
export const userServers = (
  params?: UserServersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserServers200>> => {
  return axios.get(`/v1/user/servers`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUserServersQueryKey = (params?: UserServersParams) => {
  return [`/v1/user/servers`, ...(params ? [params] : [])] as const;
};

export const getUserServersQueryOptions = <
  TData = Awaited<ReturnType<typeof userServers>>,
  TError = AxiosError<unknown>,
>(
  params?: UserServersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userServers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserServersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userServers>>> = ({
    signal,
  }) => userServers(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userServers>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserServersQueryResult = NonNullable<
  Awaited<ReturnType<typeof userServers>>
>;
export type UserServersQueryError = AxiosError<unknown>;

export function useUserServers<
  TData = Awaited<ReturnType<typeof userServers>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | UserServersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userServers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userServers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserServers<
  TData = Awaited<ReturnType<typeof userServers>>,
  TError = AxiosError<unknown>,
>(
  params?: UserServersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userServers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userServers>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserServers<
  TData = Awaited<ReturnType<typeof userServers>>,
  TError = AxiosError<unknown>,
>(
  params?: UserServersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userServers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary User server list
 */

export function useUserServers<
  TData = Awaited<ReturnType<typeof userServers>>,
  TError = AxiosError<unknown>,
>(
  params?: UserServersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userServers>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserServersQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Get AI sites and AI stores for the authenticated user. Defaults to both types. At least one of ai_sites or ai_stores must be true.
 * @summary User AI sites list
 */
export const userSitesAi = (
  params?: UserSitesAiParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserSitesAi200>> => {
  return axios.get(`/v1/user/sites/ai`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getUserSitesAiQueryKey = (params?: UserSitesAiParams) => {
  return [`/v1/user/sites/ai`, ...(params ? [params] : [])] as const;
};

export const getUserSitesAiQueryOptions = <
  TData = Awaited<ReturnType<typeof userSitesAi>>,
  TError = AxiosError<UserSitesAi400>,
>(
  params?: UserSitesAiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userSitesAi>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserSitesAiQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userSitesAi>>> = ({
    signal,
  }) => userSitesAi(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userSitesAi>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserSitesAiQueryResult = NonNullable<
  Awaited<ReturnType<typeof userSitesAi>>
>;
export type UserSitesAiQueryError = AxiosError<UserSitesAi400>;

export function useUserSitesAi<
  TData = Awaited<ReturnType<typeof userSitesAi>>,
  TError = AxiosError<UserSitesAi400>,
>(
  params: undefined | UserSitesAiParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userSitesAi>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userSitesAi>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserSitesAi<
  TData = Awaited<ReturnType<typeof userSitesAi>>,
  TError = AxiosError<UserSitesAi400>,
>(
  params?: UserSitesAiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userSitesAi>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userSitesAi>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserSitesAi<
  TData = Awaited<ReturnType<typeof userSitesAi>>,
  TError = AxiosError<UserSitesAi400>,
>(
  params?: UserSitesAiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userSitesAi>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary User AI sites list
 */

export function useUserSitesAi<
  TData = Awaited<ReturnType<typeof userSitesAi>>,
  TError = AxiosError<UserSitesAi400>,
>(
  params?: UserSitesAiParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userSitesAi>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserSitesAiQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns active and manual_create SpamExperts addons across every hosting package on the authenticated user.
 * @summary SpamExperts details for all hosting on the authenticated user
 */
export const userSpamexperts = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<UserSpamexperts200>> => {
  return axios.get(`/v1/user/spamexperts`, options);
};

export const getUserSpamexpertsQueryKey = () => {
  return [`/v1/user/spamexperts`] as const;
};

export const getUserSpamexpertsQueryOptions = <
  TData = Awaited<ReturnType<typeof userSpamexperts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userSpamexperts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUserSpamexpertsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userSpamexperts>>> = ({
    signal,
  }) => userSpamexperts({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userSpamexperts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type UserSpamexpertsQueryResult = NonNullable<
  Awaited<ReturnType<typeof userSpamexperts>>
>;
export type UserSpamexpertsQueryError = AxiosError<unknown>;

export function useUserSpamexperts<
  TData = Awaited<ReturnType<typeof userSpamexperts>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userSpamexperts>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof userSpamexperts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserSpamexperts<
  TData = Awaited<ReturnType<typeof userSpamexperts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userSpamexperts>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof userSpamexperts>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useUserSpamexperts<
  TData = Awaited<ReturnType<typeof userSpamexperts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userSpamexperts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary SpamExperts details for all hosting on the authenticated user
 */

export function useUserSpamexperts<
  TData = Awaited<ReturnType<typeof userSpamexperts>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof userSpamexperts>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getUserSpamexpertsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an SSO redirect URL for the WaldAI (BLU GPT / AI All Access) product. Accepts a product instance ID, resolves the providerProdInstId from FG, and returns the SSO redirect URL from ESB.
 * @summary Get WaldAI SSO redirect URL
 */
export const waldaiSso = (
  prodInstId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<WaldaiSso200>> => {
  return axios.get(`/v1/user/wald-ai/${prodInstId}/sso`, options);
};

export const getWaldaiSsoQueryKey = (prodInstId: string) => {
  return [`/v1/user/wald-ai/${prodInstId}/sso`] as const;
};

export const getWaldaiSsoQueryOptions = <
  TData = Awaited<ReturnType<typeof waldaiSso>>,
  TError = AxiosError<WaldaiSso404 | WaldaiSso502>,
>(
  prodInstId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWaldaiSsoQueryKey(prodInstId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof waldaiSso>>> = ({
    signal,
  }) => waldaiSso(prodInstId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!prodInstId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type WaldaiSsoQueryResult = NonNullable<
  Awaited<ReturnType<typeof waldaiSso>>
>;
export type WaldaiSsoQueryError = AxiosError<WaldaiSso404 | WaldaiSso502>;

export function useWaldaiSso<
  TData = Awaited<ReturnType<typeof waldaiSso>>,
  TError = AxiosError<WaldaiSso404 | WaldaiSso502>,
>(
  prodInstId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof waldaiSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWaldaiSso<
  TData = Awaited<ReturnType<typeof waldaiSso>>,
  TError = AxiosError<WaldaiSso404 | WaldaiSso502>,
>(
  prodInstId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof waldaiSso>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useWaldaiSso<
  TData = Awaited<ReturnType<typeof waldaiSso>>,
  TError = AxiosError<WaldaiSso404 | WaldaiSso502>,
>(
  prodInstId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get WaldAI SSO redirect URL
 */

export function useWaldaiSso<
  TData = Awaited<ReturnType<typeof waldaiSso>>,
  TError = AxiosError<WaldaiSso404 | WaldaiSso502>,
>(
  prodInstId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof waldaiSso>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getWaldaiSsoQueryOptions(prodInstId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a hosting account list with nullable optional account fields.
 * @summary Hosting account list for a customer (v2 schema)
 */
export const accountHostingListV2 = (
  params?: AccountHostingListV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountHostingListV2200>> => {
  return axios.get(`/v2/account/hosting`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAccountHostingListV2QueryKey = (
  params?: AccountHostingListV2Params,
) => {
  return [`/v2/account/hosting`, ...(params ? [params] : [])] as const;
};

export const getAccountHostingListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof accountHostingListV2>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAccountHostingListV2QueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof accountHostingListV2>>
  > = ({ signal }) => accountHostingListV2(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof accountHostingListV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AccountHostingListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof accountHostingListV2>>
>;
export type AccountHostingListV2QueryError = AxiosError<unknown>;

export function useAccountHostingListV2<
  TData = Awaited<ReturnType<typeof accountHostingListV2>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | AccountHostingListV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingListV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountHostingListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountHostingListV2<
  TData = Awaited<ReturnType<typeof accountHostingListV2>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingListV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof accountHostingListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAccountHostingListV2<
  TData = Awaited<ReturnType<typeof accountHostingListV2>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Hosting account list for a customer (v2 schema)
 */

export function useAccountHostingListV2<
  TData = Awaited<ReturnType<typeof accountHostingListV2>>,
  TError = AxiosError<unknown>,
>(
  params?: AccountHostingListV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof accountHostingListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAccountHostingListV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns an oauth login URL that can be used to access Sitelock dashboard for a user.
 * @summary sso
 */
export const addonsSitelockSsoV2 = (
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AddonsSitelockSsoV2200>> => {
  return axios.get(`/v2/addons/sitelock/${addonId}/sso`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getAddonsSitelockSsoV2QueryKey = (
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
) => {
  return [
    `/v2/addons/sitelock/${addonId}/sso`,
    ...(params ? [params] : []),
  ] as const;
};

export const getAddonsSitelockSsoV2QueryOptions = <
  TData = Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAddonsSitelockSsoV2QueryKey(addonId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof addonsSitelockSsoV2>>
  > = ({ signal }) =>
    addonsSitelockSsoV2(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AddonsSitelockSsoV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof addonsSitelockSsoV2>>
>;
export type AddonsSitelockSsoV2QueryError = AxiosError<unknown>;

export function useAddonsSitelockSsoV2<
  TData = Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: undefined | AddonsSitelockSsoV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSitelockSsoV2<
  TData = Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useAddonsSitelockSsoV2<
  TData = Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sso
 */

export function useAddonsSitelockSsoV2<
  TData = Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params?: AddonsSitelockSsoV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof addonsSitelockSsoV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAddonsSitelockSsoV2QueryOptions(
    addonId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup create
 * @deprecated
 * @summary Backup create
 */
export const backupCreateV2 = (
  addonId: number,
  backupCreateV2Body: BackupCreateV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupCreateV2200>> => {
  return axios.post(
    `/v2/addons/${addonId}/backup/create`,
    backupCreateV2Body,
    options,
  );
};

export const getBackupCreateV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateV2>>,
    TError,
    { addonId: number; data: BackupCreateV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupCreateV2>>,
  TError,
  { addonId: number; data: BackupCreateV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupCreateV2>>,
    { addonId: number; data: BackupCreateV2Body }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupCreateV2(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupCreateV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupCreateV2>>
>;
export type BackupCreateV2MutationBody = BackupCreateV2Body;
export type BackupCreateV2MutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary Backup create
 */
export const useBackupCreateV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateV2>>,
    TError,
    { addonId: number; data: BackupCreateV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupCreateV2>>,
  TError,
  { addonId: number; data: BackupCreateV2Body },
  TContext
> => {
  const mutationOptions = getBackupCreateV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Backup download
 * @summary Backup download
 */
export const backupDownloadV2 = (
  addonId: number,
  backupDownloadV2Body: BackupDownloadV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupDownloadV2200>> => {
  return axios.post(
    `/v2/addons/${addonId}/backup/download`,
    backupDownloadV2Body,
    options,
  );
};

export const getBackupDownloadV2MutationOptions = <
  TError = AxiosError<
    | BackupDownloadV2400
    | BackupDownloadV2403
    | BackupDownloadV2404
    | BackupDownloadV2409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupDownloadV2>>,
    TError,
    { addonId: number; data: BackupDownloadV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupDownloadV2>>,
  TError,
  { addonId: number; data: BackupDownloadV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupDownloadV2>>,
    { addonId: number; data: BackupDownloadV2Body }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupDownloadV2(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupDownloadV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupDownloadV2>>
>;
export type BackupDownloadV2MutationBody = BackupDownloadV2Body;
export type BackupDownloadV2MutationError = AxiosError<
  | BackupDownloadV2400
  | BackupDownloadV2403
  | BackupDownloadV2404
  | BackupDownloadV2409
>;

/**
 * @summary Backup download
 */
export const useBackupDownloadV2 = <
  TError = AxiosError<
    | BackupDownloadV2400
    | BackupDownloadV2403
    | BackupDownloadV2404
    | BackupDownloadV2409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupDownloadV2>>,
    TError,
    { addonId: number; data: BackupDownloadV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupDownloadV2>>,
  TError,
  { addonId: number; data: BackupDownloadV2Body },
  TContext
> => {
  const mutationOptions = getBackupDownloadV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Backup list
 * @summary Backup list
 */
export const backupListV2 = (
  addonId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupListV2200>> => {
  return axios.get(`/v2/addons/${addonId}/backup/list`, options);
};

export const getBackupListV2QueryKey = (addonId: number) => {
  return [`/v2/addons/${addonId}/backup/list`] as const;
};

export const getBackupListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof backupListV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBackupListV2QueryKey(addonId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupListV2>>> = ({
    signal,
  }) => backupListV2(addonId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupListV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof backupListV2>>
>;
export type BackupListV2QueryError = AxiosError<unknown>;

export function useBackupListV2<
  TData = Awaited<ReturnType<typeof backupListV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupListV2<
  TData = Awaited<ReturnType<typeof backupListV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupListV2<
  TData = Awaited<ReturnType<typeof backupListV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup list
 */

export function useBackupListV2<
  TData = Awaited<ReturnType<typeof backupListV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupListV2QueryOptions(addonId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup restore
 * @deprecated
 * @summary Backup restore
 */
export const backupRestoreV2 = (
  addonId: number,
  backupRestoreV2Body: BackupRestoreV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupRestoreV2200>> => {
  return axios.post(
    `/v2/addons/${addonId}/backup/restore`,
    backupRestoreV2Body,
    options,
  );
};

export const getBackupRestoreV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupRestoreV2>>,
    TError,
    { addonId: number; data: BackupRestoreV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupRestoreV2>>,
  TError,
  { addonId: number; data: BackupRestoreV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupRestoreV2>>,
    { addonId: number; data: BackupRestoreV2Body }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupRestoreV2(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupRestoreV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupRestoreV2>>
>;
export type BackupRestoreV2MutationBody = BackupRestoreV2Body;
export type BackupRestoreV2MutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary Backup restore
 */
export const useBackupRestoreV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupRestoreV2>>,
    TError,
    { addonId: number; data: BackupRestoreV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupRestoreV2>>,
  TError,
  { addonId: number; data: BackupRestoreV2Body },
  TContext
> => {
  const mutationOptions = getBackupRestoreV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Backup status
 * @summary Backup status
 */
export const backupStatusV2 = (
  addonId: number,
  params: BackupStatusV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupStatusV2200>> => {
  return axios.get(`/v2/addons/${addonId}/backup/status`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupStatusV2QueryKey = (
  addonId: number,
  params: BackupStatusV2Params,
) => {
  return [
    `/v2/addons/${addonId}/backup/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBackupStatusV2QueryOptions = <
  TData = Awaited<ReturnType<typeof backupStatusV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: BackupStatusV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupStatusV2QueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupStatusV2>>> = ({
    signal,
  }) => backupStatusV2(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupStatusV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupStatusV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof backupStatusV2>>
>;
export type BackupStatusV2QueryError = AxiosError<unknown>;

export function useBackupStatusV2<
  TData = Awaited<ReturnType<typeof backupStatusV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: BackupStatusV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatusV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatusV2<
  TData = Awaited<ReturnType<typeof backupStatusV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: BackupStatusV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatusV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatusV2<
  TData = Awaited<ReturnType<typeof backupStatusV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: BackupStatusV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup status
 */

export function useBackupStatusV2<
  TData = Awaited<ReturnType<typeof backupStatusV2>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  params: BackupStatusV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupStatusV2QueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting server info with nullable optional fields for MCP and structured clients
 * @summary server status/info (v2 schema)
 */
export const hostingAdvancedServerV2 = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingAdvancedServerV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/advanced/server`, options);
};

export const getHostingAdvancedServerV2QueryKey = (hostingId: number) => {
  return [`/v2/hosting/${hostingId}/advanced/server`] as const;
};

export const getHostingAdvancedServerV2QueryOptions = <
  TData = Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingAdvancedServerV2QueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingAdvancedServerV2>>
  > = ({ signal }) =>
    hostingAdvancedServerV2(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingAdvancedServerV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingAdvancedServerV2>>
>;
export type HostingAdvancedServerV2QueryError = AxiosError<unknown>;

export function useHostingAdvancedServerV2<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServerV2<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingAdvancedServerV2<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary server status/info (v2 schema)
 */

export function useHostingAdvancedServerV2<
  TData = Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingAdvancedServerV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingAdvancedServerV2QueryOptions(
    hostingId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List all DB names
 * @summary Get list of database names
 */
export const dbListV2 = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DbListV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/db`, options);
};

export const getDbListV2QueryKey = (hostingId: string) => {
  return [`/v2/hosting/${hostingId}/db`] as const;
};

export const getDbListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof dbListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDbListV2QueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof dbListV2>>> = ({
    signal,
  }) => dbListV2(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData> & {
    queryKey: QueryKey;
  };
};

export type DbListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof dbListV2>>
>;
export type DbListV2QueryError = AxiosError<unknown>;

export function useDbListV2<
  TData = Awaited<ReturnType<typeof dbListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbListV2<
  TData = Awaited<ReturnType<typeof dbListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof dbListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useDbListV2<
  TData = Awaited<ReturnType<typeof dbListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Get list of database names
 */

export function useDbListV2<
  TData = Awaited<ReturnType<typeof dbListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof dbListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDbListV2QueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of domains
 * @summary domain list v2
 */
export const hostingDomainsV2 = (
  hostingId: string,
  params?: HostingDomainsV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainsV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/domains`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingDomainsV2QueryKey = (
  hostingId: string,
  params?: HostingDomainsV2Params,
) => {
  return [
    `/v2/hosting/${hostingId}/domains`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingDomainsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof hostingDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingDomainsV2QueryKey(hostingId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingDomainsV2>>
  > = ({ signal }) =>
    hostingDomainsV2(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingDomainsV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingDomainsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainsV2>>
>;
export type HostingDomainsV2QueryError = AxiosError<unknown>;

export function useHostingDomainsV2<
  TData = Awaited<ReturnType<typeof hostingDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingDomainsV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDomainsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDomainsV2<
  TData = Awaited<ReturnType<typeof hostingDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingDomainsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingDomainsV2<
  TData = Awaited<ReturnType<typeof hostingDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary domain list v2
 */

export function useHostingDomainsV2<
  TData = Awaited<ReturnType<typeof hostingDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingDomainsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingDomainsV2QueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Unassign the domain associated with the hosting account
 * @summary Unassign the domain
 */
export const hostingDomainsUnassignV2 = (
  hostingId: string,
  hostingDomainsUnassignV2Body: HostingDomainsUnassignV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingDomainsUnassignV2200>> => {
  return axios.post(
    `/v2/hosting/${hostingId}/domains/unassign`,
    hostingDomainsUnassignV2Body,
    options,
  );
};

export const getHostingDomainsUnassignV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsUnassignV2>>,
    TError,
    { hostingId: string; data: HostingDomainsUnassignV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingDomainsUnassignV2>>,
  TError,
  { hostingId: string; data: HostingDomainsUnassignV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingDomainsUnassignV2>>,
    { hostingId: string; data: HostingDomainsUnassignV2Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingDomainsUnassignV2(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingDomainsUnassignV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingDomainsUnassignV2>>
>;
export type HostingDomainsUnassignV2MutationBody = HostingDomainsUnassignV2Body;
export type HostingDomainsUnassignV2MutationError = AxiosError<unknown>;

/**
 * @summary Unassign the domain
 */
export const useHostingDomainsUnassignV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingDomainsUnassignV2>>,
    TError,
    { hostingId: string; data: HostingDomainsUnassignV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingDomainsUnassignV2>>,
  TError,
  { hostingId: string; data: HostingDomainsUnassignV2Body },
  TContext
> => {
  const mutationOptions = getHostingDomainsUnassignV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List files under the given directory
 * @summary List files
 */
export const listFilesV2 = (
  hostingId: string,
  params: ListFilesV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ListFilesV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/files`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getListFilesV2QueryKey = (
  hostingId: string,
  params: ListFilesV2Params,
) => {
  return [
    `/v2/hosting/${hostingId}/files`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFilesV2QueryOptions = <
  TData = Awaited<ReturnType<typeof listFilesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ListFilesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFilesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFilesV2QueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFilesV2>>> = ({
    signal,
  }) => listFilesV2(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listFilesV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListFilesV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof listFilesV2>>
>;
export type ListFilesV2QueryError = AxiosError<unknown>;

export function useListFilesV2<
  TData = Awaited<ReturnType<typeof listFilesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ListFilesV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFilesV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFilesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListFilesV2<
  TData = Awaited<ReturnType<typeof listFilesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ListFilesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFilesV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFilesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useListFilesV2<
  TData = Awaited<ReturnType<typeof listFilesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ListFilesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFilesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List files
 */

export function useListFilesV2<
  TData = Awaited<ReturnType<typeof listFilesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: ListFilesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFilesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListFilesV2QueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the hosting server nameservers information
 * @summary hosting server nameservers info
 */
export const hostingNameserversV2 = (
  hostingId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingNameserversV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/nameservers`, options);
};

export const getHostingNameserversV2QueryKey = (hostingId: number) => {
  return [`/v2/hosting/${hostingId}/nameservers`] as const;
};

export const getHostingNameserversV2QueryOptions = <
  TData = Awaited<ReturnType<typeof hostingNameserversV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameserversV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingNameserversV2QueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingNameserversV2>>
  > = ({ signal }) =>
    hostingNameserversV2(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingNameserversV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingNameserversV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingNameserversV2>>
>;
export type HostingNameserversV2QueryError = AxiosError<unknown>;

export function useHostingNameserversV2<
  TData = Awaited<ReturnType<typeof hostingNameserversV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameserversV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingNameserversV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingNameserversV2<
  TData = Awaited<ReturnType<typeof hostingNameserversV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameserversV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingNameserversV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingNameserversV2<
  TData = Awaited<ReturnType<typeof hostingNameserversV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameserversV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary hosting server nameservers info
 */

export function useHostingNameserversV2<
  TData = Awaited<ReturnType<typeof hostingNameserversV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingNameserversV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingNameserversV2QueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the list of site's redirects
 * @summary List redirects
 */
export const hostingRedirectsV2 = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingRedirectsV2200Item[]>> => {
  return axios.get(`/v2/hosting/${hostingId}/redirects`, options);
};

export const getHostingRedirectsV2QueryKey = (hostingId: string) => {
  return [`/v2/hosting/${hostingId}/redirects`] as const;
};

export const getHostingRedirectsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof hostingRedirectsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirectsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingRedirectsV2QueryKey(hostingId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof hostingRedirectsV2>>
  > = ({ signal }) =>
    hostingRedirectsV2(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingRedirectsV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingRedirectsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingRedirectsV2>>
>;
export type HostingRedirectsV2QueryError = AxiosError<unknown>;

export function useHostingRedirectsV2<
  TData = Awaited<ReturnType<typeof hostingRedirectsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirectsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRedirectsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRedirectsV2<
  TData = Awaited<ReturnType<typeof hostingRedirectsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirectsV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingRedirectsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingRedirectsV2<
  TData = Awaited<ReturnType<typeof hostingRedirectsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirectsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary List redirects
 */

export function useHostingRedirectsV2<
  TData = Awaited<ReturnType<typeof hostingRedirectsV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof hostingRedirectsV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingRedirectsV2QueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of sites.
 * @summary sites list v2
 */
export const hostingSitesV2 = (
  hostingId: string,
  params?: HostingSitesV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSitesV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/sites`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getHostingSitesV2QueryKey = (
  hostingId: string,
  params?: HostingSitesV2Params,
) => {
  return [
    `/v2/hosting/${hostingId}/sites`,
    ...(params ? [params] : []),
  ] as const;
};

export const getHostingSitesV2QueryOptions = <
  TData = Awaited<ReturnType<typeof hostingSitesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingSitesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSitesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getHostingSitesV2QueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof hostingSitesV2>>> = ({
    signal,
  }) => hostingSitesV2(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof hostingSitesV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HostingSitesV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof hostingSitesV2>>
>;
export type HostingSitesV2QueryError = AxiosError<unknown>;

export function useHostingSitesV2<
  TData = Awaited<ReturnType<typeof hostingSitesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | HostingSitesV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSitesV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSitesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSitesV2<
  TData = Awaited<ReturnType<typeof hostingSitesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingSitesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSitesV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof hostingSitesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useHostingSitesV2<
  TData = Awaited<ReturnType<typeof hostingSitesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingSitesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSitesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sites list v2
 */

export function useHostingSitesV2<
  TData = Awaited<ReturnType<typeof hostingSitesV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: HostingSitesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof hostingSitesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHostingSitesV2QueryOptions(
    hostingId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a site to the current hosting.
 * @summary sites add
 */
export const hostingSiteAddV2 = (
  hostingId: string,
  hostingSiteAddV2Body: HostingSiteAddV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSiteAddV2200>> => {
  return axios.post(
    `/v2/hosting/${hostingId}/sites`,
    hostingSiteAddV2Body,
    options,
  );
};

export const getHostingSiteAddV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAddV2>>,
    TError,
    { hostingId: string; data: HostingSiteAddV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingSiteAddV2>>,
  TError,
  { hostingId: string; data: HostingSiteAddV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingSiteAddV2>>,
    { hostingId: string; data: HostingSiteAddV2Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingSiteAddV2(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingSiteAddV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingSiteAddV2>>
>;
export type HostingSiteAddV2MutationBody = HostingSiteAddV2Body;
export type HostingSiteAddV2MutationError = AxiosError<unknown>;

/**
 * @summary sites add
 */
export const useHostingSiteAddV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAddV2>>,
    TError,
    { hostingId: string; data: HostingSiteAddV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingSiteAddV2>>,
  TError,
  { hostingId: string; data: HostingSiteAddV2Body },
  TContext
> => {
  const mutationOptions = getHostingSiteAddV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Import public/private ssh key
 * @deprecated
 * @summary Deprecated -Import ssh key
 */
export const sshKeyImportV2 = (
  hostingId: string,
  sshKeyImportV2Body: SshKeyImportV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyImportV2200>> => {
  return axios.post(
    `/v2/hosting/${hostingId}/ssh/import`,
    sshKeyImportV2Body,
    options,
  );
};

export const getSshKeyImportV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImportV2>>,
    TError,
    { hostingId: string; data: SshKeyImportV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKeyImportV2>>,
  TError,
  { hostingId: string; data: SshKeyImportV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKeyImportV2>>,
    { hostingId: string; data: SshKeyImportV2Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKeyImportV2(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyImportV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyImportV2>>
>;
export type SshKeyImportV2MutationBody = SshKeyImportV2Body;
export type SshKeyImportV2MutationError = AxiosError<unknown>;

/**
 * @deprecated
 * @summary Deprecated -Import ssh key
 */
export const useSshKeyImportV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImportV2>>,
    TError,
    { hostingId: string; data: SshKeyImportV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKeyImportV2>>,
  TError,
  { hostingId: string; data: SshKeyImportV2Body },
  TContext
> => {
  const mutationOptions = getSshKeyImportV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ diretory.
 * @deprecated
 * @summary Deprecated - ssh keys list
 */
export const sshKeyListV2 = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyListV2200>> => {
  return axios.get(`/v2/hosting/${hostingId}/ssh/keys`, options);
};

export const getSshKeyListV2QueryKey = (hostingId: string) => {
  return [`/v2/hosting/${hostingId}/ssh/keys`] as const;
};

export const getSshKeyListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sshKeyListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSshKeyListV2QueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sshKeyListV2>>> = ({
    signal,
  }) => sshKeyListV2(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sshKeyListV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SshKeyListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyListV2>>
>;
export type SshKeyListV2QueryError = AxiosError<unknown>;

export function useSshKeyListV2<
  TData = Awaited<ReturnType<typeof sshKeyListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV2<
  TData = Awaited<ReturnType<typeof sshKeyListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV2<
  TData = Awaited<ReturnType<typeof sshKeyListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Deprecated - ssh keys list
 */

export function useSshKeyListV2<
  TData = Awaited<ReturnType<typeof sshKeyListV2>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSshKeyListV2QueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deletes an SSH key. VPS/dedicated: id required, optional remote. Shared: name and authorize.
 * @summary ssh key delete
 */
export const sshKeyV2 = (
  hostingId: string,
  sshKeyV2Body: SshKeyV2Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyV2200>> => {
  return axios.delete(`/v2/hosting/${hostingId}/ssh/keys`, {
    data: sshKeyV2Body,
    ...options,
  });
};

export const getSshKeyV2MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyV2>>,
    TError,
    { hostingId: string; data: SshKeyV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKeyV2>>,
  TError,
  { hostingId: string; data: SshKeyV2Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKeyV2>>,
    { hostingId: string; data: SshKeyV2Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKeyV2(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyV2>>
>;
export type SshKeyV2MutationBody = SshKeyV2Body;
export type SshKeyV2MutationError = AxiosError<unknown>;

/**
 * @summary ssh key delete
 */
export const useSshKeyV2 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyV2>>,
    TError,
    { hostingId: string; data: SshKeyV2Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKeyV2>>,
  TError,
  { hostingId: string; data: SshKeyV2Body },
  TContext
> => {
  const mutationOptions = getSshKeyV2MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns a list of images available for public use.
 * @summary Public OS image list (v2)
 */
export const publicImagesV2 = (
  params?: PublicImagesV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<PublicImagesV2200>> => {
  return axios.get(`/v2/public/images`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getPublicImagesV2QueryKey = (params?: PublicImagesV2Params) => {
  return [`/v2/public/images`, ...(params ? [params] : [])] as const;
};

export const getPublicImagesV2QueryOptions = <
  TData = Awaited<ReturnType<typeof publicImagesV2>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImagesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPublicImagesV2QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof publicImagesV2>>> = ({
    signal,
  }) => publicImagesV2(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof publicImagesV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type PublicImagesV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof publicImagesV2>>
>;
export type PublicImagesV2QueryError = AxiosError<unknown>;

export function usePublicImagesV2<
  TData = Awaited<ReturnType<typeof publicImagesV2>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | PublicImagesV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImagesV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicImagesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicImagesV2<
  TData = Awaited<ReturnType<typeof publicImagesV2>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImagesV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof publicImagesV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function usePublicImagesV2<
  TData = Awaited<ReturnType<typeof publicImagesV2>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImagesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Public OS image list (v2)
 */

export function usePublicImagesV2<
  TData = Awaited<ReturnType<typeof publicImagesV2>>,
  TError = AxiosError<unknown>,
>(
  params?: PublicImagesV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof publicImagesV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getPublicImagesV2QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Deprecated - use sites_list_v3 instead
 * @deprecated
 * @summary Site list for an account v2
 */
export const sitesListV2 = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesListV2200>> => {
  return axios.get(`/v2/sites`, options);
};

export const getSitesListV2QueryKey = () => {
  return [`/v2/sites`] as const;
};

export const getSitesListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesListV2>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof sitesListV2>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesListV2QueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesListV2>>> = ({
    signal,
  }) => sitesListV2({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesListV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesListV2>>
>;
export type SitesListV2QueryError = AxiosError<unknown>;

export function useSitesListV2<
  TData = Awaited<ReturnType<typeof sitesListV2>>,
  TError = AxiosError<unknown>,
>(options: {
  query: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof sitesListV2>>, TError, TData>
  > &
    Pick<
      DefinedInitialDataOptions<
        Awaited<ReturnType<typeof sitesListV2>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesListV2<
  TData = Awaited<ReturnType<typeof sitesListV2>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof sitesListV2>>, TError, TData>
  > &
    Pick<
      UndefinedInitialDataOptions<
        Awaited<ReturnType<typeof sitesListV2>>,
        TError,
        TData
      >,
      'initialData'
    >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesListV2<
  TData = Awaited<ReturnType<typeof sitesListV2>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof sitesListV2>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary Site list for an account v2
 */

export function useSitesListV2<
  TData = Awaited<ReturnType<typeof sitesListV2>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof sitesListV2>>, TError, TData>
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesListV2QueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns v2 site information. (compatible platforms: jarvis, hal)
 * @summary site info
 */
export const sitesInfoV2 = (
  siteId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteInfoResponseModelV2>> => {
  return axios.get(`/v2/sites/${siteId}`, options);
};

export const getSitesInfoV2QueryKey = (siteId: string) => {
  return [`/v2/sites/${siteId}`] as const;
};

export const getSitesInfoV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesInfoV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesInfoV2QueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesInfoV2>>> = ({
    signal,
  }) => sitesInfoV2(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesInfoV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesInfoV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesInfoV2>>
>;
export type SitesInfoV2QueryError = AxiosError<unknown>;

export function useSitesInfoV2<
  TData = Awaited<ReturnType<typeof sitesInfoV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfoV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfoV2<
  TData = Awaited<ReturnType<typeof sitesInfoV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfoV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfoV2<
  TData = Awaited<ReturnType<typeof sitesInfoV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary site info
 */

export function useSitesInfoV2<
  TData = Awaited<ReturnType<typeof sitesInfoV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesInfoV2QueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Provides the domains list associated with the site
 * @summary Domains list for the site
 */
export const sitesDomainsV2 = (
  siteId: string,
  params?: SitesDomainsV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesDomainsV2200>> => {
  return axios.get(`/v2/sites/${siteId}/domains`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesDomainsV2QueryKey = (
  siteId: string,
  params?: SitesDomainsV2Params,
) => {
  return [`/v2/sites/${siteId}/domains`, ...(params ? [params] : [])] as const;
};

export const getSitesDomainsV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomainsV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesDomainsV2QueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesDomainsV2>>> = ({
    signal,
  }) => sitesDomainsV2(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesDomainsV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesDomainsV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesDomainsV2>>
>;
export type SitesDomainsV2QueryError = AxiosError<unknown>;

export function useSitesDomainsV2<
  TData = Awaited<ReturnType<typeof sitesDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params: undefined | SitesDomainsV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomainsV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDomainsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDomainsV2<
  TData = Awaited<ReturnType<typeof sitesDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomainsV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesDomainsV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesDomainsV2<
  TData = Awaited<ReturnType<typeof sitesDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomainsV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Domains list for the site
 */

export function useSitesDomainsV2<
  TData = Awaited<ReturnType<typeof sitesDomainsV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  params?: SitesDomainsV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesDomainsV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesDomainsV2QueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns malware status of atomic site
 * @summary malware status of atomic site
 */
export const siteMalwareStatusV2 = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteMalwareStatusV2200>> => {
  return axios.get(`/v2/sites/${siteId}/malware-status`, options);
};

export const getSiteMalwareStatusV2QueryKey = (siteId: number) => {
  return [`/v2/sites/${siteId}/malware-status`] as const;
};

export const getSiteMalwareStatusV2QueryOptions = <
  TData = Awaited<ReturnType<typeof siteMalwareStatusV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatusV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSiteMalwareStatusV2QueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof siteMalwareStatusV2>>
  > = ({ signal }) => siteMalwareStatusV2(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteMalwareStatusV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteMalwareStatusV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof siteMalwareStatusV2>>
>;
export type SiteMalwareStatusV2QueryError = AxiosError<unknown>;

export function useSiteMalwareStatusV2<
  TData = Awaited<ReturnType<typeof siteMalwareStatusV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatusV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteMalwareStatusV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteMalwareStatusV2<
  TData = Awaited<ReturnType<typeof siteMalwareStatusV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatusV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteMalwareStatusV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteMalwareStatusV2<
  TData = Awaited<ReturnType<typeof siteMalwareStatusV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatusV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary malware status of atomic site
 */

export function useSiteMalwareStatusV2<
  TData = Awaited<ReturnType<typeof siteMalwareStatusV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof siteMalwareStatusV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteMalwareStatusV2QueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns the site's sitelock information.
 * @summary sitelock info
 */
export const sitesSecuritySitelockV2 = (
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSecuritySitelockV2200>> => {
  return axios.get(`/v2/sites/${siteId}/security/sitelock`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesSecuritySitelockV2QueryKey = (
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
) => {
  return [
    `/v2/sites/${siteId}/security/sitelock`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSitesSecuritySitelockV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getSitesSecuritySitelockV2QueryKey(siteId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSecuritySitelockV2>>
  > = ({ signal }) =>
    sitesSecuritySitelockV2(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSecuritySitelockV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSecuritySitelockV2>>
>;
export type SitesSecuritySitelockV2QueryError = AxiosError<unknown>;

export function useSitesSecuritySitelockV2<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SitesSecuritySitelockV2Params,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySitelockV2<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSecuritySitelockV2<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary sitelock info
 */

export function useSitesSecuritySitelockV2<
  TData = Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SitesSecuritySitelockV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSecuritySitelockV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSecuritySitelockV2QueryOptions(
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List ssh users V2
 * @summary site - ssh - list users v2
 */
export const sitesSshUserListV2 = (
  siteId: number,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesSshUserListV2200>> => {
  return axios.get(`/v2/sites/${siteId}/ssh-users`, options);
};

export const getSitesSshUserListV2QueryKey = (siteId: number) => {
  return [`/v2/sites/${siteId}/ssh-users`] as const;
};

export const getSitesSshUserListV2QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesSshUserListV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSitesSshUserListV2QueryKey(siteId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof sitesSshUserListV2>>
  > = ({ signal }) => sitesSshUserListV2(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesSshUserListV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesSshUserListV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesSshUserListV2>>
>;
export type SitesSshUserListV2QueryError = AxiosError<unknown>;

export function useSitesSshUserListV2<
  TData = Awaited<ReturnType<typeof sitesSshUserListV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserListV2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSshUserListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSshUserListV2<
  TData = Awaited<ReturnType<typeof sitesSshUserListV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserListV2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesSshUserListV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesSshUserListV2<
  TData = Awaited<ReturnType<typeof sitesSshUserListV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary site - ssh - list users v2
 */

export function useSitesSshUserListV2<
  TData = Awaited<ReturnType<typeof sitesSshUserListV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof sitesSshUserListV2>>,
        TError,
        TData
      >
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesSshUserListV2QueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of the site's users with additional information like limit,offset, and total count
 * @summary users info
 */
export const siteUsersV2 = (
  siteId: number,
  params?: SiteUsersV2Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteUsersV2200>> => {
  return axios.get(`/v2/sites/${siteId}/users`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSiteUsersV2QueryKey = (
  siteId: number,
  params?: SiteUsersV2Params,
) => {
  return [`/v2/sites/${siteId}/users`, ...(params ? [params] : [])] as const;
};

export const getSiteUsersV2QueryOptions = <
  TData = Awaited<ReturnType<typeof siteUsersV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SiteUsersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsersV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSiteUsersV2QueryKey(siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof siteUsersV2>>> = ({
    signal,
  }) => siteUsersV2(siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof siteUsersV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SiteUsersV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof siteUsersV2>>
>;
export type SiteUsersV2QueryError = AxiosError<unknown>;

export function useSiteUsersV2<
  TData = Awaited<ReturnType<typeof siteUsersV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params: undefined | SiteUsersV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsersV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteUsersV2<
  TData = Awaited<ReturnType<typeof siteUsersV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SiteUsersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsersV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof siteUsersV2>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSiteUsersV2<
  TData = Awaited<ReturnType<typeof siteUsersV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SiteUsersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsersV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary users info
 */

export function useSiteUsersV2<
  TData = Awaited<ReturnType<typeof siteUsersV2>>,
  TError = AxiosError<unknown>,
>(
  siteId: number,
  params?: SiteUsersV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof siteUsersV2>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSiteUsersV2QueryOptions(siteId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Backup create
 * @summary Backup create
 */
export const backupCreateV3 = (
  addonId: number,
  backupCreateV3Body: BackupCreateV3Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupCreateV3200>> => {
  return axios.post(
    `/v3/addons/${addonId}/backup/create`,
    backupCreateV3Body,
    options,
  );
};

export const getBackupCreateV3MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateV3>>,
    TError,
    { addonId: number; data: BackupCreateV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupCreateV3>>,
  TError,
  { addonId: number; data: BackupCreateV3Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupCreateV3>>,
    { addonId: number; data: BackupCreateV3Body }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupCreateV3(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupCreateV3MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupCreateV3>>
>;
export type BackupCreateV3MutationBody = BackupCreateV3Body;
export type BackupCreateV3MutationError = AxiosError<unknown>;

/**
 * @summary Backup create
 */
export const useBackupCreateV3 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupCreateV3>>,
    TError,
    { addonId: number; data: BackupCreateV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupCreateV3>>,
  TError,
  { addonId: number; data: BackupCreateV3Body },
  TContext
> => {
  const mutationOptions = getBackupCreateV3MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Backup restore
 * @summary Backup restore
 */
export const backupRestoreV3 = (
  addonId: number,
  backupRestoreV3Body: BackupRestoreV3Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupRestoreV3200>> => {
  return axios.post(
    `/v3/addons/${addonId}/backup/site_restore`,
    backupRestoreV3Body,
    options,
  );
};

export const getBackupRestoreV3MutationOptions = <
  TError = AxiosError<
    | BackupRestoreV3400
    | BackupRestoreV3403
    | BackupRestoreV3404
    | BackupRestoreV3409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupRestoreV3>>,
    TError,
    { addonId: number; data: BackupRestoreV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof backupRestoreV3>>,
  TError,
  { addonId: number; data: BackupRestoreV3Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof backupRestoreV3>>,
    { addonId: number; data: BackupRestoreV3Body }
  > = (props) => {
    const { addonId, data } = props ?? {};

    return backupRestoreV3(addonId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BackupRestoreV3MutationResult = NonNullable<
  Awaited<ReturnType<typeof backupRestoreV3>>
>;
export type BackupRestoreV3MutationBody = BackupRestoreV3Body;
export type BackupRestoreV3MutationError = AxiosError<
  | BackupRestoreV3400
  | BackupRestoreV3403
  | BackupRestoreV3404
  | BackupRestoreV3409
>;

/**
 * @summary Backup restore
 */
export const useBackupRestoreV3 = <
  TError = AxiosError<
    | BackupRestoreV3400
    | BackupRestoreV3403
    | BackupRestoreV3404
    | BackupRestoreV3409
  >,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof backupRestoreV3>>,
    TError,
    { addonId: number; data: BackupRestoreV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof backupRestoreV3>>,
  TError,
  { addonId: number; data: BackupRestoreV3Body },
  TContext
> => {
  const mutationOptions = getBackupRestoreV3MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Returns backups for the addon and site with pagination via page and limit query parameters.
 * @summary Backup list (paginated)
 */
export const backupListV3 = (
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupListV3200>> => {
  return axios.get(`/v3/addons/${addonId}/backup/sites/${siteId}/list`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupListV3QueryKey = (
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
) => {
  return [
    `/v3/addons/${addonId}/backup/sites/${siteId}/list`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBackupListV3QueryOptions = <
  TData = Awaited<ReturnType<typeof backupListV3>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupListV3QueryKey(addonId, siteId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupListV3>>> = ({
    signal,
  }) => backupListV3(addonId, siteId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(addonId && siteId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupListV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupListV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof backupListV3>>
>;
export type BackupListV3QueryError = AxiosError<unknown>;

export function useBackupListV3<
  TData = Awaited<ReturnType<typeof backupListV3>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  params: undefined | BackupListV3Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV3>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupListV3<
  TData = Awaited<ReturnType<typeof backupListV3>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV3>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupListV3<
  TData = Awaited<ReturnType<typeof backupListV3>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup list (paginated)
 */

export function useBackupListV3<
  TData = Awaited<ReturnType<typeof backupListV3>>,
  TError = AxiosError<unknown>,
>(
  addonId: number,
  siteId: number,
  params?: BackupListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupListV3QueryOptions(
    addonId,
    siteId,
    params,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Poll backup event status using client_tracking_id from cbs_event_processing.
 * @summary Backup status
 */
export const backupStatusV3 = (
  addonId: number,
  params: BackupStatusV3Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<BackupStatusV3200>> => {
  return axios.get(`/v3/addons/${addonId}/backup/status`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getBackupStatusV3QueryKey = (
  addonId: number,
  params: BackupStatusV3Params,
) => {
  return [
    `/v3/addons/${addonId}/backup/status`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBackupStatusV3QueryOptions = <
  TData = Awaited<ReturnType<typeof backupStatusV3>>,
  TError = AxiosError<BackupStatusV3400>,
>(
  addonId: number,
  params: BackupStatusV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBackupStatusV3QueryKey(addonId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof backupStatusV3>>> = ({
    signal,
  }) => backupStatusV3(addonId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!addonId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof backupStatusV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type BackupStatusV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof backupStatusV3>>
>;
export type BackupStatusV3QueryError = AxiosError<BackupStatusV3400>;

export function useBackupStatusV3<
  TData = Awaited<ReturnType<typeof backupStatusV3>>,
  TError = AxiosError<BackupStatusV3400>,
>(
  addonId: number,
  params: BackupStatusV3Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV3>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatusV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatusV3<
  TData = Awaited<ReturnType<typeof backupStatusV3>>,
  TError = AxiosError<BackupStatusV3400>,
>(
  addonId: number,
  params: BackupStatusV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV3>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof backupStatusV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useBackupStatusV3<
  TData = Awaited<ReturnType<typeof backupStatusV3>>,
  TError = AxiosError<BackupStatusV3400>,
>(
  addonId: number,
  params: BackupStatusV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Backup status
 */

export function useBackupStatusV3<
  TData = Awaited<ReturnType<typeof backupStatusV3>>,
  TError = AxiosError<BackupStatusV3400>,
>(
  addonId: number,
  params: BackupStatusV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof backupStatusV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getBackupStatusV3QueryOptions(addonId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Add a site to the current hosting.
 * @summary sites add
 */
export const hostingSiteAddV3 = (
  hostingId: string,
  hostingSiteAddV3Body: HostingSiteAddV3Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<HostingSiteAddV3200>> => {
  return axios.post(
    `/v3/hosting/${hostingId}/sites`,
    hostingSiteAddV3Body,
    options,
  );
};

export const getHostingSiteAddV3MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAddV3>>,
    TError,
    { hostingId: string; data: HostingSiteAddV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof hostingSiteAddV3>>,
  TError,
  { hostingId: string; data: HostingSiteAddV3Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof hostingSiteAddV3>>,
    { hostingId: string; data: HostingSiteAddV3Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return hostingSiteAddV3(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type HostingSiteAddV3MutationResult = NonNullable<
  Awaited<ReturnType<typeof hostingSiteAddV3>>
>;
export type HostingSiteAddV3MutationBody = HostingSiteAddV3Body;
export type HostingSiteAddV3MutationError = AxiosError<unknown>;

/**
 * @summary sites add
 */
export const useHostingSiteAddV3 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof hostingSiteAddV3>>,
    TError,
    { hostingId: string; data: HostingSiteAddV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof hostingSiteAddV3>>,
  TError,
  { hostingId: string; data: HostingSiteAddV3Body },
  TContext
> => {
  const mutationOptions = getHostingSiteAddV3MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Import public ssh key
 * @summary Import ssh key
 */
export const sshKeyImportV3 = (
  hostingId: string,
  sshKeyImportV3Body: SshKeyImportV3Body,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyImportV3200>> => {
  return axios.post(
    `/v3/hosting/${hostingId}/ssh/import`,
    sshKeyImportV3Body,
    options,
  );
};

export const getSshKeyImportV3MutationOptions = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImportV3>>,
    TError,
    { hostingId: string; data: SshKeyImportV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sshKeyImportV3>>,
  TError,
  { hostingId: string; data: SshKeyImportV3Body },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sshKeyImportV3>>,
    { hostingId: string; data: SshKeyImportV3Body }
  > = (props) => {
    const { hostingId, data } = props ?? {};

    return sshKeyImportV3(hostingId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SshKeyImportV3MutationResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyImportV3>>
>;
export type SshKeyImportV3MutationBody = SshKeyImportV3Body;
export type SshKeyImportV3MutationError = AxiosError<unknown>;

/**
 * @summary Import ssh key
 */
export const useSshKeyImportV3 = <
  TError = AxiosError<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sshKeyImportV3>>,
    TError,
    { hostingId: string; data: SshKeyImportV3Body },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof sshKeyImportV3>>,
  TError,
  { hostingId: string; data: SshKeyImportV3Body },
  TContext
> => {
  const mutationOptions = getSshKeyImportV3MutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * List all SSH keys on a server or account. Finds all keys in user's .ssh/ directory.
 * @deprecated
 * @summary ssh keys list
 */
export const sshKeyListV3 = (
  hostingId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyListV3200>> => {
  return axios.get(`/v3/hosting/${hostingId}/ssh/keys`, options);
};

export const getSshKeyListV3QueryKey = (hostingId: string) => {
  return [`/v3/hosting/${hostingId}/ssh/keys`] as const;
};

export const getSshKeyListV3QueryOptions = <
  TData = Awaited<ReturnType<typeof sshKeyListV3>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSshKeyListV3QueryKey(hostingId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sshKeyListV3>>> = ({
    signal,
  }) => sshKeyListV3(hostingId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sshKeyListV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SshKeyListV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyListV3>>
>;
export type SshKeyListV3QueryError = AxiosError<unknown>;

export function useSshKeyListV3<
  TData = Awaited<ReturnType<typeof sshKeyListV3>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV3>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV3<
  TData = Awaited<ReturnType<typeof sshKeyListV3>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV3>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV3<
  TData = Awaited<ReturnType<typeof sshKeyListV3>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @deprecated
 * @summary ssh keys list
 */

export function useSshKeyListV3<
  TData = Awaited<ReturnType<typeof sshKeyListV3>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSshKeyListV3QueryOptions(hostingId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns a list of sites. (Compatible platforms: jarvis, hal)
 * @summary Site list for an account v3
 */
export const sitesListV3 = (
  params?: SitesListV3Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SitesListV3200>> => {
  return axios.get(`/v3/sites`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSitesListV3QueryKey = (params?: SitesListV3Params) => {
  return [`/v3/sites`, ...(params ? [params] : [])] as const;
};

export const getSitesListV3QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesListV3>>,
  TError = AxiosError<unknown>,
>(
  params?: SitesListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesListV3QueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesListV3>>> = ({
    signal,
  }) => sitesListV3(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesListV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesListV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesListV3>>
>;
export type SitesListV3QueryError = AxiosError<unknown>;

export function useSitesListV3<
  TData = Awaited<ReturnType<typeof sitesListV3>>,
  TError = AxiosError<unknown>,
>(
  params: undefined | SitesListV3Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesListV3>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesListV3<
  TData = Awaited<ReturnType<typeof sitesListV3>>,
  TError = AxiosError<unknown>,
>(
  params?: SitesListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesListV3>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesListV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesListV3<
  TData = Awaited<ReturnType<typeof sitesListV3>>,
  TError = AxiosError<unknown>,
>(
  params?: SitesListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site list for an account v3
 */

export function useSitesListV3<
  TData = Awaited<ReturnType<typeof sitesListV3>>,
  TError = AxiosError<unknown>,
>(
  params?: SitesListV3Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesListV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesListV3QueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns v3 site information including WordPress options (blogname, blogdescription, nfd_origin_prompt) and WooCommerce status.
 * @summary Site info v3
 */
export const sitesInfoV3 = (
  siteId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SiteInfoResponseModelV2>> => {
  return axios.get(`/v3/sites/${siteId}`, options);
};

export const getSitesInfoV3QueryKey = (siteId: string) => {
  return [`/v3/sites/${siteId}`] as const;
};

export const getSitesInfoV3QueryOptions = <
  TData = Awaited<ReturnType<typeof sitesInfoV3>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSitesInfoV3QueryKey(siteId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sitesInfoV3>>> = ({
    signal,
  }) => sitesInfoV3(siteId, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!siteId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sitesInfoV3>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SitesInfoV3QueryResult = NonNullable<
  Awaited<ReturnType<typeof sitesInfoV3>>
>;
export type SitesInfoV3QueryError = AxiosError<unknown>;

export function useSitesInfoV3<
  TData = Awaited<ReturnType<typeof sitesInfoV3>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV3>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfoV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfoV3<
  TData = Awaited<ReturnType<typeof sitesInfoV3>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV3>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sitesInfoV3>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSitesInfoV3<
  TData = Awaited<ReturnType<typeof sitesInfoV3>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary Site info v3
 */

export function useSitesInfoV3<
  TData = Awaited<ReturnType<typeof sitesInfoV3>>,
  TError = AxiosError<unknown>,
>(
  siteId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sitesInfoV3>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSitesInfoV3QueryOptions(siteId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * List SSH public keys. Shared hosting reads keys from the account .ssh directory via gap_ssh_key_list. VPS/Dedicated hosting reads customer keys via server_pubkey_list, or server_pubkey_scan when scan=true.
 * @summary ssh keys list
 */
export const sshKeyListV4 = (
  hostingId: string,
  params?: SshKeyListV4Params,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<SshKeyListV4200>> => {
  return axios.get(`/v4/hosting/${hostingId}/ssh/keys`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getSshKeyListV4QueryKey = (
  hostingId: string,
  params?: SshKeyListV4Params,
) => {
  return [
    `/v4/hosting/${hostingId}/ssh/keys`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSshKeyListV4QueryOptions = <
  TData = Awaited<ReturnType<typeof sshKeyListV4>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: SshKeyListV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV4>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSshKeyListV4QueryKey(hostingId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof sshKeyListV4>>> = ({
    signal,
  }) => sshKeyListV4(hostingId, params, { signal, ...axiosOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!hostingId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof sshKeyListV4>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type SshKeyListV4QueryResult = NonNullable<
  Awaited<ReturnType<typeof sshKeyListV4>>
>;
export type SshKeyListV4QueryError = AxiosError<unknown>;

export function useSshKeyListV4<
  TData = Awaited<ReturnType<typeof sshKeyListV4>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params: undefined | SshKeyListV4Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV4>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV4>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV4<
  TData = Awaited<ReturnType<typeof sshKeyListV4>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: SshKeyListV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV4>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof sshKeyListV4>>,
          TError,
          TData
        >,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
export function useSshKeyListV4<
  TData = Awaited<ReturnType<typeof sshKeyListV4>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: SshKeyListV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV4>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey };
/**
 * @summary ssh keys list
 */

export function useSshKeyListV4<
  TData = Awaited<ReturnType<typeof sshKeyListV4>>,
  TError = AxiosError<unknown>,
>(
  hostingId: string,
  params?: SshKeyListV4Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof sshKeyListV4>>, TError, TData>
    >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getSshKeyListV4QueryOptions(hostingId, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
